(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[161],{

/***/ 77383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ CacheProvider; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ ThemeContext; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* reexport */ css_browser_esm; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withEmotionCache": function() { return /* reexport */ withEmotionCache; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/emotion-element-57a3a7a3.browser.esm.js






var emotion_element_57a3a7a3_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

/* harmony default export */ var css_browser_esm = (css);

;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css_browser_esm.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),

/***/ 24955:
/***/ (function(module) {

/*! algoliasearch.umd.js | 4.13.1 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";function t(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function e(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function r(r){for(var n=1;n<arguments.length;n++){var a=null!=arguments[n]?arguments[n]:{};n%2?e(Object(a),!0).forEach((function(e){t(r,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(a)):e(Object(a)).forEach((function(t){Object.defineProperty(r,t,Object.getOwnPropertyDescriptor(a,t))}))}return r}function n(t,e){if(null==t)return{};var r,n,a=function(t,e){if(null==t)return{};var r,n,a={},o=Object.keys(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||(a[r]=t[r]);return a}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(t,r)&&(a[r]=t[r])}return a}function a(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if(!(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t)))return;var r=[],n=!0,a=!1,o=void 0;try{for(var i,u=t[Symbol.iterator]();!(n=(i=u.next()).done)&&(r.push(i.value),!e||r.length!==e);n=!0);}catch(t){a=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(a)throw o}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function o(t){return function(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function i(t){var e,r="algoliasearch-client-js-".concat(t.key),n=function(){return void 0===e&&(e=t.localStorage||window.localStorage),e},o=function(){return JSON.parse(n().getItem(r)||"{}")};return{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return Promise.resolve().then((function(){var r=JSON.stringify(t),n=o()[r];return Promise.all([n||e(),void 0!==n])})).then((function(t){var e=a(t,2),n=e[0],o=e[1];return Promise.all([n,o||r.miss(n)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve().then((function(){var a=o();return a[JSON.stringify(t)]=e,n().setItem(r,JSON.stringify(a)),e}))},delete:function(t){return Promise.resolve().then((function(){var e=o();delete e[JSON.stringify(t)],n().setItem(r,JSON.stringify(e))}))},clear:function(){return Promise.resolve().then((function(){n().removeItem(r)}))}}}function u(t){var e=o(t.caches),r=e.shift();return void 0===r?{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},n=e();return n.then((function(t){return Promise.all([t,r.miss(t)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve(e)},delete:function(t){return Promise.resolve()},clear:function(){return Promise.resolve()}}:{get:function(t,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return r.get(t,n,a).catch((function(){return u({caches:e}).get(t,n,a)}))},set:function(t,n){return r.set(t,n).catch((function(){return u({caches:e}).set(t,n)}))},delete:function(t){return r.delete(t).catch((function(){return u({caches:e}).delete(t)}))},clear:function(){return r.clear().catch((function(){return u({caches:e}).clear()}))}}}function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{serializable:!0},e={};return{get:function(r,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},o=JSON.stringify(r);if(o in e)return Promise.resolve(t.serializable?JSON.parse(e[o]):e[o]);var i=n(),u=a&&a.miss||function(){return Promise.resolve()};return i.then((function(t){return u(t)})).then((function(){return i}))},set:function(r,n){return e[JSON.stringify(r)]=t.serializable?JSON.stringify(n):n,Promise.resolve(n)},delete:function(t){return delete e[JSON.stringify(t)],Promise.resolve()},clear:function(){return e={},Promise.resolve()}}}function c(t,e,r){var n={"x-algolia-api-key":r,"x-algolia-application-id":e};return{headers:function(){return t===m.WithinHeaders?n:{}},queryParameters:function(){return t===m.WithinQueryParameters?n:{}}}}function f(t){var e=0;return t((function r(){return e++,new Promise((function(n){setTimeout((function(){n(t(r))}),Math.min(100*e,1e3))}))}))}function d(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(t,e){return Promise.resolve()};return Object.assign(t,{wait:function(r){return d(t.then((function(t){return Promise.all([e(t,r),t])})).then((function(t){return t[1]})))}})}function l(t){for(var e=t.length-1;e>0;e--){var r=Math.floor(Math.random()*(e+1)),n=t[e];t[e]=t[r],t[r]=n}return t}function p(t,e){return e?(Object.keys(e).forEach((function(r){t[r]=e[r](t)})),t):t}function h(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),n=1;n<e;n++)r[n-1]=arguments[n];var a=0;return t.replace(/%s/g,(function(){return encodeURIComponent(r[a++])}))}var m={WithinQueryParameters:0,WithinHeaders:1};function y(t,e){var r=t||{},n=r.data||{};return Object.keys(r).forEach((function(t){-1===["timeout","headers","queryParameters","data","cacheable"].indexOf(t)&&(n[t]=r[t])})),{data:Object.entries(n).length>0?n:void 0,timeout:r.timeout||e,headers:r.headers||{},queryParameters:r.queryParameters||{},cacheable:r.cacheable}}var g={Read:1,Write:2,Any:3},v=1,b=2,P=3;function w(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:v;return r(r({},t),{},{status:e,lastUpdate:Date.now()})}function O(t){return"string"==typeof t?{protocol:"https",url:t,accept:g.Any}:{protocol:t.protocol||"https",url:t.url,accept:t.accept||g.Any}}var I="DELETE",x="GET",j="POST",D="PUT";function q(t,e){return Promise.all(e.map((function(e){return t.get(e,(function(){return Promise.resolve(w(e))}))}))).then((function(t){var r=t.filter((function(t){return function(t){return t.status===v||Date.now()-t.lastUpdate>12e4}(t)})),n=t.filter((function(t){return function(t){return t.status===P&&Date.now()-t.lastUpdate<=12e4}(t)})),a=[].concat(o(r),o(n));return{getTimeout:function(t,e){return(0===n.length&&0===t?1:n.length+3+t)*e},statelessHosts:a.length>0?a.map((function(t){return O(t)})):e}}))}function S(t,e,n,a){var i=[],u=function(t,e){if(t.method===x||void 0===t.data&&void 0===e.data)return;var n=Array.isArray(t.data)?t.data:r(r({},t.data),e.data);return JSON.stringify(n)}(n,a),s=function(t,e){var n=r(r({},t.headers),e.headers),a={};return Object.keys(n).forEach((function(t){var e=n[t];a[t.toLowerCase()]=e})),a}(t,a),c=n.method,f=n.method!==x?{}:r(r({},n.data),a.data),d=r(r(r({"x-algolia-agent":t.userAgent.value},t.queryParameters),f),a.queryParameters),l=0,p=function e(r,o){var f=r.pop();if(void 0===f)throw{name:"RetryError",message:"Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",transporterStackTrace:R(i)};var p={data:u,headers:s,method:c,url:N(f,n.path,d),connectTimeout:o(l,t.timeouts.connect),responseTimeout:o(l,a.timeout)},h=function(t){var e={request:p,response:t,host:f,triesLeft:r.length};return i.push(e),e},m={onSuccess:function(t){return function(t){try{return JSON.parse(t.content)}catch(e){throw function(t,e){return{name:"DeserializationError",message:t,response:e}}(e.message,t)}}(t)},onRetry:function(n){var a=h(n);return n.isTimedOut&&l++,Promise.all([t.logger.info("Retryable failure",A(a)),t.hostsCache.set(f,w(f,n.isTimedOut?P:b))]).then((function(){return e(r,o)}))},onFail:function(t){throw h(t),function(t,e){var r=t.content,n=t.status,a=r;try{a=JSON.parse(r).message}catch(t){}return function(t,e,r){return{name:"ApiError",message:t,status:e,transporterStackTrace:r}}(a,n,e)}(t,R(i))}};return t.requester.send(p).then((function(t){return function(t,e){return function(t){var e=t.status;return t.isTimedOut||function(t){var e=t.isTimedOut,r=t.status;return!e&&0==~~r}(t)||2!=~~(e/100)&&4!=~~(e/100)}(t)?e.onRetry(t):2==~~(t.status/100)?e.onSuccess(t):e.onFail(t)}(t,m)}))};return q(t.hostsCache,e).then((function(t){return p(o(t.statelessHosts).reverse(),t.getTimeout)}))}function k(t){var e=t.hostsCache,r=t.logger,n=t.requester,o=t.requestsCache,i=t.responsesCache,u=t.timeouts,s=t.userAgent,c=t.hosts,f=t.queryParameters,d={hostsCache:e,logger:r,requester:n,requestsCache:o,responsesCache:i,timeouts:u,userAgent:s,headers:t.headers,queryParameters:f,hosts:c.map((function(t){return O(t)})),read:function(t,e){var r=y(e,d.timeouts.read),n=function(){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Read)})),t,r)};if(!0!==(void 0!==r.cacheable?r.cacheable:t.cacheable))return n();var o={request:t,mappedRequestOptions:r,transporter:{queryParameters:d.queryParameters,headers:d.headers}};return d.responsesCache.get(o,(function(){return d.requestsCache.get(o,(function(){return d.requestsCache.set(o,n()).then((function(t){return Promise.all([d.requestsCache.delete(o),t])}),(function(t){return Promise.all([d.requestsCache.delete(o),Promise.reject(t)])})).then((function(t){var e=a(t,2);e[0];return e[1]}))}))}),{miss:function(t){return d.responsesCache.set(o,t)}})},write:function(t,e){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Write)})),t,y(e,d.timeouts.write))}};return d}function T(t){var e={value:"Algolia for JavaScript (".concat(t,")"),add:function(t){var r="; ".concat(t.segment).concat(void 0!==t.version?" (".concat(t.version,")"):"");return-1===e.value.indexOf(r)&&(e.value="".concat(e.value).concat(r)),e}};return e}function N(t,e,r){var n=E(r),a="".concat(t.protocol,"://").concat(t.url,"/").concat("/"===e.charAt(0)?e.substr(1):e);return n.length&&(a+="?".concat(n)),a}function E(t){return Object.keys(t).map((function(e){return h("%s=%s",e,(r=t[e],"[object Object]"===Object.prototype.toString.call(r)||"[object Array]"===Object.prototype.toString.call(r)?JSON.stringify(t[e]):t[e]));var r})).join("&")}function R(t){return t.map((function(t){return A(t)}))}function A(t){var e=t.request.headers["x-algolia-api-key"]?{"x-algolia-api-key":"*****"}:{};return r(r({},t),{},{request:r(r({},t.request),{},{headers:r(r({},t.request.headers),e)})})}var C=function(t){return function(e,r){return t.transporter.write({method:j,path:"2/abtests",data:e},r)}},U=function(t){return function(e,r){return t.transporter.write({method:I,path:h("2/abtests/%s",e)},r)}},z=function(t){return function(e,r){return t.transporter.read({method:x,path:h("2/abtests/%s",e)},r)}},J=function(t){return function(e){return t.transporter.read({method:x,path:"2/abtests"},e)}},F=function(t){return function(e,r){return t.transporter.write({method:j,path:h("2/abtests/%s/stop",e)},r)}},H=function(t){return function(e){return t.transporter.read({method:x,path:"1/strategies/personalization"},e)}},M=function(t){return function(e,r){return t.transporter.write({method:j,path:"1/strategies/personalization",data:e},r)}};function K(t){return function e(r){return t.request(r).then((function(n){if(void 0!==t.batch&&t.batch(n.hits),!t.shouldStop(n))return n.cursor?e({cursor:n.cursor}):e({page:(r.page||0)+1})}))}({})}var W=function(t){return function(e,a){var o=a||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=r({acl:e},void 0!==i?{queryParameters:i}:{});return d(t.transporter.write({method:j,path:"1/keys",data:s},u),(function(e,r){return f((function(n){return tt(t)(e.key,r).catch((function(t){if(404!==t.status)throw t;return n()}))}))}))}},B=function(t){return function(e,r,n){var a=y(n);return a.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:j,path:"1/clusters/mapping",data:{cluster:r}},a)}},Q=function(t){return function(e,r,n){return t.transporter.write({method:j,path:"1/clusters/mapping/batch",data:{users:e,cluster:r}},n)}},G=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:{action:"addEntry",body:[]}}},r),(function(e,r){return jt(t)(e.taskID,r)}))}},L=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"copy",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},V=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Rules]}))}},_=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Settings]}))}},X=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Synonyms]}))}},Y=function(t){return function(e,r){return e.method===x?t.transporter.read(e,r):t.transporter.write(e,r)}},Z=function(t){return function(e,r){return d(t.transporter.write({method:I,path:h("1/keys/%s",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).then(r).catch((function(t){if(404!==t.status)throw t}))}))}))}},$=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"deleteEntry",body:{objectID:t}}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},tt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/keys/%s",e)},r)}},et=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/task/%s",e.toString())},r)}},rt=function(t){return function(e){return t.transporter.read({method:x,path:"/1/dictionaries/*/settings"},e)}},nt=function(t){return function(e){return t.transporter.read({method:x,path:"1/logs"},e)}},at=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping/top"},e)}},ot=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/clusters/mapping/%s",e)},r)}},it=function(t){return function(e){var r=e||{},a=r.retrieveMappings,o=n(r,["retrieveMappings"]);return!0===a&&(o.getClusters=!0),t.transporter.read({method:x,path:"1/clusters/mapping/pending"},o)}},ut=function(t){return function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={transporter:t.transporter,appId:t.appId,indexName:e};return p(n,r.methods)}},st=function(t){return function(e){return t.transporter.read({method:x,path:"1/keys"},e)}},ct=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters"},e)}},ft=function(t){return function(e){return t.transporter.read({method:x,path:"1/indexes"},e)}},dt=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping"},e)}},lt=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"move",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},pt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:"1/indexes/*/batch",data:{requests:e}},r),(function(e,r){return Promise.all(Object.keys(e.taskID).map((function(n){return ut(t)(n,{methods:{waitTask:de}}).waitTask(e.taskID[n],r)})))}))}},ht=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:e}},r)}},mt=function(t){return function(e,n){var a=e.map((function(t){return r(r({},t),{},{params:E(t.params||{})})}));return t.transporter.read({method:j,path:"1/indexes/*/queries",data:{requests:a},cacheable:!0},n)}},yt=function(t){return function(e,a){return Promise.all(e.map((function(e){var o=e.params,i=o.facetName,u=o.facetQuery,s=n(o,["facetName","facetQuery"]);return ut(t)(e.indexName,{methods:{searchForFacetValues:ue}}).searchForFacetValues(i,u,r(r({},a),s))})))}},gt=function(t){return function(e,r){var n=y(r);return n.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:I,path:"1/clusters/mapping"},n)}},vt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},bt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/keys/%s/restore",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).catch((function(t){if(404!==t.status)throw t;return r()}))}))}))}},Pt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},wt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("/1/dictionaries/%s/search",e),data:{query:r},cacheable:!0},n)}},Ot=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/clusters/mapping/search",data:{query:e}},r)}},It=function(t){return function(e,r){return d(t.transporter.write({method:D,path:"/1/dictionaries/*/settings",data:e},r),(function(e,r){return jt(t)(e.taskID,r)}))}},xt=function(t){return function(e,r){var a=Object.assign({},r),o=r||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=i?{queryParameters:i}:{},c=["acl","indexes","referers","restrictSources","queryParameters","description","maxQueriesPerIPPerHour","maxHitsPerQuery"];return d(t.transporter.write({method:D,path:h("1/keys/%s",e),data:s},u),(function(r,n){return f((function(r){return tt(t)(e,n).then((function(t){return function(t){return Object.keys(a).filter((function(t){return-1!==c.indexOf(t)})).every((function(e){return t[e]===a[e]}))}(t)?Promise.resolve():r()}))}))}))}},jt=function(t){return function(e,r){return f((function(n){return et(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},Dt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/batch",t.indexName),data:{requests:e}},r),(function(e,r){return de(t)(e.taskID,r)}))}},qt=function(t){return function(e){return K(r(r({shouldStop:function(t){return void 0===t.cursor}},e),{},{request:function(r){return t.transporter.read({method:j,path:h("1/indexes/%s/browse",t.indexName),data:r},e)}}))}},St=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return se(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},kt=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return ce(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},Tt=function(t){return function(e,r,a){var o=a||{},i=o.batchSize,u=n(o,["batchSize"]),s={taskIDs:[],objectIDs:[]};return d(function n(){var a,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,c=[];for(a=o;a<e.length&&(c.push(e[a]),c.length!==(i||1e3));a++);return 0===c.length?Promise.resolve(s):Dt(t)(c.map((function(t){return{action:r,body:t}})),u).then((function(t){return s.objectIDs=s.objectIDs.concat(t.objectIDs),s.taskIDs.push(t.taskID),a++,n(a)}))}(),(function(e,r){return Promise.all(e.taskIDs.map((function(e){return de(t)(e,r)})))}))}},Nt=function(t){return function(e){return d(t.transporter.write({method:j,path:h("1/indexes/%s/clear",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Et=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},Rt=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},At=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/deleteByQuery",t.indexName),data:e},r),(function(e,r){return de(t)(e.taskID,r)}))}},Ct=function(t){return function(e){return d(t.transporter.write({method:I,path:h("1/indexes/%s",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Ut=function(t){return function(e,r){return d(zt(t)([e],r).then((function(t){return{taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},zt=function(t){return function(e,r){var n=e.map((function(t){return{objectID:t}}));return Tt(t)(n,le.DeleteObject,r)}},Jt=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/rules/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ft=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ht=function(t){return function(e){return Lt(t)(e).then((function(){return!0})).catch((function(t){if(404!==t.status)throw t;return!1}))}},Mt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/answers/%s/prediction",t.indexName),data:{query:e,queryLanguages:r},cacheable:!0},n)}},Kt=function(t){return function(e,o){var i=o||{},u=i.query,s=i.paginate,c=n(i,["query","paginate"]),f=0;return function n(){return ie(t)(u||"",r(r({},c),{},{page:f})).then((function(t){for(var r=0,o=Object.entries(t.hits);r<o.length;r++){var i=a(o[r],2),u=i[0],c=i[1];if(e(c))return{object:c,position:parseInt(u,10),page:f}}if(f++,!1===s||f>=t.nbPages)throw{name:"ObjectNotFoundError",message:"Object not found."};return n()}))}()}},Wt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/%s",t.indexName,e)},r)}},Bt=function(){return function(t,e){for(var r=0,n=Object.entries(t.hits);r<n.length;r++){var o=a(n[r],2),i=o[0];if(o[1].objectID===e)return parseInt(i,10)}return-1}},Qt=function(t){return function(e,a){var o=a||{},i=o.attributesToRetrieve,u=n(o,["attributesToRetrieve"]),s=e.map((function(e){return r({indexName:t.indexName,objectID:e},i?{attributesToRetrieve:i}:{})}));return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:s}},u)}},Gt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/rules/%s",t.indexName,e)},r)}},Lt=function(t){return function(e){return t.transporter.read({method:x,path:h("1/indexes/%s/settings",t.indexName),data:{getVersion:2}},e)}},Vt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},r)}},_t=function(t){return function(e,r){return d(Xt(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},Xt=function(t){return function(e,r){var a=r||{},o=a.createIfNotExists,i=n(a,["createIfNotExists"]),u=o?le.PartialUpdateObject:le.PartialUpdateObjectNoCreate;return Tt(t)(e,u,i)}},Yt=function(t){return function(e,i){var u=i||{},s=u.safe,c=u.autoGenerateObjectIDIfNotExist,f=u.batchSize,l=n(u,["safe","autoGenerateObjectIDIfNotExist","batchSize"]),p=function(e,r,n,a){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:n,destination:r}},a),(function(e,r){return de(t)(e.taskID,r)}))},m=Math.random().toString(36).substring(7),y="".concat(t.indexName,"_tmp_").concat(m),g=ee({appId:t.appId,transporter:t.transporter,indexName:y}),v=[],b=p(t.indexName,y,"copy",r(r({},l),{},{scope:["settings","synonyms","rules"]}));return v.push(b),d((s?b.wait(l):b).then((function(){var t=g(e,r(r({},l),{},{autoGenerateObjectIDIfNotExist:c,batchSize:f}));return v.push(t),s?t.wait(l):t})).then((function(){var e=p(y,t.indexName,"move",l);return v.push(e),s?e.wait(l):e})).then((function(){return Promise.all(v)})).then((function(t){var e=a(t,3),r=e[0],n=e[1],i=e[2];return{objectIDs:n.objectIDs,taskIDs:[r.taskID].concat(o(n.taskIDs),[i.taskID])}})),(function(t,e){return Promise.all(v.map((function(t){return t.wait(e)})))}))}},Zt=function(t){return function(e,n){return ne(t)(e,r(r({},n),{},{clearExistingRules:!0}))}},$t=function(t){return function(e,n){return oe(t)(e,r(r({},n),{},{clearExistingSynonyms:!0}))}},te=function(t){return function(e,r){return d(ee(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},ee=function(t){return function(e,r){var a=r||{},o=a.autoGenerateObjectIDIfNotExist,i=n(a,["autoGenerateObjectIDIfNotExist"]),u=o?le.AddObject:le.UpdateObject;if(u===le.UpdateObject){var s=!0,c=!1,f=void 0;try{for(var l,p=e[Symbol.iterator]();!(s=(l=p.next()).done);s=!0){if(void 0===l.value.objectID)return d(Promise.reject({name:"MissingObjectIDError",message:"All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."}))}}catch(t){c=!0,f=t}finally{try{s||null==p.return||p.return()}finally{if(c)throw f}}}return Tt(t)(e,u,i)}},re=function(t){return function(e,r){return ne(t)([e],r)}},ne=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingRules,u=y(n(a,["forwardToReplicas","clearExistingRules"]));return o&&(u.queryParameters.forwardToReplicas=1),i&&(u.queryParameters.clearExistingRules=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/batch",t.indexName),data:e},u),(function(e,r){return de(t)(e.taskID,r)}))}},ae=function(t){return function(e,r){return oe(t)([e],r)}},oe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingSynonyms,u=a.replaceExistingSynonyms,s=y(n(a,["forwardToReplicas","clearExistingSynonyms","replaceExistingSynonyms"]));return o&&(s.queryParameters.forwardToReplicas=1),(u||i)&&(s.queryParameters.replaceExistingSynonyms=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/batch",t.indexName),data:e},s),(function(e,r){return de(t)(e.taskID,r)}))}},ie=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/query",t.indexName),data:{query:e},cacheable:!0},r)}},ue=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/indexes/%s/facets/%s/query",t.indexName,e),data:{facetQuery:r},cacheable:!0},n)}},se=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/rules/search",t.indexName),data:{query:e}},r)}},ce=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/synonyms/search",t.indexName),data:{query:e}},r)}},fe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:D,path:h("1/indexes/%s/settings",t.indexName),data:e},i),(function(e,r){return de(t)(e.taskID,r)}))}},de=function(t){return function(e,r){return f((function(n){return function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/task/%s",t.indexName,e.toString())},r)}}(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},le={AddObject:"addObject",UpdateObject:"updateObject",PartialUpdateObject:"partialUpdateObject",PartialUpdateObjectNoCreate:"partialUpdateObjectNoCreate",DeleteObject:"deleteObject",DeleteIndex:"delete",ClearIndex:"clear"},pe={Settings:"settings",Synonyms:"synonyms",Rules:"rules"},he=1,me=2,ye=3;function ge(t,e,n){var a,o={appId:t,apiKey:e,timeouts:{connect:1,read:2,write:30},requester:{send:function(t){return new Promise((function(e){var r=new XMLHttpRequest;r.open(t.method,t.url,!0),Object.keys(t.headers).forEach((function(e){return r.setRequestHeader(e,t.headers[e])}));var n,a=function(t,n){return setTimeout((function(){r.abort(),e({status:0,content:n,isTimedOut:!0})}),1e3*t)},o=a(t.connectTimeout,"Connection timeout");r.onreadystatechange=function(){r.readyState>r.OPENED&&void 0===n&&(clearTimeout(o),n=a(t.responseTimeout,"Socket timeout"))},r.onerror=function(){0===r.status&&(clearTimeout(o),clearTimeout(n),e({content:r.responseText||"Network request failed",status:r.status,isTimedOut:!1}))},r.onload=function(){clearTimeout(o),clearTimeout(n),e({content:r.responseText,status:r.status,isTimedOut:!1})},r.send(t.data)}))}},logger:(a=ye,{debug:function(t,e){return he>=a&&console.debug(t,e),Promise.resolve()},info:function(t,e){return me>=a&&console.info(t,e),Promise.resolve()},error:function(t,e){return console.error(t,e),Promise.resolve()}}),responsesCache:s(),requestsCache:s({serializable:!1}),hostsCache:u({caches:[i({key:"".concat("4.13.1","-").concat(t)}),s()]}),userAgent:T("4.13.1").add({segment:"Browser"})},f=r(r({},o),n),d=function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"personalization.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{getPersonalizationStrategy:H,setPersonalizationStrategy:M}}))}};return function(t){var e=t.appId,n=c(void 0!==t.authMode?t.authMode:m.WithinHeaders,e,t.apiKey),a=k(r(r({hosts:[{url:"".concat(e,"-dsn.algolia.net"),accept:g.Read},{url:"".concat(e,".algolia.net"),accept:g.Write}].concat(l([{url:"".concat(e,"-1.algolianet.com")},{url:"".concat(e,"-2.algolianet.com")},{url:"".concat(e,"-3.algolianet.com")}]))},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/x-www-form-urlencoded"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({transporter:a,appId:e,addAlgoliaAgent:function(t,e){a.userAgent.add({segment:t,version:e})},clearCache:function(){return Promise.all([a.requestsCache.clear(),a.responsesCache.clear()]).then((function(){}))}},t.methods)}(r(r({},f),{},{methods:{search:mt,searchForFacetValues:yt,multipleBatch:pt,multipleGetObjects:ht,multipleQueries:mt,copyIndex:L,copySettings:_,copySynonyms:X,copyRules:V,moveIndex:lt,listIndices:ft,getLogs:nt,listClusters:ct,multipleSearchForFacetValues:yt,getApiKey:tt,addApiKey:W,listApiKeys:st,updateApiKey:xt,deleteApiKey:Z,restoreApiKey:bt,assignUserID:B,assignUserIDs:Q,getUserID:ot,searchUserIDs:Ot,listUserIDs:dt,getTopUserIDs:at,removeUserID:gt,hasPendingMappings:it,clearDictionaryEntries:G,deleteDictionaryEntries:$,getDictionarySettings:rt,getAppTask:et,replaceDictionaryEntries:vt,saveDictionaryEntries:Pt,searchDictionaryEntries:wt,setDictionarySettings:It,waitAppTask:jt,customRequest:Y,initIndex:function(t){return function(e){return ut(t)(e,{methods:{batch:Dt,delete:Ct,findAnswers:Mt,getObject:Wt,getObjects:Qt,saveObject:te,saveObjects:ee,search:ie,searchForFacetValues:ue,waitTask:de,setSettings:fe,getSettings:Lt,partialUpdateObject:_t,partialUpdateObjects:Xt,deleteObject:Ut,deleteObjects:zt,deleteBy:At,clearObjects:Nt,browseObjects:qt,getObjectPosition:Bt,findObject:Kt,exists:Ht,saveSynonym:ae,saveSynonyms:oe,getSynonym:Vt,searchSynonyms:ce,browseSynonyms:kt,deleteSynonym:Ft,clearSynonyms:Rt,replaceAllObjects:Yt,replaceAllSynonyms:$t,searchRules:se,getRule:Gt,deleteRule:Jt,saveRule:re,saveRules:ne,replaceAllRules:Zt,browseRules:St,clearRules:Et}})}},initAnalytics:function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"analytics.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{addABTest:C,getABTest:z,getABTests:J,stopABTest:F,deleteABTest:U}}))}},initPersonalization:d,initRecommendation:function(){return function(t){return f.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."),d()(t)}}}}))}return ge.version="4.13.1",ge}));


/***/ }),

/***/ 46403:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var digitCharacters = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "#",
    "$",
    "%",
    "*",
    "+",
    ",",
    "-",
    ".",
    ":",
    ";",
    "=",
    "?",
    "@",
    "[",
    "]",
    "^",
    "_",
    "{",
    "|",
    "}",
    "~"
];
exports.decode83 = function (str) {
    var value = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str[i];
        var digit = digitCharacters.indexOf(c);
        value = value * 83 + digit;
    }
    return value;
};
exports.encode83 = function (n, length) {
    var result = "";
    for (var i = 1; i <= length; i++) {
        var digit = (Math.floor(n) / Math.pow(83, length - i)) % 83;
        result += digitCharacters[Math.floor(digit)];
    }
    return result;
};
//# sourceMappingURL=base83.js.map

/***/ }),

/***/ 59055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var base83_1 = __webpack_require__(46403);
var utils_1 = __webpack_require__(53096);
var error_1 = __webpack_require__(50795);
/**
 * Returns an error message if invalid or undefined if valid
 * @param blurhash
 */
var validateBlurhash = function (blurhash) {
    if (!blurhash || blurhash.length < 6) {
        throw new error_1.ValidationError("The blurhash string must be at least 6 characters");
    }
    var sizeFlag = base83_1.decode83(blurhash[0]);
    var numY = Math.floor(sizeFlag / 9) + 1;
    var numX = (sizeFlag % 9) + 1;
    if (blurhash.length !== 4 + 2 * numX * numY) {
        throw new error_1.ValidationError("blurhash length mismatch: length is " + blurhash.length + " but it should be " + (4 + 2 * numX * numY));
    }
};
exports.isBlurhashValid = function (blurhash) {
    try {
        validateBlurhash(blurhash);
    }
    catch (error) {
        return { result: false, errorReason: error.message };
    }
    return { result: true };
};
var decodeDC = function (value) {
    var intR = value >> 16;
    var intG = (value >> 8) & 255;
    var intB = value & 255;
    return [utils_1.sRGBToLinear(intR), utils_1.sRGBToLinear(intG), utils_1.sRGBToLinear(intB)];
};
var decodeAC = function (value, maximumValue) {
    var quantR = Math.floor(value / (19 * 19));
    var quantG = Math.floor(value / 19) % 19;
    var quantB = value % 19;
    var rgb = [
        utils_1.signPow((quantR - 9) / 9, 2.0) * maximumValue,
        utils_1.signPow((quantG - 9) / 9, 2.0) * maximumValue,
        utils_1.signPow((quantB - 9) / 9, 2.0) * maximumValue
    ];
    return rgb;
};
var decode = function (blurhash, width, height, punch) {
    validateBlurhash(blurhash);
    punch = punch | 1;
    var sizeFlag = base83_1.decode83(blurhash[0]);
    var numY = Math.floor(sizeFlag / 9) + 1;
    var numX = (sizeFlag % 9) + 1;
    var quantisedMaximumValue = base83_1.decode83(blurhash[1]);
    var maximumValue = (quantisedMaximumValue + 1) / 166;
    var colors = new Array(numX * numY);
    for (var i = 0; i < colors.length; i++) {
        if (i === 0) {
            var value = base83_1.decode83(blurhash.substring(2, 6));
            colors[i] = decodeDC(value);
        }
        else {
            var value = base83_1.decode83(blurhash.substring(4 + i * 2, 6 + i * 2));
            colors[i] = decodeAC(value, maximumValue * punch);
        }
    }
    var bytesPerRow = width * 4;
    var pixels = new Uint8ClampedArray(bytesPerRow * height);
    for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
            var r = 0;
            var g = 0;
            var b = 0;
            for (var j = 0; j < numY; j++) {
                for (var i = 0; i < numX; i++) {
                    var basis = Math.cos((Math.PI * x * i) / width) *
                        Math.cos((Math.PI * y * j) / height);
                    var color = colors[i + j * numX];
                    r += color[0] * basis;
                    g += color[1] * basis;
                    b += color[2] * basis;
                }
            }
            var intR = utils_1.linearTosRGB(r);
            var intG = utils_1.linearTosRGB(g);
            var intB = utils_1.linearTosRGB(b);
            pixels[4 * x + 0 + y * bytesPerRow] = intR;
            pixels[4 * x + 1 + y * bytesPerRow] = intG;
            pixels[4 * x + 2 + y * bytesPerRow] = intB;
            pixels[4 * x + 3 + y * bytesPerRow] = 255; // alpha
        }
    }
    return pixels;
};
exports["default"] = decode;
//# sourceMappingURL=decode.js.map

/***/ }),

/***/ 1796:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var base83_1 = __webpack_require__(46403);
var utils_1 = __webpack_require__(53096);
var error_1 = __webpack_require__(50795);
var bytesPerPixel = 4;
var multiplyBasisFunction = function (pixels, width, height, basisFunction) {
    var r = 0;
    var g = 0;
    var b = 0;
    var bytesPerRow = width * bytesPerPixel;
    for (var x = 0; x < width; x++) {
        for (var y = 0; y < height; y++) {
            var basis = basisFunction(x, y);
            r +=
                basis * utils_1.sRGBToLinear(pixels[bytesPerPixel * x + 0 + y * bytesPerRow]);
            g +=
                basis * utils_1.sRGBToLinear(pixels[bytesPerPixel * x + 1 + y * bytesPerRow]);
            b +=
                basis * utils_1.sRGBToLinear(pixels[bytesPerPixel * x + 2 + y * bytesPerRow]);
        }
    }
    var scale = 1 / (width * height);
    return [r * scale, g * scale, b * scale];
};
var encodeDC = function (value) {
    var roundedR = utils_1.linearTosRGB(value[0]);
    var roundedG = utils_1.linearTosRGB(value[1]);
    var roundedB = utils_1.linearTosRGB(value[2]);
    return (roundedR << 16) + (roundedG << 8) + roundedB;
};
var encodeAC = function (value, maximumValue) {
    var quantR = Math.floor(Math.max(0, Math.min(18, Math.floor(utils_1.signPow(value[0] / maximumValue, 0.5) * 9 + 9.5))));
    var quantG = Math.floor(Math.max(0, Math.min(18, Math.floor(utils_1.signPow(value[1] / maximumValue, 0.5) * 9 + 9.5))));
    var quantB = Math.floor(Math.max(0, Math.min(18, Math.floor(utils_1.signPow(value[2] / maximumValue, 0.5) * 9 + 9.5))));
    return quantR * 19 * 19 + quantG * 19 + quantB;
};
var encode = function (pixels, width, height, componentX, componentY) {
    if (componentX < 1 || componentX > 9 || componentY < 1 || componentY > 9) {
        throw new error_1.ValidationError("BlurHash must have between 1 and 9 components");
    }
    if (width * height * 4 !== pixels.length) {
        throw new error_1.ValidationError("Width and height must match the pixels array");
    }
    var factors = [];
    var _loop_1 = function (y) {
        var _loop_2 = function (x) {
            var normalisation = x == 0 && y == 0 ? 1 : 2;
            var factor = multiplyBasisFunction(pixels, width, height, function (i, j) {
                return normalisation *
                    Math.cos((Math.PI * x * i) / width) *
                    Math.cos((Math.PI * y * j) / height);
            });
            factors.push(factor);
        };
        for (var x = 0; x < componentX; x++) {
            _loop_2(x);
        }
    };
    for (var y = 0; y < componentY; y++) {
        _loop_1(y);
    }
    var dc = factors[0];
    var ac = factors.slice(1);
    var hash = "";
    var sizeFlag = componentX - 1 + (componentY - 1) * 9;
    hash += base83_1.encode83(sizeFlag, 1);
    var maximumValue;
    if (ac.length > 0) {
        var actualMaximumValue = Math.max.apply(Math, ac.map(function (val) { return Math.max.apply(Math, val); }));
        var quantisedMaximumValue = Math.floor(Math.max(0, Math.min(82, Math.floor(actualMaximumValue * 166 - 0.5))));
        maximumValue = (quantisedMaximumValue + 1) / 166;
        hash += base83_1.encode83(quantisedMaximumValue, 1);
    }
    else {
        maximumValue = 1;
        hash += base83_1.encode83(0, 1);
    }
    hash += base83_1.encode83(encodeDC(dc), 4);
    ac.forEach(function (factor) {
        hash += base83_1.encode83(encodeAC(factor, maximumValue), 2);
    });
    return hash;
};
exports["default"] = encode;
//# sourceMappingURL=encode.js.map

/***/ }),

/***/ 50795:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "ValidationError";
        _this.message = message;
        return _this;
    }
    return ValidationError;
}(Error));
exports.ValidationError = ValidationError;
//# sourceMappingURL=error.js.map

/***/ }),

/***/ 13060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
var decode_1 = __webpack_require__(59055);
exports.decode = decode_1.default;
exports.isBlurhashValid = decode_1.isBlurhashValid;
var encode_1 = __webpack_require__(1796);
exports.encode = encode_1.default;
__export(__webpack_require__(50795));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 53096:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sRGBToLinear = function (value) {
    var v = value / 255;
    if (v <= 0.04045) {
        return v / 12.92;
    }
    else {
        return Math.pow((v + 0.055) / 1.055, 2.4);
    }
};
exports.linearTosRGB = function (value) {
    var v = Math.max(0, Math.min(1, value));
    if (v <= 0.0031308) {
        return Math.round(v * 12.92 * 255 + 0.5);
    }
    else {
        return Math.round((1.055 * Math.pow(v, 1 / 2.4) - 0.055) * 255 + 0.5);
    }
};
exports.sign = function (n) { return (n < 0 ? -1 : 1); };
exports.signPow = function (val, exp) {
    return exports.sign(val) * Math.pow(Math.abs(val), exp);
};
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 46138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(99960);
var entities = __webpack_require__(45863);

/* mixed-case SVG and MathML tags & attributes
   recognized by the HTML parser, see
   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
*/
var foreignNames = __webpack_require__(69933);
foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
foreignNames.attributeNames.__proto__ = null;

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '';
  var value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    if (opts.xmlMode === 'foreign') {
      /* fix up mixed-case attribute names */
      key = foreignNames.attributeNames[key] || key;
    }
    output += key;
    if ((value !== null && value !== '') || opts.xmlMode) {
      output +=
        '="' +
        (opts.decodeEntities
          ? entities.encodeXML(value)
          : value.replace(/\"/g, '&quot;')) +
        '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
};

var render = (module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for (var i = 0; i < dom.length; i++) {
    var elem = dom[i];

    if (elem.type === 'root') output += render(elem.children, opts);
    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment) output += renderComment(elem);
    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
    else output += renderText(elem, opts);
  }

  return output;
});

var foreignModeIntegrationPoints = [
  'mi',
  'mo',
  'mn',
  'ms',
  'mtext',
  'annotation-xml',
  'foreignObject',
  'desc',
  'title'
];

function renderTag(elem, opts) {
  // Handle SVG / MathML in HTML
  if (opts.xmlMode === 'foreign') {
    /* fix up mixed-case element names */
    elem.name = foreignNames.elementNames[elem.name] || elem.name;
    /* exit foreign mode at integration points */
    if (
      elem.parent &&
      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
    )
      opts = Object.assign({}, opts, { xmlMode: false });
  }
  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
  }

  var tag = '<' + elem.name;
  var attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (
    opts.decodeEntities &&
    !(elem.parent && elem.parent.name in unencodedElements)
  ) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}


/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 2.3.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.5/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, function () { 'use strict';

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);

  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);

  var regExpTest = unapply(RegExp.prototype.test);

  var typeErrorCreate = unconstruct(TypeError);

  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }

  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array) {
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = stringToLowerCase(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);

    var property = void 0;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);

  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);

  var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);

  var text = freeze(['#text']);

  var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);

  var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

  var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html$$1) {
          return html$$1;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.3.5';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;

      return DOMPurify;
    }

    var originalDocument = window.document;

    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;


    var ElementPrototype = Element.prototype;

    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';

    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;


    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;

    var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
        ERB_EXPR$$1 = ERB_EXPR,
        DATA_ATTR$$1 = DATA_ATTR,
        ARIA_ATTR$$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);

    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE = void 0;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc = void 0;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function (x) {
        return x;
      } : stringToLowerCase;

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html);
          addToSet(ALLOWED_ATTR, html$1);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl);
          addToSet(ALLOWED_ATTR, mathMl$1);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);

    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);

    var ALL_MATHML_TAGS = addToSet({}, mathMl);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: HTML_NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erronously deleted from
        // HTML namespace.
        var commonSvgAndHTMLElements = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG or MathML). Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc = void 0;
      var leadingWhitespace = void 0;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function');
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content = void 0;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }

        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
        content = stringReplace(content, ERB_EXPR$$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };

    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */
    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr = void 0;
      var value = void 0;
      var lcName = void 0;
      var l = void 0;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;

        value = stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
          value = stringReplace(value, ERB_EXPR$$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode = void 0;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty, cfg) {
      var body = void 0;
      var importedNode = void 0;
      var currentNode = void 0;
      var oldNode = void 0;
      var returnNode = void 0;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 12417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DomUtils = module.exports;

[
	__webpack_require__(43346),
	__webpack_require__(85010),
	__webpack_require__(26765),
	__webpack_require__(98043),
	__webpack_require__(23905),
	__webpack_require__(74975)
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});


/***/ }),

/***/ 74975:
/***/ (function(__unused_webpack_module, exports) {

// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};


/***/ }),

/***/ 23905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var ElementType = __webpack_require__(12386);
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};


/***/ }),

/***/ 26765:
/***/ (function(__unused_webpack_module, exports) {

exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};




/***/ }),

/***/ 98043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isTag = (__webpack_require__(12386).isTag);

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = rootElems.slice();
	while(stack.length){
		var elem = stack.shift();
		if(!isTag(elem)) continue;
		if (elem.children && elem.children.length > 0) {
			stack.unshift.apply(stack, elem.children);
		}
		if(test(elem)) result.push(elem);
	}
	return result;
}


/***/ }),

/***/ 43346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ElementType = __webpack_require__(12386),
    getOuterHTML = __webpack_require__(46138),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}


/***/ }),

/***/ 85010:
/***/ (function(__unused_webpack_module, exports) {

var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};


/***/ }),

/***/ 12386:
/***/ (function(module) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),

/***/ 83999:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
exports.validate = function(email)
{
	if (!email)
		return false;
		
	if(email.length>254)
		return false;

	var valid = tester.test(email);
	if(!valid)
		return false;

	// Further checking of some things regex can't handle
	var parts = email.split("@");
	if(parts[0].length>64)
		return false;

	var domainParts = parts[1].split(".");
	if(domainParts.some(function(part) { return part.length>63; }))
		return false;

	return true;
}

/***/ }),

/***/ 44076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
var entities_json_1 = __importDefault(__webpack_require__(59323));
var legacy_json_1 = __importDefault(__webpack_require__(29591));
var xml_json_1 = __importDefault(__webpack_require__(2586));
var decode_codepoint_1 = __importDefault(__webpack_require__(26));
var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
exports.decodeXML = getStrictDecoder(xml_json_1.default);
exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
function getStrictDecoder(map) {
    var replace = getReplacer(map);
    return function (str) { return String(str).replace(strictEntityRe, replace); };
}
var sorter = function (a, b) { return (a < b ? 1 : -1); };
exports.decodeHTML = (function () {
    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
    var keys = Object.keys(entities_json_1.default).sort(sorter);
    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        }
        else {
            keys[i] += ";";
        }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";")
            str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function (str) { return String(str).replace(re, replacer); };
})();
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") {
                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
            }
            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}


/***/ }),

/***/ 26:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var decode_json_1 = __importDefault(__webpack_require__(33600));
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
    }
    return fromCodePoint(codePoint);
}
exports["default"] = decodeCodePoint;


/***/ }),

/***/ 87322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
var xml_json_1 = __importDefault(__webpack_require__(2586));
var inverseXML = getInverseObj(xml_json_1.default);
var xmlReplacer = getInverseReplacer(inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeXML = getASCIIEncoder(inverseXML);
var entities_json_1 = __importDefault(__webpack_require__(59323));
var inverseHTML = getInverseObj(entities_json_1.default);
var htmlReplacer = getInverseReplacer(inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
        var k = _a[_i];
        if (k.length === 1) {
            // Add value to single array
            single.push("\\" + k);
        }
        else {
            // Add value to multiple array
            multiple.push(k);
        }
    }
    // Add ranges to single characters.
    single.sort();
    for (var start = 0; start < single.length - 1; start++) {
        // Find the end of a run of characters
        var end = start;
        while (end < single.length - 1 &&
            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
            end += 1;
        }
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3)
            continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var getCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        function (str) { return str.codePointAt(0); }
    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        function (c) {
            return (c.charCodeAt(0) - 0xd800) * 0x400 +
                c.charCodeAt(1) -
                0xdc00 +
                0x10000;
        };
function singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
        .toString(16)
        .toUpperCase() + ";";
}
function getInverse(inverse, re) {
    return function (data) {
        return data
            .replace(re, function (name) { return inverse[name]; })
            .replace(reNonASCII, singleCharReplacer);
    };
}
var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
function escape(data) {
    return data.replace(reEscapeChars, singleCharReplacer);
}
exports.escape = escape;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
function escapeUTF8(data) {
    return data.replace(xmlReplacer, singleCharReplacer);
}
exports.escapeUTF8 = escapeUTF8;
function getASCIIEncoder(obj) {
    return function (data) {
        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
    };
}


/***/ }),

/***/ 45863:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
var decode_1 = __webpack_require__(44076);
var encode_1 = __webpack_require__(87322);
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */
function decode(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
}
exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */
function decodeStrict(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */
function encode(data, level) {
    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
}
exports.encode = encode;
var encode_2 = __webpack_require__(87322);
Object.defineProperty(exports, "encodeXML", ({ enumerable: true, get: function () { return encode_2.encodeXML; } }));
Object.defineProperty(exports, "encodeHTML", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
Object.defineProperty(exports, "encodeNonAsciiHTML", ({ enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } }));
Object.defineProperty(exports, "escape", ({ enumerable: true, get: function () { return encode_2.escape; } }));
Object.defineProperty(exports, "escapeUTF8", ({ enumerable: true, get: function () { return encode_2.escapeUTF8; } }));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "encodeHTML4", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
Object.defineProperty(exports, "encodeHTML5", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
var decode_2 = __webpack_require__(44076);
Object.defineProperty(exports, "decodeXML", ({ enumerable: true, get: function () { return decode_2.decodeXML; } }));
Object.defineProperty(exports, "decodeHTML", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTMLStrict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "decodeHTML4", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTML5", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTML4Strict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
Object.defineProperty(exports, "decodeHTML5Strict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
Object.defineProperty(exports, "decodeXMLStrict", ({ enumerable: true, get: function () { return decode_2.decodeXML; } }));


/***/ }),

/***/ 58875:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 95449:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = CollectingHandler;

function CollectingHandler(cbs) {
    this._cbs = cbs || {};
    this.events = [];
}

var EVENTS = (__webpack_require__(23719).EVENTS);
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function() {
            this.events.push([name]);
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a) {
            this.events.push([name, a]);
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a, b) {
            this.events.push([name, a, b]);
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});

CollectingHandler.prototype.onreset = function() {
    this.events = [];
    if (this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function() {
    if (this._cbs.onreset) this._cbs.onreset();

    for (var i = 0, len = this.events.length; i < len; i++) {
        if (this._cbs[this.events[i][0]]) {
            var num = this.events[i].length;

            if (num === 1) {
                this._cbs[this.events[i][0]]();
            } else if (num === 2) {
                this._cbs[this.events[i][0]](this.events[i][1]);
            } else {
                this._cbs[this.events[i][0]](
                    this.events[i][1],
                    this.events[i][2]
                );
            }
        }
    }
};


/***/ }),

/***/ 63870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DomHandler = __webpack_require__(29730);
var DomUtils = __webpack_require__(12417);

//TODO: make this a streamable handler
function FeedHandler(callback, options) {
    this.init(callback, options);
}

__webpack_require__(35717)(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where) {
    return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where) {
    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse) {
    return DomUtils.getText(
        DomUtils.getElementsByTagName(what, where, recurse, 1)
    ).trim();
}

function addConditionally(obj, prop, what, where, recurse) {
    var tmp = fetch(what, where, recurse);
    if (tmp) obj[prop] = tmp;
}

var isValidFeed = function(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function() {
    var feed = {},
        feedRoot = getOneElement(isValidFeed, this.dom),
        tmp,
        childs;

    if (feedRoot) {
        if (feedRoot.name === "feed") {
            childs = feedRoot.children;

            feed.type = "atom";
            addConditionally(feed, "id", "id", childs);
            addConditionally(feed, "title", "title", childs);
            if (
                (tmp = getOneElement("link", childs)) &&
                (tmp = tmp.attribs) &&
                (tmp = tmp.href)
            )
                feed.link = tmp;
            addConditionally(feed, "description", "subtitle", childs);
            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
            addConditionally(feed, "author", "email", childs, true);

            feed.items = getElements("entry", childs).map(function(item) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "id", item);
                addConditionally(entry, "title", "title", item);
                if (
                    (tmp = getOneElement("link", item)) &&
                    (tmp = tmp.attribs) &&
                    (tmp = tmp.href)
                )
                    entry.link = tmp;
                if ((tmp = fetch("summary", item) || fetch("content", item)))
                    entry.description = tmp;
                if ((tmp = fetch("updated", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        } else {
            childs = getOneElement("channel", feedRoot.children).children;

            feed.type = feedRoot.name.substr(0, 3);
            feed.id = "";
            addConditionally(feed, "title", "title", childs);
            addConditionally(feed, "link", "link", childs);
            addConditionally(feed, "description", "description", childs);
            if ((tmp = fetch("lastBuildDate", childs)))
                feed.updated = new Date(tmp);
            addConditionally(feed, "author", "managingEditor", childs, true);

            feed.items = getElements("item", feedRoot.children).map(function(
                item
            ) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "guid", item);
                addConditionally(entry, "title", "title", item);
                addConditionally(entry, "link", "link", item);
                addConditionally(entry, "description", "description", item);
                if ((tmp = fetch("pubDate", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        }
    }
    this.dom = feed;
    DomHandler.prototype._handleCallback.call(
        this,
        feedRoot ? null : Error("couldn't find root of feed")
    );
};

module.exports = FeedHandler;


/***/ }),

/***/ 50763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Tokenizer = __webpack_require__(39889);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
    input: true,
    option: true,
    optgroup: true,
    select: true,
    button: true,
    datalist: true,
    textarea: true
};

var openImpliesClose = {
    tr: { tr: true, th: true, td: true },
    th: { th: true },
    td: { thead: true, th: true, td: true },
    body: { head: true, link: true, script: true },
    li: { li: true },
    p: { p: true },
    h1: { p: true },
    h2: { p: true },
    h3: { p: true },
    h4: { p: true },
    h5: { p: true },
    h6: { p: true },
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: { option: true },
    optgroup: { optgroup: true }
};

var voidElements = {
    __proto__: null,
    area: true,
    base: true,
    basefont: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    isindex: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};

var foreignContextElements = {
    __proto__: null,
    math: true,
    svg: true
};
var htmlIntegrationElements = {
    __proto__: null,
    mi: true,
    mo: true,
    mn: true,
    ms: true,
    mtext: true,
    "annotation-xml": true,
    foreignObject: true,
    desc: true,
    title: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options) {
    this._options = options || {};
    this._cbs = cbs || {};

    this._tagname = "";
    this._attribname = "";
    this._attribvalue = "";
    this._attribs = null;
    this._stack = [];
    this._foreignContext = [];

    this.startIndex = 0;
    this.endIndex = null;

    this._lowerCaseTagNames =
        "lowerCaseTags" in this._options
            ? !!this._options.lowerCaseTags
            : !this._options.xmlMode;
    this._lowerCaseAttributeNames =
        "lowerCaseAttributeNames" in this._options
            ? !!this._options.lowerCaseAttributeNames
            : !this._options.xmlMode;

    if (this._options.Tokenizer) {
        Tokenizer = this._options.Tokenizer;
    }
    this._tokenizer = new Tokenizer(this._options, this);

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(35717)(Parser, (__webpack_require__(17187).EventEmitter));

Parser.prototype._updatePosition = function(initialOffset) {
    if (this.endIndex === null) {
        if (this._tokenizer._sectionStart <= initialOffset) {
            this.startIndex = 0;
        } else {
            this.startIndex = this._tokenizer._sectionStart - initialOffset;
        }
    } else this.startIndex = this.endIndex + 1;
    this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data) {
    this._updatePosition(1);
    this.endIndex--;

    if (this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name) {
    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    this._tagname = name;

    if (!this._options.xmlMode && name in openImpliesClose) {
        for (
            var el;
            (el = this._stack[this._stack.length - 1]) in
            openImpliesClose[name];
            this.onclosetag(el)
        );
    }

    if (this._options.xmlMode || !(name in voidElements)) {
        this._stack.push(name);
        if (name in foreignContextElements) this._foreignContext.push(true);
        else if (name in htmlIntegrationElements)
            this._foreignContext.push(false);
    }

    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
    if (this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function() {
    this._updatePosition(1);

    if (this._attribs) {
        if (this._cbs.onopentag)
            this._cbs.onopentag(this._tagname, this._attribs);
        this._attribs = null;
    }

    if (
        !this._options.xmlMode &&
        this._cbs.onclosetag &&
        this._tagname in voidElements
    ) {
        this._cbs.onclosetag(this._tagname);
    }

    this._tagname = "";
};

Parser.prototype.onclosetag = function(name) {
    this._updatePosition(1);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }
    
    if (name in foreignContextElements || name in htmlIntegrationElements) {
        this._foreignContext.pop();
    }

    if (
        this._stack.length &&
        (!(name in voidElements) || this._options.xmlMode)
    ) {
        var pos = this._stack.lastIndexOf(name);
        if (pos !== -1) {
            if (this._cbs.onclosetag) {
                pos = this._stack.length - pos;
                while (pos--) this._cbs.onclosetag(this._stack.pop());
            } else this._stack.length = pos;
        } else if (name === "p" && !this._options.xmlMode) {
            this.onopentagname(name);
            this._closeCurrentTag();
        }
    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
        this.onopentagname(name);
        this._closeCurrentTag();
    }
};

Parser.prototype.onselfclosingtag = function() {
    if (
        this._options.xmlMode ||
        this._options.recognizeSelfClosing ||
        this._foreignContext[this._foreignContext.length - 1]
    ) {
        this._closeCurrentTag();
    } else {
        this.onopentagend();
    }
};

Parser.prototype._closeCurrentTag = function() {
    var name = this._tagname;

    this.onopentagend();

    //self-closing tags will be on the top of the stack
    //(cheaper check than in onclosetag)
    if (this._stack[this._stack.length - 1] === name) {
        if (this._cbs.onclosetag) {
            this._cbs.onclosetag(name);
        }
        this._stack.pop();
        
    }
};

Parser.prototype.onattribname = function(name) {
    if (this._lowerCaseAttributeNames) {
        name = name.toLowerCase();
    }
    this._attribname = name;
};

Parser.prototype.onattribdata = function(value) {
    this._attribvalue += value;
};

Parser.prototype.onattribend = function() {
    if (this._cbs.onattribute)
        this._cbs.onattribute(this._attribname, this._attribvalue);
    if (
        this._attribs &&
        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
    ) {
        this._attribs[this._attribname] = this._attribvalue;
    }
    this._attribname = "";
    this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value) {
    var idx = value.search(re_nameEnd),
        name = idx < 0 ? value : value.substr(0, idx);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    return name;
};

Parser.prototype.ondeclaration = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("!" + name, "!" + value);
    }
};

Parser.prototype.onprocessinginstruction = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("?" + name, "?" + value);
    }
};

Parser.prototype.oncomment = function(value) {
    this._updatePosition(4);

    if (this._cbs.oncomment) this._cbs.oncomment(value);
    if (this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value) {
    this._updatePosition(1);

    if (this._options.xmlMode || this._options.recognizeCDATA) {
        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
        if (this._cbs.ontext) this._cbs.ontext(value);
        if (this._cbs.oncdataend) this._cbs.oncdataend();
    } else {
        this.oncomment("[CDATA[" + value + "]]");
    }
};

Parser.prototype.onerror = function(err) {
    if (this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function() {
    if (this._cbs.onclosetag) {
        for (
            var i = this._stack.length;
            i > 0;
            this._cbs.onclosetag(this._stack[--i])
        );
    }
    if (this._cbs.onend) this._cbs.onend();
};

//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function() {
    if (this._cbs.onreset) this._cbs.onreset();
    this._tokenizer.reset();

    this._tagname = "";
    this._attribname = "";
    this._attribs = null;
    this._stack = [];

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data) {
    this.reset();
    this.end(data);
};

Parser.prototype.write = function(chunk) {
    this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk) {
    this._tokenizer.end(chunk);
};

Parser.prototype.pause = function() {
    this._tokenizer.pause();
};

Parser.prototype.resume = function() {
    this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),

/***/ 76321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = ProxyHandler;

function ProxyHandler(cbs) {
    this._cbs = cbs || {};
}

var EVENTS = (__webpack_require__(23719).EVENTS);
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function() {
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a) {
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a, b) {
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});


/***/ }),

/***/ 89924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(83621);

function Stream(options) {
    Parser.call(this, new Cbs(this), options);
}

__webpack_require__(35717)(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope) {
    this.scope = scope;
}

var EVENTS = (__webpack_require__(23719).EVENTS);

Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        Cbs.prototype["on" + name] = function() {
            this.scope.emit(name);
        };
    } else if (EVENTS[name] === 1) {
        Cbs.prototype["on" + name] = function(a) {
            this.scope.emit(name, a);
        };
    } else if (EVENTS[name] === 2) {
        Cbs.prototype["on" + name] = function(a, b) {
            this.scope.emit(name, a, b);
        };
    } else {
        throw Error("wrong number of arguments!");
    }
});


/***/ }),

/***/ 39889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(58894);
var entityMap = __webpack_require__(23042);
var legacyMap = __webpack_require__(60317);
var xmlMap = __webpack_require__(51373);

var i = 0;

var TEXT = i++;
var BEFORE_TAG_NAME = i++; //after <
var IN_TAG_NAME = i++;
var IN_SELF_CLOSING_TAG = i++;
var BEFORE_CLOSING_TAG_NAME = i++;
var IN_CLOSING_TAG_NAME = i++;
var AFTER_CLOSING_TAG_NAME = i++;

//attributes
var BEFORE_ATTRIBUTE_NAME = i++;
var IN_ATTRIBUTE_NAME = i++;
var AFTER_ATTRIBUTE_NAME = i++;
var BEFORE_ATTRIBUTE_VALUE = i++;
var IN_ATTRIBUTE_VALUE_DQ = i++; // "
var IN_ATTRIBUTE_VALUE_SQ = i++; // '
var IN_ATTRIBUTE_VALUE_NQ = i++;

//declarations
var BEFORE_DECLARATION = i++; // !
var IN_DECLARATION = i++;

//processing instructions
var IN_PROCESSING_INSTRUCTION = i++; // ?

//comments
var BEFORE_COMMENT = i++;
var IN_COMMENT = i++;
var AFTER_COMMENT_1 = i++;
var AFTER_COMMENT_2 = i++;

//cdata
var BEFORE_CDATA_1 = i++; // [
var BEFORE_CDATA_2 = i++; // C
var BEFORE_CDATA_3 = i++; // D
var BEFORE_CDATA_4 = i++; // A
var BEFORE_CDATA_5 = i++; // T
var BEFORE_CDATA_6 = i++; // A
var IN_CDATA = i++; // [
var AFTER_CDATA_1 = i++; // ]
var AFTER_CDATA_2 = i++; // ]

//special tags
var BEFORE_SPECIAL = i++; //S
var BEFORE_SPECIAL_END = i++; //S

var BEFORE_SCRIPT_1 = i++; //C
var BEFORE_SCRIPT_2 = i++; //R
var BEFORE_SCRIPT_3 = i++; //I
var BEFORE_SCRIPT_4 = i++; //P
var BEFORE_SCRIPT_5 = i++; //T
var AFTER_SCRIPT_1 = i++; //C
var AFTER_SCRIPT_2 = i++; //R
var AFTER_SCRIPT_3 = i++; //I
var AFTER_SCRIPT_4 = i++; //P
var AFTER_SCRIPT_5 = i++; //T

var BEFORE_STYLE_1 = i++; //T
var BEFORE_STYLE_2 = i++; //Y
var BEFORE_STYLE_3 = i++; //L
var BEFORE_STYLE_4 = i++; //E
var AFTER_STYLE_1 = i++; //T
var AFTER_STYLE_2 = i++; //Y
var AFTER_STYLE_3 = i++; //L
var AFTER_STYLE_4 = i++; //E

var BEFORE_ENTITY = i++; //&
var BEFORE_NUMERIC_ENTITY = i++; //#
var IN_NAMED_ENTITY = i++;
var IN_NUMERIC_ENTITY = i++;
var IN_HEX_ENTITY = i++; //X

var j = 0;

var SPECIAL_NONE = j++;
var SPECIAL_SCRIPT = j++;
var SPECIAL_STYLE = j++;

function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();

    if (upper === lower) {
        return function(c) {
            if (c === lower) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    } else {
        return function(c) {
            if (c === lower || c === upper) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    }
}

function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();

    return function(c) {
        if (c === lower || c === upper) {
            this._state = NEXT_STATE;
        } else {
            this._state = IN_TAG_NAME;
            this._index--; //consume the token again
        }
    };
}

function Tokenizer(options, cbs) {
    this._state = TEXT;
    this._buffer = "";
    this._sectionStart = 0;
    this._index = 0;
    this._bufferOffset = 0; //chars removed from _buffer
    this._baseState = TEXT;
    this._special = SPECIAL_NONE;
    this._cbs = cbs;
    this._running = true;
    this._ended = false;
    this._xmlMode = !!(options && options.xmlMode);
    this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c) {
    if (c === "<") {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._state = BEFORE_TAG_NAME;
        this._sectionStart = this._index;
    } else if (
        this._decodeEntities &&
        this._special === SPECIAL_NONE &&
        c === "&"
    ) {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._baseState = TEXT;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeTagName = function(c) {
    if (c === "/") {
        this._state = BEFORE_CLOSING_TAG_NAME;
    } else if (c === "<") {
        this._cbs.ontext(this._getSection());
        this._sectionStart = this._index;
    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
        this._state = TEXT;
    } else if (c === "!") {
        this._state = BEFORE_DECLARATION;
        this._sectionStart = this._index + 1;
    } else if (c === "?") {
        this._state = IN_PROCESSING_INSTRUCTION;
        this._sectionStart = this._index + 1;
    } else {
        this._state =
            !this._xmlMode && (c === "s" || c === "S")
                ? BEFORE_SPECIAL
                : IN_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInTagName = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._emitToken("onopentagname");
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
    if (whitespace(c));
    else if (c === ">") {
        this._state = TEXT;
    } else if (this._special !== SPECIAL_NONE) {
        if (c === "s" || c === "S") {
            this._state = BEFORE_SPECIAL_END;
        } else {
            this._state = TEXT;
            this._index--;
        }
    } else {
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInCloseingTagName = function(c) {
    if (c === ">" || whitespace(c)) {
        this._emitToken("onclosetag");
        this._state = AFTER_CLOSING_TAG_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
    //skip everything until ">"
    if (c === ">") {
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeAttributeName = function(c) {
    if (c === ">") {
        this._cbs.onopentagend();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c === "/") {
        this._state = IN_SELF_CLOSING_TAG;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInSelfClosingTag = function(c) {
    if (c === ">") {
        this._cbs.onselfclosingtag();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateInAttributeName = function(c) {
    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
        this._cbs.onattribname(this._getSection());
        this._sectionStart = -1;
        this._state = AFTER_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterAttributeName = function(c) {
    if (c === "=") {
        this._state = BEFORE_ATTRIBUTE_VALUE;
    } else if (c === "/" || c === ">") {
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (!whitespace(c)) {
        this._cbs.onattribend();
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
    if (c === '"') {
        this._state = IN_ATTRIBUTE_VALUE_DQ;
        this._sectionStart = this._index + 1;
    } else if (c === "'") {
        this._state = IN_ATTRIBUTE_VALUE_SQ;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_VALUE_NQ;
        this._sectionStart = this._index;
        this._index--; //reconsume token
    }
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
    if (c === '"') {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
    if (c === "'") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
    if (whitespace(c) || c === ">") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeDeclaration = function(c) {
    this._state =
        c === "["
            ? BEFORE_CDATA_1
            : c === "-"
                ? BEFORE_COMMENT
                : IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c) {
    if (c === ">") {
        this._cbs.ondeclaration(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateInProcessingInstruction = function(c) {
    if (c === ">") {
        this._cbs.onprocessinginstruction(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeComment = function(c) {
    if (c === "-") {
        this._state = IN_COMMENT;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
    }
};

Tokenizer.prototype._stateInComment = function(c) {
    if (c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c) {
    if (c === "-") {
        this._state = AFTER_COMMENT_2;
    } else {
        this._state = IN_COMMENT;
    }
};

Tokenizer.prototype._stateAfterComment2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncomment(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "-") {
        this._state = IN_COMMENT;
    }
    // else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
    "C",
    BEFORE_CDATA_2,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
    "D",
    BEFORE_CDATA_3,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
    "A",
    BEFORE_CDATA_4,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
    "T",
    BEFORE_CDATA_5,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
    "A",
    BEFORE_CDATA_6,
    IN_DECLARATION
);

Tokenizer.prototype._stateBeforeCdata6 = function(c) {
    if (c === "[") {
        this._state = IN_CDATA;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
        this._index--;
    }
};

Tokenizer.prototype._stateInCdata = function(c) {
    if (c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = function(c) {
    if (c === "]") this._state = AFTER_CDATA_2;
    else this._state = IN_CDATA;
};

Tokenizer.prototype._stateAfterCdata2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncdata(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "]") {
        this._state = IN_CDATA;
    }
    //else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c) {
    if (c === "c" || c === "C") {
        this._state = BEFORE_SCRIPT_1;
    } else if (c === "t" || c === "T") {
        this._state = BEFORE_STYLE_1;
    } else {
        this._state = IN_TAG_NAME;
        this._index--; //consume the token again
    }
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
        this._state = AFTER_SCRIPT_1;
    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
        this._state = AFTER_STYLE_1;
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
    "R",
    BEFORE_SCRIPT_2
);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
    "I",
    BEFORE_SCRIPT_3
);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
    "P",
    BEFORE_SCRIPT_4
);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
    "T",
    BEFORE_SCRIPT_5
);

Tokenizer.prototype._stateBeforeScript5 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_SCRIPT;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 6;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
    "Y",
    BEFORE_STYLE_2
);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
    "L",
    BEFORE_STYLE_3
);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
    "E",
    BEFORE_STYLE_4
);

Tokenizer.prototype._stateBeforeStyle4 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_STYLE;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 5;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState(
    "#",
    BEFORE_NUMERIC_ENTITY,
    IN_NAMED_ENTITY
);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
    "X",
    IN_HEX_ENTITY,
    IN_NUMERIC_ENTITY
);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function() {
    //offset = 1
    if (this._sectionStart + 1 < this._index) {
        var entity = this._buffer.substring(
                this._sectionStart + 1,
                this._index
            ),
            map = this._xmlMode ? xmlMap : entityMap;

        if (map.hasOwnProperty(entity)) {
            this._emitPartial(map[entity]);
            this._sectionStart = this._index + 1;
        }
    }
};

//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function() {
    var start = this._sectionStart + 1,
        limit = this._index - start;

    if (limit > 6) limit = 6; //the max length of legacy entities is 6

    while (limit >= 2) {
        //the min length of legacy entities is 2
        var entity = this._buffer.substr(start, limit);

        if (legacyMap.hasOwnProperty(entity)) {
            this._emitPartial(legacyMap[entity]);
            this._sectionStart += limit + 1;
            return;
        } else {
            limit--;
        }
    }
};

Tokenizer.prototype._stateInNamedEntity = function(c) {
    if (c === ";") {
        this._parseNamedEntityStrict();
        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
            this._parseLegacyEntity();
        }
        this._state = this._baseState;
    } else if (
        (c < "a" || c > "z") &&
        (c < "A" || c > "Z") &&
        (c < "0" || c > "9")
    ) {
        if (this._xmlMode);
        else if (this._sectionStart + 1 === this._index);
        else if (this._baseState !== TEXT) {
            if (c !== "=") {
                this._parseNamedEntityStrict();
            }
        } else {
            this._parseLegacyEntity();
        }

        this._state = this._baseState;
        this._index--;
    }
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
    var sectionStart = this._sectionStart + offset;

    if (sectionStart !== this._index) {
        //parse entity
        var entity = this._buffer.substring(sectionStart, this._index);
        var parsed = parseInt(entity, base);

        this._emitPartial(decodeCodePoint(parsed));
        this._sectionStart = this._index;
    } else {
        this._sectionStart--;
    }

    this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(2, 10);
        this._sectionStart++;
    } else if (c < "0" || c > "9") {
        if (!this._xmlMode) {
            this._decodeNumericEntity(2, 10);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._stateInHexEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(3, 16);
        this._sectionStart++;
    } else if (
        (c < "a" || c > "f") &&
        (c < "A" || c > "F") &&
        (c < "0" || c > "9")
    ) {
        if (!this._xmlMode) {
            this._decodeNumericEntity(3, 16);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._cleanup = function() {
    if (this._sectionStart < 0) {
        this._buffer = "";
        this._bufferOffset += this._index;
        this._index = 0;
    } else if (this._running) {
        if (this._state === TEXT) {
            if (this._sectionStart !== this._index) {
                this._cbs.ontext(this._buffer.substr(this._sectionStart));
            }
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else if (this._sectionStart === this._index) {
            //the section just started
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else {
            //remove everything unnecessary
            this._buffer = this._buffer.substr(this._sectionStart);
            this._index -= this._sectionStart;
            this._bufferOffset += this._sectionStart;
        }

        this._sectionStart = 0;
    }
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".write() after done!"));

    this._buffer += chunk;
    this._parse();
};

Tokenizer.prototype._parse = function() {
    while (this._index < this._buffer.length && this._running) {
        var c = this._buffer.charAt(this._index);
        if (this._state === TEXT) {
            this._stateText(c);
        } else if (this._state === BEFORE_TAG_NAME) {
            this._stateBeforeTagName(c);
        } else if (this._state === IN_TAG_NAME) {
            this._stateInTagName(c);
        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
            this._stateBeforeCloseingTagName(c);
        } else if (this._state === IN_CLOSING_TAG_NAME) {
            this._stateInCloseingTagName(c);
        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
            this._stateAfterCloseingTagName(c);
        } else if (this._state === IN_SELF_CLOSING_TAG) {
            this._stateInSelfClosingTag(c);
        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {

        /*
		*	attributes
		*/
            this._stateBeforeAttributeName(c);
        } else if (this._state === IN_ATTRIBUTE_NAME) {
            this._stateInAttributeName(c);
        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
            this._stateAfterAttributeName(c);
        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
            this._stateBeforeAttributeValue(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
            this._stateInAttributeValueDoubleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
            this._stateInAttributeValueSingleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
            this._stateInAttributeValueNoQuotes(c);
        } else if (this._state === BEFORE_DECLARATION) {

        /*
		*	declarations
		*/
            this._stateBeforeDeclaration(c);
        } else if (this._state === IN_DECLARATION) {
            this._stateInDeclaration(c);
        } else if (this._state === IN_PROCESSING_INSTRUCTION) {

        /*
		*	processing instructions
		*/
            this._stateInProcessingInstruction(c);
        } else if (this._state === BEFORE_COMMENT) {

        /*
		*	comments
		*/
            this._stateBeforeComment(c);
        } else if (this._state === IN_COMMENT) {
            this._stateInComment(c);
        } else if (this._state === AFTER_COMMENT_1) {
            this._stateAfterComment1(c);
        } else if (this._state === AFTER_COMMENT_2) {
            this._stateAfterComment2(c);
        } else if (this._state === BEFORE_CDATA_1) {

        /*
		*	cdata
		*/
            this._stateBeforeCdata1(c);
        } else if (this._state === BEFORE_CDATA_2) {
            this._stateBeforeCdata2(c);
        } else if (this._state === BEFORE_CDATA_3) {
            this._stateBeforeCdata3(c);
        } else if (this._state === BEFORE_CDATA_4) {
            this._stateBeforeCdata4(c);
        } else if (this._state === BEFORE_CDATA_5) {
            this._stateBeforeCdata5(c);
        } else if (this._state === BEFORE_CDATA_6) {
            this._stateBeforeCdata6(c);
        } else if (this._state === IN_CDATA) {
            this._stateInCdata(c);
        } else if (this._state === AFTER_CDATA_1) {
            this._stateAfterCdata1(c);
        } else if (this._state === AFTER_CDATA_2) {
            this._stateAfterCdata2(c);
        } else if (this._state === BEFORE_SPECIAL) {

        /*
		* special tags
		*/
            this._stateBeforeSpecial(c);
        } else if (this._state === BEFORE_SPECIAL_END) {
            this._stateBeforeSpecialEnd(c);
        } else if (this._state === BEFORE_SCRIPT_1) {

        /*
		* script
		*/
            this._stateBeforeScript1(c);
        } else if (this._state === BEFORE_SCRIPT_2) {
            this._stateBeforeScript2(c);
        } else if (this._state === BEFORE_SCRIPT_3) {
            this._stateBeforeScript3(c);
        } else if (this._state === BEFORE_SCRIPT_4) {
            this._stateBeforeScript4(c);
        } else if (this._state === BEFORE_SCRIPT_5) {
            this._stateBeforeScript5(c);
        } else if (this._state === AFTER_SCRIPT_1) {
            this._stateAfterScript1(c);
        } else if (this._state === AFTER_SCRIPT_2) {
            this._stateAfterScript2(c);
        } else if (this._state === AFTER_SCRIPT_3) {
            this._stateAfterScript3(c);
        } else if (this._state === AFTER_SCRIPT_4) {
            this._stateAfterScript4(c);
        } else if (this._state === AFTER_SCRIPT_5) {
            this._stateAfterScript5(c);
        } else if (this._state === BEFORE_STYLE_1) {

        /*
		* style
		*/
            this._stateBeforeStyle1(c);
        } else if (this._state === BEFORE_STYLE_2) {
            this._stateBeforeStyle2(c);
        } else if (this._state === BEFORE_STYLE_3) {
            this._stateBeforeStyle3(c);
        } else if (this._state === BEFORE_STYLE_4) {
            this._stateBeforeStyle4(c);
        } else if (this._state === AFTER_STYLE_1) {
            this._stateAfterStyle1(c);
        } else if (this._state === AFTER_STYLE_2) {
            this._stateAfterStyle2(c);
        } else if (this._state === AFTER_STYLE_3) {
            this._stateAfterStyle3(c);
        } else if (this._state === AFTER_STYLE_4) {
            this._stateAfterStyle4(c);
        } else if (this._state === BEFORE_ENTITY) {

        /*
		* entities
		*/
            this._stateBeforeEntity(c);
        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
            this._stateBeforeNumericEntity(c);
        } else if (this._state === IN_NAMED_ENTITY) {
            this._stateInNamedEntity(c);
        } else if (this._state === IN_NUMERIC_ENTITY) {
            this._stateInNumericEntity(c);
        } else if (this._state === IN_HEX_ENTITY) {
            this._stateInHexEntity(c);
        } else {
            this._cbs.onerror(Error("unknown _state"), this._state);
        }

        this._index++;
    }

    this._cleanup();
};

Tokenizer.prototype.pause = function() {
    this._running = false;
};
Tokenizer.prototype.resume = function() {
    this._running = true;

    if (this._index < this._buffer.length) {
        this._parse();
    }
    if (this._ended) {
        this._finish();
    }
};

Tokenizer.prototype.end = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
    if (chunk) this.write(chunk);

    this._ended = true;

    if (this._running) this._finish();
};

Tokenizer.prototype._finish = function() {
    //if there is remaining data, emit it in a reasonable way
    if (this._sectionStart < this._index) {
        this._handleTrailingData();
    }

    this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function() {
    var data = this._buffer.substr(this._sectionStart);

    if (
        this._state === IN_CDATA ||
        this._state === AFTER_CDATA_1 ||
        this._state === AFTER_CDATA_2
    ) {
        this._cbs.oncdata(data);
    } else if (
        this._state === IN_COMMENT ||
        this._state === AFTER_COMMENT_1 ||
        this._state === AFTER_COMMENT_2
    ) {
        this._cbs.oncomment(data);
    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
        this._parseLegacyEntity();
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(2, 10);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(3, 16);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (
        this._state !== IN_TAG_NAME &&
        this._state !== BEFORE_ATTRIBUTE_NAME &&
        this._state !== BEFORE_ATTRIBUTE_VALUE &&
        this._state !== AFTER_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
        this._state !== IN_CLOSING_TAG_NAME
    ) {
        this._cbs.ontext(data);
    }
    //else, ignore remaining data
    //TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function() {
    Tokenizer.call(
        this,
        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
        this._cbs
    );
};

Tokenizer.prototype.getAbsoluteIndex = function() {
    return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function() {
    return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name) {
    this._cbs[name](this._getSection());
    this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value) {
    if (this._baseState !== TEXT) {
        this._cbs.onattribdata(value); //TODO implement the new event
    } else {
        this._cbs.ontext(value);
    }
};


/***/ }),

/***/ 83621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(50763);
var WritableStream = (__webpack_require__(50247).Writable);
var StringDecoder = (__webpack_require__(32553)/* .StringDecoder */ .s);
var Buffer = (__webpack_require__(48764).Buffer);

function Stream(cbs, options) {
    var parser = (this._parser = new Parser(cbs, options));
    var decoder = (this._decoder = new StringDecoder());

    WritableStream.call(this, { decodeStrings: false });

    this.once("finish", function() {
        parser.end(decoder.end());
    });
}

__webpack_require__(35717)(Stream, WritableStream);

Stream.prototype._write = function(chunk, encoding, cb) {
    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
    this._parser.write(chunk);
    cb();
};


/***/ }),

/***/ 23719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Parser = __webpack_require__(50763);
var DomHandler = __webpack_require__(29730);

function defineProp(name, value) {
    delete module.exports[name];
    module.exports[name] = value;
    return value;
}

module.exports = {
    Parser: Parser,
    Tokenizer: __webpack_require__(39889),
    ElementType: __webpack_require__(62391),
    DomHandler: DomHandler,
    get FeedHandler() {
        return defineProp("FeedHandler", __webpack_require__(63870));
    },
    get Stream() {
        return defineProp("Stream", __webpack_require__(89924));
    },
    get WritableStream() {
        return defineProp("WritableStream", __webpack_require__(83621));
    },
    get ProxyHandler() {
        return defineProp("ProxyHandler", __webpack_require__(76321));
    },
    get DomUtils() {
        return defineProp("DomUtils", __webpack_require__(12417));
    },
    get CollectingHandler() {
        return defineProp(
            "CollectingHandler",
            __webpack_require__(95449)
        );
    },
    // For legacy support
    DefaultHandler: DomHandler,
    get RssHandler() {
        return defineProp("RssHandler", this.FeedHandler);
    },
    //helper methods
    parseDOM: function(data, options) {
        var handler = new DomHandler(options);
        new Parser(handler, options).end(data);
        return handler.dom;
    },
    parseFeed: function(feed, options) {
        var handler = new module.exports.FeedHandler(options);
        new Parser(handler, options).end(feed);
        return handler.dom;
    },
    createDomStream: function(cb, options, elementCb) {
        var handler = new DomHandler(cb, options, elementCb);
        return new Parser(handler, options);
    },
    // List of all events that the parser emits
    EVENTS: {
        /* Format: eventname: number of arguments */
        attribute: 2,
        cdatastart: 0,
        cdataend: 0,
        text: 1,
        processinginstruction: 2,
        comment: 1,
        commentend: 0,
        closetag: 1,
        opentag: 2,
        opentagname: 1,
        error: 1,
        end: 0
    }
};


/***/ }),

/***/ 62391:
/***/ (function(module) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),

/***/ 29730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ElementType = __webpack_require__(62391);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(16805);
var ElementPrototype = __webpack_require__(7359);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices && elem){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),

/***/ 7359:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(16805);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),

/***/ 16805:
/***/ (function(module) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),

/***/ 58894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var decodeMap = __webpack_require__(42968);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }

    if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
    }

    var output = "";

    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }

    output += String.fromCharCode(codePoint);
    return output;
}


/***/ }),

/***/ 35717:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 29238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(27856)["default"]) || __webpack_require__(27856));

/***/ }),

/***/ 19575:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 *  base64.js
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */
;(function (global, factory) {
     true
        ? module.exports = factory(global)
        : 0
}((
    typeof self !== 'undefined' ? self
        : typeof window !== 'undefined' ? window
        : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g
: this
), function(global) {
    'use strict';
    // existing version for noConflict()
    global = global || {};
    var _Base64 = global.Base64;
    var version = "2.6.4";
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
        ord = ccc.charCodeAt(0) << 16
            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
        chars = [
            b64chars.charAt( ord >>> 18),
            b64chars.charAt((ord >>> 12) & 63),
            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global.btoa && typeof global.btoa == 'function'
        ? function(b){ return global.btoa(b) } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError(
            'The string contains invalid characters.'
        );
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function (b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) { return encode(u, true) };
    var fromUint8Array;
    if (global.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for (var i = 0, l = a.length; i < l; i += 3) {
            var a0 = a[i], a1 = a[i+1], a2 = a[i+2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 +=    b64chars.charAt( ord >>> 18)
                +     b64chars.charAt((ord >>> 12) & 63)
                + ( typeof a1 != 'undefined'
                    ? b64chars.charAt((ord >>>  6) & 63) : '=')
                + ( typeof a2 != 'undefined'
                    ? b64chars.charAt( ord         & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                |    ((0x3f & cccc.charCodeAt(1)) << 12)
                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                |     (0x3f & cccc.charCodeAt(3)),
            offset = cp - 0x10000;
            return (fromCharCode((offset  >>> 10) + 0xD800)
                    + fromCharCode((offset & 0x3FF) + 0xDC00));
        case 3:
            return fromCharCode(
                ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
            );
        default:
            return  fromCharCode(
                ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
            );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
        padlen = len % 4,
        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
        chars = [
            fromCharCode( n >>> 16),
            fromCharCode((n >>>  8) & 0xff),
            fromCharCode( n         & 0xff)
        ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var _atob = global.atob && typeof global.atob == 'function'
        ? function(a){ return global.atob(a) } : function(a){
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function(a) { return btou(_atob(a)) };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == '-' ? '+' : '/'
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function(a){
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global['Meteor']) { // Meteor.js
        Base64 = global.Base64;
    }
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if ( true && module.exports) {
        module.exports.Base64 = global.Base64;
    }
    else if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){ return global.Base64 }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    // that's it!
    return {Base64: global.Base64}
}));


/***/ }),

/***/ 91296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 78566:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _defineProperty = __webpack_require__(930);

var _slicedToArray = __webpack_require__(85696);

var _toConsumableArray = __webpack_require__(7980);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Image;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _head = _interop_require_default(__webpack_require__(72717));

var _imageConfig = __webpack_require__(48187);

var _useIntersection = __webpack_require__(90639);

var _imageConfigContext = __webpack_require__(89239);

var _utils = __webpack_require__(99475);

var _normalizeTrailingSlash = __webpack_require__(24969);

function Image(_param) {
  var _linkProps;

  var src = _param.src,
      sizes = _param.sizes,
      _param$unoptimized = _param.unoptimized,
      unoptimized = _param$unoptimized === void 0 ? false : _param$unoptimized,
      _param$priority = _param.priority,
      priority = _param$priority === void 0 ? false : _param$priority,
      loading = _param.loading,
      _param$lazyRoot = _param.lazyRoot,
      lazyRoot = _param$lazyRoot === void 0 ? null : _param$lazyRoot,
      lazyBoundary = _param.lazyBoundary,
      className = _param.className,
      quality = _param.quality,
      width = _param.width,
      height = _param.height,
      style = _param.style,
      objectFit = _param.objectFit,
      objectPosition = _param.objectPosition,
      onLoadingComplete = _param.onLoadingComplete,
      _param$placeholder = _param.placeholder,
      placeholder = _param$placeholder === void 0 ? 'empty' : _param$placeholder,
      blurDataURL = _param.blurDataURL,
      all = _object_without_properties_loose(_param, ["src", "sizes", "unoptimized", "priority", "loading", "lazyRoot", "lazyBoundary", "className", "quality", "width", "height", "style", "objectFit", "objectPosition", "onLoadingComplete", "placeholder", "blurDataURL"]);

  var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
  var config = (0, _react).useMemo(function () {
    var c = configEnv || configContext || _imageConfig.imageConfigDefault;
    var allSizes = [].concat(_toConsumableArray(c.deviceSizes), _toConsumableArray(c.imageSizes)).sort(function (a, b) {
      return a - b;
    });
    var deviceSizes = c.deviceSizes.sort(function (a, b) {
      return a - b;
    });
    return _extends({}, c, {
      allSizes: allSizes,
      deviceSizes: deviceSizes
    });
  }, [configContext]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';

  if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread on <img>:

    delete rest.layout;
  }

  var loader = defaultImageLoader;

  if ('loader' in rest) {
    if (rest.loader) {
      var customImageLoader = rest.loader;

      var _tmp;

      _tmp = function _tmp(obj) {
        var _ = obj.config,
            opts = _object_without_properties_loose(obj, ["config"]); // The config object is internal only so we must
        // not pass it to the user-defined loader()


        return customImageLoader(opts);
      }, loader = _tmp, _tmp;
    } // Remove property so it's not spread on <img>


    delete rest.loader;
  }

  var staticSrc = '';

  if (isStaticImport(src)) {
    var staticImageData = isStaticRequire(src) ? src["default"] : src;

    if (!staticImageData.src) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
    }

    blurDataURL = blurDataURL || staticImageData.blurDataURL;
    staticSrc = staticImageData.src;

    if (!layout || layout !== 'fill') {
      height = height || staticImageData.height;
      width = width || staticImageData.width;

      if (!staticImageData.height || !staticImageData.width) {
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
      }
    }
  }

  src = typeof src === 'string' ? src : staticSrc;
  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src.startsWith('data:') || src.startsWith('blob:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  if ( true && loadedImageURLs.has(src)) {
    isLazy = false;
  }

  if (config.unoptimized) {
    unoptimized = true;
  }

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      blurComplete = _useState2[0],
      setBlurComplete = _useState2[1];

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootRef: lazyRoot,
    rootMargin: lazyBoundary || '200px',
    disabled: !isLazy
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersection = _useIntersection3[0],
      isIntersected = _useIntersection3[1],
      resetIntersected = _useIntersection3[2];

  var isVisible = !isLazy || isIntersected;
  var wrapperStyle = {
    boxSizing: 'border-box',
    display: 'block',
    overflow: 'hidden',
    width: 'initial',
    height: 'initial',
    background: 'none',
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var sizerStyle = {
    boxSizing: 'border-box',
    display: 'block',
    width: 'initial',
    height: 'initial',
    background: 'none',
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var hasSizer = false;
  var sizerSvgUrl;
  var layoutStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);

  if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }

  var imgStyle = Object.assign({}, style, layoutStyle);
  var blurStyle = placeholder === 'blur' && !blurComplete ? {
    backgroundSize: objectFit || 'cover',
    backgroundPosition: objectPosition || '0% 0%',
    filter: 'blur(20px)',
    backgroundImage: "url(\"".concat(blurDataURL, "\")")
  } : {};

  if (layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle.display = 'block';
    wrapperStyle.position = 'absolute';
    wrapperStyle.top = 0;
    wrapperStyle.left = 0;
    wrapperStyle.bottom = 0;
    wrapperStyle.right = 0;
  } else if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle.display = 'block';
      wrapperStyle.position = 'relative';
      hasSizer = true;
      sizerStyle.paddingTop = paddingTop;
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle.display = 'inline-block';
      wrapperStyle.position = 'relative';
      wrapperStyle.maxWidth = '100%';
      hasSizer = true;
      sizerStyle.maxWidth = '100%';
      sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle.display = 'inline-block';
      wrapperStyle.position = 'relative';
      wrapperStyle.width = widthInt;
      wrapperStyle.height = heightInt;
    }
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: emptyDataURL,
    srcSet: undefined,
    sizes: undefined
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      config: config,
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes,
      loader: loader
    });
  }

  var srcString = src;

  if (false) { var fullUrl; }

  var imageSrcSetPropName = 'imagesrcset';
  var imageSizesPropName = 'imagesizes';

  if (false) {}

  var linkProps = (_linkProps = {}, _defineProperty(_linkProps, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_linkProps, imageSizesPropName, imgAttributes.sizes), _defineProperty(_linkProps, "crossOrigin", rest.crossOrigin), _linkProps);
  var useLayoutEffect =  false ? 0 : _react["default"].useLayoutEffect;
  var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
  var previousImageSrc = (0, _react).useRef(src);
  (0, _react).useEffect(function () {
    onLoadingCompleteRef.current = onLoadingComplete;
  }, [onLoadingComplete]);
  useLayoutEffect(function () {
    if (previousImageSrc.current !== src) {
      resetIntersected();
      previousImageSrc.current = src;
    }
  }, [resetIntersected, src]);

  var imgElementArgs = _extends({
    isLazy: isLazy,
    imgAttributes: imgAttributes,
    heightInt: heightInt,
    widthInt: widthInt,
    qualityInt: qualityInt,
    layout: layout,
    className: className,
    imgStyle: imgStyle,
    blurStyle: blurStyle,
    loading: loading,
    config: config,
    unoptimized: unoptimized,
    placeholder: placeholder,
    loader: loader,
    srcString: srcString,
    onLoadingCompleteRef: onLoadingCompleteRef,
    setBlurComplete: setBlurComplete,
    setIntersection: setIntersection,
    isVisible: isVisible,
    noscriptSizes: sizes
  }, rest);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: wrapperStyle
  }, hasSizer ? /*#__PURE__*/_react["default"].createElement("span", {
    style: sizerStyle
  }, sizerSvgUrl ? /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      display: 'block',
      maxWidth: '100%',
      width: 'initial',
      height: 'initial',
      background: 'none',
      opacity: 1,
      border: 0,
      margin: 0,
      padding: 0
    },
    alt: "",
    "aria-hidden": true,
    src: sizerSvgUrl
  }) : null) : null, /*#__PURE__*/_react["default"].createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // Note how we omit the `href` attribute, as it would only be relevant
  // for browsers that do not support `imagesrcset`, and in those cases
  // it would likely cause the incorrect image to be preloaded.
  //
  // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset

  /*#__PURE__*/
  _react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("link", Object.assign({
    key: '__nimg-' + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
    rel: "preload",
    as: "image",
    href: imgAttributes.srcSet ? undefined : imgAttributes.src
  }, linkProps))) : null);
}

'client';

function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

if (false) {}

var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && (['lazy', 'eager', undefined]));

function imgixLoader(_ref) {
  var config = _ref.config,
      src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
  var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
  var params = url.searchParams; // auto params can be combined with comma separation, or reiteration

  params.set('auto', params.getAll('auto').join(',') || 'format');
  params.set('fit', params.get('fit') || 'max');
  params.set('w', params.get('w') || width.toString());

  if (quality) {
    params.set('q', quality.toString());
  }

  return url.href;
}

function akamaiLoader(_ref2) {
  var config = _ref2.config,
      src = _ref2.src,
      width = _ref2.width;
  return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref3) {
  var config = _ref3.config,
      src = _ref3.src,
      width = _ref3.width,
      quality = _ref3.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}

function customLoader(_ref4) {
  var src = _ref4.src;
  throw new Error("Image with src \"".concat(src, "\" is missing \"loader\" prop.") + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}

function defaultLoader(_ref5) {
  var config = _ref5.config,
      src = _ref5.src,
      width = _ref5.width,
      quality = _ref5.quality;

  if (false) { var _require, hasMatch, parsedSrc, missingValues; }

  if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src;
  }

  return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

var loaders = new Map([['default', defaultLoader], ['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['custom', customLoader]]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && (['fill', 'fixed', 'intrinsic', 'responsive', undefined]));

function isStaticRequire(src) {
  return src["default"] !== undefined;
}

function isStaticImageData(src) {
  return src.src !== undefined;
}

function isStaticImport(src) {
  return typeof src === 'object' && (isStaticRequire(src) || isStaticImageData(src));
}

function getWidths(_ref6, width, layout, sizes) {
  var deviceSizes = _ref6.deviceSizes,
      allSizes = _ref6.allSizes;

  if (sizes && (layout === 'fill' || layout === 'responsive')) {
    // Find all the "vw" percent sizes used in the sizes prop
    var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
    var percentSizes = [];

    for (var match; match = viewportWidthRe.exec(sizes); match) {
      percentSizes.push(parseInt(match[2]));
    }

    if (percentSizes.length) {
      var smallestRatio = Math.min.apply(Math, percentSizes) * 0.01;
      return {
        widths: allSizes.filter(function (s) {
          return s >= deviceSizes[0] * smallestRatio;
        }),
        kind: 'w'
      };
    }

    return {
      widths: allSizes,
      kind: 'w'
    };
  }

  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: deviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set( // > This means that most OLED screens that say they are 3x resolution,
  // > are actually 3x in the green color, but only 1.5x in the red and
  // > blue colors. Showing a 3x resolution image in the app vs a 2x
  // > resolution image will be visually the same, though the 3x image
  // > takes significantly more data. Even true 3x resolution screens are
  // > wasteful as the human eye cannot see that level of detail without
  // > something like a magnifying glass.
  // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
  [width, width * 2
  /*, width * 3*/
  ].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function generateImgAttrs(_ref7) {
  var config = _ref7.config,
      src = _ref7.src,
      unoptimized = _ref7.unoptimized,
      layout = _ref7.layout,
      width = _ref7.width,
      quality = _ref7.quality,
      sizes = _ref7.sizes,
      loader = _ref7.loader;

  if (unoptimized) {
    return {
      src: src,
      srcSet: undefined,
      sizes: undefined
    };
  }

  var _getWidths = getWidths(config, width, layout, sizes),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  return {
    sizes: !sizes && kind === 'w' ? '100vw' : sizes,
    srcSet: widths.map(function (w, i) {
      return "".concat(loader({
        config: config,
        src: src,
        quality: quality,
        width: w
      }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
    }).join(', '),
    // It's intended to keep `src` the last attribute because React updates
    // attributes in order. If we keep `src` the first one, Safari will
    // immediately start to fetch `src`, before `sizes` and `srcSet` are even
    // updated by React. That causes multiple unnecessary requests if `srcSet`
    // and `sizes` are defined.
    // This bug cannot be reproduced in Chrome or Firefox.
    src: loader({
      config: config,
      src: src,
      quality: quality,
      width: widths[last]
    })
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function defaultImageLoader(loaderProps) {
  var ref;
  var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || 'default';
  var load = loaders.get(loaderKey);

  if (load) {
    return load(loaderProps);
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(loaderKey));
} // See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.


function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
  if (!img || img.src === emptyDataURL || img['data-loaded-src'] === src) {
    return;
  }

  img['data-loaded-src'] = src;
  var p = 'decode' in img ? img.decode() : Promise.resolve();
  p["catch"](function () {}).then(function () {
    if (!img.parentNode) {
      // Exit early in case of race condition:
      // - onload() is called
      // - decode() is called but incomplete
      // - unmount is called
      // - decode() completes
      return;
    }

    loadedImageURLs.add(src);

    if (placeholder === 'blur') {
      setBlurComplete(true);
    }

    if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
      var naturalWidth = img.naturalWidth,
          naturalHeight = img.naturalHeight; // Pass back read-only primitive values but not the
      // underlying DOM element because it could be misused.

      onLoadingCompleteRef.current({
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight
      });
    }

    if (false) { var parent, ref; }
  });
}

var ImageElement = function ImageElement(_param) {
  var imgAttributes = _param.imgAttributes,
      heightInt = _param.heightInt,
      widthInt = _param.widthInt,
      qualityInt = _param.qualityInt,
      layout = _param.layout,
      className = _param.className,
      imgStyle = _param.imgStyle,
      blurStyle = _param.blurStyle,
      isLazy = _param.isLazy,
      placeholder = _param.placeholder,
      loading = _param.loading,
      srcString = _param.srcString,
      config = _param.config,
      unoptimized = _param.unoptimized,
      loader = _param.loader,
      onLoadingCompleteRef = _param.onLoadingCompleteRef,
      setBlurComplete = _param.setBlurComplete,
      setIntersection = _param.setIntersection,
      _onLoad = _param.onLoad,
      _onError = _param.onError,
      isVisible = _param.isVisible,
      noscriptSizes = _param.noscriptSizes,
      rest = _object_without_properties_loose(_param, ["imgAttributes", "heightInt", "widthInt", "qualityInt", "layout", "className", "imgStyle", "blurStyle", "isLazy", "placeholder", "loading", "srcString", "config", "unoptimized", "loader", "onLoadingCompleteRef", "setBlurComplete", "setIntersection", "onLoad", "onError", "isVisible", "noscriptSizes"]);

  loading = isLazy ? 'lazy' : loading;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    "data-nimg": layout,
    className: className,
    style: _extends({}, imgStyle, blurStyle),
    ref: (0, _react).useCallback(function (img) {
      if (false) {}

      setIntersection(img);

      if (img == null ? void 0 : img.complete) {
        handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
      }
    }, [setIntersection, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete]),
    onLoad: function onLoad(event) {
      var img = event.currentTarget;
      handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);

      if (_onLoad) {
        _onLoad(event);
      }
    },
    onError: function onError(event) {
      if (placeholder === 'blur') {
        // If the real image fails to load, this will still remove the placeholder.
        setBlurComplete(true);
      }

      if (_onError) {
        _onError(event);
      }
    }
  })), (isLazy || placeholder === 'blur') && /*#__PURE__*/_react["default"].createElement("noscript", null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, generateImgAttrs({
    config: config,
    src: srcString,
    unoptimized: unoptimized,
    layout: layout,
    width: widthInt,
    quality: qualityInt,
    sizes: noscriptSizes,
    loader: loader
  }), {
    decoding: "async",
    "data-nimg": layout,
    style: imgStyle,
    className: className,
    // @ts-ignore - TODO: upgrade to `@types/react@17`
    loading: loading
  }))));
};

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 73579:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadable = _interop_require_default(__webpack_require__(23668));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if ( true && loadableOptions.suspense) {
    throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
  }

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

'client';
var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadableContext = __webpack_require__(3982);

var _ref =  false ? 0 : __webpack_require__(61688),
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 930:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(78566)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 16373:
/***/ (function(module) {

/* pica 5.3.0 nodeca/pica */(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c=undefined;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u=undefined,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
// Collection of math functions
//
// 1. Combine components together
// 2. Has async init to load wasm modules
//
'use strict';

var inherits = _dereq_('inherits');

var Multimath = _dereq_('multimath');

var mm_unsharp_mask = _dereq_('multimath/lib/unsharp_mask');

var mm_resize = _dereq_('./mm_resize');

function MathLib(requested_features) {
  var __requested_features = requested_features || [];

  var features = {
    js: __requested_features.indexOf('js') >= 0,
    wasm: __requested_features.indexOf('wasm') >= 0
  };
  Multimath.call(this, features);
  this.features = {
    js: features.js,
    wasm: features.wasm && this.has_wasm()
  };
  this.use(mm_unsharp_mask);
  this.use(mm_resize);
}

inherits(MathLib, Multimath);

MathLib.prototype.resizeAndUnsharp = function resizeAndUnsharp(options, cache) {
  var result = this.resize(options, cache);

  if (options.unsharpAmount) {
    this.unsharp_mask(result, options.toWidth, options.toHeight, options.unsharpAmount, options.unsharpRadius, options.unsharpThreshold);
  }

  return result;
};

module.exports = MathLib;

},{"./mm_resize":4,"inherits":15,"multimath":16,"multimath/lib/unsharp_mask":19}],2:[function(_dereq_,module,exports){
// Resize convolvers, pure JS implementation
//
'use strict'; // Precision of fixed FP values
//var FIXED_FRAC_BITS = 14;

function clampTo8(i) {
  return i < 0 ? 0 : i > 255 ? 255 : i;
} // Convolve image in horizontal directions and transpose output. In theory,
// transpose allow:
//
// - use the same convolver for both passes (this fails due different
//   types of input array and temporary buffer)
// - making vertical pass by horisonltal lines inprove CPU cache use.
//
// But in real life this doesn't work :)
//


function convolveHorizontally(src, dest, srcW, srcH, destW, filters) {
  var r, g, b, a;
  var filterPtr, filterShift, filterSize;
  var srcPtr, srcY, destX, filterVal;
  var srcOffset = 0,
      destOffset = 0; // For each row

  for (srcY = 0; srcY < srcH; srcY++) {
    filterPtr = 0; // Apply precomputed filters to each destination row point

    for (destX = 0; destX < destW; destX++) {
      // Get the filter that determines the current output pixel.
      filterShift = filters[filterPtr++];
      filterSize = filters[filterPtr++];
      srcPtr = srcOffset + filterShift * 4 | 0;
      r = g = b = a = 0; // Apply the filter to the row to get the destination pixel r, g, b, a

      for (; filterSize > 0; filterSize--) {
        filterVal = filters[filterPtr++]; // Use reverse order to workaround deopts in old v8 (node v.10)
        // Big thanks to @mraleph (Vyacheslav Egorov) for the tip.

        a = a + filterVal * src[srcPtr + 3] | 0;
        b = b + filterVal * src[srcPtr + 2] | 0;
        g = g + filterVal * src[srcPtr + 1] | 0;
        r = r + filterVal * src[srcPtr] | 0;
        srcPtr = srcPtr + 4 | 0;
      } // Bring this value back in range. All of the filter scaling factors
      // are in fixed point with FIXED_FRAC_BITS bits of fractional part.
      //
      // (!) Add 1/2 of value before clamping to get proper rounding. In other
      // case brightness loss will be noticeable if you resize image with white
      // border and place it on white background.
      //


      dest[destOffset + 3] = clampTo8(a + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      dest[destOffset + 2] = clampTo8(b + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      dest[destOffset + 1] = clampTo8(g + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      dest[destOffset] = clampTo8(r + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      destOffset = destOffset + srcH * 4 | 0;
    }

    destOffset = (srcY + 1) * 4 | 0;
    srcOffset = (srcY + 1) * srcW * 4 | 0;
  }
} // Technically, convolvers are the same. But input array and temporary
// buffer can be of different type (especially, in old browsers). So,
// keep code in separate functions to avoid deoptimizations & speed loss.


function convolveVertically(src, dest, srcW, srcH, destW, filters) {
  var r, g, b, a;
  var filterPtr, filterShift, filterSize;
  var srcPtr, srcY, destX, filterVal;
  var srcOffset = 0,
      destOffset = 0; // For each row

  for (srcY = 0; srcY < srcH; srcY++) {
    filterPtr = 0; // Apply precomputed filters to each destination row point

    for (destX = 0; destX < destW; destX++) {
      // Get the filter that determines the current output pixel.
      filterShift = filters[filterPtr++];
      filterSize = filters[filterPtr++];
      srcPtr = srcOffset + filterShift * 4 | 0;
      r = g = b = a = 0; // Apply the filter to the row to get the destination pixel r, g, b, a

      for (; filterSize > 0; filterSize--) {
        filterVal = filters[filterPtr++]; // Use reverse order to workaround deopts in old v8 (node v.10)
        // Big thanks to @mraleph (Vyacheslav Egorov) for the tip.

        a = a + filterVal * src[srcPtr + 3] | 0;
        b = b + filterVal * src[srcPtr + 2] | 0;
        g = g + filterVal * src[srcPtr + 1] | 0;
        r = r + filterVal * src[srcPtr] | 0;
        srcPtr = srcPtr + 4 | 0;
      } // Bring this value back in range. All of the filter scaling factors
      // are in fixed point with FIXED_FRAC_BITS bits of fractional part.
      //
      // (!) Add 1/2 of value before clamping to get proper rounding. In other
      // case brightness loss will be noticeable if you resize image with white
      // border and place it on white background.
      //


      dest[destOffset + 3] = clampTo8(a + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      dest[destOffset + 2] = clampTo8(b + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      dest[destOffset + 1] = clampTo8(g + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      dest[destOffset] = clampTo8(r + (1 << 13) >> 14
      /*FIXED_FRAC_BITS*/
      );
      destOffset = destOffset + srcH * 4 | 0;
    }

    destOffset = (srcY + 1) * 4 | 0;
    srcOffset = (srcY + 1) * srcW * 4 | 0;
  }
}

module.exports = {
  convolveHorizontally: convolveHorizontally,
  convolveVertically: convolveVertically
};

},{}],3:[function(_dereq_,module,exports){
// This is autogenerated file from math.wasm, don't edit.
//
'use strict';
/* eslint-disable max-len */

module.exports = 'AGFzbQEAAAABFAJgBn9/f39/fwBgB39/f39/f38AAg8BA2VudgZtZW1vcnkCAAEDAwIAAQQEAXAAAAcZAghjb252b2x2ZQAACmNvbnZvbHZlSFYAAQkBAArmAwLBAwEQfwJAIANFDQAgBEUNACAFQQRqIRVBACEMQQAhDQNAIA0hDkEAIRFBACEHA0AgB0ECaiESAn8gBSAHQQF0IgdqIgZBAmouAQAiEwRAQQAhCEEAIBNrIRQgFSAHaiEPIAAgDCAGLgEAakECdGohEEEAIQlBACEKQQAhCwNAIBAoAgAiB0EYdiAPLgEAIgZsIAtqIQsgB0H/AXEgBmwgCGohCCAHQRB2Qf8BcSAGbCAKaiEKIAdBCHZB/wFxIAZsIAlqIQkgD0ECaiEPIBBBBGohECAUQQFqIhQNAAsgEiATagwBC0EAIQtBACEKQQAhCUEAIQggEgshByABIA5BAnRqIApBgMAAakEOdSIGQf8BIAZB/wFIG0EQdEGAgPwHcUEAIAZBAEobIAtBgMAAakEOdSIGQf8BIAZB/wFIG0EYdEEAIAZBAEobciAJQYDAAGpBDnUiBkH/ASAGQf8BSBtBCHRBgP4DcUEAIAZBAEobciAIQYDAAGpBDnUiBkH/ASAGQf8BSBtB/wFxQQAgBkEAShtyNgIAIA4gA2ohDiARQQFqIhEgBEcNAAsgDCACaiEMIA1BAWoiDSADRw0ACwsLIQACQEEAIAIgAyAEIAUgABAAIAJBACAEIAUgBiABEAALCw==';

},{}],4:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  name: 'resize',
  fn: _dereq_('./resize'),
  wasm_fn: _dereq_('./resize_wasm'),
  wasm_src: _dereq_('./convolve_wasm_base64')
};

},{"./convolve_wasm_base64":3,"./resize":5,"./resize_wasm":8}],5:[function(_dereq_,module,exports){
'use strict';

var createFilters = _dereq_('./resize_filter_gen');

var convolveHorizontally = _dereq_('./convolve').convolveHorizontally;

var convolveVertically = _dereq_('./convolve').convolveVertically;

function resetAlpha(dst, width, height) {
  var ptr = 3,
      len = width * height * 4 | 0;

  while (ptr < len) {
    dst[ptr] = 0xFF;
    ptr = ptr + 4 | 0;
  }
}

module.exports = function resize(options) {
  var src = options.src;
  var srcW = options.width;
  var srcH = options.height;
  var destW = options.toWidth;
  var destH = options.toHeight;
  var scaleX = options.scaleX || options.toWidth / options.width;
  var scaleY = options.scaleY || options.toHeight / options.height;
  var offsetX = options.offsetX || 0;
  var offsetY = options.offsetY || 0;
  var dest = options.dest || new Uint8Array(destW * destH * 4);
  var quality = typeof options.quality === 'undefined' ? 3 : options.quality;
  var alpha = options.alpha || false;
  var filtersX = createFilters(quality, srcW, destW, scaleX, offsetX),
      filtersY = createFilters(quality, srcH, destH, scaleY, offsetY);
  var tmp = new Uint8Array(destW * srcH * 4); // To use single function we need src & tmp of the same type.
  // But src can be CanvasPixelArray, and tmp - Uint8Array. So, keep
  // vertical and horizontal passes separately to avoid deoptimization.

  convolveHorizontally(src, tmp, srcW, srcH, destW, filtersX);
  convolveVertically(tmp, dest, srcH, destW, destH, filtersY); // That's faster than doing checks in convolver.
  // !!! Note, canvas data is not premultipled. We don't need other
  // alpha corrections.

  if (!alpha) resetAlpha(dest, destW, destH);
  return dest;
};

},{"./convolve":2,"./resize_filter_gen":6}],6:[function(_dereq_,module,exports){
// Calculate convolution filters for each destination point,
// and pack data to Int16Array:
//
// [ shift, length, data..., shift2, length2, data..., ... ]
//
// - shift - offset in src image
// - length - filter length (in src points)
// - data - filter values sequence
//
'use strict';

var FILTER_INFO = _dereq_('./resize_filter_info'); // Precision of fixed FP values


var FIXED_FRAC_BITS = 14;

function toFixedPoint(num) {
  return Math.round(num * ((1 << FIXED_FRAC_BITS) - 1));
}

module.exports = function resizeFilterGen(quality, srcSize, destSize, scale, offset) {
  var filterFunction = FILTER_INFO[quality].filter;
  var scaleInverted = 1.0 / scale;
  var scaleClamped = Math.min(1.0, scale); // For upscale
  // Filter window (averaging interval), scaled to src image

  var srcWindow = FILTER_INFO[quality].win / scaleClamped;
  var destPixel, srcPixel, srcFirst, srcLast, filterElementSize, floatFilter, fxpFilter, total, pxl, idx, floatVal, filterTotal, filterVal;
  var leftNotEmpty, rightNotEmpty, filterShift, filterSize;
  var maxFilterElementSize = Math.floor((srcWindow + 1) * 2);
  var packedFilter = new Int16Array((maxFilterElementSize + 2) * destSize);
  var packedFilterPtr = 0;
  var slowCopy = !packedFilter.subarray || !packedFilter.set; // For each destination pixel calculate source range and built filter values

  for (destPixel = 0; destPixel < destSize; destPixel++) {
    // Scaling should be done relative to central pixel point
    srcPixel = (destPixel + 0.5) * scaleInverted + offset;
    srcFirst = Math.max(0, Math.floor(srcPixel - srcWindow));
    srcLast = Math.min(srcSize - 1, Math.ceil(srcPixel + srcWindow));
    filterElementSize = srcLast - srcFirst + 1;
    floatFilter = new Float32Array(filterElementSize);
    fxpFilter = new Int16Array(filterElementSize);
    total = 0.0; // Fill filter values for calculated range

    for (pxl = srcFirst, idx = 0; pxl <= srcLast; pxl++, idx++) {
      floatVal = filterFunction((pxl + 0.5 - srcPixel) * scaleClamped);
      total += floatVal;
      floatFilter[idx] = floatVal;
    } // Normalize filter, convert to fixed point and accumulate conversion error


    filterTotal = 0;

    for (idx = 0; idx < floatFilter.length; idx++) {
      filterVal = floatFilter[idx] / total;
      filterTotal += filterVal;
      fxpFilter[idx] = toFixedPoint(filterVal);
    } // Compensate normalization error, to minimize brightness drift


    fxpFilter[destSize >> 1] += toFixedPoint(1.0 - filterTotal); //
    // Now pack filter to useable form
    //
    // 1. Trim heading and tailing zero values, and compensate shitf/length
    // 2. Put all to single array in this format:
    //
    //    [ pos shift, data length, value1, value2, value3, ... ]
    //

    leftNotEmpty = 0;

    while (leftNotEmpty < fxpFilter.length && fxpFilter[leftNotEmpty] === 0) {
      leftNotEmpty++;
    }

    if (leftNotEmpty < fxpFilter.length) {
      rightNotEmpty = fxpFilter.length - 1;

      while (rightNotEmpty > 0 && fxpFilter[rightNotEmpty] === 0) {
        rightNotEmpty--;
      }

      filterShift = srcFirst + leftNotEmpty;
      filterSize = rightNotEmpty - leftNotEmpty + 1;
      packedFilter[packedFilterPtr++] = filterShift; // shift

      packedFilter[packedFilterPtr++] = filterSize; // size

      if (!slowCopy) {
        packedFilter.set(fxpFilter.subarray(leftNotEmpty, rightNotEmpty + 1), packedFilterPtr);
        packedFilterPtr += filterSize;
      } else {
        // fallback for old IE < 11, without subarray/set methods
        for (idx = leftNotEmpty; idx <= rightNotEmpty; idx++) {
          packedFilter[packedFilterPtr++] = fxpFilter[idx];
        }
      }
    } else {
      // zero data, write header only
      packedFilter[packedFilterPtr++] = 0; // shift

      packedFilter[packedFilterPtr++] = 0; // size
    }
  }

  return packedFilter;
};

},{"./resize_filter_info":7}],7:[function(_dereq_,module,exports){
// Filter definitions to build tables for
// resizing convolvers.
//
// Presets for quality 0..3. Filter functions + window size
//
'use strict';

module.exports = [{
  // Nearest neibor (Box)
  win: 0.5,
  filter: function filter(x) {
    return x >= -0.5 && x < 0.5 ? 1.0 : 0.0;
  }
}, {
  // Hamming
  win: 1.0,
  filter: function filter(x) {
    if (x <= -1.0 || x >= 1.0) {
      return 0.0;
    }

    if (x > -1.19209290E-07 && x < 1.19209290E-07) {
      return 1.0;
    }

    var xpi = x * Math.PI;
    return Math.sin(xpi) / xpi * (0.54 + 0.46 * Math.cos(xpi / 1.0));
  }
}, {
  // Lanczos, win = 2
  win: 2.0,
  filter: function filter(x) {
    if (x <= -2.0 || x >= 2.0) {
      return 0.0;
    }

    if (x > -1.19209290E-07 && x < 1.19209290E-07) {
      return 1.0;
    }

    var xpi = x * Math.PI;
    return Math.sin(xpi) / xpi * Math.sin(xpi / 2.0) / (xpi / 2.0);
  }
}, {
  // Lanczos, win = 3
  win: 3.0,
  filter: function filter(x) {
    if (x <= -3.0 || x >= 3.0) {
      return 0.0;
    }

    if (x > -1.19209290E-07 && x < 1.19209290E-07) {
      return 1.0;
    }

    var xpi = x * Math.PI;
    return Math.sin(xpi) / xpi * Math.sin(xpi / 3.0) / (xpi / 3.0);
  }
}];

},{}],8:[function(_dereq_,module,exports){
'use strict';

var createFilters = _dereq_('./resize_filter_gen');

function resetAlpha(dst, width, height) {
  var ptr = 3,
      len = width * height * 4 | 0;

  while (ptr < len) {
    dst[ptr] = 0xFF;
    ptr = ptr + 4 | 0;
  }
}

function asUint8Array(src) {
  return new Uint8Array(src.buffer, 0, src.byteLength);
}

var IS_LE = true; // should not crash everything on module load in old browsers

try {
  IS_LE = new Uint32Array(new Uint8Array([1, 0, 0, 0]).buffer)[0] === 1;
} catch (__) {}

function copyInt16asLE(src, target, target_offset) {
  if (IS_LE) {
    target.set(asUint8Array(src), target_offset);
    return;
  }

  for (var ptr = target_offset, i = 0; i < src.length; i++) {
    var data = src[i];
    target[ptr++] = data & 0xFF;
    target[ptr++] = data >> 8 & 0xFF;
  }
}

module.exports = function resize_wasm(options) {
  var src = options.src;
  var srcW = options.width;
  var srcH = options.height;
  var destW = options.toWidth;
  var destH = options.toHeight;
  var scaleX = options.scaleX || options.toWidth / options.width;
  var scaleY = options.scaleY || options.toHeight / options.height;
  var offsetX = options.offsetX || 0.0;
  var offsetY = options.offsetY || 0.0;
  var dest = options.dest || new Uint8Array(destW * destH * 4);
  var quality = typeof options.quality === 'undefined' ? 3 : options.quality;
  var alpha = options.alpha || false;
  var filtersX = createFilters(quality, srcW, destW, scaleX, offsetX),
      filtersY = createFilters(quality, srcH, destH, scaleY, offsetY); // destination is 0 too.

  var src_offset = 0; // buffer between convolve passes

  var tmp_offset = this.__align(src_offset + Math.max(src.byteLength, dest.byteLength));

  var filtersX_offset = this.__align(tmp_offset + srcH * destW * 4);

  var filtersY_offset = this.__align(filtersX_offset + filtersX.byteLength);

  var alloc_bytes = filtersY_offset + filtersY.byteLength;

  var instance = this.__instance('resize', alloc_bytes); //
  // Fill memory block with data to process
  //


  var mem = new Uint8Array(this.__memory.buffer);
  var mem32 = new Uint32Array(this.__memory.buffer); // 32-bit copy is much faster in chrome

  var src32 = new Uint32Array(src.buffer);
  mem32.set(src32); // We should guarantee LE bytes order. Filters are not big, so
  // speed difference is not significant vs direct .set()

  copyInt16asLE(filtersX, mem, filtersX_offset);
  copyInt16asLE(filtersY, mem, filtersY_offset); //
  // Now call webassembly method
  // emsdk does method names with '_'

  var fn = instance.exports.convolveHV || instance.exports._convolveHV;
  fn(filtersX_offset, filtersY_offset, tmp_offset, srcW, srcH, destW, destH); //
  // Copy data back to typed array
  //
  // 32-bit copy is much faster in chrome

  var dest32 = new Uint32Array(dest.buffer);
  dest32.set(new Uint32Array(this.__memory.buffer, 0, destH * destW)); // That's faster than doing checks in convolver.
  // !!! Note, canvas data is not premultipled. We don't need other
  // alpha corrections.

  if (!alpha) resetAlpha(dest, destW, destH);
  return dest;
};

},{"./resize_filter_gen":6}],9:[function(_dereq_,module,exports){
'use strict';

var GC_INTERVAL = 100;

function Pool(create, idle) {
  this.create = create;
  this.available = [];
  this.acquired = {};
  this.lastId = 1;
  this.timeoutId = 0;
  this.idle = idle || 2000;
}

Pool.prototype.acquire = function () {
  var _this = this;

  var resource;

  if (this.available.length !== 0) {
    resource = this.available.pop();
  } else {
    resource = this.create();
    resource.id = this.lastId++;

    resource.release = function () {
      return _this.release(resource);
    };
  }

  this.acquired[resource.id] = resource;
  return resource;
};

Pool.prototype.release = function (resource) {
  var _this2 = this;

  delete this.acquired[resource.id];
  resource.lastUsed = Date.now();
  this.available.push(resource);

  if (this.timeoutId === 0) {
    this.timeoutId = setTimeout(function () {
      return _this2.gc();
    }, GC_INTERVAL);
  }
};

Pool.prototype.gc = function () {
  var _this3 = this;

  var now = Date.now();
  this.available = this.available.filter(function (resource) {
    if (now - resource.lastUsed > _this3.idle) {
      resource.destroy();
      return false;
    }

    return true;
  });

  if (this.available.length !== 0) {
    this.timeoutId = setTimeout(function () {
      return _this3.gc();
    }, GC_INTERVAL);
  } else {
    this.timeoutId = 0;
  }
};

module.exports = Pool;

},{}],10:[function(_dereq_,module,exports){
// Add intermediate resizing steps when scaling down by a very large factor.
//
// For example, when resizing 10000x10000 down to 10x10, it'll resize it to
// 300x300 first.
//
// It's needed because tiler has issues when the entire tile is scaled down
// to a few pixels (1024px source tile with border size 3 should result in
// at least 3+3+2 = 8px target tile, so max scale factor is 128 here).
//
// Also, adding intermediate steps can speed up processing if we use lower
// quality algorithms for first stages.
//
'use strict'; // min size = 0 results in infinite loop,
// min size = 1 can consume large amount of memory

var MIN_INNER_TILE_SIZE = 2;

module.exports = function createStages(fromWidth, fromHeight, toWidth, toHeight, srcTileSize, destTileBorder) {
  var scaleX = toWidth / fromWidth;
  var scaleY = toHeight / fromHeight; // derived from createRegions equation:
  // innerTileWidth = pixelFloor(srcTileSize * scaleX) - 2 * destTileBorder;

  var minScale = (2 * destTileBorder + MIN_INNER_TILE_SIZE + 1) / srcTileSize; // refuse to scale image multiple times by less than twice each time,
  // it could only happen because of invalid options

  if (minScale > 0.5) return [[toWidth, toHeight]];
  var stageCount = Math.ceil(Math.log(Math.min(scaleX, scaleY)) / Math.log(minScale)); // no additional resizes are necessary,
  // stageCount can be zero or be negative when enlarging the image

  if (stageCount <= 1) return [[toWidth, toHeight]];
  var result = [];

  for (var i = 0; i < stageCount; i++) {
    var width = Math.round(Math.pow(Math.pow(fromWidth, stageCount - i - 1) * Math.pow(toWidth, i + 1), 1 / stageCount));
    var height = Math.round(Math.pow(Math.pow(fromHeight, stageCount - i - 1) * Math.pow(toHeight, i + 1), 1 / stageCount));
    result.push([width, height]);
  }

  return result;
};

},{}],11:[function(_dereq_,module,exports){
// Split original image into multiple 1024x1024 chunks to reduce memory usage
// (images have to be unpacked into typed arrays for resizing) and allow
// parallel processing of multiple tiles at a time.
//
'use strict';
/*
 * pixelFloor and pixelCeil are modified versions of Math.floor and Math.ceil
 * functions which take into account floating point arithmetic errors.
 * Those errors can cause undesired increments/decrements of sizes and offsets:
 * Math.ceil(36 / (36 / 500)) = 501
 * pixelCeil(36 / (36 / 500)) = 500
 */

var PIXEL_EPSILON = 1e-5;

function pixelFloor(x) {
  var nearest = Math.round(x);

  if (Math.abs(x - nearest) < PIXEL_EPSILON) {
    return nearest;
  }

  return Math.floor(x);
}

function pixelCeil(x) {
  var nearest = Math.round(x);

  if (Math.abs(x - nearest) < PIXEL_EPSILON) {
    return nearest;
  }

  return Math.ceil(x);
}

module.exports = function createRegions(options) {
  var scaleX = options.toWidth / options.width;
  var scaleY = options.toHeight / options.height;
  var innerTileWidth = pixelFloor(options.srcTileSize * scaleX) - 2 * options.destTileBorder;
  var innerTileHeight = pixelFloor(options.srcTileSize * scaleY) - 2 * options.destTileBorder; // prevent infinite loop, this should never happen

  if (innerTileWidth < 1 || innerTileHeight < 1) {
    throw new Error('Internal error in pica: target tile width/height is too small.');
  }

  var x, y;
  var innerX, innerY, toTileWidth, toTileHeight;
  var tiles = [];
  var tile; // we go top-to-down instead of left-to-right to make image displayed from top to
  // doesn in the browser

  for (innerY = 0; innerY < options.toHeight; innerY += innerTileHeight) {
    for (innerX = 0; innerX < options.toWidth; innerX += innerTileWidth) {
      x = innerX - options.destTileBorder;

      if (x < 0) {
        x = 0;
      }

      toTileWidth = innerX + innerTileWidth + options.destTileBorder - x;

      if (x + toTileWidth >= options.toWidth) {
        toTileWidth = options.toWidth - x;
      }

      y = innerY - options.destTileBorder;

      if (y < 0) {
        y = 0;
      }

      toTileHeight = innerY + innerTileHeight + options.destTileBorder - y;

      if (y + toTileHeight >= options.toHeight) {
        toTileHeight = options.toHeight - y;
      }

      tile = {
        toX: x,
        toY: y,
        toWidth: toTileWidth,
        toHeight: toTileHeight,
        toInnerX: innerX,
        toInnerY: innerY,
        toInnerWidth: innerTileWidth,
        toInnerHeight: innerTileHeight,
        offsetX: x / scaleX - pixelFloor(x / scaleX),
        offsetY: y / scaleY - pixelFloor(y / scaleY),
        scaleX: scaleX,
        scaleY: scaleY,
        x: pixelFloor(x / scaleX),
        y: pixelFloor(y / scaleY),
        width: pixelCeil(toTileWidth / scaleX),
        height: pixelCeil(toTileHeight / scaleY)
      };
      tiles.push(tile);
    }
  }

  return tiles;
};

},{}],12:[function(_dereq_,module,exports){
'use strict';

function objClass(obj) {
  return Object.prototype.toString.call(obj);
}

module.exports.isCanvas = function isCanvas(element) {
  //return (element.nodeName && element.nodeName.toLowerCase() === 'canvas') ||
  var cname = objClass(element);
  return cname === '[object HTMLCanvasElement]'
  /* browser */
  || cname === '[object OffscreenCanvas]' || cname === '[object Canvas]'
  /* node-canvas */
  ;
};

module.exports.isImage = function isImage(element) {
  //return element.nodeName && element.nodeName.toLowerCase() === 'img';
  return objClass(element) === '[object HTMLImageElement]';
};

module.exports.limiter = function limiter(concurrency) {
  var active = 0,
      queue = [];

  function roll() {
    if (active < concurrency && queue.length) {
      active++;
      queue.shift()();
    }
  }

  return function limit(fn) {
    return new Promise(function (resolve, reject) {
      queue.push(function () {
        fn().then(function (result) {
          resolve(result);
          active--;
          roll();
        }, function (err) {
          reject(err);
          active--;
          roll();
        });
      });
      roll();
    });
  };
};

module.exports.cib_quality_name = function cib_quality_name(num) {
  switch (num) {
    case 0:
      return 'pixelated';

    case 1:
      return 'low';

    case 2:
      return 'medium';
  }

  return 'high';
};

module.exports.cib_support = function cib_support() {
  return Promise.resolve().then(function () {
    if (typeof createImageBitmap === 'undefined' || typeof document === 'undefined') {
      return false;
    }

    var c = document.createElement('canvas');
    c.width = 100;
    c.height = 100;
    return createImageBitmap(c, 0, 0, 100, 100, {
      resizeWidth: 10,
      resizeHeight: 10,
      resizeQuality: 'high'
    }).then(function (bitmap) {
      var status = bitmap.width === 10; // Branch below is filtered on upper level. We do not call resize
      // detection for basic ImageBitmap.
      //
      // https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap
      // old Crome 51 has ImageBitmap without .close(). Then this code
      // will throw and return 'false' as expected.
      //

      bitmap.close();
      c = null;
      return status;
    });
  })["catch"](function () {
    return false;
  });
};

},{}],13:[function(_dereq_,module,exports){
// Web Worker wrapper for image resize function
'use strict';

module.exports = function () {
  var MathLib = _dereq_('./mathlib');

  var mathLib;
  /* eslint-disable no-undef */

  onmessage = function onmessage(ev) {
    var opts = ev.data.opts;
    if (!mathLib) mathLib = new MathLib(ev.data.features); // Use multimath's sync auto-init. Avoid Promise use in old browsers,
    // because polyfills are not propagated to webworker.

    var result = mathLib.resizeAndUnsharp(opts);
    postMessage({
      result: result
    }, [result.buffer]);
  };
};

},{"./mathlib":1}],14:[function(_dereq_,module,exports){
// Calculate Gaussian blur of an image using IIR filter
// The method is taken from Intel's white paper and code example attached to it:
// https://software.intel.com/en-us/articles/iir-gaussian-blur-filter
// -implementation-using-intel-advanced-vector-extensions

var a0, a1, a2, a3, b1, b2, left_corner, right_corner;

function gaussCoef(sigma) {
  if (sigma < 0.5) {
    sigma = 0.5;
  }

  var a = Math.exp(0.726 * 0.726) / sigma,
      g1 = Math.exp(-a),
      g2 = Math.exp(-2 * a),
      k = (1 - g1) * (1 - g1) / (1 + 2 * a * g1 - g2);

  a0 = k;
  a1 = k * (a - 1) * g1;
  a2 = k * (a + 1) * g1;
  a3 = -k * g2;
  b1 = 2 * g1;
  b2 = -g2;
  left_corner = (a0 + a1) / (1 - b1 - b2);
  right_corner = (a2 + a3) / (1 - b1 - b2);

  // Attempt to force type to FP32.
  return new Float32Array([ a0, a1, a2, a3, b1, b2, left_corner, right_corner ]);
}

function convolveMono16(src, out, line, coeff, width, height) {
  // takes src image and writes the blurred and transposed result into out

  var prev_src, curr_src, curr_out, prev_out, prev_prev_out;
  var src_index, out_index, line_index;
  var i, j;
  var coeff_a0, coeff_a1, coeff_b1, coeff_b2;

  for (i = 0; i < height; i++) {
    src_index = i * width;
    out_index = i;
    line_index = 0;

    // left to right
    prev_src = src[src_index];
    prev_prev_out = prev_src * coeff[6];
    prev_out = prev_prev_out;

    coeff_a0 = coeff[0];
    coeff_a1 = coeff[1];
    coeff_b1 = coeff[4];
    coeff_b2 = coeff[5];

    for (j = 0; j < width; j++) {
      curr_src = src[src_index];

      curr_out = curr_src * coeff_a0 +
                 prev_src * coeff_a1 +
                 prev_out * coeff_b1 +
                 prev_prev_out * coeff_b2;

      prev_prev_out = prev_out;
      prev_out = curr_out;
      prev_src = curr_src;

      line[line_index] = prev_out;
      line_index++;
      src_index++;
    }

    src_index--;
    line_index--;
    out_index += height * (width - 1);

    // right to left
    prev_src = src[src_index];
    prev_prev_out = prev_src * coeff[7];
    prev_out = prev_prev_out;
    curr_src = prev_src;

    coeff_a0 = coeff[2];
    coeff_a1 = coeff[3];

    for (j = width - 1; j >= 0; j--) {
      curr_out = curr_src * coeff_a0 +
                 prev_src * coeff_a1 +
                 prev_out * coeff_b1 +
                 prev_prev_out * coeff_b2;

      prev_prev_out = prev_out;
      prev_out = curr_out;

      prev_src = curr_src;
      curr_src = src[src_index];

      out[out_index] = line[line_index] + prev_out;

      src_index--;
      line_index--;
      out_index -= height;
    }
  }
}


function blurMono16(src, width, height, radius) {
  // Quick exit on zero radius
  if (!radius) { return; }

  var out      = new Uint16Array(src.length),
      tmp_line = new Float32Array(Math.max(width, height));

  var coeff = gaussCoef(radius);

  convolveMono16(src, out, tmp_line, coeff, width, height, radius);
  convolveMono16(out, src, tmp_line, coeff, height, width, radius);
}

module.exports = blurMono16;

},{}],15:[function(_dereq_,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],16:[function(_dereq_,module,exports){
'use strict';


var assign         = _dereq_('object-assign');
var base64decode   = _dereq_('./lib/base64decode');
var hasWebAssembly = _dereq_('./lib/wa_detect');


var DEFAULT_OPTIONS = {
  js: true,
  wasm: true
};


function MultiMath(options) {
  if (!(this instanceof MultiMath)) return new MultiMath(options);

  var opts = assign({}, DEFAULT_OPTIONS, options || {});

  this.options         = opts;

  this.__cache         = {};

  this.__init_promise  = null;
  this.__modules       = opts.modules || {};
  this.__memory        = null;
  this.__wasm          = {};

  this.__isLE = ((new Uint32Array((new Uint8Array([ 1, 0, 0, 0 ])).buffer))[0] === 1);

  if (!this.options.js && !this.options.wasm) {
    throw new Error('mathlib: at least "js" or "wasm" should be enabled');
  }
}


MultiMath.prototype.has_wasm = hasWebAssembly;


MultiMath.prototype.use = function (module) {
  this.__modules[module.name] = module;

  // Pin the best possible implementation
  if (this.options.wasm && this.has_wasm() && module.wasm_fn) {
    this[module.name] = module.wasm_fn;
  } else {
    this[module.name] = module.fn;
  }

  return this;
};


MultiMath.prototype.init = function () {
  if (this.__init_promise) return this.__init_promise;

  if (!this.options.js && this.options.wasm && !this.has_wasm()) {
    return Promise.reject(new Error('mathlib: only "wasm" was enabled, but it\'s not supported'));
  }

  var self = this;

  this.__init_promise = Promise.all(Object.keys(self.__modules).map(function (name) {
    var module = self.__modules[name];

    if (!self.options.wasm || !self.has_wasm() || !module.wasm_fn) return null;

    // If already compiled - exit
    if (self.__wasm[name]) return null;

    // Compile wasm source
    return WebAssembly.compile(self.__base64decode(module.wasm_src))
      .then(function (m) { self.__wasm[name] = m; });
  }))
    .then(function () { return self; });

  return this.__init_promise;
};


////////////////////////////////////////////////////////////////////////////////
// Methods below are for internal use from plugins


// Simple decode base64 to typed array. Useful to load embedded webassembly
// code. You probably don't need to call this method directly.
//
MultiMath.prototype.__base64decode = base64decode;


// Increase current memory to include specified number of bytes. Do nothing if
// size is already ok. You probably don't need to call this method directly,
// because it will be invoked from `.__instance()`.
//
MultiMath.prototype.__reallocate = function mem_grow_to(bytes) {
  if (!this.__memory) {
    this.__memory = new WebAssembly.Memory({
      initial: Math.ceil(bytes / (64 * 1024))
    });
    return this.__memory;
  }

  var mem_size = this.__memory.buffer.byteLength;

  if (mem_size < bytes) {
    this.__memory.grow(Math.ceil((bytes - mem_size) / (64 * 1024)));
  }

  return this.__memory;
};


// Returns instantinated webassembly item by name, with specified memory size
// and environment.
// - use cache if available
// - do sync module init, if async init was not called earlier
// - allocate memory if not enougth
// - can export functions to webassembly via "env_extra",
//   for example, { exp: Math.exp }
//
MultiMath.prototype.__instance = function instance(name, memsize, env_extra) {
  if (memsize) this.__reallocate(memsize);

  // If .init() was not called, do sync compile
  if (!this.__wasm[name]) {
    var module = this.__modules[name];
    this.__wasm[name] = new WebAssembly.Module(this.__base64decode(module.wasm_src));
  }

  if (!this.__cache[name]) {
    var env_base = {
      memoryBase: 0,
      memory: this.__memory,
      tableBase: 0,
      table: new WebAssembly.Table({ initial: 0, element: 'anyfunc' })
    };

    this.__cache[name] = new WebAssembly.Instance(this.__wasm[name], {
      env: assign(env_base, env_extra || {})
    });
  }

  return this.__cache[name];
};


// Helper to calculate memory aligh for pointers. Webassembly does not require
// this, but you may wish to experiment. Default base = 8;
//
MultiMath.prototype.__align = function align(number, base) {
  base = base || 8;
  var reminder = number % base;
  return number + (reminder ? base - reminder : 0);
};


module.exports = MultiMath;

},{"./lib/base64decode":17,"./lib/wa_detect":23,"object-assign":24}],17:[function(_dereq_,module,exports){
// base64 decode str -> Uint8Array, to load WA modules
//
'use strict';


var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';


module.exports = function base64decode(str) {
  var input = str.replace(/[\r\n=]/g, ''), // remove CR/LF & padding to simplify scan
      max   = input.length;

  var out = new Uint8Array((max * 3) >> 2);

  // Collect by 6*4 bits (3 bytes)

  var bits = 0;
  var ptr  = 0;

  for (var idx = 0; idx < max; idx++) {
    if ((idx % 4 === 0) && idx) {
      out[ptr++] = (bits >> 16) & 0xFF;
      out[ptr++] = (bits >> 8) & 0xFF;
      out[ptr++] = bits & 0xFF;
    }

    bits = (bits << 6) | BASE64_MAP.indexOf(input.charAt(idx));
  }

  // Dump tail

  var tailbits = (max % 4) * 6;

  if (tailbits === 0) {
    out[ptr++] = (bits >> 16) & 0xFF;
    out[ptr++] = (bits >> 8) & 0xFF;
    out[ptr++] = bits & 0xFF;
  } else if (tailbits === 18) {
    out[ptr++] = (bits >> 10) & 0xFF;
    out[ptr++] = (bits >> 2) & 0xFF;
  } else if (tailbits === 12) {
    out[ptr++] = (bits >> 4) & 0xFF;
  }

  return out;
};

},{}],18:[function(_dereq_,module,exports){
// Calculates 16-bit precision HSL lightness from 8-bit rgba buffer
//
'use strict';


module.exports = function hsl_l16_js(img, width, height) {
  var size = width * height;
  var out = new Uint16Array(size);
  var r, g, b, min, max;
  for (var i = 0; i < size; i++) {
    r = img[4 * i];
    g = img[4 * i + 1];
    b = img[4 * i + 2];
    max = (r >= g && r >= b) ? r : (g >= b && g >= r) ? g : b;
    min = (r <= g && r <= b) ? r : (g <= b && g <= r) ? g : b;
    out[i] = (max + min) * 257 >> 1;
  }
  return out;
};

},{}],19:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  name:     'unsharp_mask',
  fn:       _dereq_('./unsharp_mask'),
  wasm_fn:  _dereq_('./unsharp_mask_wasm'),
  wasm_src: _dereq_('./unsharp_mask_wasm_base64')
};

},{"./unsharp_mask":20,"./unsharp_mask_wasm":21,"./unsharp_mask_wasm_base64":22}],20:[function(_dereq_,module,exports){
// Unsharp mask filter
//
// http://stackoverflow.com/a/23322820/1031804
// USM(O) = O + (2 * (Amount / 100) * (O - GB))
// GB - gaussian blur.
//
// Image is converted from RGB to HSL, unsharp mask is applied to the
// lightness channel and then image is converted back to RGB.
//
'use strict';


var glur_mono16 = _dereq_('glur/mono16');
var hsl_l16     = _dereq_('./hsl_l16');


module.exports = function unsharp(img, width, height, amount, radius, threshold) {
  var r, g, b;
  var h, s, l;
  var min, max;
  var m1, m2, hShifted;
  var diff, iTimes4;

  if (amount === 0 || radius < 0.5) {
    return;
  }
  if (radius > 2.0) {
    radius = 2.0;
  }

  var lightness = hsl_l16(img, width, height);

  var blured = new Uint16Array(lightness); // copy, because blur modify src

  glur_mono16(blured, width, height, radius);

  var amountFp = (amount / 100 * 0x1000 + 0.5)|0;
  var thresholdFp = (threshold * 257)|0;

  var size = width * height;

  /* eslint-disable indent */
  for (var i = 0; i < size; i++) {
    diff = 2 * (lightness[i] - blured[i]);

    if (Math.abs(diff) >= thresholdFp) {
      iTimes4 = i * 4;
      r = img[iTimes4];
      g = img[iTimes4 + 1];
      b = img[iTimes4 + 2];

      // convert RGB to HSL
      // take RGB, 8-bit unsigned integer per each channel
      // save HSL, H and L are 16-bit unsigned integers, S is 12-bit unsigned integer
      // math is taken from here: http://www.easyrgb.com/index.php?X=MATH&H=18
      // and adopted to be integer (fixed point in fact) for sake of performance
      max = (r >= g && r >= b) ? r : (g >= r && g >= b) ? g : b; // min and max are in [0..0xff]
      min = (r <= g && r <= b) ? r : (g <= r && g <= b) ? g : b;
      l = (max + min) * 257 >> 1; // l is in [0..0xffff] that is caused by multiplication by 257

      if (min === max) {
        h = s = 0;
      } else {
        s = (l <= 0x7fff) ?
          (((max - min) * 0xfff) / (max + min))|0 :
          (((max - min) * 0xfff) / (2 * 0xff - max - min))|0; // s is in [0..0xfff]
        // h could be less 0, it will be fixed in backward conversion to RGB, |h| <= 0xffff / 6
        h = (r === max) ? (((g - b) * 0xffff) / (6 * (max - min)))|0
          : (g === max) ? 0x5555 + ((((b - r) * 0xffff) / (6 * (max - min)))|0) // 0x5555 == 0xffff / 3
          : 0xaaaa + ((((r - g) * 0xffff) / (6 * (max - min)))|0); // 0xaaaa == 0xffff * 2 / 3
      }

      // add unsharp mask mask to the lightness channel
      l += (amountFp * diff + 0x800) >> 12;
      if (l > 0xffff) {
        l = 0xffff;
      } else if (l < 0) {
        l = 0;
      }

      // convert HSL back to RGB
      // for information about math look above
      if (s === 0) {
        r = g = b = l >> 8;
      } else {
        m2 = (l <= 0x7fff) ? (l * (0x1000 + s) + 0x800) >> 12 :
          l  + (((0xffff - l) * s + 0x800) >>  12);
        m1 = 2 * l - m2 >> 8;
        m2 >>= 8;
        // save result to RGB channels
        // R channel
        hShifted = (h + 0x5555) & 0xffff; // 0x5555 == 0xffff / 3
        r = (hShifted >= 0xaaaa) ? m1 // 0xaaaa == 0xffff * 2 / 3
          : (hShifted >= 0x7fff) ?  m1 + ((m2 - m1) * 6 * (0xaaaa - hShifted) + 0x8000 >> 16)
          : (hShifted >= 0x2aaa) ? m2 // 0x2aaa == 0xffff / 6
          : m1 + ((m2 - m1) * 6 * hShifted + 0x8000 >> 16);
        // G channel
        hShifted = h & 0xffff;
        g = (hShifted >= 0xaaaa) ? m1 // 0xaaaa == 0xffff * 2 / 3
          : (hShifted >= 0x7fff) ?  m1 + ((m2 - m1) * 6 * (0xaaaa - hShifted) + 0x8000 >> 16)
          : (hShifted >= 0x2aaa) ? m2 // 0x2aaa == 0xffff / 6
          : m1 + ((m2 - m1) * 6 * hShifted + 0x8000 >> 16);
        // B channel
        hShifted = (h - 0x5555) & 0xffff;
        b = (hShifted >= 0xaaaa) ? m1 // 0xaaaa == 0xffff * 2 / 3
          : (hShifted >= 0x7fff) ?  m1 + ((m2 - m1) * 6 * (0xaaaa - hShifted) + 0x8000 >> 16)
          : (hShifted >= 0x2aaa) ? m2 // 0x2aaa == 0xffff / 6
          : m1 + ((m2 - m1) * 6 * hShifted + 0x8000 >> 16);
      }

      img[iTimes4] = r;
      img[iTimes4 + 1] = g;
      img[iTimes4 + 2] = b;
    }
  }
};

},{"./hsl_l16":18,"glur/mono16":14}],21:[function(_dereq_,module,exports){
'use strict';


module.exports = function unsharp(img, width, height, amount, radius, threshold) {
  if (amount === 0 || radius < 0.5) {
    return;
  }

  if (radius > 2.0) {
    radius = 2.0;
  }

  var pixels = width * height;

  var img_bytes_cnt        = pixels * 4;
  var hsl_bytes_cnt        = pixels * 2;
  var blur_bytes_cnt       = pixels * 2;
  var blur_line_byte_cnt   = Math.max(width, height) * 4; // float32 array
  var blur_coeffs_byte_cnt = 8 * 4; // float32 array

  var img_offset         = 0;
  var hsl_offset         = img_bytes_cnt;
  var blur_offset        = hsl_offset + hsl_bytes_cnt;
  var blur_tmp_offset    = blur_offset + blur_bytes_cnt;
  var blur_line_offset   = blur_tmp_offset + blur_bytes_cnt;
  var blur_coeffs_offset = blur_line_offset + blur_line_byte_cnt;

  var instance = this.__instance(
    'unsharp_mask',
    img_bytes_cnt + hsl_bytes_cnt + blur_bytes_cnt * 2 + blur_line_byte_cnt + blur_coeffs_byte_cnt,
    { exp: Math.exp }
  );

  // 32-bit copy is much faster in chrome
  var img32 = new Uint32Array(img.buffer);
  var mem32 = new Uint32Array(this.__memory.buffer);
  mem32.set(img32);

  // HSL
  var fn = instance.exports.hsl_l16 || instance.exports._hsl_l16;
  fn(img_offset, hsl_offset, width, height);

  // BLUR
  fn = instance.exports.blurMono16 || instance.exports._blurMono16;
  fn(hsl_offset, blur_offset, blur_tmp_offset,
    blur_line_offset, blur_coeffs_offset, width, height, radius);

  // UNSHARP
  fn = instance.exports.unsharp || instance.exports._unsharp;
  fn(img_offset, img_offset, hsl_offset,
    blur_offset, width, height, amount, threshold);

  // 32-bit copy is much faster in chrome
  img32.set(new Uint32Array(this.__memory.buffer, 0, pixels));
};

},{}],22:[function(_dereq_,module,exports){
// This is autogenerated file from math.wasm, don't edit.
//
'use strict';

/* eslint-disable max-len */
module.exports = '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';

},{}],23:[function(_dereq_,module,exports){
// Detect WebAssembly support.
// - Check global WebAssembly object
// - Try to load simple module (can be disabled via CSP)
//
'use strict';


var wa;


module.exports = function hasWebAssembly() {
  // use cache if called before;
  if (typeof wa !== 'undefined') return wa;

  wa = false;

  if (typeof WebAssembly === 'undefined') return wa;

  // If WebAssenbly is disabled, code can throw on compile
  try {
    // https://github.com/brion/min-wasm-fail/blob/master/min-wasm-fail.in.js
    // Additional check that WA internals are correct

    /* eslint-disable comma-spacing, max-len */
    var bin      = new Uint8Array([ 0,97,115,109,1,0,0,0,1,6,1,96,1,127,1,127,3,2,1,0,5,3,1,0,1,7,8,1,4,116,101,115,116,0,0,10,16,1,14,0,32,0,65,1,54,2,0,32,0,40,2,0,11 ]);
    var module   = new WebAssembly.Module(bin);
    var instance = new WebAssembly.Instance(module, {});

    // test storing to and loading from a non-zero location via a parameter.
    // Safari on iOS 11.2.5 returns 0 unexpectedly at non-zero locations
    if (instance.exports.test(4) !== 0) wa = true;

    return wa;
  } catch (__) {}

  return wa;
};

},{}],24:[function(_dereq_,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],25:[function(_dereq_,module,exports){
var bundleFn = arguments[3];
var sources = arguments[4];
var cache = arguments[5];

var stringify = JSON.stringify;

module.exports = function (fn, options) {
    var wkey;
    var cacheKeys = Object.keys(cache);

    for (var i = 0, l = cacheKeys.length; i < l; i++) {
        var key = cacheKeys[i];
        var exp = cache[key].exports;
        // Using babel as a transpiler to use esmodule, the export will always
        // be an object with the default export as a property of it. To ensure
        // the existing api and babel esmodule exports are both supported we
        // check for both
        if (exp === fn || exp && exp.default === fn) {
            wkey = key;
            break;
        }
    }

    if (!wkey) {
        wkey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);
        var wcache = {};
        for (var i = 0, l = cacheKeys.length; i < l; i++) {
            var key = cacheKeys[i];
            wcache[key] = key;
        }
        sources[wkey] = [
            'function(require,module,exports){' + fn + '(self); }',
            wcache
        ];
    }
    var skey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);

    var scache = {}; scache[wkey] = wkey;
    sources[skey] = [
        'function(require,module,exports){' +
            // try to call default if defined to also support babel esmodule exports
            'var f = require(' + stringify(wkey) + ');' +
            '(f.default ? f.default : f)(self);' +
        '}',
        scache
    ];

    var workerSources = {};
    resolveSources(skey);

    function resolveSources(key) {
        workerSources[key] = true;

        for (var depPath in sources[key][1]) {
            var depKey = sources[key][1][depPath];
            if (!workerSources[depKey]) {
                resolveSources(depKey);
            }
        }
    }

    var src = '(' + bundleFn + ')({'
        + Object.keys(workerSources).map(function (key) {
            return stringify(key) + ':['
                + sources[key][0]
                + ',' + stringify(sources[key][1]) + ']'
            ;
        }).join(',')
        + '},{},[' + stringify(skey) + '])'
    ;

    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

    var blob = new Blob([src], { type: 'text/javascript' });
    if (options && options.bare) { return blob; }
    var workerUrl = URL.createObjectURL(blob);
    var worker = new Worker(workerUrl);
    worker.objectURL = workerUrl;
    return worker;
};

},{}],"/":[function(_dereq_,module,exports){
'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var assign = _dereq_('object-assign');

var webworkify = _dereq_('webworkify');

var MathLib = _dereq_('./lib/mathlib');

var Pool = _dereq_('./lib/pool');

var utils = _dereq_('./lib/utils');

var worker = _dereq_('./lib/worker');

var createStages = _dereq_('./lib/stepper');

var createRegions = _dereq_('./lib/tiler'); // Deduplicate pools & limiters with the same configs
// when user creates multiple pica instances.


var singletones = {};
var NEED_SAFARI_FIX = false;

try {
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    NEED_SAFARI_FIX = navigator.userAgent.indexOf('Safari') >= 0;
  }
} catch (e) {}

var concurrency = 1;

if (typeof navigator !== 'undefined') {
  concurrency = Math.min(navigator.hardwareConcurrency || 1, 4);
}

var DEFAULT_PICA_OPTS = {
  tile: 1024,
  concurrency: concurrency,
  features: ['js', 'wasm', 'ww'],
  idle: 2000
};
var DEFAULT_RESIZE_OPTS = {
  quality: 3,
  alpha: false,
  unsharpAmount: 0,
  unsharpRadius: 0.0,
  unsharpThreshold: 0
};
var CAN_NEW_IMAGE_DATA;
var CAN_CREATE_IMAGE_BITMAP;

function workerFabric() {
  return {
    value: webworkify(worker),
    destroy: function destroy() {
      this.value.terminate();

      if (typeof window !== 'undefined') {
        var url = window.URL || window.webkitURL || window.mozURL || window.msURL;

        if (url && url.revokeObjectURL && this.value.objectURL) {
          url.revokeObjectURL(this.value.objectURL);
        }
      }
    }
  };
} ////////////////////////////////////////////////////////////////////////////////
// API methods


function Pica(options) {
  if (!(this instanceof Pica)) return new Pica(options);
  this.options = assign({}, DEFAULT_PICA_OPTS, options || {});
  var limiter_key = "lk_".concat(this.options.concurrency); // Share limiters to avoid multiple parallel workers when user creates
  // multiple pica instances.

  this.__limit = singletones[limiter_key] || utils.limiter(this.options.concurrency);
  if (!singletones[limiter_key]) singletones[limiter_key] = this.__limit; // List of supported features, according to options & browser/node.js

  this.features = {
    js: false,
    // pure JS implementation, can be disabled for testing
    wasm: false,
    // webassembly implementation for heavy functions
    cib: false,
    // resize via createImageBitmap (only FF at this moment)
    ww: false // webworkers

  };
  this.__workersPool = null; // Store requested features for webworkers

  this.__requested_features = [];
  this.__mathlib = null;
}

Pica.prototype.init = function () {
  var _this = this;

  if (this.__initPromise) return this.__initPromise; // Test if we can create ImageData without canvas and memory copy

  if (CAN_NEW_IMAGE_DATA !== false && CAN_NEW_IMAGE_DATA !== true) {
    CAN_NEW_IMAGE_DATA = false;

    if (typeof ImageData !== 'undefined' && typeof Uint8ClampedArray !== 'undefined') {
      try {
        /* eslint-disable no-new */
        new ImageData(new Uint8ClampedArray(400), 10, 10);
        CAN_NEW_IMAGE_DATA = true;
      } catch (__) {}
    }
  } // ImageBitmap can be effective in 2 places:
  //
  // 1. Threaded jpeg unpack (basic)
  // 2. Built-in resize (blocked due problem in chrome, see issue #89)
  //
  // For basic use we also need ImageBitmap wo support .close() method,
  // see https://developer.mozilla.org/ru/docs/Web/API/ImageBitmap


  if (CAN_CREATE_IMAGE_BITMAP !== false && CAN_CREATE_IMAGE_BITMAP !== true) {
    CAN_CREATE_IMAGE_BITMAP = false;

    if (typeof ImageBitmap !== 'undefined') {
      if (ImageBitmap.prototype && ImageBitmap.prototype.close) {
        CAN_CREATE_IMAGE_BITMAP = true;
      } else {
        this.debug('ImageBitmap does not support .close(), disabled');
      }
    }
  }

  var features = this.options.features.slice();

  if (features.indexOf('all') >= 0) {
    features = ['cib', 'wasm', 'js', 'ww'];
  }

  this.__requested_features = features;
  this.__mathlib = new MathLib(features); // Check WebWorker support if requested

  if (features.indexOf('ww') >= 0) {
    if (typeof window !== 'undefined' && 'Worker' in window) {
      // IE <= 11 don't allow to create webworkers from string. We should check it.
      // https://connect.microsoft.com/IE/feedback/details/801810/web-workers-from-blob-urls-in-ie-10-and-11
      try {
        var wkr = _dereq_('webworkify')(function () {});

        wkr.terminate();
        this.features.ww = true; // pool uniqueness depends on pool config + webworker config

        var wpool_key = "wp_".concat(JSON.stringify(this.options));

        if (singletones[wpool_key]) {
          this.__workersPool = singletones[wpool_key];
        } else {
          this.__workersPool = new Pool(workerFabric, this.options.idle);
          singletones[wpool_key] = this.__workersPool;
        }
      } catch (__) {}
    }
  }

  var initMath = this.__mathlib.init().then(function (mathlib) {
    // Copy detected features
    assign(_this.features, mathlib.features);
  });

  var checkCibResize;

  if (!CAN_CREATE_IMAGE_BITMAP) {
    checkCibResize = Promise.resolve(false);
  } else {
    checkCibResize = utils.cib_support().then(function (status) {
      if (_this.features.cib && features.indexOf('cib') < 0) {
        _this.debug('createImageBitmap() resize supported, but disabled by config');

        return;
      }

      if (features.indexOf('cib') >= 0) _this.features.cib = status;
    });
  } // Init math lib. That's async because can load some


  this.__initPromise = Promise.all([initMath, checkCibResize]).then(function () {
    return _this;
  });
  return this.__initPromise;
};

Pica.prototype.resize = function (from, to, options) {
  var _this2 = this;

  this.debug('Start resize...');
  var opts = assign({}, DEFAULT_RESIZE_OPTS);

  if (!isNaN(options)) {
    opts = assign(opts, {
      quality: options
    });
  } else if (options) {
    opts = assign(opts, options);
  }

  opts.toWidth = to.width;
  opts.toHeight = to.height;
  opts.width = from.naturalWidth || from.width;
  opts.height = from.naturalHeight || from.height; // Prevent stepper from infinite loop

  if (to.width === 0 || to.height === 0) {
    return Promise.reject(new Error("Invalid output size: ".concat(to.width, "x").concat(to.height)));
  }

  if (opts.unsharpRadius > 2) opts.unsharpRadius = 2;
  var canceled = false;
  var cancelToken = null;

  if (opts.cancelToken) {
    // Wrap cancelToken to avoid successive resolve & set flag
    cancelToken = opts.cancelToken.then(function (data) {
      canceled = true;
      throw data;
    }, function (err) {
      canceled = true;
      throw err;
    });
  }

  var DEST_TILE_BORDER = 3; // Max possible filter window size

  var destTileBorder = Math.ceil(Math.max(DEST_TILE_BORDER, 2.5 * opts.unsharpRadius | 0));
  return this.init().then(function () {
    if (canceled) return cancelToken; // if createImageBitmap supports resize, just do it and return

    if (_this2.features.cib) {
      var toCtx = to.getContext('2d', {
        alpha: Boolean(opts.alpha)
      });

      _this2.debug('Resize via createImageBitmap()');

      return createImageBitmap(from, {
        resizeWidth: opts.toWidth,
        resizeHeight: opts.toHeight,
        resizeQuality: utils.cib_quality_name(opts.quality)
      }).then(function (imageBitmap) {
        if (canceled) return cancelToken; // if no unsharp - draw directly to output canvas

        if (!opts.unsharpAmount) {
          toCtx.drawImage(imageBitmap, 0, 0);
          imageBitmap.close();
          toCtx = null;

          _this2.debug('Finished!');

          return to;
        }

        _this2.debug('Unsharp result');

        var tmpCanvas = document.createElement('canvas');
        tmpCanvas.width = opts.toWidth;
        tmpCanvas.height = opts.toHeight;
        var tmpCtx = tmpCanvas.getContext('2d', {
          alpha: Boolean(opts.alpha)
        });
        tmpCtx.drawImage(imageBitmap, 0, 0);
        imageBitmap.close();
        var iData = tmpCtx.getImageData(0, 0, opts.toWidth, opts.toHeight);

        _this2.__mathlib.unsharp_mask(iData.data, opts.toWidth, opts.toHeight, opts.unsharpAmount, opts.unsharpRadius, opts.unsharpThreshold);

        toCtx.putImageData(iData, 0, 0);
        iData = tmpCtx = tmpCanvas = toCtx = null;

        _this2.debug('Finished!');

        return to;
      });
    } //
    // No easy way, let's resize manually via arrays
    //
    // Share cache between calls:
    //
    // - wasm instance
    // - wasm memory object
    //


    var cache = {}; // Call resizer in webworker or locally, depending on config

    var invokeResize = function invokeResize(opts) {
      return Promise.resolve().then(function () {
        if (!_this2.features.ww) return _this2.__mathlib.resizeAndUnsharp(opts, cache);
        return new Promise(function (resolve, reject) {
          var w = _this2.__workersPool.acquire();

          if (cancelToken) cancelToken["catch"](function (err) {
            return reject(err);
          });

          w.value.onmessage = function (ev) {
            w.release();
            if (ev.data.err) reject(ev.data.err);else resolve(ev.data.result);
          };

          w.value.postMessage({
            opts: opts,
            features: _this2.__requested_features,
            preload: {
              wasm_nodule: _this2.__mathlib.__
            }
          }, [opts.src.buffer]);
        });
      });
    };

    var tileAndResize = function tileAndResize(from, to, opts) {
      var srcCtx;
      var srcImageBitmap;
      var toCtx;

      var processTile = function processTile(tile) {
        return _this2.__limit(function () {
          if (canceled) return cancelToken;
          var srcImageData; // Extract tile RGBA buffer, depending on input type

          if (utils.isCanvas(from)) {
            _this2.debug('Get tile pixel data'); // If input is Canvas - extract region data directly


            srcImageData = srcCtx.getImageData(tile.x, tile.y, tile.width, tile.height);
          } else {
            // If input is Image or decoded to ImageBitmap,
            // draw region to temporary canvas and extract data from it
            //
            // Note! Attempt to reuse this canvas causes significant slowdown in chrome
            //
            _this2.debug('Draw tile imageBitmap/image to temporary canvas');

            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = tile.width;
            tmpCanvas.height = tile.height;
            var tmpCtx = tmpCanvas.getContext('2d', {
              alpha: Boolean(opts.alpha)
            });
            tmpCtx.globalCompositeOperation = 'copy';
            tmpCtx.drawImage(srcImageBitmap || from, tile.x, tile.y, tile.width, tile.height, 0, 0, tile.width, tile.height);

            _this2.debug('Get tile pixel data');

            srcImageData = tmpCtx.getImageData(0, 0, tile.width, tile.height);
            tmpCtx = tmpCanvas = null;
          }

          var o = {
            src: srcImageData.data,
            width: tile.width,
            height: tile.height,
            toWidth: tile.toWidth,
            toHeight: tile.toHeight,
            scaleX: tile.scaleX,
            scaleY: tile.scaleY,
            offsetX: tile.offsetX,
            offsetY: tile.offsetY,
            quality: opts.quality,
            alpha: opts.alpha,
            unsharpAmount: opts.unsharpAmount,
            unsharpRadius: opts.unsharpRadius,
            unsharpThreshold: opts.unsharpThreshold
          };

          _this2.debug('Invoke resize math');

          return Promise.resolve().then(function () {
            return invokeResize(o);
          }).then(function (result) {
            if (canceled) return cancelToken;
            srcImageData = null;
            var toImageData;

            _this2.debug('Convert raw rgba tile result to ImageData');

            if (CAN_NEW_IMAGE_DATA) {
              // this branch is for modern browsers
              // If `new ImageData()` & Uint8ClampedArray suported
              toImageData = new ImageData(new Uint8ClampedArray(result), tile.toWidth, tile.toHeight);
            } else {
              // fallback for `node-canvas` and old browsers
              // (IE11 has ImageData but does not support `new ImageData()`)
              toImageData = toCtx.createImageData(tile.toWidth, tile.toHeight);

              if (toImageData.data.set) {
                toImageData.data.set(result);
              } else {
                // IE9 don't have `.set()`
                for (var i = toImageData.data.length - 1; i >= 0; i--) {
                  toImageData.data[i] = result[i];
                }
              }
            }

            _this2.debug('Draw tile');

            if (NEED_SAFARI_FIX) {
              // Safari draws thin white stripes between tiles without this fix
              toCtx.putImageData(toImageData, tile.toX, tile.toY, tile.toInnerX - tile.toX, tile.toInnerY - tile.toY, tile.toInnerWidth + 1e-5, tile.toInnerHeight + 1e-5);
            } else {
              toCtx.putImageData(toImageData, tile.toX, tile.toY, tile.toInnerX - tile.toX, tile.toInnerY - tile.toY, tile.toInnerWidth, tile.toInnerHeight);
            }

            return null;
          });
        });
      }; // Need to normalize data source first. It can be canvas or image.
      // If image - try to decode in background if possible


      return Promise.resolve().then(function () {
        toCtx = to.getContext('2d', {
          alpha: Boolean(opts.alpha)
        });

        if (utils.isCanvas(from)) {
          srcCtx = from.getContext('2d', {
            alpha: Boolean(opts.alpha)
          });
          return null;
        }

        if (utils.isImage(from)) {
          // try do decode image in background for faster next operations
          if (!CAN_CREATE_IMAGE_BITMAP) return null;

          _this2.debug('Decode image via createImageBitmap');

          return createImageBitmap(from).then(function (imageBitmap) {
            srcImageBitmap = imageBitmap;
          }) // Suppress error to use fallback, if method fails
          // https://github.com/nodeca/pica/issues/190

          /* eslint-disable no-unused-vars */
          ["catch"](function (e) {
            return null;
          });
        }

        throw new Error('".from" should be image or canvas');
      }).then(function () {
        if (canceled) return cancelToken;

        _this2.debug('Calculate tiles'); //
        // Here we are with "normalized" source,
        // follow to tiling
        //


        var regions = createRegions({
          width: opts.width,
          height: opts.height,
          srcTileSize: _this2.options.tile,
          toWidth: opts.toWidth,
          toHeight: opts.toHeight,
          destTileBorder: destTileBorder
        });
        var jobs = regions.map(function (tile) {
          return processTile(tile);
        });

        function cleanup() {
          if (srcImageBitmap) {
            srcImageBitmap.close();
            srcImageBitmap = null;
          }
        }

        _this2.debug('Process tiles');

        return Promise.all(jobs).then(function () {
          _this2.debug('Finished!');

          cleanup();
          return to;
        }, function (err) {
          cleanup();
          throw err;
        });
      });
    };

    var processStages = function processStages(stages, from, to, opts) {
      if (canceled) return cancelToken;

      var _stages$shift = stages.shift(),
          _stages$shift2 = _slicedToArray(_stages$shift, 2),
          toWidth = _stages$shift2[0],
          toHeight = _stages$shift2[1];

      var isLastStage = stages.length === 0;
      opts = assign({}, opts, {
        toWidth: toWidth,
        toHeight: toHeight,
        // only use user-defined quality for the last stage,
        // use simpler (Hamming) filter for the first stages where
        // scale factor is large enough (more than 2-3)
        quality: isLastStage ? opts.quality : Math.min(1, opts.quality)
      });
      var tmpCanvas;

      if (!isLastStage) {
        // create temporary canvas
        tmpCanvas = document.createElement('canvas');
        tmpCanvas.width = toWidth;
        tmpCanvas.height = toHeight;
      }

      return tileAndResize(from, isLastStage ? to : tmpCanvas, opts).then(function () {
        if (isLastStage) return to;
        opts.width = toWidth;
        opts.height = toHeight;
        return processStages(stages, tmpCanvas, to, opts);
      });
    };

    var stages = createStages(opts.width, opts.height, opts.toWidth, opts.toHeight, _this2.options.tile, destTileBorder);
    return processStages(stages, from, to, opts);
  });
}; // RGBA buffer resize
//


Pica.prototype.resizeBuffer = function (options) {
  var _this3 = this;

  var opts = assign({}, DEFAULT_RESIZE_OPTS, options);
  return this.init().then(function () {
    return _this3.__mathlib.resizeAndUnsharp(opts);
  });
};

Pica.prototype.toBlob = function (canvas, mimeType, quality) {
  mimeType = mimeType || 'image/png';
  return new Promise(function (resolve) {
    if (canvas.toBlob) {
      canvas.toBlob(function (blob) {
        return resolve(blob);
      }, mimeType, quality);
      return;
    }

    if (canvas.convertToBlob) {
      resolve(canvas.convertToBlob({
        type: mimeType,
        quality: quality
      }));
      return;
    } // Fallback for old browsers


    var asString = atob(canvas.toDataURL(mimeType, quality).split(',')[1]);
    var len = asString.length;
    var asBuffer = new Uint8Array(len);

    for (var i = 0; i < len; i++) {
      asBuffer[i] = asString.charCodeAt(i);
    }

    resolve(new Blob([asBuffer], {
      type: mimeType
    }));
  });
};

Pica.prototype.debug = function () {};

module.exports = Pica;

},{"./lib/mathlib":1,"./lib/pool":9,"./lib/stepper":10,"./lib/tiler":11,"./lib/utils":12,"./lib/worker":13,"object-assign":24,"webworkify":25}]},{},[])("/")
});


/***/ }),

/***/ 93806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ es_Blurhash; }
});

// UNUSED EXPORTS: BlurhashCanvas

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/blurhash/dist/index.js
var dist = __webpack_require__(13060);
;// CONCATENATED MODULE: ./node_modules/react-blurhash/es/BlurhashCanvas.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var BlurhashCanvas = /** @class */ (function (_super) {
    __extends(BlurhashCanvas, _super);
    function BlurhashCanvas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canvas = null;
        _this.handleRef = function (canvas) {
            _this.canvas = canvas;
            _this.draw();
        };
        _this.draw = function () {
            var _a = _this.props, hash = _a.hash, height = _a.height, punch = _a.punch, width = _a.width;
            if (_this.canvas) {
                var pixels = (0,dist.decode)(hash, width, height, punch);
                var ctx = _this.canvas.getContext('2d');
                var imageData = ctx.createImageData(width, height);
                imageData.data.set(pixels);
                ctx.putImageData(imageData, 0, 0);
            }
        };
        return _this;
    }
    BlurhashCanvas.prototype.componentDidUpdate = function () {
        this.draw();
    };
    BlurhashCanvas.prototype.render = function () {
        var _a = this.props, hash = _a.hash, height = _a.height, width = _a.width, rest = __rest(_a, ["hash", "height", "width"]);
        return react.createElement("canvas", __assign({}, rest, { height: height, width: width, ref: this.handleRef }));
    };
    BlurhashCanvas.defaultProps = {
        height: 128,
        width: 128,
    };
    return BlurhashCanvas;
}(react.PureComponent));
/* harmony default export */ var es_BlurhashCanvas = (BlurhashCanvas);
//# sourceMappingURL=BlurhashCanvas.js.map
;// CONCATENATED MODULE: ./node_modules/react-blurhash/es/Blurhash.js
var Blurhash_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Blurhash_assign = (undefined && undefined.__assign) || function () {
    Blurhash_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Blurhash_assign.apply(this, arguments);
};
var Blurhash_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var canvasStyle = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
};
var Blurhash = /** @class */ (function (_super) {
    Blurhash_extends(Blurhash, _super);
    function Blurhash() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Blurhash.prototype.componentDidUpdate = function () {
        if (this.props.resolutionX <= 0) {
            throw new Error('resolutionX must be larger than zero');
        }
        if (this.props.resolutionY <= 0) {
            throw new Error('resolutionY must be larger than zero');
        }
    };
    Blurhash.prototype.render = function () {
        var _a = this.props, hash = _a.hash, height = _a.height, width = _a.width, punch = _a.punch, resolutionX = _a.resolutionX, resolutionY = _a.resolutionY, style = _a.style, rest = Blurhash_rest(_a, ["hash", "height", "width", "punch", "resolutionX", "resolutionY", "style"]);
        return (react.createElement("div", Blurhash_assign({}, rest, { style: Blurhash_assign(Blurhash_assign({ display: 'inline-block', height: height, width: width }, style), { position: 'relative' }) }),
            react.createElement(es_BlurhashCanvas, { hash: hash, height: resolutionY, width: resolutionX, punch: punch, style: canvasStyle })));
    };
    Blurhash.defaultProps = {
        height: 128,
        width: 128,
        resolutionX: 32,
        resolutionY: 32,
    };
    return Blurhash;
}(react.PureComponent));
/* harmony default export */ var es_Blurhash = (Blurhash);
//# sourceMappingURL=Blurhash.js.map
;// CONCATENATED MODULE: ./node_modules/react-blurhash/es/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 53441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DebounceInput = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _lodash = _interopRequireDefault(__webpack_require__(91296));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DebounceInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DebounceInput, _React$PureComponent);

  var _super = _createSuper(DebounceInput);

  function DebounceInput(props) {
    var _this;

    _classCallCheck(this, DebounceInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      event.persist();
      var oldValue = _this.state.value;
      var minLength = _this.props.minLength;

      _this.setState({
        value: event.target.value
      }, function () {
        var value = _this.state.value;

        if (value.length >= minLength) {
          _this.notify(event);

          return;
        } // If user hits backspace and goes below minLength consider it cleaning the value


        if (oldValue.length > value.length) {
          _this.notify(_objectSpread(_objectSpread({}, event), {}, {
            target: _objectSpread(_objectSpread({}, event.target), {}, {
              value: ''
            })
          }));
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === 'Enter') {
        _this.forceNotify(event);
      } // Invoke original onKeyDown if present


      var onKeyDown = _this.props.onKeyDown;

      if (onKeyDown) {
        event.persist();
        onKeyDown(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      _this.forceNotify(event); // Invoke original onBlur if present


      var onBlur = _this.props.onBlur;

      if (onBlur) {
        event.persist();
        onBlur(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createNotifier", function (debounceTimeout) {
      if (debounceTimeout < 0) {
        _this.notify = function () {
          return null;
        };
      } else if (debounceTimeout === 0) {
        _this.notify = _this.doNotify;
      } else {
        var debouncedChangeFunc = (0, _lodash["default"])(function (event) {
          _this.isDebouncing = false;

          _this.doNotify(event);
        }, debounceTimeout);

        _this.notify = function (event) {
          _this.isDebouncing = true;
          debouncedChangeFunc(event);
        };

        _this.flush = function () {
          return debouncedChangeFunc.flush();
        };

        _this.cancel = function () {
          _this.isDebouncing = false;
          debouncedChangeFunc.cancel();
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "doNotify", function () {
      var onChange = _this.props.onChange;
      onChange.apply(void 0, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "forceNotify", function (event) {
      var debounceTimeout = _this.props.debounceTimeout;

      if (!_this.isDebouncing && debounceTimeout > 0) {
        return;
      }

      if (_this.cancel) {
        _this.cancel();
      }

      var value = _this.state.value;
      var minLength = _this.props.minLength;

      if (value.length >= minLength) {
        _this.doNotify(event);
      } else {
        _this.doNotify(_objectSpread(_objectSpread({}, event), {}, {
          target: _objectSpread(_objectSpread({}, event.target), {}, {
            value: value
          })
        }));
      }
    });

    _this.isDebouncing = false;
    _this.state = {
      value: typeof props.value === 'undefined' || props.value === null ? '' : props.value
    };
    var _debounceTimeout2 = _this.props.debounceTimeout;

    _this.createNotifier(_debounceTimeout2);

    return _this;
  }

  _createClass(DebounceInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.isDebouncing) {
        return;
      }

      var _this$props = this.props,
          value = _this$props.value,
          debounceTimeout = _this$props.debounceTimeout;
      var oldTimeout = prevProps.debounceTimeout,
          oldValue = prevProps.value;
      var stateValue = this.state.value;

      if (typeof value !== 'undefined' && oldValue !== value && stateValue !== value) {
        // Update state.value if new value passed via props, yep re-render should happen
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          value: value
        });
      }

      if (debounceTimeout !== oldTimeout) {
        this.createNotifier(debounceTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.flush) {
        this.flush();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          element = _this$props2.element,
          _onChange = _this$props2.onChange,
          _value = _this$props2.value,
          _minLength = _this$props2.minLength,
          _debounceTimeout = _this$props2.debounceTimeout,
          forceNotifyByEnter = _this$props2.forceNotifyByEnter,
          forceNotifyOnBlur = _this$props2.forceNotifyOnBlur,
          onKeyDown = _this$props2.onKeyDown,
          onBlur = _this$props2.onBlur,
          inputRef = _this$props2.inputRef,
          props = _objectWithoutProperties(_this$props2, ["element", "onChange", "value", "minLength", "debounceTimeout", "forceNotifyByEnter", "forceNotifyOnBlur", "onKeyDown", "onBlur", "inputRef"]);

      var value = this.state.value;
      var maybeOnKeyDown;

      if (forceNotifyByEnter) {
        maybeOnKeyDown = {
          onKeyDown: this.onKeyDown
        };
      } else if (onKeyDown) {
        maybeOnKeyDown = {
          onKeyDown: onKeyDown
        };
      } else {
        maybeOnKeyDown = {};
      }

      var maybeOnBlur;

      if (forceNotifyOnBlur) {
        maybeOnBlur = {
          onBlur: this.onBlur
        };
      } else if (onBlur) {
        maybeOnBlur = {
          onBlur: onBlur
        };
      } else {
        maybeOnBlur = {};
      }

      var maybeRef = inputRef ? {
        ref: inputRef
      } : {};
      return /*#__PURE__*/_react["default"].createElement(element, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
        onChange: this.onChange,
        value: value
      }, maybeOnKeyDown), maybeOnBlur), maybeRef));
    }
  }]);

  return DebounceInput;
}(_react["default"].PureComponent);

exports.DebounceInput = DebounceInput;

_defineProperty(DebounceInput, "defaultProps", {
  element: 'input',
  type: 'text',
  onKeyDown: undefined,
  onBlur: undefined,
  value: undefined,
  minLength: 0,
  debounceTimeout: 100,
  forceNotifyByEnter: true,
  forceNotifyOnBlur: true,
  inputRef: undefined
});

/***/ }),

/***/ 775:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(53441),
    DebounceInput = _require.DebounceInput;

DebounceInput.DebounceInput = DebounceInput;
module.exports = DebounceInput;

/***/ }),

/***/ 64887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = HtmlParser;

var _htmlparser = __webpack_require__(23719);

var _htmlparser2 = _interopRequireDefault(_htmlparser);

var _processNodes = __webpack_require__(96630);

var _processNodes2 = _interopRequireDefault(_processNodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parses a HTML string and returns a list of React components generated from it
 *
 * @param {String} html The HTML to convert into React component
 * @param {Object} options Options to pass
 * @returns {Array} List of top level React elements
 */
function HtmlParser(html) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$decodeEntities = _ref.decodeEntities,
      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
      transform = _ref.transform,
      _ref$preprocessNodes = _ref.preprocessNodes,
      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
    return nodes;
  } : _ref$preprocessNodes;

  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
  return (0, _processNodes2.default)(nodes, transform);
}

/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = convertNodeToElement;

var _elementTypes = __webpack_require__(30532);

var _elementTypes2 = _interopRequireDefault(_elementTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a htmlparser2 node to a React element
 *
 * @param {Object} node The htmlparser2 node to convert
 * @param {Number} index The index of the current node
 * @param {Function} transform Transform function to apply to children of the node
 * @returns {React.Element}
 */
function convertNodeToElement(node, index, transform) {
  return _elementTypes2.default[node.type](node, index, transform);
}

/***/ }),

/***/ 25888:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/**
 * List of boolean attributes
 * These attributes should have their React attribute value set to be the same as their name
 * E.g. <input disabled> = <input disabled>
 *      <input disabled=""> = <input disabled>
 *      <input disabled="disabled"> = <input disabled>
 * @type {Array}
 */
exports["default"] = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ }),

/***/ 65260:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/**
 * Mapping of standard HTML attributes to their React counterparts
 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 * @type {Object}
 */
exports["default"] = {
  /**
   * Standard Properties
   */
  accept: 'accept',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  allowtransparency: 'allowTransparency',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocomplete: 'autoComplete',
  autoplay: 'autoPlay',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  charset: 'charSet',
  challenge: 'challenge',
  checked: 'checked',
  cite: 'cite',
  classid: 'classID',
  class: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlsList: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  form: 'form',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formmethod: 'formMethod',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  for: 'htmlFor',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginheight: 'marginHeight',
  marginwidth: 'marginWidth',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  slot: 'slot',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  /**
   * RDFa Properties
   */
  about: 'about',
  datatype: 'datatype',
  inlist: 'inlist',
  prefix: 'prefix',
  property: 'property',
  resource: 'resource',
  typeof: 'typeof',
  vocab: 'vocab',
  /**
   * Non-standard Properties
   */
  autocapitalize: 'autoCapitalize',
  autocorrect: 'autoCorrect',
  autosave: 'autoSave',
  color: 'color',
  itemprop: 'itemProp',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  itemid: 'itemID',
  itemref: 'itemRef',
  results: 'results',
  security: 'security',
  unselectable: 'unselectable'
};

/***/ }),

/***/ 73662:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/**
 * List of void elements
 * These elements are not allowed to have children
 * @type {Array}
 */
exports["default"] = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ }),

/***/ 95961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = StyleElementType;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _generatePropsFromAttributes = __webpack_require__(98024);

var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a <style> element to a React element
 *
 * @param {Object} node The style node
 * @param {String} index The index of the React element relative to it's parent
 * @returns {React.Element} The React style element
 */
function StyleElementType(node, index) {

  // The style element only ever has a single child which is the styles so try and find this to add as
  // a child to the style element that will be created
  var styles = void 0;
  if (node.children.length > 0) {
    styles = node.children[0].data;
  }

  // generate props
  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);

  // create and return the element
  return _react2.default.createElement('style', props, styles);
}

/***/ }),

/***/ 32593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = TagElementType;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _processNodes = __webpack_require__(96630);

var _processNodes2 = _interopRequireDefault(_processNodes);

var _generatePropsFromAttributes = __webpack_require__(98024);

var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);

var _VoidElements = __webpack_require__(73662);

var _VoidElements2 = _interopRequireDefault(_VoidElements);

var _isValidTagOrAttributeName = __webpack_require__(92536);

var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
 *
 * @param {Object} node The tag node
 * @param {String} index The index of the React element relative to it's parent
 * @param {Function} transform The transform function to apply to all children
 * @returns {React.Element} The React tag element
 */
function TagElementType(node, index, transform) {

  var tagName = node.name;

  // validate tag name
  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
    return null;
  }

  // generate props
  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);

  // If the node is not a void element and has children then process them
  var children = null;
  if (_VoidElements2.default.indexOf(tagName) === -1) {
    children = (0, _processNodes2.default)(node.children, transform);
  }

  // create and return the element
  return _react2.default.createElement(tagName, props, children);
}

/***/ }),

/***/ 43180:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = TextElementType;
/**
 * Converts a text node to a React text element
 *
 * @param {Object} node The text node
 * @returns {String} The text
 */
function TextElementType(node) {

  // React will accept plain text for rendering so just return the node data
  return node.data;
}

/***/ }),

/***/ 65639:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = UnsupportedElementType;
/**
 * Handles an unsupported element type by returning null so nothing is rendered
 * @returns {null}
 */
function UnsupportedElementType() {

  // do nothing because the element type is unsupported
  // comment, directive, script, cdata, doctype are all currently unsupported
  return null;
}

/***/ }),

/***/ 30532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _ElementType$Text$Ele;

var _htmlparser = __webpack_require__(23719);

var _TextElementType = __webpack_require__(43180);

var _TextElementType2 = _interopRequireDefault(_TextElementType);

var _TagElementType = __webpack_require__(32593);

var _TagElementType2 = _interopRequireDefault(_TagElementType);

var _StyleElementType = __webpack_require__(95961);

var _StyleElementType2 = _interopRequireDefault(_StyleElementType);

var _UnsupportedElementType = __webpack_require__(65639);

var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
                                                                                                                                                                                                                   * value
                                                                                                                                                                                                                   */

exports["default"] = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ }),

/***/ 30653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _processNodes = __webpack_require__(96630);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_processNodes).default;
  }
});

var _convertNodeToElement = __webpack_require__(5324);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_convertNodeToElement).default;
  }
});

var _htmlparser = __webpack_require__(23719);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_htmlparser).default;
  }
});

var _HtmlParser = __webpack_require__(64887);

var _HtmlParser2 = _interopRequireDefault(_HtmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ZP = _HtmlParser2.default;

/***/ }),

/***/ 96630:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = processNodes;

var _isEmptyTextNode = __webpack_require__(92057);

var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);

var _convertNodeToElement = __webpack_require__(5324);

var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes the nodes generated by htmlparser2 and convert them all into React elements
 *
 * @param {Object[]} nodes List of nodes to process
 * @param {Function} transform Transform function to optionally apply to nodes
 * @returns {React.Element[]} The list of processed React elements
 */
function processNodes(nodes, transform) {

  return nodes.filter(function (node) {
    return !(0, _isEmptyTextNode2.default)(node);
  }).map(function (node, index) {

    // return the result of the transform function if applicable
    var transformed = void 0;
    if (typeof transform === 'function') {
      transformed = transform(node, index);
      if (transformed === null || !!transformed) {
        return transformed;
      }
    }

    // otherwise convert the node as standard
    return (0, _convertNodeToElement2.default)(node, index, transform);
  });
}

/***/ }),

/***/ 98024:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = generatePropsFromAttributes;

var _htmlAttributesToReact = __webpack_require__(24381);

var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);

var _inlineStyleToObject = __webpack_require__(13083);

var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates props for a React element from an object of HTML attributes
 *
 * @param {Object} attributes The HTML attributes
 * @param {String} key The key to give the react element
 */
function generatePropsFromAttributes(attributes, key) {

  // generate props
  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });

  // if there is an inline/string style prop then convert it to a React style object
  // otherwise, it is invalid and omitted
  if (typeof props.style === 'string' || props.style instanceof String) {
    props.style = (0, _inlineStyleToObject2.default)(props.style);
  } else {
    delete props.style;
  }

  return props;
}

/***/ }),

/***/ 24381:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = htmlAttributesToReact;

var _BooleanAttributes = __webpack_require__(25888);

var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);

var _ReactAttributes = __webpack_require__(65260);

var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);

var _isValidTagOrAttributeName = __webpack_require__(92536);

var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the parsed attribute value taking into account things like boolean attributes
 *
 * @param {String} attribute The name of the attribute
 * @param {*} value The value of the attribute from the HTML
 * @returns {*} The parsed attribute value
 */
var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {

  // if the attribute if a boolean then it's value should be the same as it's name
  // e.g. disabled="disabled"
  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
    return attr.toLowerCase();
  });
  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
    value = attribute;
  }

  return value;
};

/**
 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
 * version does not exist for an attribute then just use it as it is
 *
 * @param {Object} attributes The HTML attributes to convert
 * @returns {Object} The React attributes
 */
function htmlAttributesToReact(attributes) {

  return Object.keys(attributes).filter(function (attr) {
    return (0, _isValidTagOrAttributeName2.default)(attr);
  }).reduce(function (mappedAttributes, attribute) {

    // lowercase the attribute name and find it in the react attribute map
    var lowerCaseAttribute = attribute.toLowerCase();

    // format the attribute name
    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;

    // add the parsed attribute value to the mapped attributes
    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);

    return mappedAttributes;
  }, {});
}

/***/ }),

/***/ 13083:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports["default"] = InlineStyleToObject;
/**
 * Converts an inline style string into an object of React style properties
 *
 * @param {String} inlineStyle='' The inline style to convert
 * @returns {Object} The converted style
 */
function InlineStyleToObject() {
  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


  // just return empty object if the inlineStyle is empty
  if (inlineStyle === '') {
    return {};
  }

  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {

    // extract the style property name and value
    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
      return i > 0;
    }).map(function (item) {
      return item.trim().toLowerCase();
    }),
        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
        property = _stylePropertyValue$s2[0],
        value = _stylePropertyValue$s2[1];

    // if there is no value (i.e. no : in the style) then ignore it


    if (value === undefined) {
      return styleObject;
    }

    // convert the property name into the correct React format
    // remove all hyphens and convert the letter immediately after each hyphen to upper case
    // additionally don't uppercase any -ms- prefix
    // e.g. -ms-style-property = msStyleProperty
    //      -webkit-style-property = WebkitStyleProperty
    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
      return character.toUpperCase();
    });

    // add the new style property and value to the style object
    styleObject[property] = value;

    return styleObject;
  }, {});
}

/***/ }),

/***/ 92057:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEmptyTextNode;
/**
 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
 *
 * @param {Object} node The element object as created by htmlparser2
 * @returns {boolean} Whether the node is an empty text node
 */
function isEmptyTextNode(node) {
  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
}

/***/ }),

/***/ 92536:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isValidTagOrAttributeName;
var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;

var nameCache = {};

function isValidTagOrAttributeName(tagName) {
  if (!nameCache.hasOwnProperty(tagName)) {
    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
  }
  return nameCache[tagName];
}

/***/ }),

/***/ 71100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ es; }
});

// UNUSED EXPORTS: Background, Picture, PublicConfigAPI, Source, buildURL

;// CONCATENATED MODULE: ./node_modules/react-imgix/es/array-findindex.js
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, "findIndex", {
    value: function value(predicate) {
      "use strict";

      if (this == null) {
        throw new TypeError("Array.prototype.findIndex called on null or undefined");
      }

      if (typeof predicate !== "function") {
        throw new TypeError("predicate must be a function");
      }

      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];

        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }

      return -1;
    },
    enumerable: false,
    configurable: false,
    writable: false
  });
}

/* harmony default export */ var array_findindex = (true);
//# sourceMappingURL=array-findindex.js.map
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/targetWidths.js
function targetWidths() {
  var resolutions = [];
  var prev = 100;
  var INCREMENT_PERCENTAGE = 8;
  var MAX_SIZE = 8192;

  var ensureEven = function ensureEven(n) {
    return 2 * Math.round(n / 2);
  };

  while (prev <= MAX_SIZE) {
    resolutions.push(ensureEven(prev));
    prev *= 1 + INCREMENT_PERCENTAGE / 100 * 2;
  }

  resolutions.push(MAX_SIZE);
  return resolutions;
}

/* harmony default export */ var es_targetWidths = (targetWidths());
//# sourceMappingURL=targetWidths.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/constructUrl.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright © 2015 by Coursera
Licensed under the Apache License 2.0, seen https://github.com/coursera/react-imgix/blob/master/LICENSE

Minor syntax modifications have been made
*/
var Base64 = (__webpack_require__(19575).Base64);

var PACKAGE_VERSION = "9.0.2";
 // @see https://www.imgix.com/docs/reference

var PARAM_EXPANSION = Object.freeze({
  // Adjustment
  brightness: "bri",
  contrast: "con",
  exposure: "exp",
  gamma: "gam",
  highlights: "high",
  hue: "hue",
  invert: "invert",
  saturation: "sat",
  shaddows: "shad",
  sharpness: "sharp",
  "unsharp-mask": "usm",
  "unsharp-radius": "usmrad",
  vibrance: "vib",
  // Automatic
  "auto-features": "auto",
  // Background
  "background-color": "bg",
  // Blend
  blend: "blend",
  "blend-mode": "bm",
  "blend-align": "ba",
  "blend-alpha": "balph",
  "blend-padding": "bp",
  "blend-width": "bw",
  "blend-height": "bh",
  "blend-fit": "bf",
  "blend-crop": "bc",
  "blend-size": "bs",
  "blend-x": "bx",
  "blend-y": "by",
  // Border & Padding
  border: "border",
  padding: "pad",
  // Face Detection
  "face-index": "faceindex",
  "face-padding": "facepad",
  faces: "faces",
  // Format
  "chroma-subsampling": "chromasub",
  "color-quantization": "colorquant",
  download: "dl",
  DPI: "dpi",
  format: "fm",
  "lossless-compression": "lossless",
  quality: "q",
  // Mask
  "mask-image": "mask",
  // Mask
  "noise-blur": "nr",
  "noise-sharpen": "nrs",
  // Palette n/a
  // PDF n/a
  // Pixel Density n/a
  // Rotation
  "flip-direction": "flip",
  orientation: "or",
  "rotation-angle": "rot",
  // Size
  "crop-mode": "crop",
  "fit-mode": "fit",
  "image-height": "h",
  "image-width": "w",
  // Stylize
  blurring: "blur",
  halftone: "htn",
  monotone: "mono",
  pixelate: "px",
  "sepia-tone": "sepia",
  // Trim TODO
  // Watermark TODO
  // Extra
  height: "h",
  width: "w"
});
var DEFAULT_OPTIONS = Object.freeze({
  auto: "format" // http://www.imgix.com/docs/reference/automatic#param-auto

});
/**
 * Construct a URL for an image with an Imgix proxy, expanding image options
 * per the [API reference docs](https://www.imgix.com/docs/reference).
 * @param  {String} src         src of raw image
 * @param  {Object} longOptions map of image API options, in long or short form per expansion rules
 * @return {String}             URL of image src transformed by Imgix
 */

function constructUrl(src, longOptions) {
  if (!src) {
    return "";
  }

  var keys = Object.keys(longOptions);
  var keysLength = keys.length;
  var url = src + "?";

  for (var i = 0; i < keysLength; i++) {
    var key = keys[i];
    var val = longOptions[key];

    if (PARAM_EXPANSION[key]) {
      key = PARAM_EXPANSION[key];
    } else {
      key = encodeURIComponent(key);
    }

    if (key.substr(-2) === "64") {
      val = Base64.encodeURI(val);
    }

    url += key + "=" + encodeURIComponent(val) + "&";
  }

  return url.slice(0, -1);
}

function buildURLPublic(src) {
  var imgixParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var disableLibraryParam = options.disableLibraryParam;

  var _extractQueryParams = extractQueryParams(src),
      _extractQueryParams2 = _slicedToArray(_extractQueryParams, 2),
      rawSrc = _extractQueryParams2[0],
      params = _extractQueryParams2[1];

  return constructUrl(rawSrc, _extends({}, params, imgixParams, disableLibraryParam ? {} : {
    ixlib: "react-".concat(PACKAGE_VERSION)
  }));
}

/* harmony default export */ var es_constructUrl = (constructUrl);

//# sourceMappingURL=constructUrl.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/extractQueryParams.js
function extractQueryParams_extractQueryParams(src) {
  var splitSrc = src.split("?");
  var url = splitSrc[0];
  var query = splitSrc[1];

  if (!query) {
    return [url, {}];
  }

  var paramsPairs = query.split("&");
  var params = {};
  var len = paramsPairs.length;

  for (var i = 0; i < len; i++) {
    var param = paramsPairs[i];
    var splitParam = param.split("=");
    var key = splitParam[0];
    var val = splitParam[1];
    params[key] = decodeURIComponent(val);
  }

  return [url, params];
}
//# sourceMappingURL=extractQueryParams.js.map
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/config.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var config = {
  warnings: {
    fallbackImage: true,
    sizesAttribute: true,
    invalidARFormat: true
  }
};

var _setWarning = function _setWarning(name, value) {
  if (!name || !(name in config.warnings)) {
    return;
  }

  config.warnings[name] = value;
};

var PublicConfigAPI =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function PublicConfigAPI() {
    _classCallCheck(this, PublicConfigAPI);
  }

  _createClass(PublicConfigAPI, null, [{
    key: "disableWarning",
    value: function disableWarning(name) {
      _setWarning(name, false);
    }
  }, {
    key: "enableWarning",
    value: function enableWarning(name) {
      _setWarning(name, true);
    }
  }]);

  return PublicConfigAPI;
}()));

/* harmony default export */ var es_config = (config);

//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/common.js


 // Taken from https://github.com/reduxjs/redux/blob/v4.0.0/src/compose.js

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/HOCs/shouldComponentUpdateHOC.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function shouldComponentUpdateHOC_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function shouldComponentUpdateHOC_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function shouldComponentUpdateHOC_createClass(Constructor, protoProps, staticProps) { if (protoProps) shouldComponentUpdateHOC_defineProperties(Constructor.prototype, protoProps); if (staticProps) shouldComponentUpdateHOC_defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var ShouldComponentUpdateHOC = function ShouldComponentUpdateHOC(WrappedComponent) {
  var ShouldComponentUpdateHOC =
  /*#__PURE__*/
  function (_Component) {
    _inherits(ShouldComponentUpdateHOC, _Component);

    function ShouldComponentUpdateHOC() {
      var _getPrototypeOf2;

      var _this;

      shouldComponentUpdateHOC_classCallCheck(this, ShouldComponentUpdateHOC);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ShouldComponentUpdateHOC)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function (nextProps) {
        var props = _this.props;
        warning_default()(nextProps.onMounted == _this.props.onMounted, "props.onMounted() is changing between renders. This is probably not intended. Ensure that a class method is being passed to Imgix rather than a function that is created every render. If this is intended, ignore this warning.");

        var customizer = function customizer(oldProp, newProp, key) {
          if (key === "children") {
            return shallowequal_default()(oldProp, newProp);
          }

          if (key === "imgixParams") {
            return shallowequal_default()(oldProp, newProp, function (a, b) {
              if (Array.isArray(a)) {
                return shallowequal_default()(a, b);
              }

              return undefined;
            });
          }

          if (key === "htmlAttributes") {
            return shallowequal_default()(oldProp, newProp);
          }

          if (key === "attributeConfig") {
            return shallowequal_default()(oldProp, newProp);
          }

          return undefined; // handled by shallowEqual
        };

        var propsAreEqual = shallowequal_default()(props, nextProps, customizer);
        return !propsAreEqual;
      });

      return _this;
    }

    shouldComponentUpdateHOC_createClass(ShouldComponentUpdateHOC, [{
      key: "render",
      value: function render() {
        return react.createElement(WrappedComponent, this.props);
      }
    }]);

    return ShouldComponentUpdateHOC;
  }(react.Component);

  ShouldComponentUpdateHOC.displayName = "ShouldComponentUpdateHOC(".concat(WrappedComponent.displayName, ")");
  return ShouldComponentUpdateHOC;
};


//# sourceMappingURL=shouldComponentUpdateHOC.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/HOCs/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/constants.js
function _objectValues(obj) {
  var values = [];
  var keys = Object.keys(obj);

  for (var k = 0; k < keys.length; k++) values.push(obj[keys[k]]);

  return values;
}

var DPR_QUALITY = {
  q_dpr1: 75,
  q_dpr2: 50,
  q_dpr3: 35,
  q_dpr4: 23,
  q_dpr5: 20
};
var DPR_QUALITY_VALUES = _objectValues(DPR_QUALITY);
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/react-imgix.js
function react_imgix_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { react_imgix_typeof = function _typeof(obj) { return typeof obj; }; } else { react_imgix_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return react_imgix_typeof(obj); }

function react_imgix_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function react_imgix_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function react_imgix_createClass(Constructor, protoProps, staticProps) { if (protoProps) react_imgix_defineProperties(Constructor.prototype, protoProps); if (staticProps) react_imgix_defineProperties(Constructor, staticProps); return Constructor; }

function react_imgix_possibleConstructorReturn(self, call) { if (call && (react_imgix_typeof(call) === "object" || typeof call === "function")) { return call; } return react_imgix_assertThisInitialized(self); }

function react_imgix_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function react_imgix_getPrototypeOf(o) { react_imgix_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return react_imgix_getPrototypeOf(o); }

function react_imgix_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) react_imgix_setPrototypeOf(subClass, superClass); }

function react_imgix_setPrototypeOf(o, p) { react_imgix_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return react_imgix_setPrototypeOf(o, p); }

function react_imgix_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function react_imgix_slicedToArray(arr, i) { return react_imgix_arrayWithHoles(arr) || react_imgix_iterableToArrayLimit(arr, i) || react_imgix_nonIterableRest(); }

function react_imgix_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function react_imgix_iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function react_imgix_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function react_imgix_extends() { react_imgix_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return react_imgix_extends.apply(this, arguments); }










var react_imgix_PACKAGE_VERSION = "9.0.2";
var NODE_ENV = "production";

var buildKey = function buildKey(idx) {
  return "react-imgix-".concat(idx);
};

var defaultImgixParams = {
  auto: ["format"]
};
var defaultAttributeMap = {
  src: "src",
  srcSet: "srcSet",
  sizes: "sizes"
};

var noop = function noop() {};

var COMMON_PROP_TYPES = {
  className: (prop_types_default()).string,
  onMounted: (prop_types_default()).func,
  htmlAttributes: (prop_types_default()).object
};

var SHARED_IMGIX_AND_SOURCE_PROP_TYPES = react_imgix_extends({}, COMMON_PROP_TYPES, {
  disableQualityByDPR: (prop_types_default()).bool,
  disableSrcSet: (prop_types_default()).bool,
  disableLibraryParam: (prop_types_default()).bool,
  imgixParams: (prop_types_default()).object,
  sizes: (prop_types_default()).string,
  width: (prop_types_default()).number,
  height: (prop_types_default()).number,
  src: (prop_types_default()).string.isRequired
});
/**
 * Validates that an aspect ratio is in the format w:h. If false is returned, the aspect ratio is in the wrong format.
 */


function aspectRatioIsValid(aspectRatio) {
  if (typeof aspectRatio !== "string") {
    return false;
  }

  return /^\d+(\.\d+)?:\d+(\.\d+)?$/.test(aspectRatio);
}

var setParentRef = function setParentRef(parentRef, el) {
  if (!parentRef) {
    return;
  } // assign ref based on if it's a callback vs object


  if (typeof parentRef === "function") {
    parentRef(el);
  } else {
    parentRef.current = el;
  }
};

var buildSrcSetPairWithFixedHeight = function buildSrcSetPairWithFixedHeight(url, targetWidth, fixedHeight, _) {
  return url + "&h=" + fixedHeight + "&w=" + targetWidth + " " + targetWidth + "w";
};

var buildSrcSetPairWithTargetWidth = function buildSrcSetPairWithTargetWidth(url, targetWidth, _1, _2) {
  return url + "&w=" + targetWidth + " " + targetWidth + "w";
};

var buildDprSrcWithQuality = function buildDprSrcWithQuality(url, quality, dpr) {
  return url + "&q=" + quality + "&dpr=" + dpr + " " + dpr + "x";
};

var buildDprSrcWithoutQuality = function buildDprSrcWithoutQuality(url, _, dpr) {
  return url + "&dpr=" + dpr + " " + dpr + "x";
};

var buildDprSrcWithQualityByDpr = function buildDprSrcWithQualityByDpr(url, quality, dpr) {
  return url + "&q=" + quality + "&dpr=" + dpr + " " + dpr + "x";
};
/**
 * Build a imgix source url with parameters from a raw url
 */


function buildSrc(_ref) {
  var inputSrc = _ref.src,
      width = _ref.width,
      height = _ref.height,
      disableLibraryParam = _ref.disableLibraryParam,
      disableSrcSet = _ref.disableSrcSet,
      imgixParams = _ref.imgixParams,
      disableQualityByDPR = _ref.disableQualityByDPR;
  var fixedSize = width != null || height != null;

  var _extractQueryParams = extractQueryParams_extractQueryParams(inputSrc),
      _extractQueryParams2 = react_imgix_slicedToArray(_extractQueryParams, 2),
      rawSrc = _extractQueryParams2[0],
      params = _extractQueryParams2[1];

  var srcOptions = react_imgix_extends({}, params, imgixParams, disableLibraryParam ? {} : {
    ixlib: "react-".concat(react_imgix_PACKAGE_VERSION)
  }, fixedSize && height ? {
    height: height
  } : {}, fixedSize && width ? {
    width: width
  } : {});

  var src = es_constructUrl(rawSrc, srcOptions);
  var srcSet;

  if (disableSrcSet) {
    srcSet = src;
  } else {
    if (fixedSize) {
      var q = srcOptions.q,
          urlParams = _objectWithoutProperties(srcOptions, ["q"]);

      var constructedUrl = es_constructUrl(rawSrc, urlParams);
      var srcFn = buildDprSrcWithQualityByDpr;

      if (q) {
        srcFn = buildDprSrcWithQuality;
      } else if (disableQualityByDPR) {
        srcFn = buildDprSrcWithoutQuality;
      }

      srcSet = "";
      var len = DPR_QUALITY_VALUES.length;

      for (var _i2 = 0; _i2 < len; _i2++) {
        var quality = DPR_QUALITY_VALUES[_i2];
        srcSet += srcFn(constructedUrl, q || quality, _i2 + 1) + ", ";
      }

      srcSet = srcSet.slice(0, -2);
    } else {
      var _width = srcOptions.width,
          w = srcOptions.w,
          _height = srcOptions.height,
          _urlParams = _objectWithoutProperties(srcOptions, ["width", "w", "height"]);

      var _constructedUrl = es_constructUrl(rawSrc, _urlParams);

      var aspectRatio = imgixParams.ar;
      var showARWarning = aspectRatio != null && aspectRatioIsValid(aspectRatio) === false;
      var _srcFn = buildSrcSetPairWithTargetWidth;

      if (_height) {
        _srcFn = buildSrcSetPairWithFixedHeight;
      }

      srcSet = "";
      var _len = es_targetWidths.length;

      for (var _i3 = 0; _i3 < _len; _i3++) {
        var targetWidth = es_targetWidths[_i3];
        srcSet += _srcFn(_constructedUrl, targetWidth, _height) + ", ";
      }

      srcSet = srcSet.slice(0, -2);

      if (NODE_ENV !== "production" && showARWarning && es_config.warnings.invalidARFormat) {
        console.warn("[Imgix] The aspect ratio passed (\"".concat(aspectRatio, "\") is not in the correct format. The correct format is \"W:H\"."));
      }
    }
  }

  return {
    src: src,
    srcSet: srcSet
  };
}
/**
 * Combines default imgix params with custom imgix params to make a imgix params config object
 */


function imgixParams(props) {
  var params = react_imgix_extends({}, defaultImgixParams, props.imgixParams);

  return react_imgix_extends({}, params);
}
/**
 * React component used to render <img> elements with Imgix
 */


var ReactImgix =
/*#__PURE__*/
function (_Component) {
  react_imgix_inherits(ReactImgix, _Component);

  function ReactImgix(props) {
    var _this;

    react_imgix_classCallCheck(this, ReactImgix);

    _this = react_imgix_possibleConstructorReturn(this, react_imgix_getPrototypeOf(ReactImgix).call(this, props));
    _this.imgRef = null;
    return _this;
  }

  react_imgix_createClass(ReactImgix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.imgRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _extends2;

      var _this$props = this.props,
          disableSrcSet = _this$props.disableSrcSet,
          type = _this$props.type,
          width = _this$props.width,
          height = _this$props.height; // Pre-render checks

      if (NODE_ENV !== "production" && es_config.warnings.sizesAttribute) {
        if (this.props.width == null && this.props.height == null && this.props.sizes == null && !this.props._inPicture) {
          console.warn("If width and height are not set, a sizes attribute should be passed.");
        }
      }

      var _buildSrc = buildSrc(react_imgix_extends({}, this.props, {
        type: "img",
        imgixParams: imgixParams(this.props)
      })),
          src = _buildSrc.src,
          srcSet = _buildSrc.srcSet;

      var attributeConfig = react_imgix_extends({}, defaultAttributeMap, this.props.attributeConfig);

      var childProps = react_imgix_extends({}, this.props.htmlAttributes, (_extends2 = {}, react_imgix_defineProperty(_extends2, attributeConfig.sizes, this.props.sizes), react_imgix_defineProperty(_extends2, "className", this.props.className), react_imgix_defineProperty(_extends2, "width", width <= 1 ? null : width), react_imgix_defineProperty(_extends2, "height", height <= 1 ? null : height), react_imgix_defineProperty(_extends2, attributeConfig.src, src), react_imgix_defineProperty(_extends2, "ref", function ref(el) {
        _this2.imgRef = el;

        if (_this2.props.htmlAttributes !== undefined && "ref" in _this2.props.htmlAttributes) {
          setParentRef(_this2.props.htmlAttributes.ref, _this2.imgRef);
        }
      }), _extends2));

      if (!disableSrcSet) {
        childProps[attributeConfig.srcSet] = srcSet;
      }

      return react.createElement("img", childProps);
    }
  }]);

  return ReactImgix;
}(react.Component);

react_imgix_defineProperty(ReactImgix, "propTypes", react_imgix_extends({}, SHARED_IMGIX_AND_SOURCE_PROP_TYPES));

react_imgix_defineProperty(ReactImgix, "defaultProps", {
  disableSrcSet: false,
  onMounted: noop
});

ReactImgix.displayName = "ReactImgix";
/**
 * React component used to render <picture> elements with Imgix
 */

var PictureImpl =
/*#__PURE__*/
function (_Component2) {
  react_imgix_inherits(PictureImpl, _Component2);

  function PictureImpl(props) {
    var _this3;

    react_imgix_classCallCheck(this, PictureImpl);

    _this3 = react_imgix_possibleConstructorReturn(this, react_imgix_getPrototypeOf(PictureImpl).call(this, props));
    _this3.pictureRef = null;
    return _this3;
  }

  react_imgix_createClass(PictureImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.pictureRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var children = this.props.children; // make sure all of our children have key set, otherwise we get react warnings

      var _children = react.Children.map(children, function (child, idx) {
        return react.cloneElement(child, {
          key: buildKey(idx),
          _inPicture: true
        });
      }) || [];
      /*
      We need to make sure an <img /> or <Imgix /> is the last child so we look for one in children
        a. if we find one, move it to the last entry if it's not already there
        b. if we don't find one, warn the user as they probably want to pass one.
      */
      // look for an <img> or <ReactImgix type='img'> - at the bare minimum we have to have a single <img> element or else it will not work.


      var imgIdx = _children.findIndex(function (c) {
        return c.type === "img" || c.type === ReactImgix || c.type === ReactImgixWrapped;
      });

      if (imgIdx === -1 && es_config.warnings.fallbackImage) {
        console.warn("No fallback <img /> or <Imgix /> found in the children of a <picture> component. A fallback image should be passed to ensure the image renders correctly at all dimensions.");
      } else if (imgIdx !== _children.length - 1) {
        // found one, need to move it to the end
        _children.push(_children.splice(imgIdx, 1)[0]);
      }

      return react.createElement("picture", {
        ref: function ref(el) {
          return _this4.pictureRef = el;
        },
        children: _children
      });
    }
  }]);

  return PictureImpl;
}(react.Component);

react_imgix_defineProperty(PictureImpl, "propTypes", react_imgix_extends({}, COMMON_PROP_TYPES, {
  children: (prop_types_default()).any
}));

react_imgix_defineProperty(PictureImpl, "defaultProps", {
  onMounted: noop
});

PictureImpl.displayName = "ReactImgixPicture";
/**
 * React component used to render <source> elements with Imgix
 */

var SourceImpl =
/*#__PURE__*/
function (_Component3) {
  react_imgix_inherits(SourceImpl, _Component3);

  function SourceImpl(props) {
    var _this5;

    react_imgix_classCallCheck(this, SourceImpl);

    _this5 = react_imgix_possibleConstructorReturn(this, react_imgix_getPrototypeOf(SourceImpl).call(this, props));
    _this5.sourceRef = null;
    return _this5;
  }

  react_imgix_createClass(SourceImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.sourceRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
          _extends3;

      var _this$props2 = this.props,
          disableSrcSet = _this$props2.disableSrcSet,
          width = _this$props2.width,
          height = _this$props2.height;

      var _buildSrc2 = buildSrc(react_imgix_extends({}, this.props, {
        type: "source",
        imgixParams: imgixParams(this.props)
      })),
          src = _buildSrc2.src,
          srcSet = _buildSrc2.srcSet;

      var attributeConfig = react_imgix_extends({}, defaultAttributeMap, this.props.attributeConfig);

      var childProps = react_imgix_extends({}, this.props.htmlAttributes, (_extends3 = {}, react_imgix_defineProperty(_extends3, attributeConfig.sizes, this.props.sizes), react_imgix_defineProperty(_extends3, "className", this.props.className), react_imgix_defineProperty(_extends3, "width", width <= 1 ? null : width), react_imgix_defineProperty(_extends3, "height", height <= 1 ? null : height), react_imgix_defineProperty(_extends3, "ref", function ref(el) {
        _this6.sourceRef = el;

        if (_this6.props.htmlAttributes !== undefined && "ref" in _this6.props.htmlAttributes) {
          setParentRef(_this6.props.htmlAttributes.ref, _this6.sourceRef);
        }
      }), _extends3)); // inside of a <picture> element a <source> element ignores its src
      // attribute in favor of srcSet so we set that with either an actual
      // srcSet or a single src


      if (disableSrcSet) {
        childProps[attributeConfig.srcSet] = src;
      } else {
        childProps[attributeConfig.srcSet] = "".concat(srcSet);
      } // for now we'll take media from htmlAttributes which isn't ideal because
      //   a) this isn't an <img>
      //   b) passing objects as props means that react will always rerender
      //      since objects dont respond correctly to ===


      return react.createElement("source", childProps);
    }
  }]);

  return SourceImpl;
}(react.Component);

react_imgix_defineProperty(SourceImpl, "propTypes", react_imgix_extends({}, SHARED_IMGIX_AND_SOURCE_PROP_TYPES));

react_imgix_defineProperty(SourceImpl, "defaultProps", {
  disableSrcSet: false,
  onMounted: noop
});

SourceImpl.displayName = "ReactImgixSource";
var ReactImgixWrapped = compose(ShouldComponentUpdateHOC)(ReactImgix);
var Picture = compose(ShouldComponentUpdateHOC)(PictureImpl);
var Source = compose(ShouldComponentUpdateHOC)(SourceImpl);
/* harmony default export */ var react_imgix = (ReactImgixWrapped);

//# sourceMappingURL=react-imgix.js.map
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
;// CONCATENATED MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ var ResizeObserver_es = (index);

;// CONCATENATED MODULE: ./node_modules/react-measure/dist/index.esm.js







var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}

function index_esm_getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: styles ? parseInt(styles.marginTop) : 0,
      right: styles ? parseInt(styles.marginRight) : 0,
      bottom: styles ? parseInt(styles.marginBottom) : 0,
      left: styles ? parseInt(styles.marginLeft) : 0
    };
  }

  return calculations;
}

/**
 * Returns the global window object associated with provided element.
 */
function index_esm_getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
  // provided element.

  return ownerGlobal || window;
}

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      (0,inheritsLoose/* default */.Z)(WithContentRect, _Component);

      function WithContentRect() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        };
        _this._animationFrameID = null;
        _this._resizeObserver = null;
        _this._node = null;
        _this._window = null;

        _this.measure = function (entries) {
          var contentRect = index_esm_getContentRect(_this._node, types || getTypes(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this._animationFrameID = _this._window.requestAnimationFrame(function () {
            if (_this._resizeObserver !== null) {
              _this.setState({
                contentRect: contentRect
              });

              if (typeof _this.props.onResize === 'function') {
                _this.props.onResize(contentRect);
              }
            }
          });
        };

        _this._handleRef = function (node) {
          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.unobserve(_this._node);
          }

          _this._node = node;
          _this._window = index_esm_getWindowOf(_this._node);
          var innerRef = _this.props.innerRef;

          if (innerRef) {
            if (typeof innerRef === 'function') {
              innerRef(_this._node);
            } else {
              innerRef.current = _this._node;
            }
          }

          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.observe(_this._node);
          }
        };

        return _this;
      }

      var _proto = WithContentRect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new ResizeObserver_es(this.measure);

        if (this._node !== null) {
          this._resizeObserver.observe(this._node);

          if (typeof this.props.onResize === 'function') {
            this.props.onResize(index_esm_getContentRect(this._node, types || getTypes(this.props)));
          }
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this._window !== null) {
          this._window.cancelAnimationFrame(this._animationFrameID);
        }

        if (this._resizeObserver !== null) {
          this._resizeObserver.disconnect();

          this._resizeObserver = null;
        }
      };

      _proto.render = function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            onResize = _this$props.onResize,
            props = (0,objectWithoutPropertiesLoose["default"])(_this$props, ["innerRef", "onResize"]);

        return (0,react.createElement)(WrappedComponent, (0,esm_extends["default"])({}, props, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      };

      return WithContentRect;
    }(react.Component), _class.propTypes = {
      client: (prop_types_default()).bool,
      offset: (prop_types_default()).bool,
      scroll: (prop_types_default()).bool,
      bounds: (prop_types_default()).bool,
      margin: (prop_types_default()).bool,
      innerRef: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).func]),
      onResize: (prop_types_default()).func
    }, _temp;
  };
}

var Measure = withContentRect()(function (_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;
  return children({
    measure: measure,
    measureRef: measureRef,
    contentRect: contentRect
  });
});
Measure.displayName = 'Measure';
Measure.propTypes.children = (prop_types_default()).func;

/* harmony default export */ var index_esm = ((/* unused pure expression or super */ null && (Measure)));


;// CONCATENATED MODULE: ./node_modules/react-imgix/es/findClosest.js
/**
 * Finds the closest value in the search array to the value provided using a binary search
 * If the value is in the middle of two candidate values, it chooses the higher value
 */
function findClosest(searchValue, arr) {
  if (searchValue < arr[0]) {
    return arr[0];
  }

  if (searchValue > arr[arr.length - 1]) {
    return arr[arr.length - 1];
  }

  var mid;
  var lo = 0;
  var hi = arr.length - 1;

  while (hi - lo > 1) {
    mid = Math.floor((lo + hi) / 2);

    if (arr[mid] < searchValue) {
      lo = mid;
    } else {
      hi = mid;
    }
  }

  if (searchValue - arr[lo] < arr[hi] - searchValue) {
    return arr[lo];
  }

  return arr[hi];
}
//# sourceMappingURL=findClosest.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/react-imgix-bg.js
function react_imgix_bg_slicedToArray(arr, i) { return react_imgix_bg_arrayWithHoles(arr) || react_imgix_bg_iterableToArrayLimit(arr, i) || react_imgix_bg_nonIterableRest(); }

function react_imgix_bg_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function react_imgix_bg_iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function react_imgix_bg_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function react_imgix_bg_extends() { react_imgix_bg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return react_imgix_bg_extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { react_imgix_bg_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function react_imgix_bg_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var react_imgix_bg_PACKAGE_VERSION = "9.0.2";

var react_imgix_bg_noop = function noop() {};

var findNearestWidth = function findNearestWidth(actualWidth) {
  return findClosest(actualWidth, es_targetWidths);
};

var toFixed = function toFixed(dp, value) {
  return +value.toFixed(dp);
};

var BackgroundImpl = function BackgroundImpl(props) {
  var measureRef = props.measureRef,
      measure = props.measure,
      contentRect = props.contentRect,
      _props$imgixParams = props.imgixParams,
      imgixParams = _props$imgixParams === void 0 ? {} : _props$imgixParams,
      onLoad = props.onLoad,
      disableLibraryParam = props.disableLibraryParam,
      src = props.src,
      children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className;
  var forcedWidth = imgixParams.w,
      forcedHeight = imgixParams.h;
  var hasDOMDimensions = contentRect.bounds.width != null && contentRect.bounds.height != null;
  var htmlAttributes = props.htmlAttributes || {};
  var dpr = toFixed(2, imgixParams.dpr || __webpack_require__.g.devicePixelRatio || 1);
  var ref = htmlAttributes.ref;

  var onRef = function onRef(el) {
    measureRef(el);

    if (typeof ref === "function") {
      ref(el);
    }
  };

  var _ref = function () {
    var bothWidthAndHeightPassed = forcedWidth != null && forcedHeight != null;

    if (bothWidthAndHeightPassed) {
      return {
        width: forcedWidth,
        height: forcedHeight
      };
    }

    if (!hasDOMDimensions) {
      return {
        width: undefined,
        height: undefined
      };
    }

    var ar = contentRect.bounds.width / contentRect.bounds.height;
    var neitherWidthNorHeightPassed = forcedWidth == null && forcedHeight == null;

    if (neitherWidthNorHeightPassed) {
      var _width = findNearestWidth(contentRect.bounds.width);

      var _height = Math.ceil(_width / ar);

      return {
        width: _width,
        height: _height
      };
    }

    if (forcedWidth != null) {
      var _height2 = Math.ceil(forcedWidth / ar);

      return {
        width: forcedWidth,
        height: _height2
      };
    } else if (forcedHeight != null) {
      var _width2 = Math.ceil(forcedHeight * ar);

      return {
        width: _width2,
        height: forcedHeight
      };
    }
  }(),
      width = _ref.width,
      height = _ref.height;

  var isReady = width != null && height != null;

  var commonProps = _objectSpread({}, htmlAttributes);

  if (!isReady) {
    return react.createElement("div", react_imgix_bg_extends({}, commonProps, {
      className: "react-imgix-bg-loading ".concat(className),
      ref: onRef
    }), children);
  }

  var renderedSrc = function () {
    var _extractQueryParams = extractQueryParams_extractQueryParams(src),
        _extractQueryParams2 = react_imgix_bg_slicedToArray(_extractQueryParams, 2),
        rawSrc = _extractQueryParams2[0],
        params = _extractQueryParams2[1];

    var srcOptions = _objectSpread({}, params, {
      fit: "crop"
    }, imgixParams, {}, disableLibraryParam ? {} : {
      ixlib: "react-".concat(react_imgix_bg_PACKAGE_VERSION)
    }, {
      width: width,
      height: height,
      dpr: dpr
    });

    return es_constructUrl(rawSrc, srcOptions);
  }();

  var style = _objectSpread({}, htmlAttributes.style, {
    backgroundImage: "url(".concat(renderedSrc, ")"),
    backgroundSize: (htmlAttributes.style || {}).backgroundSize !== undefined ? htmlAttributes.style.backgroundSize : "cover"
  });

  return react.createElement("div", react_imgix_bg_extends({}, commonProps, {
    className: className,
    ref: onRef,
    style: style
  }), children);
};

var Background = withContentRect("bounds")(BackgroundImpl);

//# sourceMappingURL=react-imgix-bg.js.map
;// CONCATENATED MODULE: ./node_modules/react-imgix/es/index.js




/* harmony default export */ var es = (react_imgix);


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 54490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vU": function() { return /* binding */ defineMessages; }
});

// UNUSED EXPORTS: FormattedDate, FormattedDateParts, FormattedDateTimeRange, FormattedDisplayName, FormattedList, FormattedListParts, FormattedMessage, FormattedNumber, FormattedNumberParts, FormattedPlural, FormattedRelativeTime, FormattedTime, FormattedTimeParts, IntlContext, IntlProvider, InvalidConfigError, MessageFormatError, MissingDataError, MissingTranslationError, RawIntlProvider, ReactIntlError, ReactIntlErrorCode, UnsupportedFormatterError, createIntl, createIntlCache, defineMessage, injectIntl, useIntl

// EXTERNAL MODULE: ./node_modules/react-intl/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(25719);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var components_useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/createFormattedComponent.js



var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) {
    var intl = (0,components_useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function (props) {
    var intl = useIntl();
    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props
        // TODO: fix TS type definition for localeMatcher upstream
        , ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

;// CONCATENATED MODULE: ./node_modules/react-intl/lib/index.js


function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}



// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = createFormattedComponent('formatDate');
var FormattedTime = createFormattedComponent('formatTime');
// @ts-ignore issue w/ TS Intl types
var FormattedNumber = createFormattedComponent('formatNumber');
var FormattedList = createFormattedComponent('formatList');
var FormattedDisplayName = createFormattedComponent('formatDisplayName');
var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime');







/***/ }),

/***/ 44012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25719);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 86896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ }),

/***/ 46871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 51655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "ZP", ({
  enumerable: true,
  get: function get() {
    return _skeleton.default;
  }
}));
Object.defineProperty(exports, "yB", ({
  enumerable: true,
  get: function get() {
    return _skeletonTheme.default;
  }
}));

var _skeleton = _interopRequireDefault(__webpack_require__(59020));

var _skeletonTheme = _interopRequireDefault(__webpack_require__(65201));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 65201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _core = __webpack_require__(77383);

var _skeleton = __webpack_require__(59020);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SkeletonTheme =
/*#__PURE__*/
function (_Component) {
  _inherits(SkeletonTheme, _Component);

  function SkeletonTheme() {
    _classCallCheck(this, SkeletonTheme);

    return _possibleConstructorReturn(this, _getPrototypeOf(SkeletonTheme).apply(this, arguments));
  }

  _createClass(SkeletonTheme, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          highlightColor = _this$props.highlightColor,
          children = _this$props.children;
      var themeStyles =
      /*#__PURE__*/
      (0, _core.css)(".react-loading-skeleton{background-color:", color, ";background-image:linear-gradient( 90deg,", color, ",", highlightColor, ",", color, " );};label:SkeletonTheme;" + ( true ? "" : 0));
      return (0, _core.jsx)("div", {
        css: themeStyles
      }, children);
    }
  }]);

  return SkeletonTheme;
}(_react.Component);

exports["default"] = SkeletonTheme;

_defineProperty(SkeletonTheme, "defaultProps", {
  color: _skeleton.defaultBaseColor,
  highlightColor: _skeleton.defaultHighlightColor
});

/***/ }),

/***/ 59020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Skeleton;
exports.skeletonStyles = exports.skeletonKeyframes = exports.defaultHighlightColor = exports.defaultBaseColor = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _core = __webpack_require__(77383);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultBaseColor = "#eee";
exports.defaultBaseColor = defaultBaseColor;
var defaultHighlightColor = "#f5f5f5";
exports.defaultHighlightColor = defaultHighlightColor;
var skeletonKeyframes = (0, _core.keyframes)(_templateObject());
exports.skeletonKeyframes = skeletonKeyframes;
var skeletonStyles =
/*#__PURE__*/
(0, _core.css)("background-color:", defaultBaseColor, ";background-image:linear-gradient( 90deg,", defaultBaseColor, ",", defaultHighlightColor, ",", defaultBaseColor, " );background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%;;label:skeletonStyles;" + ( true ? "" : 0));
exports.skeletonStyles = skeletonStyles;

function Skeleton(_ref) {
  var count = _ref.count,
      duration = _ref.duration,
      width = _ref.width,
      Wrapper = _ref.wrapper,
      height = _ref.height,
      circle = _ref.circle,
      customStyle = _ref.style,
      customClassName = _ref.className;
  var elements = [];

  for (var i = 0; i < count; i++) {
    var style = {};

    if (width !== null) {
      style.width = width;
    }

    if (height !== null) {
      style.height = height;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = "50%";
    }

    var className = "react-loading-skeleton";

    if (customClassName) {
      className += " " + customClassName;
    }

    elements.push((0, _core.jsx)("span", {
      key: i,
      className: className,
      css:
      /*#__PURE__*/
      (0, _core.css)(skeletonStyles, " animation:", skeletonKeyframes, " ", duration, "s ease-in-out infinite;label:Skeleton;" + ( true ? "" : 0)),
      style: _objectSpread({}, customStyle, {}, style)
    }, "\u200C"));
  }

  return (0, _core.jsx)("span", null, Wrapper ? elements.map(function (element, i) {
    return (0, _core.jsx)(Wrapper, {
      key: i
    }, element, "\u200C");
  }) : elements);
}

Skeleton.defaultProps = {
  count: 1,
  duration: 1.2,
  width: null,
  wrapper: null,
  height: null,
  circle: false
};

/***/ }),

/***/ 40827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const defaultProps = {
  breakpointCols: undefined,
  // optional, number or object { default: number, [key: number]: number }
  className: undefined,
  // required, string
  columnClassName: undefined,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: undefined,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: undefined,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: undefined
};
const DEFAULT_COLUMNS = 2;

class Masonry extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props); // Correct scope for when methods are accessed externally

    this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this);
    this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this); // default state

    let columnCount;

    if (this.props.breakpointCols && this.props.breakpointCols.default) {
      columnCount = this.props.breakpointCols.default;
    } else {
      columnCount = parseInt(this.props.breakpointCols) || DEFAULT_COLUMNS;
    }

    this.state = {
      columnCount
    };
  }

  componentDidMount() {
    this.reCalculateColumnCount(); // window may not be available in some environments

    if (window) {
      window.addEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  componentDidUpdate() {
    this.reCalculateColumnCount();
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      // IE10+
      this.reCalculateColumnCount();
      return;
    }

    if (window.cancelAnimationFrame) {
      // IE10+
      window.cancelAnimationFrame(this._lastRecalculateAnimationFrame);
    }

    this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }

  reCalculateColumnCount() {
    const windowWidth = window && window.innerWidth || Infinity;
    let breakpointColsObject = this.props.breakpointCols; // Allow passing a single number to `breakpointCols` instead of an object

    if (typeof breakpointColsObject !== 'object') {
      breakpointColsObject = {
        default: parseInt(breakpointColsObject) || DEFAULT_COLUMNS
      };
    }

    let matchedBreakpoint = Infinity;
    let columns = breakpointColsObject.default || DEFAULT_COLUMNS;

    for (let breakpoint in breakpointColsObject) {
      const optBreakpoint = parseInt(breakpoint);
      const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;

      if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
        matchedBreakpoint = optBreakpoint;
        columns = breakpointColsObject[breakpoint];
      }
    }

    columns = Math.max(1, parseInt(columns) || 1);

    if (this.state.columnCount !== columns) {
      this.setState({
        columnCount: columns
      });
    }
  }

  itemsInColumns() {
    const currentColumnCount = this.state.columnCount;
    const itemsInColumns = new Array(currentColumnCount); // Force children to be handled as an array

    const items = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(this.props.children);

    for (let i = 0; i < items.length; i++) {
      const columnIndex = i % currentColumnCount;

      if (!itemsInColumns[columnIndex]) {
        itemsInColumns[columnIndex] = [];
      }

      itemsInColumns[columnIndex].push(items[i]);
    }

    return itemsInColumns;
  }

  renderColumns() {
    const {
      column,
      columnAttrs = {},
      columnClassName
    } = this.props;
    const childrenInColumns = this.itemsInColumns();
    const columnWidth = `${100 / childrenInColumns.length}%`;
    let className = columnClassName;

    if (className && typeof className !== 'string') {
      this.logDeprecated('The property "columnClassName" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        className = 'my-masonry-grid_column';
      }
    }

    const columnAttributes = _objectSpread(_objectSpread(_objectSpread({}, column), columnAttrs), {}, {
      style: _objectSpread(_objectSpread({}, columnAttrs.style), {}, {
        width: columnWidth
      }),
      className
    });

    return childrenInColumns.map((items, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, columnAttributes, {
        key: i
      }), items);
    });
  }

  logDeprecated(message) {
    console.error('[Masonry]', message);
  }

  render() {
    const _this$props = this.props,
          {
      // ignored
      children,
      breakpointCols,
      columnClassName,
      columnAttrs,
      column,
      // used
      className
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);

    let classNameOutput = className;

    if (typeof className !== 'string') {
      this.logDeprecated('The property "className" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        classNameOutput = 'my-masonry-grid';
      }
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, rest, {
      className: classNameOutput
    }), this.renderColumns());
  }

}

Masonry.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["Z"] = (Masonry);


/***/ }),

/***/ 29983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(28747);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46871);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 28747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(99685);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(88338);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(32409);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(35063);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 57149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(51112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (true) return;
  var check = globalElement || {};
  console.log("ariaAppHider ----------");
  console.log(check.nodeName, check.className, check.id);
  console.log("end ariaAppHider ----------");
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 35063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 32409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (true) return;

  var classes = document.getElementsByTagName("html")[0].className;
  var buffer = "Show tracked classes:\n\n";

  buffer += "<html /> (" + classes + "):\n";
  for (var x in htmlClassList) {
    buffer += "  " + x + " " + htmlClassList[x] + "\n";
  }

  classes = document.body.className;

  buffer += "\n\ndoc.body (" + classes + "):\n";
  for (var _x in docBodyClassList) {
    buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
  }

  buffer += "\n";

  console.log(buffer);
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 99685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (true) return;
  console.log("focusManager ----------");
  focusLaterElements.forEach(function (f) {
    var check = f || {};
    console.log(check.nodeName, check.className, check.id);
  });
  console.log("end focusManager ----------");
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 89623:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 51112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(58875);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 88338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 37845:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
    // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 83253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(29983);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 5585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RelativeTimeFormat; }
});

// UNUSED EXPORTS: UNITS

;// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/LocaleDataStore.js
// Fallback locale.
// (when not a single one of the supplied "preferred" locales is available)
var defaultLocale = 'en'; // For all locales added
// their relative time formatter messages will be stored here.

var localesData = {}; // According to the spec BCP 47 language tags are case-insensitive.
// https://tools.ietf.org/html/rfc5646

var lowercaseLocaleLookup = {};
function getDefaultLocale() {
  return defaultLocale;
}
function setDefaultLocale(locale) {
  defaultLocale = locale;
}
/**
 * Gets locale data previously added by `addLocaleData()`.
 * @return  {object} [localeData]
 */

function getLocaleData(locale) {
  return localesData[locale];
}
/**
 * Adds locale data.
 * Is called by `RelativeTimeFormat.addLocale(...)`.
 * @param  {object} localeData
 */

function addLocaleData(localeData) {
  if (!localeData) {
    throw new Error('No locale data passed');
  } // This locale data is stored in a global variable
  // and later used when calling `.format(time)`.


  localesData[localeData.locale] = localeData;
  lowercaseLocaleLookup[localeData.locale.toLowerCase()] = localeData.locale;
}
/**
 * Returns a locale for which locale data has been added
 * via `RelativeTimeFormat.addLocale(...)`.
 * @param  {string} locale
 * @return {string} [locale]
 */

function resolveLocale(locale) {
  if (localesData[locale]) {
    return locale;
  }

  if (lowercaseLocaleLookup[locale.toLowerCase()]) {
    return lowercaseLocaleLookup[locale.toLowerCase()];
  }
}
//# sourceMappingURL=LocaleDataStore.js.map
;// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/resolveLocale.js

/**
 * Resolves a locale to a supported one (if any).
 * @param  {string} locale
 * @param {Object} [options] - An object that may have the following property:
 * @param {string} [options.localeMatcher="lookup"] - The locale matching algorithm to use. Possible values are "lookup" and "best fit". Currently only "lookup" is supported.
 * @return {string} [locale]
 * @example
 * // Returns "sr"
 * resolveLocale("sr-Cyrl-BA")
 * // Returns `undefined`
 * resolveLocale("xx-Latn")
 */

function resolveLocale_resolveLocale(locale) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localeMatcher = options.localeMatcher || 'lookup';

  switch (localeMatcher) {
    case 'lookup':
      return resolveLocaleLookup(locale);
    // "best fit" locale matching is not supported.
    // https://github.com/catamphetamine/relative-time-format/issues/2

    case 'best fit':
      // return resolveLocaleBestFit(locale)
      return resolveLocaleLookup(locale);

    default:
      throw new RangeError("Invalid \"localeMatcher\" option: ".concat(localeMatcher));
  }
}
/**
 * Resolves a locale to a supported one (if any).
 * Starts from the most specific locale and gradually
 * falls back to less specific ones.
 * This is a basic implementation of the "lookup" algorithm.
 * https://tools.ietf.org/html/rfc4647#section-3.4
 * @param  {string} locale
 * @return {string} [locale]
 * @example
 * // Returns "sr"
 * resolveLocaleLookup("sr-Cyrl-BA")
 * // Returns `undefined`
 * resolveLocaleLookup("xx-Latn")
 */

function resolveLocaleLookup(locale) {
  var resolvedLocale = resolveLocale(locale);

  if (resolvedLocale) {
    return resolvedLocale;
  } // `sr-Cyrl-BA` -> `sr-Cyrl` -> `sr`.


  var parts = locale.split('-');

  while (locale.length > 1) {
    parts.pop();
    locale = parts.join('-');

    var _resolvedLocale = resolveLocale(locale);

    if (_resolvedLocale) {
      return _resolvedLocale;
    }
  }
}
//# sourceMappingURL=resolveLocale.js.map
;// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/PluralRuleFunctions.js
// (this file was autogenerated by `generate-locales`)
// "plural rules" functions are not stored in locale JSON files because they're not strings.
// This file isn't big — it's about 5 kilobytes in size (minified).
// Alternatively, the pluralization rules for each locale could be stored
// in their JSON files in a non-parsed form and later parsed via `make-plural` library.
// But `make-plural` library itself is relatively big in size:
// `make-plural.min.js` is about 6 kilobytes (https://unpkg.com/make-plural/).
// So, it's more practical to bypass runtime `make-plural` pluralization rules compilation
// and just include the already compiled pluarlization rules for all locales in the library code.
var $ = {
  af: function classify(n) {
    return n == 1 ? 'one' : 'other';
  },
  am: function classify(n) {
    return n >= 0 && n <= 1 ? 'one' : 'other';
  },
  ar: function classify(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
  },
  ast: function classify(n) {
    var s = String(n).split('.'),
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : 'other';
  },
  be: function classify(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
  },
  br: function classify(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        n1000000 = t0 && s[0].slice(-6);
    return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
  },
  bs: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  },
  cs: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
  },
  cy: function classify(n) {
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
  },
  da: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n;
    return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
  },
  dsb: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i100 = i.slice(-2),
        f100 = f.slice(-2);
    return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
  },
  dz: function classify(n) {
    return 'other';
  },
  fil: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  },
  fr: function classify(n) {
    return n >= 0 && n < 2 ? 'one' : 'other';
  },
  ga: function classify(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
  },
  gd: function classify(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
  },
  he: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
  },
  is: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n,
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
  },
  ksh: function classify(n) {
    return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
  },
  lt: function classify(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
  },
  lv: function classify(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        v = f.length,
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        f100 = f.slice(-2),
        f10 = f.slice(-1);
    return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
  },
  mk: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
  },
  mt: function classify(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 ? 'one' : n == 0 || n100 >= 2 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
  },
  pa: function classify(n) {
    return n == 0 || n == 1 ? 'one' : 'other';
  },
  pl: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
  },
  pt: function classify(n) {
    var s = String(n).split('.'),
        i = s[0];
    return i == 0 || i == 1 ? 'one' : 'other';
  },
  ro: function classify(n) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 && v0 ? 'one' : !v0 || n == 0 || n != 1 && n100 >= 1 && n100 <= 19 ? 'few' : 'other';
  },
  ru: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
  },
  se: function classify(n) {
    return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
  },
  si: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '';
    return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
  },
  sl: function classify(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i100 = i.slice(-2);
    return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
  }
};
$.as = $.am;
$.az = $.af;
$.bg = $.af;
$.bn = $.am;
$.ca = $.ast;
$.ce = $.af;
$.chr = $.af;
$.de = $.ast;
$.ee = $.af;
$.el = $.af;
$.en = $.ast;
$.es = $.af;
$.et = $.ast;
$.eu = $.af;
$.fa = $.am;
$.fi = $.ast;
$.fo = $.af;
$.fur = $.af;
$.fy = $.ast;
$.gl = $.ast;
$.gu = $.am;
$.hi = $.am;
$.hr = $.bs;
$.hsb = $.dsb;
$.hu = $.af;
$.hy = $.fr;
$.ia = $.ast;
$.id = $.dz;
$.it = $.ast;
$.ja = $.dz;
$.jgo = $.af;
$.jv = $.dz;
$.ka = $.af;
$.kea = $.dz;
$.kk = $.af;
$.kl = $.af;
$.km = $.dz;
$.kn = $.am;
$.ko = $.dz;
$.ku = $.af;
$.ky = $.af;
$.lb = $.af;
$.lkt = $.dz;
$.lo = $.dz;
$.ml = $.af;
$.mn = $.af;
$.mr = $.am;
$.ms = $.dz;
$.my = $.dz;
$.nb = $.af;
$.ne = $.af;
$.nl = $.ast;
$.nn = $.af;
$.or = $.af;
$.ps = $.af;
$["pt-PT"] = $.ast;
$.sah = $.dz;
$.sd = $.af;
$.sk = $.cs;
$.so = $.af;
$.sq = $.af;
$.sr = $.bs;
$.sv = $.ast;
$.sw = $.ast;
$.ta = $.af;
$.te = $.af;
$.th = $.dz;
$.ti = $.pa;
$.tk = $.af;
$.to = $.dz;
$.tr = $.af;
$.ug = $.af;
$.uk = $.ru;
$.ur = $.ast;
$.uz = $.af;
$.vi = $.dz;
$.wae = $.af;
$.yi = $.ast;
$.yue = $.dz;
$.zh = $.dz;
$.zu = $.am;
/* harmony default export */ var PluralRuleFunctions = ($);
//# sourceMappingURL=PluralRuleFunctions.js.map
;// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/getPluralRulesLocale.js
/**
 * Returns a `locale` for which a function exists in `./PluralRuleFunctions.js`.
 * @param  {string} locale
 * @return {string}
 * @example
 * getPluralRulesLocale("ru-RU-Cyrl") // Returns "ru".
 */
function getPluralRulesLocale(locale) {
  // "pt" language is the only one having different pluralization rules
  // for the one ("pt") (Portuguese) locale and the other ("pt-PT") (European Portuguese).
  // http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html
  // (see the entries for "pt" and "pt_PT" there)
  if (locale === 'pt-PT') {
    return locale;
  }

  return getLanguageFromLanguageTag(locale);
}
/**
 * Extracts language from an IETF BCP 47 language tag.
 * @param {string} languageTag - IETF BCP 47 language tag.
 * @return {string}
 * @example
 * // Returns "he"
 * getLanguageFromLanguageTag("he-IL-u-ca-hebrew-tz-jeruslm")
 * // Returns "ar"
 * getLanguageFromLanguageTag("ar-u-nu-latn")
 */

var LANGUAGE_REG_EXP = /^([a-z0-9]+)/i;

function getLanguageFromLanguageTag(languageTag) {
  var match = languageTag.match(LANGUAGE_REG_EXP);

  if (!match) {
    throw new TypeError("Invalid locale: ".concat(languageTag));
  }

  return match[1];
}
//# sourceMappingURL=getPluralRulesLocale.js.map
;// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/PluralRules.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Importing `PluralRule` polyfill from a separate package
// results in a bundle that is larger by 1kB for some reason.
// export { default as default } from 'intl-plural-rules-polyfill/cardinal'


/**
 * `Intl.PluralRules` polyfill.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/PluralRules
 */

var PluralRules =
/*#__PURE__*/
function () {
  function PluralRules(locale, options) {
    _classCallCheck(this, PluralRules);

    var locales = PluralRules.supportedLocalesOf(locale);

    if (locales.length === 0) {
      throw new RangeError("Unsupported locale: " + locale);
    }

    if (options && options.type !== "cardinal") {
      throw new RangeError("Only \"cardinal\" \"type\" is supported");
    }

    this.$ = PluralRuleFunctions[getPluralRulesLocale(locales[0])];
  }

  _createClass(PluralRules, [{
    key: "select",
    value: function select(number) {
      return this.$(number);
    }
  }], [{
    key: "supportedLocalesOf",
    value: function supportedLocalesOf(locales) {
      if (typeof locales === "string") {
        locales = [locales];
      }

      return locales.filter(function (locale) {
        return PluralRuleFunctions[getPluralRulesLocale(locale)];
      });
    }
  }]);

  return PluralRules;
}();


//# sourceMappingURL=PluralRules.js.map
;// CONCATENATED MODULE: ./node_modules/relative-time-format/modules/RelativeTimeFormat.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RelativeTimeFormat_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RelativeTimeFormat_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RelativeTimeFormat_createClass(Constructor, protoProps, staticProps) { if (protoProps) RelativeTimeFormat_defineProperties(Constructor.prototype, protoProps); if (staticProps) RelativeTimeFormat_defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Importing `PluralRule` polyfill from a separate package
// results in a bundle that is larger by 1kB for some reason.
// import PluralRules from 'intl-plural-rules-polyfill/cardinal'
// Valid time units.

var UNITS = ["second", "minute", "hour", "day", "week", "month", "quarter", "year"]; // Valid values for the `numeric` option.

var NUMERIC_VALUES = ["auto", "always"]; // Valid values for the `style` option.

var STYLE_VALUES = ["long", "short", "narrow"]; // Valid values for the `localeMatcher` option.

var LOCALE_MATCHER_VALUES = ["lookup", "best fit"];
/**
 * Polyfill for `Intl.RelativeTimeFormat` proposal.
 * https://github.com/tc39/proposal-intl-relative-time
 * https://github.com/tc39/proposal-intl-relative-time/issues/55
 */

var RelativeTimeFormat =
/*#__PURE__*/
function () {
  /**
   * @param {(string|string[])} [locales] - Preferred locales (or locale).
   * @param {Object} [options] - Formatting options.
   * @param {string} [options.style="long"] - One of: "long", "short", "narrow".
   * @param {string} [options.numeric="always"] - (Version >= 2) One of: "always", "auto".
   * @param {string} [options.localeMatcher="lookup"] - One of: "lookup", "best fit". Currently only "lookup" is supported.
   */
  function RelativeTimeFormat() {
    var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    RelativeTimeFormat_classCallCheck(this, RelativeTimeFormat);

    _defineProperty(this, "numeric", "always");

    _defineProperty(this, "style", "long");

    _defineProperty(this, "localeMatcher", "lookup");

    var numeric = options.numeric,
        style = options.style,
        localeMatcher = options.localeMatcher; // Set `numeric` option.

    if (numeric !== undefined) {
      if (NUMERIC_VALUES.indexOf(numeric) < 0) {
        throw new RangeError("Invalid \"numeric\" option: ".concat(numeric));
      }

      this.numeric = numeric;
    } // Set `style` option.


    if (style !== undefined) {
      if (STYLE_VALUES.indexOf(style) < 0) {
        throw new RangeError("Invalid \"style\" option: ".concat(style));
      }

      this.style = style;
    } // Set `localeMatcher` option.


    if (localeMatcher !== undefined) {
      if (LOCALE_MATCHER_VALUES.indexOf(localeMatcher) < 0) {
        throw new RangeError("Invalid \"localeMatcher\" option: ".concat(localeMatcher));
      }

      this.localeMatcher = localeMatcher;
    } // Set `locale`.
    // Convert `locales` to an array.


    if (typeof locales === 'string') {
      locales = [locales];
    } // Add default locale.


    locales.push(getDefaultLocale()); // Choose the most appropriate locale.

    this.locale = RelativeTimeFormat.supportedLocalesOf(locales, {
      localeMatcher: this.localeMatcher
    })[0];

    if (!this.locale) {
      throw new Error("No supported locale was found");
    } // Construct an `Intl.PluralRules` instance (polyfill).


    if (PluralRules.supportedLocalesOf(this.locale).length > 0) {
      this.pluralRules = new PluralRules(this.locale);
    } else {
      console.warn("\"".concat(this.locale, "\" locale is not supported"));
    } // Use `Intl.NumberFormat` for formatting numbers (when available).


    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      this.numberFormat = new Intl.NumberFormat(this.locale);
      this.numberingSystem = this.numberFormat.resolvedOptions().numberingSystem;
    } else {
      this.numberingSystem = 'latn';
    }

    this.locale = resolveLocale_resolveLocale(this.locale, {
      localeMatcher: this.localeMatcher
    });
  }
  /**
   * Formats time `number` in `units` (either in past or in future).
   * @param {number} number - Time interval value.
   * @param {string} unit - Time interval measurement unit.
   * @return {string}
   * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
   * @example
   * // Returns "2 days ago"
   * rtf.format(-2, "day")
   * // Returns "in 5 minutes"
   * rtf.format(5, "minute")
   */


  RelativeTimeFormat_createClass(RelativeTimeFormat, [{
    key: "format",
    value: function format() {
      var _parseFormatArgs = parseFormatArgs(arguments),
          _parseFormatArgs2 = _slicedToArray(_parseFormatArgs, 2),
          number = _parseFormatArgs2[0],
          unit = _parseFormatArgs2[1];

      return this.getRule(number, unit).replace('{0}', this.formatNumber(Math.abs(number)));
    }
    /**
     * Formats time `number` in `units` (either in past or in future).
     * @param {number} number - Time interval value.
     * @param {string} unit - Time interval measurement unit.
     * @return {Object[]} The parts (`{ type, value }`).
     * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
     * @example
     * // Version 1.
     * // Returns [
     * //   { type: "literal", value: "in " },
     * //   { type: "day", value: "100" },
     * //   { type: "literal", value: " days" }
     * // ]
     * rtf.formatToParts(100, "day")
     * //
     * // Version 2.
     * // Returns [
     * //   { type: "literal", value: "in " },
     * //   { type: "integer", value: "100", unit: "day" },
     * //   { type: "literal", value: " days" }
     * // ]
     * rtf.formatToParts(100, "day")
     */

  }, {
    key: "formatToParts",
    value: function formatToParts() {
      var _parseFormatArgs3 = parseFormatArgs(arguments),
          _parseFormatArgs4 = _slicedToArray(_parseFormatArgs3, 2),
          number = _parseFormatArgs4[0],
          unit = _parseFormatArgs4[1];

      var rule = this.getRule(number, unit);
      var valueIndex = rule.indexOf("{0}"); // "yesterday"/"today"/"tomorrow".

      if (valueIndex < 0) {
        return [{
          type: "literal",
          value: rule
        }];
      }

      var parts = [];

      if (valueIndex > 0) {
        parts.push({
          type: "literal",
          value: rule.slice(0, valueIndex)
        });
      }

      parts = parts.concat(this.formatNumberToParts(Math.abs(number)).map(function (part) {
        return _objectSpread({}, part, {
          unit: unit
        });
      }));

      if (valueIndex + "{0}".length < rule.length - 1) {
        parts.push({
          type: "literal",
          value: rule.slice(valueIndex + "{0}".length)
        });
      }

      return parts;
    }
    /**
     * Returns formatting rule for `value` in `units` (either in past or in future).
     * @param {number} value - Time interval value.
     * @param {string} unit - Time interval measurement unit.
     * @return {string}
     * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
     * @example
     * // Returns "{0} days ago"
     * getRule(-2, "day")
     */

  }, {
    key: "getRule",
    value: function getRule(value, unit) {
      // Get locale-specific time interval formatting rules
      // of a given `style` for the given value of measurement `unit`.
      //
      // E.g.:
      //
      // ```json
      // {
      //  "past": {
      //    "one": "a second ago",
      //    "other": "{0} seconds ago"
      //  },
      //  "future": {
      //    "one": "in a second",
      //    "other": "in {0} seconds"
      //  }
      // }
      // ```
      //
      var unitMessages = getLocaleData(this.locale)[this.style][unit]; // Special case for "yesterday"/"today"/"tomorrow".

      if (this.numeric === "auto") {
        // "yesterday", "the day before yesterday", etc.
        if (value === -2 || value === -1) {
          var message = unitMessages["previous".concat(value === -1 ? '' : '-' + Math.abs(value))];

          if (message) {
            return message;
          }
        } // "tomorrow", "the day after tomorrow", etc.
        else if (value === 1 || value === 2) {
            var _message = unitMessages["next".concat(value === 1 ? '' : '-' + Math.abs(value))];

            if (_message) {
              return _message;
            }
          } // "today"
          else if (value === 0) {
              if (unitMessages.current) {
                return unitMessages.current;
              }
            }
      } // Choose either "past" or "future" based on time `value` sign.
      // If there's only "other" then it's being collapsed.
      // (the resulting bundle size optimization technique)


      var pluralizedMessages = unitMessages[isNegative(value) ? "past" : "future"]; // Bundle size optimization technique.

      if (typeof pluralizedMessages === "string") {
        return pluralizedMessages;
      } // Quantify `value`.
      // There seems to be no such locale in CLDR
      // for which "plural rules" function is missing.


      var quantifier = this.pluralRules && this.pluralRules.select(Math.abs(value)) || 'other'; // "other" rule is supposed to be always present.
      // If only "other" rule is present then "rules" is not an object and is a string.

      return pluralizedMessages[quantifier] || pluralizedMessages.other;
    }
    /**
     * Formats a number into a string.
     * Uses `Intl.NumberFormat` when available.
     * @param  {number} number
     * @return {string}
     */

  }, {
    key: "formatNumber",
    value: function formatNumber(number) {
      return this.numberFormat ? this.numberFormat.format(number) : String(number);
    }
    /**
     * Formats a number into a list of parts.
     * Uses `Intl.NumberFormat` when available.
     * @param  {number} number
     * @return {object[]}
     */

  }, {
    key: "formatNumberToParts",
    value: function formatNumberToParts(number) {
      // `Intl.NumberFormat.formatToParts()` is not present, for example,
      // in Node.js 8.x while `Intl.NumberFormat` itself is present.
      return this.numberFormat && this.numberFormat.formatToParts ? this.numberFormat.formatToParts(number) : [{
        type: "integer",
        value: this.formatNumber(number)
      }];
    }
    /**
     * Returns a new object with properties reflecting the locale and date and time formatting options computed during initialization of this DateTimeFormat object.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/resolvedOptions
     * @return {Object}
     */

  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      return {
        locale: this.locale,
        style: this.style,
        numeric: this.numeric,
        numberingSystem: this.numberingSystem
      };
    }
  }]);

  return RelativeTimeFormat;
}();
/**
 * Returns an array containing those of the provided locales
 * that are supported in collation without having to fall back
 * to the runtime's default locale.
 * @param {(string|string[])} locale - A string with a BCP 47 language tag, or an array of such strings. For the general form of the locales argument, see the Intl page.
 * @param {Object} [options] - An object that may have the following property:
 * @param {string} [options.localeMatcher="lookup"] - The locale matching algorithm to use. Possible values are "lookup" and "best fit". Currently only "lookup" is supported.
 * @return {string[]} An array of strings representing a subset of the given locale tags that are supported in collation without having to fall back to the runtime's default locale.
 * @example
 * var locales = ['ban', 'id-u-co-pinyin', 'es-PY']
 * var options = { localeMatcher: 'lookup' }
 * // Returns ["id", "es-PY"]
 * Intl.RelativeTimeFormat.supportedLocalesOf(locales, options)
 */




RelativeTimeFormat.supportedLocalesOf = function (locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Convert `locales` to an array.
  if (typeof locales === 'string') {
    locales = [locales];
  } else if (!Array.isArray(locales)) {
    throw new TypeError('Invalid "locales" argument');
  }

  return locales.filter(function (locale) {
    return resolveLocale_resolveLocale(locale, options);
  });
};
/**
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 */


RelativeTimeFormat.addLocale = addLocaleData;
/**
 * Sets default locale.
 * @param  {string} locale
 */

RelativeTimeFormat.setDefaultLocale = setDefaultLocale;
/**
 * Gets default locale.
 * @return  {string} locale
 */

RelativeTimeFormat.getDefaultLocale = getDefaultLocale;
/**
 * Export `Intl.PluralRules` just in case it's used somewhere else.
 */

RelativeTimeFormat.PluralRules = PluralRules; // The specification allows units to be in plural form.
// Convert plural to singular.
// Example: "seconds" -> "second".

var UNIT_ERROR = 'Invalid "unit" argument';

function parseUnit(unit) {
  if (_typeof(unit) === 'symbol') {
    throw new TypeError(UNIT_ERROR);
  }

  if (typeof unit !== 'string') {
    throw new RangeError("".concat(UNIT_ERROR, ": ").concat(unit));
  }

  if (unit[unit.length - 1] === 's') {
    unit = unit.slice(0, unit.length - 1);
  }

  if (UNITS.indexOf(unit) < 0) {
    throw new RangeError("".concat(UNIT_ERROR, ": ").concat(unit));
  }

  return unit;
} // Converts `value` to a `Number`.
// The specification allows value to be a non-number.
// For example, "-0" is supposed to be treated as `-0`.
// Also checks if `value` is a finite number.


var NUMBER_ERROR = 'Invalid "number" argument';

function parseNumber(value) {
  value = Number(value);

  if (Number.isFinite) {
    if (!Number.isFinite(value)) {
      throw new RangeError("".concat(NUMBER_ERROR, ": ").concat(value));
    }
  }

  return value;
}
/**
 * Tells `0` from `-0`.
 * https://stackoverflow.com/questions/7223359/are-0-and-0-the-same
 * @param  {number} number
 * @return {Boolean}
 * @example
 * isNegativeZero(0); // false
 * isNegativeZero(-0); // true
 */


function isNegativeZero(number) {
  return 1 / number === -Infinity;
}

function isNegative(number) {
  return number < 0 || number === 0 && isNegativeZero(number);
}

function parseFormatArgs(args) {
  if (args.length < 2) {
    throw new TypeError("\"unit\" argument is required");
  }

  return [parseNumber(args[0]), parseUnit(args[1])];
}
//# sourceMappingURL=RelativeTimeFormat.js.map

/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 32553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(89509).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.s = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 75068:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 36137:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function noop() {}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(url, opts) {
	opts = opts || {};

	var ws, num=0, timer=1, $={};
	var max = opts.maxAttempts || Infinity;

	$.open = function () {
		ws = new WebSocket(url, opts.protocols || []);

		ws.onmessage = opts.onmessage || noop;

		ws.onopen = function (e) {
			(opts.onopen || noop)(e);
			num = 0;
		};

		ws.onclose = function (e) {
			e.code === 1e3 || e.code === 1001 || e.code === 1005 || $.reconnect(e);
			(opts.onclose || noop)(e);
		};

		ws.onerror = function (e) {
			(e && e.code==='ECONNREFUSED') ? $.reconnect(e) : (opts.onerror || noop)(e);
		};
	};

	$.reconnect = function (e) {
		if (timer && num++ < max) {
			timer = setTimeout(function () {
				(opts.onreconnect || noop)(e);
				$.open();
			}, opts.timeout || 1e3);
		} else {
			(opts.onmaximum || noop)(e);
		}
	};

	$.json = function (x) {
		ws.send(JSON.stringify(x));
	};

	$.send = function (x) {
		ws.send(x);
	};

	$.close = function (x, y) {
		timer = clearTimeout(timer);
		ws.close(x || 1e3, y);
	};

	$.open(); // init

	return $;
}


/***/ }),

/***/ 69933:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"elementNames":{"altglyph":"altGlyph","altglyphdef":"altGlyphDef","altglyphitem":"altGlyphItem","animatecolor":"animateColor","animatemotion":"animateMotion","animatetransform":"animateTransform","clippath":"clipPath","feblend":"feBlend","fecolormatrix":"feColorMatrix","fecomponenttransfer":"feComponentTransfer","fecomposite":"feComposite","feconvolvematrix":"feConvolveMatrix","fediffuselighting":"feDiffuseLighting","fedisplacementmap":"feDisplacementMap","fedistantlight":"feDistantLight","fedropshadow":"feDropShadow","feflood":"feFlood","fefunca":"feFuncA","fefuncb":"feFuncB","fefuncg":"feFuncG","fefuncr":"feFuncR","fegaussianblur":"feGaussianBlur","feimage":"feImage","femerge":"feMerge","femergenode":"feMergeNode","femorphology":"feMorphology","feoffset":"feOffset","fepointlight":"fePointLight","fespecularlighting":"feSpecularLighting","fespotlight":"feSpotLight","fetile":"feTile","feturbulence":"feTurbulence","foreignobject":"foreignObject","glyphref":"glyphRef","lineargradient":"linearGradient","radialgradient":"radialGradient","textpath":"textPath"},"attributeNames":{"definitionurl":"definitionURL","attributename":"attributeName","attributetype":"attributeType","basefrequency":"baseFrequency","baseprofile":"baseProfile","calcmode":"calcMode","clippathunits":"clipPathUnits","diffuseconstant":"diffuseConstant","edgemode":"edgeMode","filterunits":"filterUnits","glyphref":"glyphRef","gradienttransform":"gradientTransform","gradientunits":"gradientUnits","kernelmatrix":"kernelMatrix","kernelunitlength":"kernelUnitLength","keypoints":"keyPoints","keysplines":"keySplines","keytimes":"keyTimes","lengthadjust":"lengthAdjust","limitingconeangle":"limitingConeAngle","markerheight":"markerHeight","markerunits":"markerUnits","markerwidth":"markerWidth","maskcontentunits":"maskContentUnits","maskunits":"maskUnits","numoctaves":"numOctaves","pathlength":"pathLength","patterncontentunits":"patternContentUnits","patterntransform":"patternTransform","patternunits":"patternUnits","pointsatx":"pointsAtX","pointsaty":"pointsAtY","pointsatz":"pointsAtZ","preservealpha":"preserveAlpha","preserveaspectratio":"preserveAspectRatio","primitiveunits":"primitiveUnits","refx":"refX","refy":"refY","repeatcount":"repeatCount","repeatdur":"repeatDur","requiredextensions":"requiredExtensions","requiredfeatures":"requiredFeatures","specularconstant":"specularConstant","specularexponent":"specularExponent","spreadmethod":"spreadMethod","startoffset":"startOffset","stddeviation":"stdDeviation","stitchtiles":"stitchTiles","surfacescale":"surfaceScale","systemlanguage":"systemLanguage","tablevalues":"tableValues","targetx":"targetX","targety":"targetY","textlength":"textLength","viewbox":"viewBox","viewtarget":"viewTarget","xchannelselector":"xChannelSelector","ychannelselector":"yChannelSelector","zoomandpan":"zoomAndPan"}}');

/***/ }),

/***/ 33600:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

/***/ }),

/***/ 59323:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ }),

/***/ 29591:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","QUOT":"\\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}');

/***/ }),

/***/ 2586:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

/***/ }),

/***/ 42968:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

/***/ }),

/***/ 23042:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ }),

/***/ 60317:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","QUOT":"\\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}');

/***/ }),

/***/ 51373:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

/***/ }),

/***/ 15567:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"af","long":{"year":{"previous":"verlede jaar","current":"hierdie jaar","next":"volgende jaar","past":"{0} jaar gelede","future":"oor {0} jaar"},"quarter":{"previous":"verlede kwartaal","current":"hierdie kwartaal","next":"volgende kwartaal","past":{"one":"{0} kwartaal gelede","other":"{0} kwartale gelede"},"future":{"one":"oor {0} kwartaal","other":"oor {0} kwartale"}},"month":{"previous":"verlede maand","current":"vandeesmaand","next":"volgende maand","past":{"one":"{0} maand gelede","other":"{0} maande gelede"},"future":{"one":"oor {0} maand","other":"oor {0} maande"}},"week":{"previous":"verlede week","current":"hierdie week","next":"volgende week","past":{"one":"{0} week gelede","other":"{0} weke gelede"},"future":{"one":"oor {0} week","other":"oor {0} weke"}},"day":{"previous":"gister","previous-2":"eergister","current":"vandag","next":"môre","next-2":"oormôre","past":{"one":"{0} dag gelede","other":"{0} dae gelede"},"future":{"one":"oor {0} dag","other":"oor {0} dae"}},"hour":{"current":"hierdie uur","past":"{0} uur gelede","future":"oor {0} uur"},"minute":{"current":"hierdie minuut","past":{"one":"{0} minuut gelede","other":"{0} minute gelede"},"future":{"one":"oor {0} minuut","other":"oor {0} minute"}},"second":{"current":"nou","past":{"one":"{0} sekonde gelede","other":"{0} sekondes gelede"},"future":{"one":"oor {0} sekonde","other":"oor {0} sekondes"}}},"short":{"year":{"previous":"verlede jaar","current":"hierdie jaar","next":"volgende jaar","past":"{0} j. gelede","future":"oor {0} j."},"quarter":{"previous":"verlede kwartaal","current":"hierdie kwartaal","next":"volgende kwartaal","past":"{0} kw. gelede","future":"oor {0} kw."},"month":{"previous":"verlede maand","current":"vandeesmaand","next":"volgende maand","past":"{0} md. gelede","future":"oor {0} md."},"week":{"previous":"verlede week","current":"hierdie week","next":"volgende week","past":"{0} w. gelede","future":"oor {0} w."},"day":{"previous":"gister","previous-2":"eergister","current":"vandag","next":"môre","next-2":"oormôre","past":{"one":"{0} dag gelede","other":"{0} dae gelede"},"future":{"one":"oor {0} dag","other":"oor {0} dae"}},"hour":{"current":"hierdie uur","past":"{0} u. gelede","future":"oor {0} u."},"minute":{"current":"hierdie minuut","past":"{0} min. gelede","future":"oor {0} min."},"second":{"current":"nou","past":"{0} s. gelede","future":"oor {0} s."}},"narrow":{"year":{"previous":"verlede jaar","current":"hierdie jaar","next":"volgende jaar","past":"{0} j. gelede","future":"oor {0} j."},"quarter":{"previous":"verlede kwartaal","current":"hierdie kwartaal","next":"volgende kwartaal","past":"{0} kw. gelede","future":"oor {0} kw."},"month":{"previous":"verlede maand","current":"vandeesmaand","next":"volgende maand","past":"{0} md. gelede","future":"oor {0} md."},"week":{"previous":"verlede week","current":"hierdie week","next":"volgende week","past":"{0} w. gelede","future":"oor {0} w."},"day":{"previous":"gister","previous-2":"eergister","current":"vandag","next":"môre","next-2":"oormôre","past":{"one":"{0} dag gelede","other":"{0} dae gelede"},"future":{"one":"oor {0} dag","other":"oor {0} dae"}},"hour":{"current":"hierdie uur","past":"{0} u. gelede","future":"oor {0} u."},"minute":{"current":"hierdie minuut","past":"{0} min. gelede","future":"oor {0} min."},"second":{"current":"nou","past":"{0} s. gelede","future":"oor {0} s."}}}');

/***/ }),

/***/ 44138:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"am","long":{"year":{"previous":"ያለፈው ዓመት","current":"በዚህ ዓመት","next":"የሚቀጥለው ዓመት","past":{"one":"ከ{0} ዓመት በፊት","other":"ከ{0} ዓመታት በፊት"},"future":"በ{0} ዓመታት ውስጥ"},"quarter":{"previous":"የመጨረሻው ሩብ","current":"ይህ ሩብ","next":"የሚቀጥለው ሩብ","past":"{0} ሩብ በፊት","future":"+{0} ሩብ"},"month":{"previous":"ያለፈው ወር","current":"በዚህ ወር","next":"የሚቀጥለው ወር","past":{"one":"ከ{0} ወር በፊት","other":"ከ{0} ወራት በፊት"},"future":{"one":"በ{0} ወር ውስጥ","other":"በ{0} ወራት ውስጥ"}},"week":{"previous":"ያለፈው ሳምንት","current":"በዚህ ሳምንት","next":"የሚቀጥለው ሳምንት","past":{"one":"ከ{0} ሳምንት በፊት","other":"ከ{0} ሳምንታት በፊት"},"future":{"one":"በ{0} ሳምንት ውስጥ","other":"በ{0} ሳምንታት ውስጥ"}},"day":{"previous":"ትናንት","previous-2":"ከትናንት ወዲያ","current":"ዛሬ","next":"ነገ","next-2":"ከነገ ወዲያ","past":{"one":"ከ{0} ቀን በፊት","other":"ከ{0} ቀናት በፊት"},"future":{"one":"በ{0} ቀን ውስጥ","other":"በ{0} ቀናት ውስጥ"}},"hour":{"current":"ይህ ሰዓት","past":{"one":"ከ{0} ሰዓት በፊት","other":"ከ{0} ሰዓቶች በፊት"},"future":{"one":"በ{0} ሰዓት ውስጥ","other":"በ{0} ሰዓቶች ውስጥ"}},"minute":{"current":"ይህ ደቂቃ","past":{"one":"ከ{0} ደቂቃ በፊት","other":"ከ{0} ደቂቃዎች በፊት"},"future":{"one":"በ{0} ደቂቃ ውስጥ","other":"በ{0} ደቂቃዎች ውስጥ"}},"second":{"current":"አሁን","past":{"one":"ከ{0} ሰከንድ በፊት","other":"ከ{0} ሰከንዶች በፊት"},"future":{"one":"በ{0} ሰከንድ ውስጥ","other":"በ{0} ሰከንዶች ውስጥ"}}},"short":{"year":{"previous":"ያለፈው ዓመት","current":"በዚህ ዓመት","next":"የሚቀጥለው ዓመት","past":"ከ{0} ዓመታት በፊት","future":"በ{0} ዓመታት ውስጥ"},"quarter":{"previous":"የመጨረሻው ሩብ","current":"ይህ ሩብ","next":"የሚቀጥለው ሩብ","past":"{0} ሩብ በፊት","future":"+{0} ሩብ"},"month":{"previous":"ያለፈው ወር","current":"በዚህ ወር","next":"የሚቀጥለው ወር","past":"ከ{0} ወራት በፊት","future":"በ{0} ወራት ውስጥ"},"week":{"previous":"ባለፈው ሳምንት","current":"በዚህ ሣምንት","next":"የሚቀጥለው ሳምንት","past":"ከ{0} ሳምንታት በፊት","future":"በ{0} ሳምንታት ውስጥ"},"day":{"previous":"ትላንትና","previous-2":"ከትናንት ወዲያ","current":"ዛሬ","next":"ነገ","next-2":"ከነገ ወዲያ","past":{"one":"ከ {0} ቀን በፊት","other":"ከ{0} ቀኖች በፊት"},"future":{"one":"በ{0} ቀን ውስጥ","other":"በ{0} ቀኖች ውስጥ"}},"hour":{"current":"ይህ ሰዓት","past":{"one":"ከ{0} ሰዓት በፊት","other":"ከ{0} ሰዓቶች በፊት"},"future":{"one":"በ{0} ሰዓት ውስጥ","other":"በ{0} ሰዓቶች ውስጥ"}},"minute":{"current":"ይህ ደቂቃ","past":{"one":"ከ{0} ደቂቃ በፊት","other":"ከ{0} ደቂቃዎች በፊት"},"future":{"one":"በ{0} ደቂቃ ውስጥ","other":"በ{0} ደቂቃዎች ውስጥ"}},"second":{"current":"አሁን","past":{"one":"ከ{0} ሰከንድ በፊት","other":"ከ{0} ሰከንዶች በፊት"},"future":{"one":"በ{0} ሰከንድ ውስጥ","other":"በ{0} ሰከንዶች ውስጥ"}}},"narrow":{"year":{"previous":"ያለፈው ዓመት","current":"በዚህ ዓመት","next":"የሚቀጥለው ዓመት","past":"ከ{0} ዓመታት በፊት","future":"በ{0} ዓመታት ውስጥ"},"quarter":{"previous":"የመጨረሻው ሩብ","current":"ይህ ሩብ","next":"የሚቀጥለው ሩብ","past":"{0} ሩብ በፊት","future":"+{0} ሩብ"},"month":{"previous":"ያለፈው ወር","current":"በዚህ ወር","next":"የሚቀጥለው ወር","past":"ከ{0} ወራት በፊት","future":"በ{0} ወራት ውስጥ"},"week":{"previous":"ባለፈው ሳምንት","current":"በዚህ ሣምንት","next":"የሚቀጥለው ሳምንት","past":"ከ{0} ሳምንታት በፊት","future":"በ{0} ሳምንታት ውስጥ"},"day":{"previous":"ትላንትና","previous-2":"ከትናንት ወዲያ","current":"ዛሬ","next":"ነገ","next-2":"ከነገ ወዲያ","past":{"one":"ከ {0} ቀን በፊት","other":"ከ{0} ቀኖች በፊት"},"future":{"one":"በ{0} ቀን ውስጥ","other":"በ{0} ቀኖች ውስጥ"}},"hour":{"current":"ይህ ሰዓት","past":{"one":"ከ{0} ሰዓት በፊት","other":"ከ{0} ሰዓቶች በፊት"},"future":{"one":"በ{0} ሰዓት ውስጥ","other":"በ{0} ሰዓቶች ውስጥ"}},"minute":{"current":"ይህ ደቂቃ","past":{"one":"ከ{0} ደቂቃ በፊት","other":"ከ{0} ደቂቃዎች በፊት"},"future":{"one":"በ{0} ደቂቃ ውስጥ","other":"በ{0} ደቂቃዎች ውስጥ"}},"second":{"current":"አሁን","past":{"one":"ከ{0} ሰከንድ በፊት","other":"ከ{0} ሰከንዶች በፊት"},"future":{"one":"በ{0} ሰከንድ ውስጥ","other":"በ{0} ሰከንዶች ውስጥ"}}}}');

/***/ }),

/***/ 94677:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ar-AE","long":{"year":{"previous":"السنة الماضية","current":"هذه السنة","next":"السنة التالية","past":{"one":"قبل سنة واحدة","two":"قبل سنتين","few":"قبل {0} سنوات","other":"قبل {0} سنة"},"future":{"one":"خلال سنة واحدة","two":"خلال سنتين","few":"خلال {0} سنوات","other":"خلال {0} سنة"}},"quarter":{"previous":"الربع الأخير","current":"هذا الربع","next":"الربع القادم","past":{"one":"قبل ربع سنة واحد","two":"قبل ربعي سنة","few":"قبل {0} أرباع سنة","other":"قبل {0} ربع سنة"},"future":{"one":"خلال ربع سنة واحد","two":"خلال ربعي سنة","few":"خلال {0} أرباع سنة","other":"خلال {0} ربع سنة"}},"month":{"previous":"الشهر الماضي","current":"هذا الشهر","next":"الشهر القادم","past":{"one":"قبل شهر واحد","two":"قبل شهرين","few":"قبل {0} أشهر","many":"قبل {0} شهرًا","other":"قبل {0} شهر"},"future":{"one":"خلال شهر واحد","two":"خلال شهرين","few":"خلال {0} أشهر","many":"خلال {0} شهرًا","other":"خلال {0} شهر"}},"week":{"previous":"الأسبوع الماضي","current":"هذا الأسبوع","next":"الأسبوع القادم","past":{"one":"قبل أسبوع واحد","two":"قبل أسبوعين","few":"قبل {0} أسابيع","many":"قبل {0} أسبوعًا","other":"قبل {0} أسبوع"},"future":{"one":"خلال أسبوع واحد","two":"خلال أسبوعين","few":"خلال {0} أسابيع","many":"خلال {0} أسبوعًا","other":"خلال {0} أسبوع"}},"day":{"previous":"أمس","previous-2":"أول أمس","current":"اليوم","next":"غدًا","next-2":"بعد الغد","past":{"one":"قبل يوم واحد","two":"قبل يومين","few":"قبل {0} أيام","many":"قبل {0} يومًا","other":"قبل {0} يوم"},"future":{"one":"خلال يوم واحد","two":"خلال يومين","few":"خلال {0} أيام","many":"خلال {0} يومًا","other":"خلال {0} يوم"}},"hour":{"current":"الساعة الحالية","past":{"one":"قبل ساعة واحدة","two":"قبل ساعتين","few":"قبل {0} ساعات","other":"قبل {0} ساعة"},"future":{"one":"خلال ساعة واحدة","two":"خلال ساعتين","few":"خلال {0} ساعات","other":"خلال {0} ساعة"}},"minute":{"current":"هذه الدقيقة","past":{"one":"قبل دقيقة واحدة","two":"قبل دقيقتين","few":"قبل {0} دقائق","other":"قبل {0} دقيقة"},"future":{"one":"خلال دقيقة واحدة","two":"خلال دقيقتين","few":"خلال {0} دقائق","other":"خلال {0} دقيقة"}},"second":{"current":"الآن","past":{"one":"قبل ثانية واحدة","two":"قبل ثانيتين","few":"قبل {0} ثوانِ","other":"قبل {0} ثانية"},"future":{"one":"خلال ثانية واحدة","two":"خلال ثانيتين","few":"خلال {0} ثوانٍ","other":"خلال {0} ثانية"}}},"short":{"year":{"previous":"السنة الماضية","current":"هذه السنة","next":"السنة التالية","past":{"one":"قبل سنة واحدة","two":"قبل سنتين","few":"قبل {0} سنوات","other":"قبل {0} سنة"},"future":{"one":"خلال سنة واحدة","two":"خلال سنتين","few":"خلال {0} سنوات","other":"خلال {0} سنة"}},"quarter":{"previous":"الربع الأخير","current":"هذا الربع","next":"الربع القادم","past":{"one":"قبل ربع سنة واحد","two":"قبل ربعي سنة","few":"قبل {0} أرباع سنة","other":"قبل {0} ربع سنة"},"future":{"one":"خلال ربع سنة واحد","two":"خلال ربعي سنة","few":"خلال {0} أرباع سنة","other":"خلال {0} ربع سنة"}},"month":{"previous":"الشهر الماضي","current":"هذا الشهر","next":"الشهر القادم","past":{"one":"قبل شهر واحد","two":"قبل شهرين","few":"خلال {0} أشهر","many":"قبل {0} شهرًا","other":"قبل {0} شهر"},"future":{"one":"خلال شهر واحد","two":"خلال شهرين","few":"خلال {0} أشهر","many":"خلال {0} شهرًا","other":"خلال {0} شهر"}},"week":{"previous":"الأسبوع الماضي","current":"هذا الأسبوع","next":"الأسبوع القادم","past":{"one":"قبل أسبوع واحد","two":"قبل أسبوعين","few":"قبل {0} أسابيع","many":"قبل {0} أسبوعًا","other":"قبل {0} أسبوع"},"future":{"one":"خلال أسبوع واحد","two":"خلال {0} أسبوعين","few":"خلال {0} أسابيع","many":"خلال {0} أسبوعًا","other":"خلال {0} أسبوع"}},"day":{"previous":"أمس","previous-2":"أول أمس","current":"اليوم","next":"غدًا","next-2":"بعد الغد","past":{"one":"قبل يوم واحد","two":"قبل يومين","few":"قبل {0} أيام","many":"قبل {0} يومًا","other":"قبل {0} يوم"},"future":{"one":"خلال يوم واحد","two":"خلال يومين","few":"خلال {0} أيام","many":"خلال {0} يومًا","other":"خلال {0} يوم"}},"hour":{"current":"الساعة الحالية","past":{"one":"قبل ساعة واحدة","two":"قبل ساعتين","few":"قبل {0} ساعات","other":"قبل {0} ساعة"},"future":{"one":"خلال ساعة واحدة","two":"خلال ساعتين","few":"خلال {0} ساعات","other":"خلال {0} ساعة"}},"minute":{"current":"هذه الدقيقة","past":{"one":"قبل دقيقة واحدة","two":"قبل دقيقتين","few":"قبل {0} دقائق","other":"قبل {0} دقيقة"},"future":{"one":"خلال دقيقة واحدة","two":"خلال دقيقتين","few":"خلال {0} دقائق","other":"خلال {0} دقيقة"}},"second":{"current":"الآن","past":{"one":"قبل ثانية واحدة","two":"قبل ثانيتين","few":"قبل {0} ثوانٍ","other":"قبل {0} ثانية"},"future":{"one":"خلال ثانية واحدة","two":"خلال ثانيتين","few":"خلال {0} ثوانٍ","other":"خلال {0} ثانية"}}},"narrow":{"year":{"previous":"السنة الماضية","current":"هذه السنة","next":"السنة التالية","past":{"one":"قبل سنة واحدة","two":"قبل سنتين","few":"قبل {0} سنوات","other":"قبل {0} سنة"},"future":{"one":"خلال سنة واحدة","two":"خلال سنتين","few":"خلال {0} سنوات","other":"خلال {0} سنة"}},"quarter":{"previous":"الربع الأخير","current":"هذا الربع","next":"الربع القادم","past":{"one":"قبل ربع سنة واحد","two":"قبل ربعي سنة","few":"قبل {0} أرباع سنة","other":"قبل {0} ربع سنة"},"future":{"one":"خلال ربع سنة واحد","two":"خلال ربعي سنة","few":"خلال {0} أرباع سنة","other":"خلال {0} ربع سنة"}},"month":{"previous":"الشهر الماضي","current":"هذا الشهر","next":"الشهر القادم","past":{"one":"قبل شهر واحد","two":"قبل شهرين","few":"قبل {0} أشهر","many":"قبل {0} شهرًا","other":"قبل {0} شهر"},"future":{"one":"خلال شهر واحد","two":"خلال شهرين","few":"خلال {0} أشهر","many":"خلال {0} شهرًا","other":"خلال {0} شهر"}},"week":{"previous":"الأسبوع الماضي","current":"هذا الأسبوع","next":"الأسبوع القادم","past":{"one":"قبل أسبوع واحد","two":"قبل أسبوعين","few":"قبل {0} أسابيع","many":"قبل {0} أسبوعًا","other":"قبل {0} أسبوع"},"future":{"one":"خلال أسبوع واحد","two":"خلال أسبوعين","few":"خلال {0} أسابيع","many":"خلال {0} أسبوعًا","other":"خلال {0} أسبوع"}},"day":{"previous":"أمس","previous-2":"أول أمس","current":"اليوم","next":"غدًا","next-2":"بعد الغد","past":{"one":"قبل يوم واحد","two":"قبل يومين","few":"قبل {0} أيام","many":"قبل {0} يومًا","other":"قبل {0} يوم"},"future":{"one":"خلال يوم واحد","two":"خلال يومين","few":"خلال {0} أيام","many":"خلال {0} يومًا","other":"خلال {0} يوم"}},"hour":{"current":"الساعة الحالية","past":{"one":"قبل ساعة واحدة","two":"قبل ساعتين","few":"قبل {0} ساعات","other":"قبل {0} ساعة"},"future":{"one":"خلال ساعة واحدة","two":"خلال ساعتين","few":"خلال {0} ساعات","other":"خلال {0} ساعة"}},"minute":{"current":"هذه الدقيقة","past":{"one":"قبل دقيقة واحدة","two":"قبل دقيقتين","few":"قبل {0} دقائق","other":"قبل {0} دقيقة"},"future":{"one":"خلال دقيقة واحدة","two":"خلال دقيقتين","few":"خلال {0} دقائق","other":"خلال {0} دقيقة"}},"second":{"current":"الآن","past":{"one":"قبل ثانية واحدة","two":"قبل ثانيتين","few":"قبل {0} ثوانٍ","other":"قبل {0} ثانية"},"future":{"one":"خلال ثانية واحدة","two":"خلال ثانيتين","few":"خلال {0} ثوانٍ","other":"خلال {0} ثانية"}}}}');

/***/ }),

/***/ 79793:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ar","long":{"year":{"previous":"السنة الماضية","current":"السنة الحالية","next":"السنة القادمة","past":{"one":"قبل سنة واحدة","two":"قبل سنتين","few":"قبل {0} سنوات","other":"قبل {0} سنة"},"future":{"one":"خلال سنة واحدة","two":"خلال سنتين","few":"خلال {0} سنوات","other":"خلال {0} سنة"}},"quarter":{"previous":"الربع الأخير","current":"هذا الربع","next":"الربع القادم","past":{"one":"قبل ربع سنة واحد","two":"قبل ربعي سنة","few":"قبل {0} أرباع سنة","other":"قبل {0} ربع سنة"},"future":{"one":"خلال ربع سنة واحد","two":"خلال ربعي سنة","few":"خلال {0} أرباع سنة","other":"خلال {0} ربع سنة"}},"month":{"previous":"الشهر الماضي","current":"هذا الشهر","next":"الشهر القادم","past":{"one":"قبل شهر واحد","two":"قبل شهرين","few":"قبل {0} أشهر","many":"قبل {0} شهرًا","other":"قبل {0} شهر"},"future":{"one":"خلال شهر واحد","two":"خلال شهرين","few":"خلال {0} أشهر","many":"خلال {0} شهرًا","other":"خلال {0} شهر"}},"week":{"previous":"الأسبوع الماضي","current":"هذا الأسبوع","next":"الأسبوع القادم","past":{"one":"قبل أسبوع واحد","two":"قبل أسبوعين","few":"قبل {0} أسابيع","many":"قبل {0} أسبوعًا","other":"قبل {0} أسبوع"},"future":{"one":"خلال أسبوع واحد","two":"خلال أسبوعين","few":"خلال {0} أسابيع","many":"خلال {0} أسبوعًا","other":"خلال {0} أسبوع"}},"day":{"previous":"أمس","previous-2":"أول أمس","current":"اليوم","next":"غدًا","next-2":"بعد الغد","past":{"one":"قبل يوم واحد","two":"قبل يومين","few":"قبل {0} أيام","many":"قبل {0} يومًا","other":"قبل {0} يوم"},"future":{"one":"خلال يوم واحد","two":"خلال يومين","few":"خلال {0} أيام","many":"خلال {0} يومًا","other":"خلال {0} يوم"}},"hour":{"current":"الساعة الحالية","past":{"one":"قبل ساعة واحدة","two":"قبل ساعتين","few":"قبل {0} ساعات","other":"قبل {0} ساعة"},"future":{"one":"خلال ساعة واحدة","two":"خلال ساعتين","few":"خلال {0} ساعات","other":"خلال {0} ساعة"}},"minute":{"current":"هذه الدقيقة","past":{"one":"قبل دقيقة واحدة","two":"قبل دقيقتين","few":"قبل {0} دقائق","other":"قبل {0} دقيقة"},"future":{"one":"خلال دقيقة واحدة","two":"خلال دقيقتين","few":"خلال {0} دقائق","other":"خلال {0} دقيقة"}},"second":{"current":"الآن","past":{"one":"قبل ثانية واحدة","two":"قبل ثانيتين","few":"قبل {0} ثوانِ","other":"قبل {0} ثانية"},"future":{"one":"خلال ثانية واحدة","two":"خلال ثانيتين","few":"خلال {0} ثوانٍ","other":"خلال {0} ثانية"}}},"short":{"year":{"previous":"السنة الماضية","current":"السنة الحالية","next":"السنة القادمة","past":{"one":"قبل سنة واحدة","two":"قبل سنتين","few":"قبل {0} سنوات","other":"قبل {0} سنة"},"future":{"one":"خلال سنة واحدة","two":"خلال سنتين","few":"خلال {0} سنوات","other":"خلال {0} سنة"}},"quarter":{"previous":"الربع الأخير","current":"هذا الربع","next":"الربع القادم","past":{"one":"قبل ربع سنة واحد","two":"قبل ربعي سنة","few":"قبل {0} أرباع سنة","other":"قبل {0} ربع سنة"},"future":{"one":"خلال ربع سنة واحد","two":"خلال ربعي سنة","few":"خلال {0} أرباع سنة","other":"خلال {0} ربع سنة"}},"month":{"previous":"الشهر الماضي","current":"هذا الشهر","next":"الشهر القادم","past":{"one":"قبل شهر واحد","two":"قبل شهرين","few":"خلال {0} أشهر","many":"قبل {0} شهرًا","other":"قبل {0} شهر"},"future":{"one":"خلال شهر واحد","two":"خلال شهرين","few":"خلال {0} أشهر","many":"خلال {0} شهرًا","other":"خلال {0} شهر"}},"week":{"previous":"الأسبوع الماضي","current":"هذا الأسبوع","next":"الأسبوع القادم","past":{"one":"قبل أسبوع واحد","two":"قبل أسبوعين","few":"قبل {0} أسابيع","many":"قبل {0} أسبوعًا","other":"قبل {0} أسبوع"},"future":{"one":"خلال أسبوع واحد","two":"خلال {0} أسبوعين","few":"خلال {0} أسابيع","many":"خلال {0} أسبوعًا","other":"خلال {0} أسبوع"}},"day":{"previous":"أمس","previous-2":"أول أمس","current":"اليوم","next":"غدًا","next-2":"بعد الغد","past":{"one":"قبل يوم واحد","two":"قبل يومين","few":"قبل {0} أيام","many":"قبل {0} يومًا","other":"قبل {0} يوم"},"future":{"one":"خلال يوم واحد","two":"خلال يومين","few":"خلال {0} أيام","many":"خلال {0} يومًا","other":"خلال {0} يوم"}},"hour":{"current":"الساعة الحالية","past":{"one":"قبل ساعة واحدة","two":"قبل ساعتين","few":"قبل {0} ساعات","other":"قبل {0} ساعة"},"future":{"one":"خلال ساعة واحدة","two":"خلال ساعتين","few":"خلال {0} ساعات","other":"خلال {0} ساعة"}},"minute":{"current":"هذه الدقيقة","past":{"one":"قبل دقيقة واحدة","two":"قبل دقيقتين","few":"قبل {0} دقائق","other":"قبل {0} دقيقة"},"future":{"one":"خلال دقيقة واحدة","two":"خلال دقيقتين","few":"خلال {0} دقائق","other":"خلال {0} دقيقة"}},"second":{"current":"الآن","past":{"one":"قبل ثانية واحدة","two":"قبل ثانيتين","few":"قبل {0} ثوانٍ","other":"قبل {0} ثانية"},"future":{"one":"خلال ثانية واحدة","two":"خلال ثانيتين","few":"خلال {0} ثوانٍ","other":"خلال {0} ثانية"}}},"narrow":{"year":{"previous":"السنة الماضية","current":"السنة الحالية","next":"السنة القادمة","past":{"one":"قبل سنة واحدة","two":"قبل سنتين","few":"قبل {0} سنوات","other":"قبل {0} سنة"},"future":{"one":"خلال سنة واحدة","two":"خلال سنتين","few":"خلال {0} سنوات","other":"خلال {0} سنة"}},"quarter":{"previous":"الربع الأخير","current":"هذا الربع","next":"الربع القادم","past":{"one":"قبل ربع سنة واحد","two":"قبل ربعي سنة","few":"قبل {0} أرباع سنة","other":"قبل {0} ربع سنة"},"future":{"one":"خلال ربع سنة واحد","two":"خلال ربعي سنة","few":"خلال {0} أرباع سنة","other":"خلال {0} ربع سنة"}},"month":{"previous":"الشهر الماضي","current":"هذا الشهر","next":"الشهر القادم","past":{"one":"قبل شهر واحد","two":"قبل شهرين","few":"قبل {0} أشهر","many":"قبل {0} شهرًا","other":"قبل {0} شهر"},"future":{"one":"خلال شهر واحد","two":"خلال شهرين","few":"خلال {0} أشهر","many":"خلال {0} شهرًا","other":"خلال {0} شهر"}},"week":{"previous":"الأسبوع الماضي","current":"هذا الأسبوع","next":"الأسبوع القادم","past":{"one":"قبل أسبوع واحد","two":"قبل أسبوعين","few":"قبل {0} أسابيع","many":"قبل {0} أسبوعًا","other":"قبل {0} أسبوع"},"future":{"one":"خلال أسبوع واحد","two":"خلال أسبوعين","few":"خلال {0} أسابيع","many":"خلال {0} أسبوعًا","other":"خلال {0} أسبوع"}},"day":{"previous":"أمس","previous-2":"أول أمس","current":"اليوم","next":"غدًا","next-2":"بعد الغد","past":{"one":"قبل يوم واحد","two":"قبل يومين","few":"قبل {0} أيام","many":"قبل {0} يومًا","other":"قبل {0} يوم"},"future":{"one":"خلال يوم واحد","two":"خلال يومين","few":"خلال {0} أيام","many":"خلال {0} يومًا","other":"خلال {0} يوم"}},"hour":{"current":"الساعة الحالية","past":{"one":"قبل ساعة واحدة","two":"قبل ساعتين","few":"قبل {0} ساعات","other":"قبل {0} ساعة"},"future":{"one":"خلال ساعة واحدة","two":"خلال ساعتين","few":"خلال {0} ساعات","other":"خلال {0} ساعة"}},"minute":{"current":"هذه الدقيقة","past":{"one":"قبل دقيقة واحدة","two":"قبل دقيقتين","few":"قبل {0} دقائق","other":"قبل {0} دقيقة"},"future":{"one":"خلال دقيقة واحدة","two":"خلال دقيقتين","few":"خلال {0} دقائق","other":"خلال {0} دقيقة"}},"second":{"current":"الآن","past":{"one":"قبل ثانية واحدة","two":"قبل ثانيتين","few":"قبل {0} ثوانٍ","other":"قبل {0} ثانية"},"future":{"one":"خلال ثانية واحدة","two":"خلال ثانيتين","few":"خلال {0} ثوانٍ","other":"خلال {0} ثانية"}}}}');

/***/ }),

/***/ 48407:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"as","long":{"year":{"previous":"যোৱা বছৰ","current":"এই বছৰ","next":"অহা বছৰ","past":"{0} বছৰৰ পূৰ্বে","future":"{0} বছৰত"},"quarter":{"previous":"যোৱা তিনি মাহ","current":"এই তিনি মাহ","next":"অহা তিনি মাহ","past":"{0} তিনি মাহ পূৰ্বে","future":"{0} তিনি মাহত"},"month":{"previous":"যোৱা মাহ","current":"এই মাহ","next":"অহা মাহ","past":"{0} মাহ পূৰ্বে","future":"{0} মাহত"},"week":{"previous":"যোৱা সপ্তাহ","current":"এই সপ্তাহ","next":"অহা সপ্তাহ","past":"{0} সপ্তাহ পূৰ্বে","future":"{0} সপ্তাহত"},"day":{"previous":"কালি","previous-2":"পৰহি","current":"আজি","next":"কাইলৈ","next-2":"পৰহিলৈ","past":"{0} দিন পূৰ্বে","future":"{0} দিনত"},"hour":{"current":"এইটো ঘণ্টাত","past":"{0} ঘণ্টা পূৰ্বে","future":"{0} ঘণ্টাত"},"minute":{"current":"এইটো মিনিটত","past":"{0} মিনিট পূৰ্বে","future":"{0} মিনিটত"},"second":{"current":"এতিয়া","past":"{0} ছেকেণ্ড পূৰ্বে","future":"{0} ছেকেণ্ডত"}},"short":{"year":{"previous":"যোৱা বছৰ","current":"এই বছৰ","next":"অহা বছৰ","past":"{0} বছৰৰ পূৰ্বে","future":"{0} বছৰত"},"quarter":{"previous":"যোৱা তিনি মাহ","current":"এই তিনি মাহ","next":"অহা তিনি মাহ","past":"{0} তিনি মাহ পূৰ্বে","future":"{0} তিনি মাহত"},"month":{"previous":"যোৱা মাহ","current":"এই মাহ","next":"অহা মাহ","past":"{0} মাহ পূৰ্বে","future":"{0} মাহত"},"week":{"previous":"যোৱা সপ্তাহ","current":"এই সপ্তাহ","next":"অহা সপ্তাহ","past":"{0} সপ্তাহ পূৰ্বে","future":"{0} সপ্তাহত"},"day":{"previous":"কালি","previous-2":"পৰহি","current":"আজি","next":"কাইলৈ","next-2":"পৰহিলৈ","past":"{0} দিন পূৰ্বে","future":"{0} দিনত"},"hour":{"current":"এইটো ঘণ্টাত","past":"{0} ঘণ্টা পূৰ্বে","future":"{0} ঘণ্টাত"},"minute":{"current":"এইটো মিনিটত","past":"{0} মিনিট পূৰ্বে","future":"{0} মিনিটত"},"second":{"current":"এতিয়া","past":"{0} ছেকেণ্ড পূৰ্বে","future":"{0} ছেকেণ্ডত"}},"narrow":{"year":{"previous":"যোৱা বছৰ","current":"এই বছৰ","next":"অহা বছৰ","past":"{0} বছৰৰ পূৰ্বে","future":"{0} বছৰত"},"quarter":{"previous":"যোৱা তিনি মাহ","current":"এই তিনি মাহ","next":"অহা তিনি মাহ","past":"{0} তিনি মাহ পূৰ্বে","future":"{0} তিনি মাহত"},"month":{"previous":"যোৱা মাহ","current":"এই মাহ","next":"অহা মাহ","past":"{0} মাহ পূৰ্বে","future":"{0} মাহত"},"week":{"previous":"যোৱা সপ্তাহ","current":"এই সপ্তাহ","next":"অহা সপ্তাহ","past":"{0} সপ্তাহ পূৰ্বে","future":"{0} সপ্তাহত"},"day":{"previous":"কালি","previous-2":"পৰহি","current":"আজি","next":"কাইলৈ","next-2":"পৰহিলৈ","past":"{0} দিন পূৰ্বে","future":"{0} দিনত"},"hour":{"current":"এইটো ঘণ্টাত","past":"{0} ঘণ্টা পূৰ্বে","future":"{0} ঘণ্টাত"},"minute":{"current":"এইটো মিনিটত","past":"{0} মিনিট পূৰ্বে","future":"{0} মিনিটত"},"second":{"current":"এতিয়া","past":"{0} ছেকেণ্ড পূৰ্বে","future":"{0} ছেকেণ্ডত"}}}');

/***/ }),

/***/ 34315:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ast","long":{"year":{"previous":"l’añu pasáu","current":"esti añu","next":"l’añu viniente","past":{"one":"hai {0} añu","other":"hai {0} años"},"future":{"one":"en {0} añu","other":"en {0} años"}},"quarter":{"previous":"trimestre anterior","current":"esti trimestre","next":"trimestre viniente","past":{"one":"hai {0} trimestre","other":"hai {0} trimestres"},"future":{"one":"en {0} trimestre","other":"en {0} trimestres"}},"month":{"previous":"el mes pasáu","current":"esti mes","next":"el mes viniente","past":{"one":"hai {0} mes","other":"hai {0} meses"},"future":{"one":"en {0} mes","other":"en {0} meses"}},"week":{"previous":"la selmana pasada","current":"esta selmana","next":"la selmana viniente","past":{"one":"hai {0} selmana","other":"hai {0} selmanes"},"future":{"one":"en {0} selmana","other":"en {0} selmanes"}},"day":{"previous":"ayeri","previous-2":"antayeri","current":"güei","next":"mañana","next-2":"pasao mañana","past":{"one":"hai {0} día","other":"hai {0} díes"},"future":{"one":"en {0} día","other":"en {0} díes"}},"hour":{"current":"esta hora","past":{"one":"hai {0} hora","other":"hai {0} hores"},"future":{"one":"en {0} hora","other":"en {0} hores"}},"minute":{"current":"esti minutu","past":{"one":"hai {0} minutu","other":"hai {0} minutos"},"future":{"one":"en {0} minutu","other":"en {0} minutos"}},"second":{"current":"agora","past":{"one":"hai {0} segundu","other":"hai {0} segundos"},"future":{"one":"en {0} segundu","other":"en {0} segundos"}}},"short":{"year":{"previous":"l’añu pas.","current":"esti añu","next":"l’añu vin.","past":{"one":"hai {0} añu","other":"hai {0} años"},"future":{"one":"en {0} añu","other":"en {0} años"}},"quarter":{"previous":"trim. ant.","current":"esti trim.","next":"trim. vin.","past":"hai {0} trim.","future":"en {0} trim."},"month":{"previous":"mes pas.","current":"esti mes","next":"mes vin.","past":{"one":"hai {0} mes","other":"hai {0} meses"},"future":{"one":"en {0} mes","other":"en {0} meses"}},"week":{"previous":"selm. pasada","current":"esta selm.","next":"selm. viniente","past":"hai {0} selm.","future":"en {0} selm."},"day":{"previous":"ayeri","previous-2":"antayeri","current":"güei","next":"mañana","next-2":"pasao mañana","past":{"one":"hai {0} día","other":"hai {0} díes"},"future":{"one":"en {0} día","other":"en {0} díes"}},"hour":{"current":"esta hora","past":"hai {0} h.","future":"en {0} h."},"minute":{"current":"esti min.","past":"hai {0} min.","future":"en {0} min."},"second":{"current":"agora","past":"hai {0} seg.","future":"en {0} seg."}},"narrow":{"year":{"previous":"añu pas.","current":"esti añu","next":"añu vin.","past":"hai {0} a.","future":"en {0} a."},"quarter":{"previous":"trim. ant.","current":"esti trim.","next":"trim. vin.","past":"hai {0} tr.","future":"en {0} tr."},"month":{"previous":"mes pas.","current":"esti mes","next":"mes vin.","past":"hai {0} m.","future":"en {0} m."},"week":{"previous":"selm. pas.","current":"esta selm.","next":"selm. vin.","past":"hai {0} se.","future":"en {0} se."},"day":{"previous":"ayeri","previous-2":"antay.","current":"güei","next":"mañ.","next-2":"p. mañ.","past":"hai {0} d.","future":"en {0} d."},"hour":{"current":"esta h.","past":"hai {0} h.","future":"en {0} h."},"minute":{"current":"esti min.","past":"hai {0} min.","future":"en {0} min."},"second":{"current":"agora","past":"hai {0} s.","future":"en {0} s."}}}');

/***/ }),

/***/ 67471:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"az","long":{"year":{"previous":"keçən il","current":"bu il","next":"gələn il","past":"{0} il öncə","future":"{0} il ərzində"},"quarter":{"previous":"keçən rüb","current":"bu rüb","next":"gələn rüb","past":"{0} rüb öncə","future":"{0} rüb ərzində"},"month":{"previous":"keçən ay","current":"bu ay","next":"gələn ay","past":"{0} ay öncə","future":"{0} ay ərzində"},"week":{"previous":"keçən həftə","current":"bu həftə","next":"gələn həftə","past":"{0} həftə öncə","future":"{0} həftə ərzində"},"day":{"previous":"dünən","current":"bu gün","next":"sabah","past":"{0} gün öncə","future":"{0} gün ərzində"},"hour":{"current":"bu saat","past":"{0} saat öncə","future":"{0} saat ərzində"},"minute":{"current":"bu dəqiqə","past":"{0} dəqiqə öncə","future":"{0} dəqiqə ərzində"},"second":{"current":"indi","past":"{0} saniyə öncə","future":"{0} saniyə ərzində"}},"short":{"year":{"previous":"keçən il","current":"bu il","next":"gələn il","past":"{0} il öncə","future":"{0} il ərzində"},"quarter":{"previous":"keçən rüb","current":"bu rüb","next":"gələn rüb","past":"{0} rüb öncə","future":"{0} rüb ərzində"},"month":{"previous":"keçən ay","current":"bu ay","next":"gələn ay","past":"{0} ay öncə","future":"{0} ay ərzində"},"week":{"previous":"keçən həftə","current":"bu həftə","next":"gələn həftə","past":"{0} həftə öncə","future":"{0} həftə ərzində"},"day":{"previous":"dünən","current":"bu gün","next":"sabah","past":"{0} gün öncə","future":"{0} gün ərzində"},"hour":{"current":"bu saat","past":"{0} saat öncə","future":"{0} saat ərzində"},"minute":{"current":"bu dəqiqə","past":"{0} dəqiqə öncə","future":"{0} dəqiqə ərzində"},"second":{"current":"indi","past":"{0} saniyə öncə","future":"{0} saniyə ərzində"}},"narrow":{"year":{"previous":"keçən il","current":"bu il","next":"gələn il","past":"{0} il öncə","future":"{0} il ərzində"},"quarter":{"previous":"keçən rüb","current":"bu rüb","next":"gələn rüb","past":"{0} rüb öncə","future":"{0} rüb ərzində"},"month":{"previous":"keçən ay","current":"bu ay","next":"gələn ay","past":"{0} ay öncə","future":"{0} ay ərzində"},"week":{"previous":"keçən həftə","current":"bu həftə","next":"gələn həftə","past":"{0} həftə öncə","future":"{0} həftə ərzində"},"day":{"previous":"dünən","current":"bu gün","next":"sabah","past":"{0} gün öncə","future":"{0} gün ərzində"},"hour":{"current":"bu saat","past":"{0} saat öncə","future":"{0} saat ərzində"},"minute":{"current":"bu dəqiqə","past":"{0} dəqiqə öncə","future":"{0} dəqiqə ərzində"},"second":{"current":"indi","past":"{0} saniyə öncə","future":"{0} saniyə ərzində"}}}');

/***/ }),

/***/ 33374:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"be","long":{"year":{"previous":"у мінулым годзе","current":"у гэтым годзе","next":"у наступным годзе","past":{"one":"{0} год таму","few":"{0} гады таму","many":"{0} гадоў таму","other":"{0} года таму"},"future":{"one":"праз {0} год","few":"праз {0} гады","many":"праз {0} гадоў","other":"праз {0} года"}},"quarter":{"previous":"у мінулым квартале","current":"у гэтым квартале","next":"у наступным квартале","past":{"one":"{0} квартал таму","few":"{0} кварталы таму","many":"{0} кварталаў таму","other":"{0} квартала таму"},"future":{"one":"праз {0} квартал","few":"праз {0} кварталы","many":"праз {0} кварталаў","other":"праз {0} квартала"}},"month":{"previous":"у мінулым месяцы","current":"у гэтым месяцы","next":"у наступным месяцы","past":{"one":"{0} месяц таму","few":"{0} месяцы таму","many":"{0} месяцаў таму","other":"{0} месяца таму"},"future":{"one":"праз {0} месяц","few":"праз {0} месяцы","many":"праз {0} месяцаў","other":"праз {0} месяца"}},"week":{"previous":"на мінулым тыдні","current":"на гэтым тыдні","next":"на наступным тыдні","past":{"one":"{0} тыдзень таму","few":"{0} тыдні таму","many":"{0} тыдняў таму","other":"{0} тыдня таму"},"future":{"one":"праз {0} тыдзень","few":"праз {0} тыдні","many":"праз {0} тыдняў","other":"праз {0} тыдня"}},"day":{"previous":"учора","previous-2":"пазаўчора","current":"сёння","next":"заўтра","next-2":"паслязаўтра","past":{"one":"{0} дзень таму","few":"{0} дні таму","many":"{0} дзён таму","other":"{0} дня таму"},"future":{"one":"праз {0} дзень","few":"праз {0} дні","many":"праз {0} дзён","other":"праз {0} дня"}},"hour":{"current":"у гэту гадзіну","past":{"one":"{0} гадзіну таму","many":"{0} гадзін таму","other":"{0} гадзіны таму"},"future":{"one":"праз {0} гадзіну","many":"праз {0} гадзін","other":"праз {0} гадзіны"}},"minute":{"current":"у гэту хвіліну","past":{"one":"{0} хвіліну таму","many":"{0} хвілін таму","other":"{0} хвіліны таму"},"future":{"one":"праз {0} хвіліну","many":"праз {0} хвілін","other":"праз {0} хвіліны"}},"second":{"current":"цяпер","past":{"one":"{0} секунду таму","many":"{0} секунд таму","other":"{0} секунды таму"},"future":{"one":"праз {0} секунду","many":"праз {0} секунд","other":"праз {0} секунды"}}},"short":{"year":{"previous":"у мінулым годзе","current":"у гэтым годзе","next":"у наступным годзе","past":"{0} г. таму","future":"праз {0} г."},"quarter":{"previous":"у мінулым квартале","current":"у гэтым квартале","next":"у наступным квартале","past":"{0} кв. таму","future":"праз {0} кв."},"month":{"previous":"у мінулым месяцы","current":"у гэтым месяцы","next":"у наступным месяцы","past":"{0} мес. таму","future":"праз {0} мес."},"week":{"previous":"на мінулым тыдні","current":"на гэтым тыдні","next":"на наступным тыдні","past":"{0} тыд таму","future":"праз {0} тыд"},"day":{"previous":"учора","previous-2":"пазаўчора","current":"сёння","next":"заўтра","next-2":"паслязаўтра","past":{"one":"{0} дзень таму","few":"{0} дні таму","many":"{0} дзён таму","other":"{0} дня таму"},"future":{"one":"праз {0} дзень","few":"праз {0} дні","many":"праз {0} дзён","other":"праз {0} дня"}},"hour":{"current":"у гэту гадзіну","past":"{0} гадз таму","future":"праз {0} гадз"},"minute":{"current":"у гэту хвіліну","past":"{0} хв таму","future":"праз {0} хв"},"second":{"current":"цяпер","past":"{0} с таму","future":"праз {0} с"}},"narrow":{"year":{"previous":"у мінулым годзе","current":"у гэтым годзе","next":"у наступным годзе","past":"{0} г. таму","future":"праз {0} г."},"quarter":{"previous":"у мінулым квартале","current":"у гэтым квартале","next":"у наступным квартале","past":"{0} кв. таму","future":"праз {0} кв."},"month":{"previous":"у мінулым месяцы","current":"у гэтым месяцы","next":"у наступным месяцы","past":"{0} мес. таму","future":"праз {0} мес."},"week":{"previous":"на мінулым тыдні","current":"на гэтым тыдні","next":"на наступным тыдні","past":"{0} тыд таму","future":"праз {0} тыд"},"day":{"previous":"учора","previous-2":"пазаўчора","current":"сёння","next":"заўтра","next-2":"паслязаўтра","past":{"one":"{0} дзень таму","few":"{0} дні таму","many":"{0} дзён таму","other":"{0} дня таму"},"future":{"one":"праз {0} дзень","few":"праз {0} дні","many":"праз {0} дзён","other":"праз {0} дня"}},"hour":{"current":"у гэту гадзіну","past":"{0} гадз таму","future":"праз {0} гадз"},"minute":{"current":"у гэту хвіліну","past":"{0} хв таму","future":"праз {0} хв"},"second":{"current":"цяпер","past":"{0} с таму","future":"праз {0} с"}}}');

/***/ }),

/***/ 12884:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"bg","long":{"year":{"previous":"миналата година","current":"тази година","next":"следващата година","past":{"one":"преди {0} година","other":"преди {0} години"},"future":{"one":"след {0} година","other":"след {0} години"}},"quarter":{"previous":"предходно тримесечие","current":"това тримесечие","next":"следващо тримесечие","past":{"one":"преди {0} тримесечие","other":"преди {0} тримесечия"},"future":{"one":"след {0} тримесечие","other":"след {0} тримесечия"}},"month":{"previous":"предходен месец","current":"този месец","next":"следващ месец","past":{"one":"преди {0} месец","other":"преди {0} месеца"},"future":{"one":"след {0} месец","other":"след {0} месеца"}},"week":{"previous":"предходната седмица","current":"тази седмица","next":"следващата седмица","past":{"one":"преди {0} седмица","other":"преди {0} седмици"},"future":{"one":"след {0} седмица","other":"след {0} седмици"}},"day":{"previous":"вчера","previous-2":"онзи ден","current":"днес","next":"утре","next-2":"вдругиден","past":{"one":"преди {0} ден","other":"преди {0} дни"},"future":{"one":"след {0} ден","other":"след {0} дни"}},"hour":{"current":"в този час","past":{"one":"преди {0} час","other":"преди {0} часа"},"future":{"one":"след {0} час","other":"след {0} часа"}},"minute":{"current":"в тази минута","past":{"one":"преди {0} минута","other":"преди {0} минути"},"future":{"one":"след {0} минута","other":"след {0} минути"}},"second":{"current":"сега","past":{"one":"преди {0} секунда","other":"преди {0} секунди"},"future":{"one":"след {0} секунда","other":"след {0} секунди"}}},"short":{"year":{"previous":"мин. г.","current":"т. г.","next":"следв. г.","past":"преди {0} г.","future":"след {0} г."},"quarter":{"previous":"мин. трим.","current":"това трим.","next":"следв. трим.","past":"преди {0} трим.","future":"след {0} трим."},"month":{"previous":"мин. мес.","current":"този мес.","next":"следв. мес.","past":"преди {0} м.","future":"след {0} м."},"week":{"previous":"миналата седмица","current":"тази седм.","next":"следв. седм.","past":"преди {0} седм.","future":"след {0} седм."},"day":{"previous":"вчера","previous-2":"онзи ден","current":"днес","next":"утре","next-2":"вдругиден","past":{"one":"преди {0} ден","other":"преди {0} дни"},"future":{"one":"след {0} ден","other":"след {0} дни"}},"hour":{"current":"в този час","past":"преди {0} ч","future":"след {0} ч"},"minute":{"current":"в тази минута","past":"преди {0} мин","future":"след {0} мин"},"second":{"current":"сега","past":"преди {0} сек","future":"след {0} сек"}},"narrow":{"year":{"previous":"мин. г.","current":"т. г.","next":"сл. г.","past":"пр. {0} г.","future":"сл. {0} г."},"quarter":{"previous":"мин. трим.","current":"това трим.","next":"следв. трим.","past":"пр. {0} трим.","future":"сл. {0} трим."},"month":{"previous":"мин. м.","current":"т. м.","next":"сл. м.","past":"пр. {0} м.","future":"сл. {0} м."},"week":{"previous":"мин. седм.","current":"тази седм.","next":"сл. седм.","past":"пр. {0} седм.","future":"сл. {0} седм."},"day":{"previous":"вчера","previous-2":"онзи ден","current":"днес","next":"утре","next-2":"вдругиден","past":"пр. {0} д","future":"сл. {0} д"},"hour":{"current":"в този час","past":"пр. {0} ч","future":"сл. {0} ч"},"minute":{"current":"в тази минута","past":"пр. {0} мин","future":"сл. {0} мин"},"second":{"current":"сега","past":"пр. {0} сек","future":"сл. {0} сек"}}}');

/***/ }),

/***/ 88168:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"bn","long":{"year":{"previous":"গত বছর","current":"এই বছর","next":"পরের বছর","past":"{0} বছর পূর্বে","future":"{0} বছরে"},"quarter":{"previous":"গত ত্রৈমাসিক","current":"এই ত্রৈমাসিক","next":"পরের ত্রৈমাসিক","past":"{0} ত্রৈমাসিক আগে","future":"{0} ত্রৈমাসিকে"},"month":{"previous":"গত মাস","current":"এই মাস","next":"পরের মাস","past":"{0} মাস আগে","future":"{0} মাসে"},"week":{"previous":"গত সপ্তাহ","current":"এই সপ্তাহ","next":"পরের সপ্তাহ","past":"{0} সপ্তাহ আগে","future":"{0} সপ্তাহে"},"day":{"previous":"গতকাল","previous-2":"গত পরশু","current":"আজ","next":"আগামীকাল","next-2":"আগামী পরশু","past":"{0} দিন আগে","future":"{0} দিনের মধ্যে"},"hour":{"current":"এই ঘণ্টায়","past":"{0} ঘন্টা আগে","future":"{0} ঘন্টায়"},"minute":{"current":"এই মিনিট","past":"{0} মিনিট আগে","future":"{0} মিনিটে"},"second":{"current":"এখন","past":"{0} সেকেন্ড পূর্বে","future":"{0} সেকেন্ডে"}},"short":{"year":{"previous":"গত বছর","current":"এই বছর","next":"পরের বছর","past":"{0} বছর পূর্বে","future":"{0} বছরে"},"quarter":{"previous":"গত ত্রৈমাসিক","current":"এই ত্রৈমাসিক","next":"পরের ত্রৈমাসিক","past":"{0} ত্রৈমাসিক আগে","future":"{0} ত্রৈমাসিকে"},"month":{"previous":"গত মাস","current":"এই মাস","next":"পরের মাস","past":"{0} মাস আগে","future":"{0} মাসে"},"week":{"previous":"গত সপ্তাহ","current":"এই সপ্তাহ","next":"পরের সপ্তাহ","past":"{0} সপ্তাহ আগে","future":"{0} সপ্তাহে"},"day":{"previous":"গতকাল","previous-2":"গত পরশু","current":"আজ","next":"আগামীকাল","next-2":"আগামী পরশু","past":"{0} দিন আগে","future":"{0} দিনের মধ্যে"},"hour":{"current":"এই ঘণ্টায়","past":"{0} ঘন্টা আগে","future":"{0} ঘন্টায়"},"minute":{"current":"এই মিনিট","past":"{0} মিনিট আগে","future":"{0} মিনিটে"},"second":{"current":"এখন","past":"{0} সেকেন্ড পূর্বে","future":"{0} সেকেন্ডে"}},"narrow":{"year":{"previous":"গত বছর","current":"এই বছর","next":"পরের বছর","past":"{0} বছর পূর্বে","future":"{0} বছরে"},"quarter":{"previous":"গত ত্রৈমাসিক","current":"এই ত্রৈমাসিক","next":"পরের ত্রৈমাসিক","past":"{0} ত্রৈমাসিক আগে","future":"{0} ত্রৈমাসিকে"},"month":{"previous":"গত মাস","current":"এই মাস","next":"পরের মাস","past":"{0} মাস আগে","future":"{0} মাসে"},"week":{"previous":"গত সপ্তাহ","current":"এই সপ্তাহ","next":"পরের সপ্তাহ","past":"{0} সপ্তাহ আগে","future":"{0} সপ্তাহে"},"day":{"previous":"গতকাল","previous-2":"গত পরশু","current":"আজ","next":"আগামীকাল","next-2":"আগামী পরশু","past":"{0} দিন আগে","future":"{0} দিনের মধ্যে"},"hour":{"current":"এই ঘণ্টায়","past":"{0} ঘন্টা আগে","future":"{0} ঘন্টায়"},"minute":{"current":"এই মিনিট","past":"{0} মিনিট আগে","future":"{0} মিনিটে"},"second":{"current":"এখন","past":"{0} সেকেন্ড আগে","future":"{0} সেকেন্ডে"}}}');

/***/ }),

/***/ 63805:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"br","long":{"year":{"previous":"warlene","current":"hevlene","next":"ar bloaz a zeu","past":{"one":"{0} bloaz zo","few":"{0} bloaz zo","many":"{0} a vloazioù zo","other":"{0} vloaz zo"},"future":{"one":"a-benn {0} bloaz","few":"a-benn {0} bloaz","many":"a-benn {0} a vloazioù","other":"a-benn {0} vloaz"}},"quarter":{"previous":"an trimiziad diaraok","current":"an trimiziad-mañ","next":"an trimiziad a zeu","past":{"two":"{0} drimiziad zo","few":"{0} zrimiziad zo","many":"{0} a zrimiziadoù zo","other":"{0} trimiziad zo"},"future":{"two":"a-benn {0} drimiziad","few":"a-benn {0} zrimiziad","many":"a-benn {0} a drimiziadoù","other":"a-benn {0} trimiziad"}},"month":{"previous":"ar miz diaraok","current":"ar miz-mañ","next":"ar miz a zeu","past":{"two":"{0} viz zo","many":"{0} a vizioù zo","other":"{0} miz zo"},"future":{"two":"a-benn {0} viz","many":"a-benn {0} a vizioù","other":"a-benn {0} miz"}},"week":{"previous":"ar sizhun diaraok","current":"ar sizhun-mañ","next":"ar sizhun a zeu","past":{"many":"{0} a sizhunioù zo","other":"{0} sizhun zo"},"future":{"many":"a-benn {0} a sizhunioù","other":"a-benn {0} sizhun"}},"day":{"previous":"decʼh","previous-2":"dercʼhent-decʼh","current":"hiziv","next":"warcʼhoazh","past":{"two":"{0} zeiz zo","many":"{0} a zeizioù zo","other":"{0} deiz zo"},"future":{"two":"a-benn {0} zeiz","many":"a-benn {0} a zeizioù","other":"a-benn {0} deiz"}},"hour":{"current":"dʼan eur-mañ","past":{"many":"{0} a eurioù zo","other":"{0} eur zo"},"future":{"many":"a-benn {0} a eurioù","other":"a-benn {0} eur"}},"minute":{"current":"this minute","past":{"two":"{0} vunut zo","many":"{0} a vunutoù zo","other":"{0} munut zo"},"future":{"two":"a-benn {0} vunut","many":"a-benn {0} a vunutoù","other":"a-benn {0} munut"}},"second":{"current":"bremañ","past":"{0} eilenn zo","future":{"many":"a-benn {0} a eilennoù","other":"a-benn {0} eilenn"}}},"short":{"year":{"previous":"warlene","current":"hevlene","next":"ar bl. a zeu","past":"{0} bl. zo","future":"a-benn {0} bl."},"quarter":{"previous":"an trim. diaraok","current":"an trim.-mañ","next":"an trim. a zeu","past":"{0} trim. zo","future":"a-benn {0} trim."},"month":{"previous":"ar miz diaraok","current":"ar miz-mañ","next":"ar miz a zeu","past":{"two":"{0} viz zo","many":"{0} a vizioù zo","other":"{0} miz zo"},"future":{"two":"a-benn {0} viz","many":"a-benn {0} a vizioù","other":"a-benn {0} miz"}},"week":{"previous":"ar sizhun diaraok","current":"ar sizhun-mañ","next":"ar sizhun a zeu","past":{"many":"{0} a sizhunioù zo","other":"{0} sizhun zo"},"future":{"many":"a-benn {0} a sizhunioù","other":"a-benn {0} sizhun"}},"day":{"previous":"decʼh","previous-2":"dercʼhent-decʼh","current":"hiziv","next":"warcʼhoazh","past":"{0} d zo","future":"a-benn {0} d"},"hour":{"current":"dʼan eur-mañ","past":"{0} e zo","future":"a-benn {0} e"},"minute":{"current":"this minute","past":"{0} min zo","future":"a-benn {0} min"},"second":{"current":"brem.","past":"{0} s zo","future":"a-benn {0} s"}},"narrow":{"year":{"previous":"warlene","current":"hevlene","next":"ar bl. a zeu","past":"-{0} bl.","future":"+{0} bl."},"quarter":{"previous":"an trim. diaraok","current":"an trim.-mañ","next":"an trim. a zeu","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"ar miz diaraok","current":"ar miz-mañ","next":"ar miz a zeu","past":"-{0} miz","future":"+{0} miz"},"week":{"previous":"ar sizhun diaraok","current":"ar sizhun-mañ","next":"ar sizhun a zeu","past":{"many":"{0} a sizhunioù zo","other":"{0} sizhun zo"},"future":{"many":"a-benn {0} a sizhunioù","other":"a-benn {0} sizhun"}},"day":{"previous":"decʼh","previous-2":"dercʼhent-decʼh","current":"hiziv","next":"warcʼhoazh","past":"-{0} d","future":"+{0} d"},"hour":{"current":"dʼan eur-mañ","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"brem.","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 91647:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"bs-Cyrl","long":{"year":{"previous":"Прошле године","current":"Ове године","next":"Следеће године","past":{"one":"пре {0} годину","few":"пре {0} године","other":"пре {0} година"},"future":{"one":"за {0} годину","few":"за {0} године","other":"за {0} година"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Прошлог месеца","current":"Овог месеца","next":"Следећег месеца","past":{"one":"пре {0} месец","few":"пре {0} месеца","other":"пре {0} месеци"},"future":{"one":"за {0} месец","few":"за {0} месеца","other":"за {0} месеци"}},"week":{"previous":"Прошле недеље","current":"Ове недеље","next":"Следеће недеље","past":{"one":"пре {0} недељу","few":"пре {0} недеље","other":"пре {0} недеља"},"future":{"one":"за {0} недељу","few":"за {0} недеље","other":"за {0} недеља"}},"day":{"previous":"јуче","previous-2":"прекјуче","current":"данас","next":"сутра","next-2":"прекосутра","past":{"one":"пре {0} дан","other":"пре {0} дана"},"future":{"one":"за {0} дан","other":"за {0} дана"}},"hour":{"current":"this hour","past":{"one":"пре {0} сат","few":"пре {0} сата","other":"пре {0} сати"},"future":{"one":"за {0} сат","few":"за {0} сата","other":"за {0} сати"}},"minute":{"current":"this minute","past":{"one":"пре {0} минут","other":"пре {0} минута"},"future":{"one":"за {0} минут","other":"за {0} минута"}},"second":{"current":"now","past":{"one":"пре {0} секунд","few":"пре {0} секунде","other":"пре {0} секунди"},"future":{"one":"за {0} секунд","few":"за {0} секунде","other":"за {0} секунди"}}},"short":{"year":{"previous":"Прошле године","current":"Ове године","next":"Следеће године","past":{"one":"пре {0} годину","few":"пре {0} године","other":"пре {0} година"},"future":{"one":"за {0} годину","few":"за {0} године","other":"за {0} година"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Прошлог месеца","current":"Овог месеца","next":"Следећег месеца","past":{"one":"пре {0} месец","few":"пре {0} месеца","other":"пре {0} месеци"},"future":{"one":"за {0} месец","few":"за {0} месеца","other":"за {0} месеци"}},"week":{"previous":"Прошле недеље","current":"Ове недеље","next":"Следеће недеље","past":{"one":"пре {0} недељу","few":"пре {0} недеље","other":"пре {0} недеља"},"future":{"one":"за {0} недељу","few":"за {0} недеље","other":"за {0} недеља"}},"day":{"previous":"јуче","previous-2":"прекјуче","current":"данас","next":"сутра","next-2":"прекосутра","past":{"one":"пре {0} дан","other":"пре {0} дана"},"future":{"one":"за {0} дан","other":"за {0} дана"}},"hour":{"current":"this hour","past":{"one":"пре {0} сат","few":"пре {0} сата","other":"пре {0} сати"},"future":{"one":"за {0} сат","few":"за {0} сата","other":"за {0} сати"}},"minute":{"current":"this minute","past":{"one":"пре {0} минут","other":"пре {0} минута"},"future":{"one":"за {0} минут","other":"за {0} минута"}},"second":{"current":"now","past":{"one":"пре {0} секунд","few":"пре {0} секунде","other":"пре {0} секунди"},"future":{"one":"за {0} секунд","few":"за {0} секунде","other":"за {0} секунди"}}},"narrow":{"year":{"previous":"Прошле године","current":"Ове године","next":"Следеће године","past":{"one":"пре {0} годину","few":"пре {0} године","other":"пре {0} година"},"future":{"one":"за {0} годину","few":"за {0} године","other":"за {0} година"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Прошлог месеца","current":"Овог месеца","next":"Следећег месеца","past":{"one":"пре {0} месец","few":"пре {0} месеца","other":"пре {0} месеци"},"future":{"one":"за {0} месец","few":"за {0} месеца","other":"за {0} месеци"}},"week":{"previous":"Прошле недеље","current":"Ове недеље","next":"Следеће недеље","past":{"one":"пре {0} недељу","few":"пре {0} недеље","other":"пре {0} недеља"},"future":{"one":"за {0} недељу","few":"за {0} недеље","other":"за {0} недеља"}},"day":{"previous":"јуче","previous-2":"прекјуче","current":"данас","next":"сутра","next-2":"прекосутра","past":{"one":"пре {0} дан","other":"пре {0} дана"},"future":{"one":"за {0} дан","other":"за {0} дана"}},"hour":{"current":"this hour","past":{"one":"пре {0} сат","few":"пре {0} сата","other":"пре {0} сати"},"future":{"one":"за {0} сат","few":"за {0} сата","other":"за {0} сати"}},"minute":{"current":"this minute","past":{"one":"пре {0} минут","other":"пре {0} минута"},"future":{"one":"за {0} минут","other":"за {0} минута"}},"second":{"current":"now","past":{"one":"пре {0} секунд","few":"пре {0} секунде","other":"пре {0} секунди"},"future":{"one":"за {0} секунд","few":"за {0} секунде","other":"за {0} секунди"}}}}');

/***/ }),

/***/ 16752:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"bs","long":{"year":{"previous":"prošle godine","current":"ove godine","next":"sljedeće godine","past":{"one":"prije {0} godinu","few":"prije {0} godine","other":"prije {0} godina"},"future":{"one":"za {0} godinu","few":"za {0} godine","other":"za {0} godina"}},"quarter":{"previous":"posljednji kvartal","current":"ovaj kvartal","next":"sljedeći kvartal","past":{"one":"prije {0} kvartal","other":"prije {0} kvartala"},"future":{"one":"za {0} kvartal","other":"za {0} kvartala"}},"month":{"previous":"prošli mjesec","current":"ovaj mjesec","next":"sljedeći mjesec","past":{"one":"prije {0} mjesec","few":"prije {0} mjeseca","other":"prije {0} mjeseci"},"future":{"one":"za {0} mjesec","few":"za {0} mjeseca","other":"za {0} mjeseci"}},"week":{"previous":"prošle sedmice","current":"ove sedmice","next":"sljedeće sedmice","past":{"one":"prije {0} sedmicu","few":"prije {0} sedmice","other":"prije {0} sedmica"},"future":{"one":"za {0} sedmicu","few":"za {0} sedmice","other":"za {0} sedmica"}},"day":{"previous":"jučer","previous-2":"prekjučer","current":"danas","next":"sutra","next-2":"prekosutra","past":{"one":"prije {0} dan","other":"prije {0} dana"},"future":{"one":"za {0} dan","other":"za {0} dana"}},"hour":{"current":"ovaj sat","past":{"one":"prije {0} sat","few":"prije {0} sata","other":"prije {0} sati"},"future":{"one":"za {0} sat","few":"za {0} sata","other":"za {0} sati"}},"minute":{"current":"ova minuta","past":{"one":"prije {0} minutu","few":"prije {0} minute","other":"prije {0} minuta"},"future":{"one":"za {0} minutu","few":"za {0} minute","other":"za {0} minuta"}},"second":{"current":"sada","past":{"one":"prije {0} sekundu","few":"prije {0} sekunde","other":"prije {0} sekundi"},"future":{"one":"za {0} sekundu","few":"za {0} sekunde","other":"za {0} sekundi"}}},"short":{"year":{"previous":"prošle godine","current":"ove godine","next":"sljedeće godine","past":"prije {0} god.","future":"za {0} god."},"quarter":{"previous":"posljednji kvartal","current":"ovaj kvartal","next":"sljedeći kvartal","past":"prije {0} kv.","future":"za {0} kv."},"month":{"previous":"prošli mjesec","current":"ovaj mjesec","next":"sljedeći mjesec","past":"prije {0} mj.","future":"za {0} mj."},"week":{"previous":"prošle sedmice","current":"ove sedmice","next":"sljedeće sedmice","past":"prije {0} sed.","future":"za {0} sed."},"day":{"previous":"jučer","previous-2":"prekjučer","current":"danas","next":"sutra","next-2":"prekosutra","past":"prije {0} d.","future":"za {0} d."},"hour":{"current":"ovaj sat","past":{"one":"prije {0} sat","few":"prije {0} sata","other":"prije {0} sati"},"future":{"one":"za {0} sat","few":"za {0} sata","other":"za {0} sati"}},"minute":{"current":"ova minuta","past":"prije {0} min.","future":"za {0} min."},"second":{"current":"sada","past":"prije {0} sek.","future":"za {0} sek."}},"narrow":{"year":{"previous":"prošle godine","current":"ove godine","next":"sljedeće godine","past":"prije {0} g.","future":"za {0} g."},"quarter":{"previous":"posljednji kvartal","current":"ovaj kvartal","next":"sljedeći kvartal","past":"prije {0} kv.","future":"za {0} kv."},"month":{"previous":"prošli mjesec","current":"ovaj mjesec","next":"sljedeći mjesec","past":"prije {0} mj.","future":"za {0} mj."},"week":{"previous":"prošle sedmice","current":"ove sedmice","next":"sljedeće sedmice","past":"prije {0} sed.","future":"za {0} sed."},"day":{"previous":"jučer","previous-2":"prekjučer","current":"danas","next":"sutra","next-2":"prekosutra","past":"prije {0} d.","future":"za {0} d."},"hour":{"current":"ovaj sat","past":{"one":"prije {0} sat","few":"prije {0} sata","other":"prije {0} sati"},"future":{"one":"za {0} sat","few":"za {0} sata","other":"za {0} sati"}},"minute":{"current":"ova minuta","past":"prije {0} min.","future":"za {0} min."},"second":{"current":"sada","past":"prije {0} sek.","future":"za {0} sek."}}}');

/***/ }),

/***/ 98742:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ca","long":{"year":{"previous":"l’any passat","current":"enguany","next":"l’any que ve","past":{"one":"fa {0} any","other":"fa {0} anys"},"future":{"one":"d’aquí a {0} any","other":"d’aquí a {0} anys"}},"quarter":{"previous":"el trimestre passat","current":"aquest trimestre","next":"el trimestre que ve","past":{"one":"fa {0} trimestre","other":"fa {0} trimestres"},"future":{"one":"d’aquí a {0} trimestre","other":"d’aquí a {0} trimestres"}},"month":{"previous":"el mes passat","current":"aquest mes","next":"el mes que ve","past":{"one":"fa {0} mes","other":"fa {0} mesos"},"future":{"one":"d’aquí a {0} mes","other":"d’aquí a {0} mesos"}},"week":{"previous":"la setmana passada","current":"aquesta setmana","next":"la setmana que ve","past":{"one":"fa {0} setmana","other":"fa {0} setmanes"},"future":{"one":"d’aquí a {0} setmana","other":"d’aquí a {0} setmanes"}},"day":{"previous":"ahir","previous-2":"abans-d’ahir","current":"avui","next":"demà","next-2":"demà passat","past":{"one":"fa {0} dia","other":"fa {0} dies"},"future":{"one":"d’aquí a {0} dia","other":"d’aquí a {0} dies"}},"hour":{"current":"aquesta hora","past":{"one":"fa {0} hora","other":"fa {0} hores"},"future":{"one":"d’aquí a {0} hora","other":"d’aquí a {0} hores"}},"minute":{"current":"aquest minut","past":{"one":"fa {0} minut","other":"fa {0} minuts"},"future":{"one":"d’aquí a {0} minut","other":"d’aquí a {0} minuts"}},"second":{"current":"ara","past":{"one":"fa {0} segon","other":"fa {0} segons"},"future":{"one":"d’aquí a {0} segon","other":"d’aquí a {0} segons"}}},"short":{"year":{"previous":"l’any passat","current":"enguany","next":"l’any que ve","past":{"one":"fa {0} any","other":"fa {0} anys"},"future":{"one":"d’aquí a {0} any","other":"d’aquí a {0} anys"}},"quarter":{"previous":"el trim. passat","current":"aquest trim.","next":"el trim. que ve","past":"fa {0} trim.","future":"d’aquí a {0} trim."},"month":{"previous":"el mes passat","current":"aquest mes","next":"el mes que ve","past":{"one":"fa {0} mes","other":"fa {0} mesos"},"future":{"one":"d’aquí a {0} mes","other":"d’aquí a {0} mesos"}},"week":{"previous":"la setm. passada","current":"aquesta setm.","next":"la setm. que ve","past":"fa {0} setm.","future":"d’aquí a {0} setm."},"day":{"previous":"ahir","previous-2":"abans-d’ahir","current":"avui","next":"demà","next-2":"demà passat","past":{"one":"fa {0} dia","other":"fa {0} dies"},"future":{"one":"d’aquí a {0} dia","other":"d’aquí a {0} dies"}},"hour":{"current":"aquesta hora","past":"fa {0} h","future":"d’aquí a {0} h"},"minute":{"current":"aquest minut","past":"fa {0} min","future":"d’aquí a {0} min"},"second":{"current":"ara","past":"fa {0} s","future":"d’aquí a {0} s"}},"narrow":{"year":{"previous":"l’any passat","current":"enguany","next":"l’any que ve","past":{"one":"fa {0} any","other":"fa {0} anys"},"future":{"one":"d’aquí a {0} any","other":"d’aquí a {0} anys"}},"quarter":{"previous":"trim. passat","current":"aquest trim.","next":"trim. vinent","past":"fa {0} trim.","future":"d’aquí a {0} trim."},"month":{"previous":"mes passat","current":"aquest mes","next":"mes vinent","past":{"one":"fa {0} mes","other":"fa {0} mesos"},"future":{"one":"d’aquí a {0} mes","other":"d’aquí a {0} mesos"}},"week":{"previous":"setm. passada","current":"aquesta setm.","next":"setm. vinent","past":"fa {0} setm.","future":"d’aquí a {0} setm."},"day":{"previous":"ahir","previous-2":"abans-d’ahir","current":"avui","next":"demà","next-2":"demà passat","past":{"one":"fa {0} dia","other":"fa {0} dies"},"future":{"one":"d’aquí a {0} dia","other":"d’aquí a {0} dies"}},"hour":{"current":"aquesta hora","past":"fa {0} h","future":"d‘aquí a {0} h"},"minute":{"current":"aquest minut","past":"fa {0} min","future":"d’aquí a {0} min"},"second":{"current":"ara","past":"fa {0} s","future":"d’aquí a {0} s"}}}');

/***/ }),

/***/ 30930:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ccp","long":{"year":{"previous":"𑄉𑄬𑄣𑄳𑄠𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","current":"𑄃𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","next":"𑄎𑄬𑄢𑄧 𑄝𑄧𑄏𑄧𑄢𑄴","past":"{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬","future":"{0} 𑄝𑄧𑄏𑄧𑄢𑄬"},"quarter":{"previous":"𑄉𑄬𑄣𑄳𑄠𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","current":"𑄃𑄳𑄆𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","next":"𑄛𑄧𑄢𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","past":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴 𑄃𑄉𑄬","future":{"one":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄬","other":"{0} 𑄖𑄨𑄚𑄟𑄏𑄬"}},"month":{"previous":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄟𑄏𑄴","current":"𑄃𑄳𑄆𑄬 𑄟𑄏𑄴","next":"𑄛𑄧𑄢𑄬 𑄟𑄏𑄴","past":"{0} 𑄟𑄏𑄧 𑄃𑄉𑄬","future":"{0} 𑄟𑄏𑄬"},"week":{"previous":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄥𑄛𑄴𑄖","current":"𑄃𑄳𑄆𑄬 𑄥𑄛𑄴𑄖","next":"𑄛𑄧𑄢𑄬 𑄥𑄛𑄴𑄖","past":"{0} 𑄥𑄛𑄴𑄖 𑄃𑄉𑄬","future":"{0} 𑄥𑄛𑄴𑄖𑄠𑄴"},"day":{"previous":"𑄉𑄬𑄣𑄴𑄣𑄳𑄠𑄇𑄬𑄣𑄳𑄠𑄬","previous-2":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄛𑄧𑄢𑄴𑄥𑄪","current":"𑄃𑄬𑄌𑄴𑄥𑄳𑄠","next":"𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄳𑄠𑄬","next-2":"𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄬 𑄛𑄧𑄢𑄴𑄥𑄪","past":"{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬","future":"{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠"},"hour":{"current":"𑄃𑄳𑄆𑄬 𑄊𑄮𑄚𑄴𑄓𑄠𑄴","past":"{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬","future":"{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"},"minute":{"current":"𑄃𑄳𑄆𑄬 𑄟𑄨𑄚𑄨𑄖𑄴","past":"{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬","future":"{0} 𑄟𑄨𑄚𑄨𑄘𑄬"},"second":{"current":"𑄃𑄨𑄇𑄴𑄅𑄚𑄪","past":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬","future":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬"}},"short":{"year":{"previous":"𑄉𑄬𑄣𑄳𑄠𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","current":"𑄃𑄳𑄆𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","next":"𑄛𑄧𑄢𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","past":"{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬","future":"{0} 𑄝𑄧𑄏𑄧𑄢𑄬"},"quarter":{"previous":"𑄉𑄬𑄣𑄳𑄠𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","current":"𑄃𑄳𑄆𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","next":"𑄛𑄧𑄢𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","past":{"one":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴 𑄃𑄉𑄬","other":"{0}𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴 𑄃𑄉𑄬"},"future":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄬"},"month":{"previous":"𑄉𑄬𑄣𑄧𑄉𑄬 𑄟𑄏𑄴","current":"𑄃𑄳𑄆𑄬 𑄟𑄏𑄴","next":"𑄛𑄧𑄢𑄬 𑄟𑄏𑄴","past":{"one":"{0} 𑄇𑄏𑄧 𑄃𑄉𑄬","other":"{0} 𑄟𑄏𑄧 𑄃𑄉𑄬"},"future":"{0} 𑄟𑄏𑄬"},"week":{"previous":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄥𑄛𑄴𑄖","current":"𑄃𑄳𑄆𑄬 𑄥𑄛𑄴𑄖","next":"𑄛𑄧𑄢𑄬 𑄥𑄛𑄴𑄖","past":"{0} 𑄥𑄛𑄴𑄖 𑄃𑄉𑄬","future":"{0} 𑄥𑄛𑄴𑄖𑄠𑄴"},"day":{"previous":"𑄉𑄬𑄣𑄴𑄣𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬","previous-2":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄛𑄧𑄢𑄴𑄥𑄪","current":"𑄃𑄬𑄌𑄴𑄥𑄳𑄠𑄬","next":"𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬","next-2":"𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬 𑄛𑄧𑄢𑄴𑄥𑄪","past":"{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬","future":"{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠"},"hour":{"current":"𑄃𑄳𑄆𑄬 𑄊𑄮𑄚𑄴𑄓𑄠𑄴","past":"{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬","future":"{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"},"minute":{"current":"𑄃𑄳𑄆𑄬 𑄟𑄨𑄚𑄨𑄖𑄴","past":"{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬","future":"{0} 𑄟𑄨𑄚𑄨𑄘𑄬"},"second":{"current":"𑄃𑄨𑄇𑄴𑄅𑄚𑄪","past":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬","future":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬"}},"narrow":{"year":{"previous":"𑄉𑄬𑄣𑄳𑄠𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","current":"𑄃𑄳𑄆𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","next":"𑄛𑄧𑄢𑄬 𑄝𑄧𑄏𑄧𑄢𑄴","past":"{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬","future":"{0} 𑄝𑄧𑄏𑄧𑄢𑄬"},"quarter":{"previous":"𑄉𑄬𑄣𑄳𑄠𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","current":"𑄃𑄳𑄆𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","next":"𑄛𑄧𑄢𑄬 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴","past":{"one":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴 𑄃𑄉𑄬","other":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄧𑄢𑄴 𑄃𑄬𑄉"},"future":"{0} 𑄖𑄨𑄚𑄴𑄟𑄏𑄬"},"month":{"previous":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄟𑄏𑄴","current":"𑄃𑄳𑄆𑄬 𑄟𑄏𑄴","next":"𑄛𑄧𑄢𑄬 𑄟𑄏𑄴","past":"{0} 𑄟𑄏𑄧 𑄃𑄉𑄬","future":"{0} 𑄟𑄏𑄬"},"week":{"previous":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄥𑄛𑄴𑄖","current":"𑄃𑄳𑄆𑄬 𑄥𑄛𑄴𑄖","next":"𑄛𑄧𑄢𑄬 𑄥𑄛𑄴𑄖","past":"{0} 𑄥𑄛𑄴𑄖𑄢𑄴 𑄃𑄉𑄬","future":"{0} 𑄥𑄛𑄴𑄖𑄠𑄴"},"day":{"previous":"𑄉𑄬𑄣𑄴𑄣𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬","previous-2":"𑄉𑄬𑄣𑄧𑄘𑄬 𑄛𑄧𑄢𑄴𑄥𑄪","current":"𑄃𑄬𑄌𑄴𑄥𑄳𑄠𑄬","next":"𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬","next-2":"𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬 𑄛𑄧𑄢𑄴𑄥𑄪","past":"{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬","future":"{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠"},"hour":{"current":"𑄃𑄳𑄆𑄬 𑄊𑄮𑄚𑄴𑄓𑄠𑄴","past":"{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬","future":"{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"},"minute":{"current":"𑄃𑄳𑄆𑄬 𑄟𑄨𑄚𑄨𑄖𑄴","past":"{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬","future":"{0} 𑄟𑄨𑄚𑄨𑄘𑄬"},"second":{"current":"𑄃𑄨𑄇𑄴𑄅𑄚𑄪","past":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬","future":{"one":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴","other":"{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬"}}}}');

/***/ }),

/***/ 40471:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ce","long":{"year":{"previous":"даханчу шарахь","current":"карарчу шарахь","next":"рогӀерчу шарахь","past":"{0} шо хьалха","future":"{0} шо даьлча"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"{0} квартал хьалха","future":"{0} квартал яьлча"},"month":{"previous":"баханчу баттахь","current":"карарчу баттахь","next":"рогӀерчу баттахь","past":"{0} бутт хьалха","future":"{0} бутт баьлча"},"week":{"previous":"даханчу кӀирнахь","current":"карарчу кӀирнахь","next":"рогӀерчу кӀирнахь","past":"{0} кӀира хьалха","future":"{0} кӀира даьлча"},"day":{"previous":"селхана","current":"тахана","next":"кхана","past":"{0} де хьалха","future":"{0} де даьлча"},"hour":{"current":"хӀокху сахьтехь","past":"{0} сахьт хьалха","future":"{0} сахьт даьлча"},"minute":{"current":"хӀокху минотехь","past":"{0} минот хьалха","future":"{0} минот яьлча"},"second":{"current":"хӀинца","past":"{0} секунд хьалха","future":"{0} секунд яьлча"}},"short":{"year":{"previous":"даханчу шарахь","current":"карарчу шарахь","next":"рогӀерчу шарахь","past":"{0} ш. хьалха","future":"{0} ш. даьлча"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"{0} кв. хьалха","future":"{0} кв. яьлча"},"month":{"previous":"баханчу баттахь","current":"карарчу баттахь","next":"рогӀерчу баттахь","past":"{0} б. хьалха","future":"{0} б. баьлча"},"week":{"previous":"даханчу кӀирнахь","current":"карарчу кӀирнахь","next":"рогӀерчу кӀирнахь","past":"{0} кӀир. хьалха","future":"{0} кӀир. даьлча"},"day":{"previous":"селхана","current":"тахана","next":"кхана","past":{"one":"{0} д. хьалха","other":"{0} де хьалха"},"future":"{0} д. даьлча"},"hour":{"current":"хӀокху сахьтехь","past":"{0} сахь. хьалха","future":"{0} сахь. даьлча"},"minute":{"current":"хӀокху минотехь","past":"{0} мин. хьалха","future":"{0} мин. яьлча"},"second":{"current":"хӀинца","past":"{0} сек. хьалха","future":"{0} сек. яьлча"}},"narrow":{"year":{"previous":"даханчу шарахь","current":"карарчу шарахь","next":"рогӀерчу шарахь","past":"{0} ш. хьалха","future":"{0} ш. даьлча"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"{0} кв. хьалха","future":"{0} кв. яьлча"},"month":{"previous":"баханчу баттахь","current":"карарчу баттахь","next":"рогӀерчу баттахь","past":"{0} б. хьалха","future":"{0} б. баьлча"},"week":{"previous":"даханчу кӀирнахь","current":"карарчу кӀирнахь","next":"рогӀерчу кӀирнахь","past":"{0} кӀир. хьалха","future":"{0} кӀир. даьлча"},"day":{"previous":"селхана","current":"тахана","next":"кхана","past":{"one":"де хьалха","other":"{0} де хьалха"},"future":"{0} д. даьлча"},"hour":{"current":"хӀокху сахьтехь","past":"{0} сахь. хьалха","future":"{0} сахь. даьлча"},"minute":{"current":"хӀокху минотехь","past":"{0} мин. хьалха","future":"{0} мин. яьлча"},"second":{"current":"хӀинца","past":"{0} сек. хьалха","future":"{0} сек. яьлча"}}}');

/***/ }),

/***/ 57754:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"chr","long":{"year":{"previous":"ᎡᏘ ᏥᎨᏒ","current":"ᎯᎠ ᏧᏕᏘᏴᏒᏘ","next":"ᎡᏘᏴᎢ","past":{"one":"{0} ᎤᏕᏘᏴᏌᏗᏒᎢ ᏥᎨᏒ","other":"{0} ᎢᏧᏕᏘᏴᏌᏗᏒᎢ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᎤᏕᏘᏴᏌᏗᏒᎢ","other":"ᎾᎿ {0} ᎢᏧᏕᏘᏴᏌᏗᏒᎢ"}},"quarter":{"previous":"ᎩᏄᏙᏗ ᏥᎨᏒ","current":"ᎯᎠ ᎩᏄᏙᏗ","next":"ᏔᎵᏁ ᎩᏄᏙᏗ","past":{"one":"ᎾᎿ {0} ᎩᏄᏙᏗ ᏥᎨᏒ","other":"{0} ᎩᏄᏙᏗ ᏥᎨᏒ"},"future":"ᎾᎿ {0} ᎩᏄᏙᏗ"},"month":{"previous":"ᎧᎸᎢ ᏥᎨᏒ","current":"ᎯᎠ ᎧᎸᎢ","next":"ᏔᎵᏁ ᎧᎸᎢ","past":{"one":"{0} ᎧᎸᎢ ᏥᎨᏒ","other":"{0} ᏗᎧᎸᎢ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᎧᎸᎢ","other":"ᎾᎿ {0} ᏗᎧᎸᎢ"}},"week":{"previous":"ᏥᏛᎵᏱᎵᏒᎢ","current":"ᎯᎠ ᎠᎵᎵᏌ","next":"ᏐᏆᎴᏅᎲ","past":{"one":"{0} ᏒᎾᏙᏓᏆᏍᏗ ᏥᎨᏒ","other":"{0} ᎢᏳᎾᏙᏓᏆᏍᏗ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᏒᎾᏙᏓᏆᏍᏗ","other":"ᎾᎿ {0} ᎢᏳᎾᏙᏓᏆᏍᏗ"}},"day":{"previous":"ᏒᎯ","current":"ᎪᎯ ᎢᎦ","next":"ᏌᎾᎴᎢ","past":{"one":"{0} ᎢᎦ ᏥᎨᏒ","other":"{0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᎢᎦ","other":"ᎾᎿ {0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ"}},"hour":{"current":"ᎯᎠ ᏑᏟᎶᏓ","past":{"one":"{0} ᏑᏟᎶᏓ ᏥᎨᏒ","other":"{0} ᎢᏳᏟᎶᏓ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᏑᏟᎶᏓ","other":"ᎾᎿ {0} ᎢᏳᏟᎶᏓ"}},"minute":{"current":"ᎯᎠ ᎢᏯᏔᏬᏍᏔᏅ","past":"{0} ᎢᏯᏔᏬᏍᏔᏅ ᏥᎨᏒ","future":"ᎾᎿ {0} ᎢᏯᏔᏬᏍᏔᏅ"},"second":{"current":"ᏃᏊ","past":{"one":"{0} ᎠᏎᏢ ᏥᎨᏒ","other":"{0} ᏓᏓᎾᏩᏍᎬ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᎠᏎᏢ","other":"ᎾᎿ {0} ᏓᏓᎾᏩᏍᎬ ᏥᎨᏒ"}}},"short":{"year":{"previous":"ᎡᏘ ᏥᎨᏒ","current":"ᎯᎠ ᏧᏕᏘᏴᏒᏘ","next":"ᎡᏘᏴᎢ","past":"{0} ᎤᏕ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎤᏕ."},"quarter":{"previous":"ᎩᏄᏙᏗ ᏥᎨᏒ","current":"ᎯᎠ ᎩᏄᏙᏗ","next":"ᏔᎵᏁ ᎩᏄᏙᏗ","past":"{0} ᎩᏄᏘ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎩᏄᏘ."},"month":{"previous":"ᎧᎸᎢ ᏥᎨᏒ","current":"ᎯᎠ ᎧᎸᎢ","next":"ᏔᎵᏁ ᎧᎸᎢ","past":"{0} ᎧᎸ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎧᎸ."},"week":{"previous":"ᏥᏛᎵᏱᎵᏒᎢ","current":"ᎯᎠ ᎠᎵᎵᏌ","next":"ᏐᏆᎴᏅᎲ","past":"{0} ᏒᎾ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᏒᎾ."},"day":{"previous":"ᏒᎯ","current":"ᎪᎯ ᎢᎦ","next":"ᏌᎾᎴᎢ","past":{"one":"{0} ᎢᎦ ᏥᎨᏒ","other":"{0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᎢᎦ","other":"ᎾᎿ {0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ"}},"hour":{"current":"ᎯᎠ ᏑᏟᎶᏓ","past":"{0} ᏑᏟ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᏑᏟ."},"minute":{"current":"ᎯᎠ ᎢᏯᏔᏬᏍᏔᏅ","past":"{0} ᎢᏯᏔ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎢᏯᏔ."},"second":{"current":"ᏃᏊ","past":"{0} ᎠᏎ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎠᏎ."}},"narrow":{"year":{"previous":"ᎡᏘ ᏥᎨᏒ","current":"ᎯᎠ ᏧᏕᏘᏴᏒᏘ","next":"ᎡᏘᏴᎢ","past":"{0} ᎤᏕ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎤᏕ."},"quarter":{"previous":"ᎩᏄᏙᏗ ᏥᎨᏒ","current":"ᎯᎠ ᎩᏄᏙᏗ","next":"ᏔᎵᏁ ᎩᏄᏙᏗ","past":"{0} ᎩᏄᏘ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎩᏄᏘ."},"month":{"previous":"ᎧᎸᎢ ᏥᎨᏒ","current":"ᎯᎠ ᎧᎸᎢ","next":"ᏔᎵᏁ ᎧᎸᎢ","past":"{0} ᎧᎸ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎧᎸ."},"week":{"previous":"ᏥᏛᎵᏱᎵᏒᎢ","current":"ᎯᎠ ᎠᎵᎵᏌ","next":"ᏐᏆᎴᏅᎲ","past":"{0} ᏒᎾ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᏒᎾ."},"day":{"previous":"ᏒᎯ","current":"ᎪᎯ ᎢᎦ","next":"ᏌᎾᎴᎢ","past":{"one":"{0} ᎢᎦ ᏥᎨᏒ","other":"{0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ ᏥᎨᏒ"},"future":{"one":"ᎾᎿ {0} ᎢᎦ","other":"ᎾᎿ {0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ"}},"hour":{"current":"ᎯᎠ ᏑᏟᎶᏓ","past":"{0} ᏑᏟ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᏑᏟ."},"minute":{"current":"ᎯᎠ ᎢᏯᏔᏬᏍᏔᏅ","past":"{0} ᎢᏯᏔ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎢᏯᏔ."},"second":{"current":"ᏃᏊ","past":"{0} ᎠᏎ. ᏥᎨᏒ","future":"ᎾᎿ {0} ᎠᏎ."}}}');

/***/ }),

/***/ 58993:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"cs","long":{"year":{"previous":"minulý rok","current":"tento rok","next":"příští rok","past":{"one":"před {0} rokem","many":"před {0} roku","other":"před {0} lety"},"future":{"one":"za {0} rok","few":"za {0} roky","many":"za {0} roku","other":"za {0} let"}},"quarter":{"previous":"minulé čtvrtletí","current":"toto čtvrtletí","next":"příští čtvrtletí","past":{"one":"před {0} čtvrtletím","many":"před {0} čtvrtletí","other":"před {0} čtvrtletími"},"future":"za {0} čtvrtletí"},"month":{"previous":"minulý měsíc","current":"tento měsíc","next":"příští měsíc","past":{"one":"před {0} měsícem","many":"před {0} měsíce","other":"před {0} měsíci"},"future":{"one":"za {0} měsíc","few":"za {0} měsíce","many":"za {0} měsíce","other":"za {0} měsíců"}},"week":{"previous":"minulý týden","current":"tento týden","next":"příští týden","past":{"one":"před {0} týdnem","many":"před {0} týdne","other":"před {0} týdny"},"future":{"one":"za {0} týden","few":"za {0} týdny","many":"za {0} týdne","other":"za {0} týdnů"}},"day":{"previous":"včera","previous-2":"předevčírem","current":"dnes","next":"zítra","next-2":"pozítří","past":{"one":"před {0} dnem","many":"před {0} dne","other":"před {0} dny"},"future":{"one":"za {0} den","few":"za {0} dny","many":"za {0} dne","other":"za {0} dní"}},"hour":{"current":"tuto hodinu","past":{"one":"před {0} hodinou","many":"před {0} hodiny","other":"před {0} hodinami"},"future":{"one":"za {0} hodinu","few":"za {0} hodiny","many":"za {0} hodiny","other":"za {0} hodin"}},"minute":{"current":"tuto minutu","past":{"one":"před {0} minutou","many":"před {0} minuty","other":"před {0} minutami"},"future":{"one":"za {0} minutu","few":"za {0} minuty","many":"za {0} minuty","other":"za {0} minut"}},"second":{"current":"nyní","past":{"one":"před {0} sekundou","many":"před {0} sekundy","other":"před {0} sekundami"},"future":{"one":"za {0} sekundu","few":"za {0} sekundy","many":"za {0} sekundy","other":"za {0} sekund"}}},"short":{"year":{"previous":"minulý rok","current":"tento rok","next":"příští rok","past":{"one":"před {0} r.","few":"před {0} r.","many":"před {0} r.","other":"před {0} l."},"future":{"one":"za {0} r.","few":"za {0} r.","many":"za {0} r.","other":"za {0} l."}},"quarter":{"previous":"minulé čtvrtletí","current":"toto čtvrtletí","next":"příští čtvrtletí","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"minulý měs.","current":"tento měs.","next":"příští měs.","past":"před {0} měs.","future":"za {0} měs."},"week":{"previous":"minulý týd.","current":"tento týd.","next":"příští týd.","past":"před {0} týd.","future":"za {0} týd."},"day":{"previous":"včera","previous-2":"předevčírem","current":"dnes","next":"zítra","next-2":"pozítří","past":{"one":"před {0} dnem","many":"před {0} dne","other":"před {0} dny"},"future":{"one":"za {0} den","few":"za {0} dny","many":"za {0} dne","other":"za {0} dní"}},"hour":{"current":"tuto hodinu","past":"před {0} h","future":"za {0} h"},"minute":{"current":"tuto minutu","past":"před {0} min","future":"za {0} min"},"second":{"current":"nyní","past":"před {0} s","future":"za {0} s"}},"narrow":{"year":{"previous":"minulý rok","current":"tento rok","next":"příští rok","past":{"one":"před {0} r.","few":"před {0} r.","many":"před {0} r.","other":"před {0} l."},"future":{"one":"za {0} r.","few":"za {0} r.","many":"za {0} r.","other":"za {0} l."}},"quarter":{"previous":"minulé čtvrtletí","current":"toto čtvrtletí","next":"příští čtvrtletí","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"minulý měs.","current":"tento měs.","next":"příští měs.","past":"před {0} měs.","future":"za {0} měs."},"week":{"previous":"minulý týd.","current":"tento týd.","next":"příští týd.","past":"před {0} týd.","future":"za {0} týd."},"day":{"previous":"včera","previous-2":"předevčírem","current":"dnes","next":"zítra","next-2":"pozítří","past":{"one":"před {0} dnem","many":"před {0} dne","other":"před {0} dny"},"future":{"one":"za {0} den","few":"za {0} dny","many":"za {0} dne","other":"za {0} dní"}},"hour":{"current":"tuto hodinu","past":"před {0} h","future":"za {0} h"},"minute":{"current":"tuto minutu","past":"před {0} min","future":"za {0} min"},"second":{"current":"nyní","past":"před {0} s","future":"za {0} s"}}}');

/***/ }),

/***/ 39977:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"cy","long":{"year":{"previous":"llynedd","current":"eleni","next":"blwyddyn nesaf","past":{"one":"blwyddyn yn ôl","two":"{0} flynedd yn ôl","few":"{0} blynedd yn ôl","many":"{0} blynedd yn ôl","other":"{0} o flynyddoedd yn ôl"},"future":{"one":"ymhen blwyddyn","two":"ymhen {0} flynedd","few":"ymhen {0} blynedd","many":"ymhen {0} blynedd","other":"ymhen {0} mlynedd"}},"quarter":{"previous":"chwarter olaf","current":"chwarter hwn","next":"chwarter nesaf","past":{"one":"{0} chwarter yn ôl","two":"{0} chwarter yn ôl","few":"{0} chwarter yn ôl","many":"{0} chwarter yn ôl","other":"{0} o chwarteri yn ôl"},"future":"ymhen {0} chwarter"},"month":{"previous":"mis diwethaf","current":"y mis hwn","next":"mis nesaf","past":{"two":"{0} fis yn ôl","other":"{0} mis yn ôl"},"future":{"one":"ymhen mis","two":"ymhen deufis","other":"ymhen {0} mis"}},"week":{"previous":"wythnos ddiwethaf","current":"yr wythnos hon","next":"wythnos nesaf","past":"{0} wythnos yn ôl","future":{"one":"ymhen wythnos","two":"ymhen pythefnos","other":"ymhen {0} wythnos"}},"day":{"previous":"ddoe","previous-2":"echdoe","current":"heddiw","next":"yfory","next-2":"drennydd","past":{"two":"{0} ddiwrnod yn ôl","other":"{0} diwrnod yn ôl"},"future":{"one":"ymhen diwrnod","two":"ymhen deuddydd","other":"ymhen {0} diwrnod"}},"hour":{"current":"yr awr hon","past":"{0} awr yn ôl","future":{"one":"ymhen awr","other":"ymhen {0} awr"}},"minute":{"current":"y funud hon","past":"{0} munud yn ôl","future":"ymhen {0} munud"},"second":{"current":"nawr","past":"{0} eiliad yn ôl","future":"ymhen {0} eiliad"}},"short":{"year":{"previous":"llynedd","current":"eleni","next":"blwyddyn nesaf","past":{"one":"blwyddyn yn ôl","two":"{0} flynedd yn ôl","few":"{0} blynedd yn ôl","many":"{0} blynedd yn ôl","other":"{0} o flynyddoedd yn ôl"},"future":{"one":"ymhen blwyddyn","two":"ymhen {0} flynedd","few":"ymhen {0} blynedd","many":"ymhen {0} blynedd","other":"ymhen {0} mlynedd"}},"quarter":{"previous":"chwarter olaf","current":"chwarter hwn","next":"chwarter nesaf","past":{"one":"{0} chwarter yn ôl","two":"{0} chwarter yn ôl","few":"{0} chwarter yn ôl","many":"{0} chwarter yn ôl","other":"{0} o chwarteri yn ôl"},"future":"ymhen {0} chwarter"},"month":{"previous":"mis diwethaf","current":"y mis hwn","next":"mis nesaf","past":{"two":"deufis yn ôl","other":"{0} mis yn ôl"},"future":{"one":"ymhen mis","two":"ymhen deufis","other":"ymhen {0} mis"}},"week":{"previous":"wythnos ddiwethaf","current":"yr wythnos hon","next":"wythnos nesaf","past":{"two":"pythefnos yn ôl","other":"{0} wythnos yn ôl"},"future":{"one":"ymhen wythnos","two":"ymhen pythefnos","other":"ymhen {0} wythnos"}},"day":{"previous":"ddoe","previous-2":"echdoe","current":"heddiw","next":"yfory","next-2":"drennydd","past":{"two":"{0} ddiwrnod yn ôl","other":"{0} diwrnod yn ôl"},"future":{"one":"ymhen diwrnod","two":"ymhen deuddydd","other":"ymhen {0} diwrnod"}},"hour":{"current":"yr awr hon","past":{"one":"awr yn ôl","other":"{0} awr yn ôl"},"future":{"one":"ymhen awr","other":"ymhen {0} awr"}},"minute":{"current":"y funud hon","past":{"two":"{0} fun. yn ôl","other":"{0} munud yn ôl"},"future":{"one":"ymhen {0} mun.","two":"ymhen {0} fun.","other":"ymhen {0} munud"}},"second":{"current":"nawr","past":"{0} eiliad yn ôl","future":"ymhen {0} eiliad"}},"narrow":{"year":{"previous":"llynedd","current":"eleni","next":"blwyddyn nesaf","past":{"one":"blwyddyn yn ôl","two":"{0} flynedd yn ôl","few":"{0} blynedd yn ôl","many":"{0} blynedd yn ôl","other":"{0} o flynyddoedd yn ôl"},"future":{"one":"ymhen blwyddyn","two":"ymhen {0} flynedd","few":"ymhen {0} blynedd","many":"ymhen {0} blynedd","other":"ymhen {0} mlynedd"}},"quarter":{"previous":"chwarter olaf","current":"chwarter hwn","next":"chwarter nesaf","past":{"one":"{0} chwarter yn ôl","two":"{0} chwarter yn ôl","few":"{0} chwarter yn ôl","many":"{0} chwarter yn ôl","other":"{0} o chwarteri yn ôl"},"future":"ymhen {0} chwarter"},"month":{"previous":"mis diwethaf","current":"y mis hwn","next":"mis nesaf","past":{"two":"{0} fis yn ôl","other":"{0} mis yn ôl"},"future":{"one":"ymhen mis","two":"ymhen deufis","other":"ymhen {0} mis"}},"week":{"previous":"wythnos ddiwethaf","current":"yr wythnos hon","next":"wythnos nesaf","past":{"two":"pythefnos yn ôl","other":"{0} wythnos yn ôl"},"future":"ymhen {0} wythnos"},"day":{"previous":"ddoe","previous-2":"echdoe","current":"heddiw","next":"yfory","next-2":"drennydd","past":{"two":"{0} ddiwrnod yn ôl","other":"{0} diwrnod yn ôl"},"future":"ymhen {0} diwrnod"},"hour":{"current":"yr awr hon","past":"{0} awr yn ôl","future":"ymhen {0} awr"},"minute":{"current":"y funud hon","past":"{0} mun. yn ôl","future":"ymhen {0} mun."},"second":{"current":"nawr","past":"{0} eiliad yn ôl","future":"ymhen {0} eiliad"}}}');

/***/ }),

/***/ 18929:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"da","long":{"year":{"previous":"sidste år","current":"i år","next":"næste år","past":"for {0} år siden","future":"om {0} år"},"quarter":{"previous":"sidste kvartal","current":"dette kvartal","next":"næste kvartal","past":{"one":"for {0} kvartal siden","other":"for {0} kvartaler siden"},"future":{"one":"om {0} kvartal","other":"om {0} kvartaler"}},"month":{"previous":"sidste måned","current":"denne måned","next":"næste måned","past":{"one":"for {0} måned siden","other":"for {0} måneder siden"},"future":{"one":"om {0} måned","other":"om {0} måneder"}},"week":{"previous":"sidste uge","current":"denne uge","next":"næste uge","past":{"one":"for {0} uge siden","other":"for {0} uger siden"},"future":{"one":"om {0} uge","other":"om {0} uger"}},"day":{"previous":"i går","previous-2":"i forgårs","current":"i dag","next":"i morgen","next-2":"i overmorgen","past":{"one":"for {0} dag siden","other":"for {0} dage siden"},"future":{"one":"om {0} dag","other":"om {0} dage"}},"hour":{"current":"i den kommende time","past":{"one":"for {0} time siden","other":"for {0} timer siden"},"future":{"one":"om {0} time","other":"om {0} timer"}},"minute":{"current":"i det kommende minut","past":{"one":"for {0} minut siden","other":"for {0} minutter siden"},"future":{"one":"om {0} minut","other":"om {0} minutter"}},"second":{"current":"nu","past":{"one":"for {0} sekund siden","other":"for {0} sekunder siden"},"future":{"one":"om {0} sekund","other":"om {0} sekunder"}}},"short":{"year":{"previous":"sidste år","current":"i år","next":"næste år","past":"for {0} år siden","future":"om {0} år"},"quarter":{"previous":"sidste kvt.","current":"dette kvt.","next":"næste kvt.","past":"for {0} kvt. siden","future":"om {0} kvt."},"month":{"previous":"sidste md.","current":"denne md.","next":"næste md.","past":{"one":"for {0} md. siden","other":"for {0} mdr. siden"},"future":{"one":"om {0} md.","other":"om {0} mdr."}},"week":{"previous":"sidste uge","current":"denne uge","next":"næste uge","past":{"one":"for {0} uge siden","other":"for {0} uger siden"},"future":{"one":"om {0} uge","other":"om {0} uger"}},"day":{"previous":"i går","previous-2":"i forgårs","current":"i dag","next":"i morgen","next-2":"i overmorgen","past":{"one":"for {0} dag siden","other":"for {0} dage siden"},"future":{"one":"om {0} dag","other":"om {0} dage"}},"hour":{"current":"i den kommende time","past":{"one":"for {0} time siden","other":"for {0} timer siden"},"future":{"one":"om {0} time","other":"om {0} timer"}},"minute":{"current":"i det kommende minut","past":"for {0} min. siden","future":"om {0} min."},"second":{"current":"nu","past":"for {0} sek. siden","future":"om {0} sek."}},"narrow":{"year":{"previous":"sidste år","current":"i år","next":"næste år","past":"for {0} år siden","future":"om {0} år"},"quarter":{"previous":"sidste kvt.","current":"dette kvt.","next":"næste kvt.","past":"for {0} kvt. siden","future":"om {0} kvt."},"month":{"previous":"sidste md.","current":"denne md.","next":"næste md.","past":{"one":"for {0} md. siden","other":"for {0} mdr. siden"},"future":{"one":"om {0} md.","other":"om {0} mdr."}},"week":{"previous":"sidste uge","current":"denne uge","next":"næste uge","past":{"one":"for {0} uge siden","other":"for {0} uger siden"},"future":{"one":"om {0} uge","other":"om {0} uger"}},"day":{"previous":"i går","previous-2":"i forgårs","current":"i dag","next":"i morgen","next-2":"i overmorgen","past":{"one":"for {0} dag siden","other":"for {0} dage siden"},"future":{"one":"om {0} dag","other":"om {0} dage"}},"hour":{"current":"i den kommende time","past":{"one":"for {0} time siden","other":"for {0} timer siden"},"future":{"one":"om {0} time","other":"om {0} timer"}},"minute":{"current":"i det kommende minut","past":"for {0} min. siden","future":"om {0} min."},"second":{"current":"nu","past":"for {0} sek. siden","future":"om {0} sek."}}}');

/***/ }),

/***/ 53128:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"de","long":{"year":{"previous":"letztes Jahr","current":"dieses Jahr","next":"nächstes Jahr","past":{"one":"vor {0} Jahr","other":"vor {0} Jahren"},"future":{"one":"in {0} Jahr","other":"in {0} Jahren"}},"quarter":{"previous":"letztes Quartal","current":"dieses Quartal","next":"nächstes Quartal","past":{"one":"vor {0} Quartal","other":"vor {0} Quartalen"},"future":{"one":"in {0} Quartal","other":"in {0} Quartalen"}},"month":{"previous":"letzten Monat","current":"diesen Monat","next":"nächsten Monat","past":{"one":"vor {0} Monat","other":"vor {0} Monaten"},"future":{"one":"in {0} Monat","other":"in {0} Monaten"}},"week":{"previous":"letzte Woche","current":"diese Woche","next":"nächste Woche","past":{"one":"vor {0} Woche","other":"vor {0} Wochen"},"future":{"one":"in {0} Woche","other":"in {0} Wochen"}},"day":{"previous":"gestern","previous-2":"vorgestern","current":"heute","next":"morgen","next-2":"übermorgen","past":{"one":"vor {0} Tag","other":"vor {0} Tagen"},"future":{"one":"in {0} Tag","other":"in {0} Tagen"}},"hour":{"current":"in dieser Stunde","past":{"one":"vor {0} Stunde","other":"vor {0} Stunden"},"future":{"one":"in {0} Stunde","other":"in {0} Stunden"}},"minute":{"current":"in dieser Minute","past":{"one":"vor {0} Minute","other":"vor {0} Minuten"},"future":{"one":"in {0} Minute","other":"in {0} Minuten"}},"second":{"current":"jetzt","past":{"one":"vor {0} Sekunde","other":"vor {0} Sekunden"},"future":{"one":"in {0} Sekunde","other":"in {0} Sekunden"}}},"short":{"year":{"previous":"letztes Jahr","current":"dieses Jahr","next":"nächstes Jahr","past":{"one":"vor {0} Jahr","other":"vor {0} Jahren"},"future":{"one":"in {0} Jahr","other":"in {0} Jahren"}},"quarter":{"previous":"letztes Quartal","current":"dieses Quartal","next":"nächstes Quartal","past":"vor {0} Quart.","future":"in {0} Quart."},"month":{"previous":"letzten Monat","current":"diesen Monat","next":"nächsten Monat","past":{"one":"vor {0} Monat","other":"vor {0} Monaten"},"future":{"one":"in {0} Monat","other":"in {0} Monaten"}},"week":{"previous":"letzte Woche","current":"diese Woche","next":"nächste Woche","past":{"one":"vor {0} Woche","other":"vor {0} Wochen"},"future":{"one":"in {0} Woche","other":"in {0} Wochen"}},"day":{"previous":"gestern","previous-2":"vorgestern","current":"heute","next":"morgen","next-2":"übermorgen","past":{"one":"vor {0} Tag","other":"vor {0} Tagen"},"future":{"one":"in {0} Tag","other":"in {0} Tagen"}},"hour":{"current":"in dieser Stunde","past":"vor {0} Std.","future":"in {0} Std."},"minute":{"current":"in dieser Minute","past":"vor {0} Min.","future":"in {0} Min."},"second":{"current":"jetzt","past":"vor {0} Sek.","future":"in {0} Sek."}},"narrow":{"year":{"previous":"letztes Jahr","current":"dieses Jahr","next":"nächstes Jahr","past":{"one":"vor {0} Jahr","other":"vor {0} Jahren"},"future":{"one":"in {0} Jahr","other":"in {0} Jahren"}},"quarter":{"previous":"letztes Quartal","current":"dieses Quartal","next":"nächstes Quartal","past":"vor {0} Q","future":"in {0} Q"},"month":{"previous":"letzten Monat","current":"diesen Monat","next":"nächsten Monat","past":{"one":"vor {0} Monat","other":"vor {0} Monaten"},"future":{"one":"in {0} Monat","other":"in {0} Monaten"}},"week":{"previous":"letzte Woche","current":"diese Woche","next":"nächste Woche","past":"vor {0} Wo.","future":"in {0} Wo."},"day":{"previous":"gestern","previous-2":"vorgestern","current":"heute","next":"morgen","next-2":"übermorgen","past":{"one":"vor {0} Tag","other":"vor {0} Tagen"},"future":{"one":"in {0} Tag","other":"in {0} Tagen"}},"hour":{"current":"in dieser Stunde","past":"vor {0} Std.","future":"in {0} Std."},"minute":{"current":"in dieser Minute","past":"vor {0} m","future":"in {0} m"},"second":{"current":"jetzt","past":"vor {0} s","future":"in {0} s"}}}');

/***/ }),

/***/ 42875:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"dsb","long":{"year":{"previous":"łoni","current":"lětosa","next":"znowa","past":{"one":"pśed {0} lětom","two":"pśed {0} lětoma","other":"pśed {0} lětami"},"future":{"one":"za {0} lěto","two":"za {0} lěśe","few":"za {0} lěta","other":"za {0} lět"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"pśed {0} kwartalom","two":"pśed {0} kwartaloma","other":"pśed {0} kwartalami"},"future":{"one":"za {0} kwartal","two":"za {0} kwartala","few":"za {0} kwartale","other":"za {0} kwartalow"}},"month":{"previous":"slědny mjasec","current":"ten mjasec","next":"pśiducy mjasec","past":{"one":"pśed {0} mjasecom","two":"pśed {0} mjasecoma","other":"pśed {0} mjasecami"},"future":{"one":"za {0} mjasec","two":"za {0} mjaseca","few":"za {0} mjasecy","other":"za {0} mjasecow"}},"week":{"previous":"slědny tyźeń","current":"ten tyźeń","next":"pśiducy tyźeń","past":{"one":"pśed {0} tyźenjom","two":"pśed {0} tyźenjoma","other":"pśed {0} tyźenjami"},"future":{"one":"za {0} tyźeń","two":"za {0} tyźenja","few":"za {0} tyźenje","other":"za {0} tyźenjow"}},"day":{"previous":"cora","current":"źinsa","next":"witśe","past":{"one":"pśed {0} dnjom","two":"pśed {0} dnjoma","other":"pśed {0} dnjami"},"future":{"one":"za {0} źeń","two":"za {0} dnja","few":"za {0} dny","other":"za {0} dnjow"}},"hour":{"current":"this hour","past":{"one":"pśed {0} góźinu","two":"pśed {0} góźinoma","other":"pśed {0} góźinami"},"future":{"one":"za {0} góźinu","two":"za {0} góźinje","few":"za {0} góźiny","other":"za {0} góźin"}},"minute":{"current":"this minute","past":{"one":"pśed {0} minutu","two":"pśed {0} minutoma","other":"pśed {0} minutami"},"future":{"one":"za {0} minutu","two":"za {0} minuśe","few":"za {0} minuty","other":"za {0} minutow"}},"second":{"current":"now","past":{"one":"pśed {0} sekundu","two":"pśed {0} sekundoma","other":"pśed {0} sekundami"},"future":{"one":"za {0} sekundu","two":"za {0} sekunźe","few":"za {0} sekundy","other":"za {0} sekundow"}}},"short":{"year":{"previous":"łoni","current":"lětosa","next":"znowa","past":"pśed {0} l.","future":"za {0} l."},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"pśed {0} kwart.","future":"za {0} kwart."},"month":{"previous":"slědny mjasec","current":"ten mjasec","next":"pśiducy mjasec","past":"pśed {0} mjas.","future":"za {0} mjas."},"week":{"previous":"slědny tyźeń","current":"ten tyźeń","next":"pśiducy tyźeń","past":"pśed {0} tyź.","future":"za {0} tyź."},"day":{"previous":"cora","current":"źinsa","next":"witśe","past":"pśed {0} dnj.","future":{"one":"za {0} źeń","few":"za {0} dny","other":"za {0} dnj."}},"hour":{"current":"this hour","past":"pśed {0} góź.","future":"za {0} góź."},"minute":{"current":"this minute","past":"pśed {0} min.","future":"za {0} min."},"second":{"current":"now","past":"pśed {0} sek.","future":"za {0} sek."}},"narrow":{"year":{"previous":"łoni","current":"lětosa","next":"znowa","past":"pśed {0} l.","future":"za {0} l."},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"pśed {0} kw.","future":"za {0} kw."},"month":{"previous":"slědny mjasec","current":"ten mjasec","next":"pśiducy mjasec","past":"pśed {0} mjas.","future":"za {0} mjas."},"week":{"previous":"slědny tyźeń","current":"ten tyźeń","next":"pśiducy tyźeń","past":"pśed {0} tyź.","future":"za {0} tyź."},"day":{"previous":"cora","current":"źinsa","next":"witśe","past":"pśed {0} d","future":"za {0} ź"},"hour":{"current":"this hour","past":"pśed {0} g","future":"za {0} g"},"minute":{"current":"this minute","past":"pśed {0} m","future":"za {0} m"},"second":{"current":"now","past":"pśed {0} s","future":"za {0} s"}}}');

/***/ }),

/***/ 88493:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"dz","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":"ལོ་འཁོར་ {0} ཧེ་མ་","future":"ལོ་འཁོར་ {0} ནང་"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"ཟླཝ་ {0} ཧེ་མ་","future":"ཟླཝ་ {0} ནང་"},"week":{"previous":"last week","current":"this week","next":"next week","past":"བངུན་ཕྲག་ {0} ཧེ་མ་","future":"བངུན་ཕྲག་ {0} ནང་"},"day":{"previous":"ཁ་ཙ་","previous-2":"ཁ་ཉིམ","current":"ད་རིས་","next":"ནངས་པ་","next-2":"གནངས་ཚེ","past":"ཉིནམ་ {0} ཧེ་མ་","future":"ཉིནམ་ {0} ནང་"},"hour":{"current":"this hour","past":"ཆུ་ཚོད་ {0} ཧེ་མ་","future":"ཆུ་ཚོད་ {0} ནང་"},"minute":{"current":"this minute","past":"སྐར་མ་ {0} ཧེ་མ་","future":"སྐར་མ་ {0} ནང་"},"second":{"current":"now","past":"སྐར་ཆ་ {0} ཧེ་མ་","future":"སྐར་ཆ་ {0} ནང་"}},"short":{"year":{"previous":"last year","current":"this year","next":"next year","past":"ལོ་འཁོར་ {0} ཧེ་མ་","future":"ལོ་འཁོར་ {0} ནང་"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"ཟླཝ་ {0} ཧེ་མ་","future":"ཟླཝ་ {0} ནང་"},"week":{"previous":"last week","current":"this week","next":"next week","past":"བངུན་ཕྲག་ {0} ཧེ་མ་","future":"བངུན་ཕྲག་ {0} ནང་"},"day":{"previous":"ཁ་ཙ་","previous-2":"ཁ་ཉིམ","current":"ད་རིས་","next":"ནངས་པ་","next-2":"གནངས་ཚེ","past":"ཉིནམ་ {0} ཧེ་མ་","future":"ཉིནམ་ {0} ནང་"},"hour":{"current":"this hour","past":"ཆུ་ཚོད་ {0} ཧེ་མ་","future":"ཆུ་ཚོད་ {0} ནང་"},"minute":{"current":"this minute","past":"སྐར་མ་ {0} ཧེ་མ་","future":"སྐར་མ་ {0} ནང་"},"second":{"current":"now","past":"སྐར་ཆ་ {0} ཧེ་མ་","future":"སྐར་ཆ་ {0} ནང་"}},"narrow":{"year":{"previous":"last year","current":"this year","next":"next year","past":"ལོ་འཁོར་ {0} ཧེ་མ་","future":"ལོ་འཁོར་ {0} ནང་"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"ཟླཝ་ {0} ཧེ་མ་","future":"ཟླཝ་ {0} ནང་"},"week":{"previous":"last week","current":"this week","next":"next week","past":"བངུན་ཕྲག་ {0} ཧེ་མ་","future":"བངུན་ཕྲག་ {0} ནང་"},"day":{"previous":"ཁ་ཙ་","previous-2":"ཁ་ཉིམ","current":"ད་རིས་","next":"ནངས་པ་","next-2":"གནངས་ཚེ","past":"ཉིནམ་ {0} ཧེ་མ་","future":"ཉིནམ་ {0} ནང་"},"hour":{"current":"this hour","past":"ཆུ་ཚོད་ {0} ཧེ་མ་","future":"ཆུ་ཚོད་ {0} ནང་"},"minute":{"current":"this minute","past":"སྐར་མ་ {0} ཧེ་མ་","future":"སྐར་མ་ {0} ནང་"},"second":{"current":"now","past":"སྐར་ཆ་ {0} ཧེ་མ་","future":"སྐར་ཆ་ {0} ནང་"}}}');

/***/ }),

/***/ 5976:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ee","long":{"year":{"previous":"ƒe si va yi","current":"ƒe sia","next":"ƒe si gbɔ na","past":{"one":"ƒe {0} si va yi","other":"ƒe {0} si wo va yi"},"future":"le ƒe {0} me"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"kɔta {0} si va yi me","future":"le kɔta {0} si gbɔ na me"},"month":{"previous":"ɣleti si va yi","current":"ɣleti sia","next":"ɣleti si gbɔ na","past":{"one":"ɣleti {0} si va yi","other":"ɣleti {0} si wo va yi"},"future":{"one":"le ɣleti {0} me","other":"le ɣleti {0} wo me"}},"week":{"previous":"kɔsiɖa si va yi","current":"kɔsiɖa sia","next":"kɔsiɖa si gbɔ na","past":{"one":"kɔsiɖa {0} si va yi","other":"kɔsiɖa {0} si wo va yi"},"future":{"one":"le kɔsiɖa {0} me","other":"le kɔsiɖa {0} wo me"}},"day":{"previous":"etsɔ si va yi","previous-2":"nyitsɔ si va yi","current":"egbe","next":"etsɔ si gbɔna","next-2":"nyitsɔ si gbɔna","past":{"one":"ŋkeke {0} si va yi","other":"ŋkeke {0} si wo va yi"},"future":{"one":"le ŋkeke {0} me","other":"le ŋkeke {0} wo me"}},"hour":{"current":"this hour","past":{"one":"gaƒoƒo {0} si va yi","other":"gaƒoƒo {0} si wo va yi"},"future":{"one":"le gaƒoƒo {0} me","other":"le gaƒoƒo {0} wo me"}},"minute":{"current":"this minute","past":{"one":"aɖabaƒoƒo {0} si va yi","other":"aɖabaƒoƒo {0} si wo va yi"},"future":{"one":"le aɖabaƒoƒo {0} me","other":"le aɖabaƒoƒo {0} wo me"}},"second":{"current":"fifi","past":{"one":"sekend {0} si va yi","other":"sekend {0} si wo va yi"},"future":{"one":"le sekend {0} me","other":"le sekend {0} wo me"}}},"short":{"year":{"previous":"ƒe si va yi","current":"ƒe sia","next":"ƒe si gbɔ na","past":"le ƒe {0} si va yi me","future":"le ƒe {0} me"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"kɔta {0} si va yi me","future":"le kɔta {0} si gbɔ na me"},"month":{"previous":"ɣleti si va yi","current":"ɣleti sia","next":"ɣleti si gbɔ na","past":{"one":"ɣleti {0} si va yi","other":"ɣleti {0} si wo va yi"},"future":{"one":"le ɣleti {0} me","other":"le ɣleti {0} wo me"}},"week":{"previous":"kɔsiɖa si va yi","current":"kɔsiɖa sia","next":"kɔsiɖa si gbɔ na","past":{"one":"kɔsiɖa {0} si va yi","other":"kɔsiɖa {0} si wo va yi"},"future":{"one":"le kɔsiɖa {0} me","other":"le kɔsiɖa {0} wo me"}},"day":{"previous":"etsɔ si va yi","previous-2":"nyitsɔ si va yi","current":"egbe","next":"etsɔ si gbɔna","next-2":"nyitsɔ si gbɔna","past":{"one":"ŋkeke {0} si va yi","other":"ŋkeke {0} si wo va yi"},"future":{"one":"le ŋkeke {0} me","other":"le ŋkeke {0} wo me"}},"hour":{"current":"this hour","past":{"one":"gaƒoƒo {0} si va yi","other":"gaƒoƒo {0} si wo va yi"},"future":{"one":"le gaƒoƒo {0} me","other":"le gaƒoƒo {0} wo me"}},"minute":{"current":"this minute","past":{"one":"aɖabaƒoƒo {0} si va yi","other":"aɖabaƒoƒo {0} si wo va yi"},"future":{"one":"le aɖabaƒoƒo {0} me","other":"le aɖabaƒoƒo {0} wo me"}},"second":{"current":"fifi","past":{"one":"sekend {0} si va yi","other":"sekend {0} si wo va yi"},"future":{"one":"le sekend {0} me","other":"le sekend {0} wo me"}}},"narrow":{"year":{"previous":"ƒe si va yi","current":"ƒe sia","next":"ƒe si gbɔ na","past":"ƒe {0} si va yi me","future":"le ƒe {0} si gbɔna me"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"kɔta {0} si va yi me","future":{"one":"le kɔta {0} si gbɔna me","other":"le kɔta {0} si gbɔ na me"}},"month":{"previous":"ɣleti si va yi","current":"ɣleti sia","next":"ɣleti si gbɔ na","past":{"one":"ɣleti {0} si va yi","other":"ɣleti {0} si wo va yi"},"future":{"one":"le ɣleti {0} me","other":"le ɣleti {0} wo me"}},"week":{"previous":"kɔsiɖa si va yi","current":"kɔsiɖa sia","next":"kɔsiɖa si gbɔ na","past":{"one":"kɔsiɖa {0} si va yi","other":"kɔsiɖa {0} si wo va yi"},"future":{"one":"le kɔsiɖa {0} me","other":"le kɔsiɖa {0} wo me"}},"day":{"previous":"etsɔ si va yi","previous-2":"nyitsɔ si va yi","current":"egbe","next":"etsɔ si gbɔna","next-2":"nyitsɔ si gbɔna","past":{"one":"ŋkeke {0} si va yi","other":"ŋkeke {0} si wo va yi"},"future":{"one":"le ŋkeke {0} me","other":"le ŋkeke {0} wo me"}},"hour":{"current":"this hour","past":{"one":"gaƒoƒo {0} si va yi","other":"gaƒoƒo {0} si wo va yi"},"future":{"one":"le gaƒoƒo {0} me","other":"le gaƒoƒo {0} wo me"}},"minute":{"current":"this minute","past":{"one":"aɖabaƒoƒo {0} si va yi","other":"aɖabaƒoƒo {0} si wo va yi"},"future":{"one":"le aɖabaƒoƒo {0} me","other":"le aɖabaƒoƒo {0} wo me"}},"second":{"current":"fifi","past":{"one":"sekend {0} si va yi","other":"sekend {0} si wo va yi"},"future":{"one":"le sekend {0} me","other":"le sekend {0} wo me"}}}}');

/***/ }),

/***/ 52622:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"el","long":{"year":{"previous":"πέρσι","current":"φέτος","next":"επόμενο έτος","past":{"one":"πριν από {0} έτος","other":"πριν από {0} έτη"},"future":{"one":"σε {0} έτος","other":"σε {0} έτη"}},"quarter":{"previous":"προηγούμενο τρίμηνο","current":"τρέχον τρίμηνο","next":"επόμενο τρίμηνο","past":{"one":"πριν από {0} τρίμηνο","other":"πριν από {0} τρίμηνα"},"future":{"one":"σε {0} τρίμηνο","other":"σε {0} τρίμηνα"}},"month":{"previous":"προηγούμενος μήνας","current":"τρέχων μήνας","next":"επόμενος μήνας","past":{"one":"πριν από {0} μήνα","other":"πριν από {0} μήνες"},"future":{"one":"σε {0} μήνα","other":"σε {0} μήνες"}},"week":{"previous":"προηγούμενη εβδομάδα","current":"τρέχουσα εβδομάδα","next":"επόμενη εβδομάδα","past":{"one":"πριν από {0} εβδομάδα","other":"πριν από {0} εβδομάδες"},"future":{"one":"σε {0} εβδομάδα","other":"σε {0} εβδομάδες"}},"day":{"previous":"χθες","previous-2":"προχθές","current":"σήμερα","next":"αύριο","next-2":"μεθαύριο","past":{"one":"πριν από {0} ημέρα","other":"πριν από {0} ημέρες"},"future":{"one":"σε {0} ημέρα","other":"σε {0} ημέρες"}},"hour":{"current":"τρέχουσα ώρα","past":{"one":"πριν από {0} ώρα","other":"πριν από {0} ώρες"},"future":{"one":"σε {0} ώρα","other":"σε {0} ώρες"}},"minute":{"current":"τρέχον λεπτό","past":{"one":"πριν από {0} λεπτό","other":"πριν από {0} λεπτά"},"future":{"one":"σε {0} λεπτό","other":"σε {0} λεπτά"}},"second":{"current":"τώρα","past":{"one":"πριν από {0} δευτερόλεπτο","other":"πριν από {0} δευτερόλεπτα"},"future":{"one":"σε {0} δευτερόλεπτο","other":"σε {0} δευτερόλεπτα"}}},"short":{"year":{"previous":"πέρσι","current":"φέτος","next":"επόμενο έτος","past":{"one":"πριν από {0} έτος","other":"πριν από {0} έτη"},"future":{"one":"σε {0} έτος","other":"σε {0} έτη"}},"quarter":{"previous":"προηγ. τρίμ.","current":"τρέχον τρίμ.","next":"επόμ. τρίμ.","past":"πριν από {0} τρίμ.","future":"σε {0} τρίμ."},"month":{"previous":"προηγούμενος μήνας","current":"τρέχων μήνας","next":"επόμενος μήνας","past":{"one":"πριν από {0} μήνα","other":"πριν από {0} μήνες"},"future":{"one":"σε {0} μήνα","other":"σε {0} μήνες"}},"week":{"previous":"προηγούμενη εβδομάδα","current":"τρέχουσα εβδομάδα","next":"επόμενη εβδομάδα","past":"πριν από {0} εβδ.","future":"σε {0} εβδ."},"day":{"previous":"χθες","previous-2":"προχθές","current":"σήμερα","next":"αύριο","next-2":"μεθαύριο","past":"πριν από {0} ημ.","future":"σε {0} ημ."},"hour":{"current":"τρέχουσα ώρα","past":"πριν από {0} ώ.","future":"σε {0} ώ."},"minute":{"current":"τρέχον λεπτό","past":"πριν από {0} λεπ.","future":"σε {0} λεπ."},"second":{"current":"τώρα","past":"πριν από {0} δευτ.","future":"σε {0} δευτ."}},"narrow":{"year":{"previous":"πέρσι","current":"φέτος","next":"επόμενο έτος","past":{"one":"{0} έτος πριν","other":"{0} έτη πριν"},"future":{"one":"σε {0} έτος","other":"σε {0} έτη"}},"quarter":{"previous":"προηγ. τρίμ.","current":"τρέχον τρίμ.","next":"επόμ. τρίμ.","past":"{0} τρίμ. πριν","future":"σε {0} τρίμ."},"month":{"previous":"προηγούμενος μήνας","current":"τρέχων μήνας","next":"επόμενος μήνας","past":"{0} μ. πριν","future":"σε {0} μ."},"week":{"previous":"προηγούμενη εβδομάδα","current":"τρέχουσα εβδομάδα","next":"επόμενη εβδομάδα","past":"{0} εβδ. πριν","future":"σε {0} εβδ."},"day":{"previous":"χθες","previous-2":"προχθές","current":"σήμερα","next":"αύριο","next-2":"μεθαύριο","past":"{0} ημ. πριν","future":"σε {0} ημ."},"hour":{"current":"τρέχουσα ώρα","past":"{0} ώ. πριν","future":"σε {0} ώ."},"minute":{"current":"τρέχον λεπτό","past":"{0} λ. πριν","future":"σε {0} λ."},"second":{"current":"τώρα","past":"{0} δ. πριν","future":"σε {0} δ."}}}');

/***/ }),

/***/ 86988:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-001","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 54845:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-150","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 79033:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-AG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 76857:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-AI","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 34230:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-AT","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 13714:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-AU","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":{"one":"{0} yr ago","other":"{0} yrs ago"},"future":{"one":"in {0} yr","other":"in {0} yrs"}},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":{"one":"{0} qtr ago","other":"{0} qtrs ago"},"future":{"one":"in {0} qtr","other":"in {0} qtrs"}},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo. ago","future":"in {0} mo."},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":{"one":"{0} wk ago","other":"{0} wks ago"},"future":{"one":"in {0} wk","other":"in {0} wks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hr ago","other":"{0} hrs ago"},"future":{"one":"in {0} hr","other":"in {0} hrs"}},"minute":{"current":"this minute","past":{"one":"{0} min. ago","other":"{0} mins ago"},"future":{"one":"in {0} min.","other":"in {0} mins"}},"second":{"current":"now","past":{"one":"{0} sec. ago","other":"{0} secs ago"},"future":{"one":"in {0} sec.","other":"in {0} secs"}}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":{"one":"{0} yr ago","other":"{0} yrs ago"},"future":{"one":"in {0} yr","other":"in {0} yrs"}},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":{"one":"in {0} qtr ago","other":"{0} qtrs ago"},"future":{"one":"in {0} qtr","other":"in {0} qtrs"}},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo. ago","future":"in {0} mo."},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":{"one":"{0} wk ago","other":"{0} wks ago"},"future":{"one":"in {0} wk","other":"in {0} wks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hr ago","other":"{0} hrs ago"},"future":{"one":"in {0} hr","other":"in {0} hrs"}},"minute":{"current":"this minute","past":{"one":"{0} min. ago","other":"{0} mins ago"},"future":{"one":"in {0} min.","other":"in {0} mins"}},"second":{"current":"now","past":{"one":"{0} sec. ago","other":"{0} secs ago"},"future":{"one":"in {0} sec.","other":"in {0} secs"}}}}');

/***/ }),

/***/ 2900:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-BB","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 85051:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-BE","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 6628:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-BM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 4998:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-BS","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 31641:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-BW","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 5251:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-BZ","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 68932:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CA","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":{"one":"{0} yr. ago","other":"{0} yrs. ago"},"future":{"one":"in {0} yr.","other":"in {0} yrs."}},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":{"one":"{0} qtr. ago","other":"{0} qtrs. ago"},"future":{"one":"in {0} qtr.","other":"in {0} qtrs."}},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":{"one":"{0} mo. ago","other":"{0} mos. ago"},"future":{"one":"in {0} mo.","other":"in {0} mos."}},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":{"one":"{0} wk. ago","other":"{0} wks. ago"},"future":{"one":"in {0} wk.","other":"in {0} wks."}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hr. ago","other":"{0} hrs. ago"},"future":{"one":"in {0} hr.","other":"in {0} hrs."}},"minute":{"current":"this minute","past":{"one":"{0} min. ago","other":"{0} mins. ago"},"future":{"one":"in {0} min.","other":"in {0} mins."}},"second":{"current":"now","past":{"one":"{0} sec. ago","other":"{0} secs. ago"},"future":{"one":"in {0} sec.","other":"in {0} secs."}}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":{"one":"{0} yr. ago","other":"{0} yrs. ago"},"future":{"one":"in {0} yr.","other":"in {0} yrs."}},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":{"one":"{0} qtr. ago","other":"{0} qtrs. ago"},"future":{"one":"in {0} qtr.","other":"in {0} qtrs."}},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":{"one":"{0} mo. ago","other":"{0} mos. ago"},"future":{"one":"in {0} mo.","other":"in {0} mos."}},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":{"one":"{0} wk. ago","other":"{0} wks. ago"},"future":{"one":"in {0} wk.","other":"in {0} wks."}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hr. ago","other":"{0} hrs. ago"},"future":{"one":"in {0} hr.","other":"in {0} hrs."}},"minute":{"current":"this minute","past":{"one":"{0} min. ago","other":"{0} mins. ago"},"future":{"one":"in {0} min.","other":"in {0} mins."}},"second":{"current":"now","past":{"one":"{0} sec. ago","other":"{0} secs. ago"},"future":{"one":"in {0} sec.","other":"in {0} secs."}}}}');

/***/ }),

/***/ 97965:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CC","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 39504:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CH","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 79491:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CK","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 45784:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 42206:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CX","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 90269:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-CY","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 6069:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-DE","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 94854:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-DG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 72125:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-DK","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 48080:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-DM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 49477:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-ER","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 89263:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-FI","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 733:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-FJ","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 6781:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-FK","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 45646:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-FM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 7002:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GB","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 9196:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GD","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 18539:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 47919:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GH","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 91306:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GI","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 27500:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 35726:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-GY","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 89955:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-HK","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 29774:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-IE","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 30682:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-IL","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 32679:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-IM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 25206:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-IN","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 35755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-IO","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 18182:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-JE","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 66134:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-JM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 81084:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-KE","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 84609:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-KI","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 44390:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-KN","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 81736:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-KY","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 85746:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-LC","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 19067:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-LR","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 90522:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-LS","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 46230:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 86845:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MO","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 91737:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MS","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 7146:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MT","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 73408:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MU","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 30669:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MW","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 5704:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-MY","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 42222:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NA","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 83832:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NF","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 49031:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 47077:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NL","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 86119:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NR","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 91803:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NU","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 66172:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-NZ","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 92395:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-PG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 78928:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-PH","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 96343:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-PK","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 37194:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-PN","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 71418:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-PW","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 19639:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-RW","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 12455:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SB","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 58917:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SC","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 59532:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SD","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 79052:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SE","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 65275:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr","current":"this yr","next":"next yr","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr","current":"this qtr","next":"next qtr","past":{"one":"{0} qtr ago","other":"{0} qtrs ago"},"future":{"one":"in {0} qtr","other":"in {0} qtrs"}},"month":{"previous":"last mth","current":"this mth","next":"next mth","past":"{0} mth ago","future":"in {0} mth"},"week":{"previous":"last wk","current":"this wk","next":"next wk","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr","current":"this yr","next":"next yr","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr","current":"this qtr","next":"next qtr","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mth","current":"this mth","next":"next mth","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk","current":"this wk","next":"next wk","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 72428:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SH","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 55597:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SI","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 78965:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SL","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 97440:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SS","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 28599:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SX","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 41260:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-SZ","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 85618:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-TC","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 19540:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-TK","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 74818:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-TO","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 61365:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-TT","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 68399:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-TV","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 75784:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-TZ","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 20359:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-UG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 1225:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-VC","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 72949:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-VG","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 79794:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-VU","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 53030:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-WS","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 15202:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-ZA","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 80968:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-ZM","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 19578:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en-ZW","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr ago","future":"in {0} yr"},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":"{0} qtr ago","future":"in {0} qtr"},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo ago","future":"in {0} mo"},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk ago","future":"in {0} wk"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr ago","future":"in {0} hr"},"minute":{"current":"this minute","past":"{0} min ago","future":"in {0} min"},"second":{"current":"now","past":"{0} sec ago","future":"in {0} sec"}}}');

/***/ }),

/***/ 67907:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"en","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} year ago","other":"{0} years ago"},"future":{"one":"in {0} year","other":"in {0} years"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"{0} quarter ago","other":"{0} quarters ago"},"future":{"one":"in {0} quarter","other":"in {0} quarters"}},"month":{"previous":"last month","current":"this month","next":"next month","past":{"one":"{0} month ago","other":"{0} months ago"},"future":{"one":"in {0} month","other":"in {0} months"}},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} week ago","other":"{0} weeks ago"},"future":{"one":"in {0} week","other":"in {0} weeks"}},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":{"one":"{0} hour ago","other":"{0} hours ago"},"future":{"one":"in {0} hour","other":"in {0} hours"}},"minute":{"current":"this minute","past":{"one":"{0} minute ago","other":"{0} minutes ago"},"future":{"one":"in {0} minute","other":"in {0} minutes"}},"second":{"current":"now","past":{"one":"{0} second ago","other":"{0} seconds ago"},"future":{"one":"in {0} second","other":"in {0} seconds"}}},"short":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr. ago","future":"in {0} yr."},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":{"one":"{0} qtr. ago","other":"{0} qtrs. ago"},"future":{"one":"in {0} qtr.","other":"in {0} qtrs."}},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo. ago","future":"in {0} mo."},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk. ago","future":"in {0} wk."},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr. ago","future":"in {0} hr."},"minute":{"current":"this minute","past":"{0} min. ago","future":"in {0} min."},"second":{"current":"now","past":"{0} sec. ago","future":"in {0} sec."}},"narrow":{"year":{"previous":"last yr.","current":"this yr.","next":"next yr.","past":"{0} yr. ago","future":"in {0} yr."},"quarter":{"previous":"last qtr.","current":"this qtr.","next":"next qtr.","past":{"one":"{0} qtr. ago","other":"{0} qtrs. ago"},"future":{"one":"in {0} qtr.","other":"in {0} qtrs."}},"month":{"previous":"last mo.","current":"this mo.","next":"next mo.","past":"{0} mo. ago","future":"in {0} mo."},"week":{"previous":"last wk.","current":"this wk.","next":"next wk.","past":"{0} wk. ago","future":"in {0} wk."},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":{"one":"{0} day ago","other":"{0} days ago"},"future":{"one":"in {0} day","other":"in {0} days"}},"hour":{"current":"this hour","past":"{0} hr. ago","future":"in {0} hr."},"minute":{"current":"this minute","past":"{0} min. ago","future":"in {0} min."},"second":{"current":"now","past":"{0} sec. ago","future":"in {0} sec."}}}');

/***/ }),

/***/ 89641:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"es-AR","long":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":{"one":"hace {0} año","other":"hace {0} años"},"future":{"one":"dentro de {0} año","other":"dentro de {0} años"}},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":{"one":"hace {0} trimestre","other":"hace {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":{"one":"hace {0} mes","other":"hace {0} meses"},"future":{"one":"dentro de {0} mes","other":"dentro de {0} meses"}},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":{"one":"hace {0} semana","other":"hace {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":{"one":"hace {0} hora","other":"hace {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hace {0} minuto","other":"hace {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"ahora","past":{"one":"hace {0} segundo","other":"hace {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":"hace {0} días","future":"dentro de {0} días"},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} seg.","future":"dentro de {0} seg."}},"narrow":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":"hace {0} días","future":"dentro de {0} días"},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} seg.","future":"dentro de {0} seg."}}}');

/***/ }),

/***/ 13306:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"es-MX","long":{"year":{"previous":"el año pasado","current":"este año","next":"el año próximo","past":{"one":"hace {0} año","other":"hace {0} años"},"future":{"one":"dentro de {0} año","other":"dentro de {0} años"}},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":{"one":"hace {0} trimestre","other":"hace {0} trimestres"},"future":{"one":"dentro de {0} trimetre","other":"dentro de {0} trimetres"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el mes próximo","past":{"one":"hace {0} mes","other":"hace {0} meses"},"future":{"one":"en {0} mes","other":"en {0} meses"}},"week":{"previous":"la semana pasada","current":"esta semana","next":"la semana próxima","past":{"one":"hace {0} semana","other":"hace {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":{"one":"hace {0} hora","other":"hace {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hace {0} minuto","other":"hace {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"ahora","past":{"one":"hace {0} segundo","other":"hace {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"en {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":{"one":"en {0} trim.","other":"en {0} trim"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"en {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la semana próxima","past":"hace {0} sem.","future":"en {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"en {0} día","other":"en {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":{"one":"en {0} h","other":"en {0} n"}},"minute":{"current":"este minuto","past":"hace {0} min","future":"en {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"en {0} s"}},"narrow":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"-{0} a","future":"en {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"-{0} T","future":"+{0} T"},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"-{0} m","future":"+{0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la semana próxima","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"+{0} día","other":"+{0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 86779:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"es-PY","long":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":{"one":"hace {0} año","other":"hace {0} años"},"future":{"one":"dentro de {0} año","other":"dentro de {0} años"}},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":{"one":"hace {0} trimestre","other":"hace {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":{"one":"hace {0} mes","other":"hace {0} meses"},"future":{"one":"dentro de {0} mes","other":"dentro de {0} meses"}},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":{"one":"hace {0} semana","other":"hace {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":{"one":"hace {0} hora","other":"hace {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hace {0} minuto","other":"hace {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"ahora","past":{"one":"hace {0} segundo","other":"hace {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} seg.","future":"dentro de {0} seg."}},"narrow":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} seg.","future":"dentro de {0} seg."}}}');

/***/ }),

/***/ 95686:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"es-SV","long":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":{"one":"hace {0} año","other":"hace {0} años"},"future":{"one":"dentro de {0} año","other":"dentro de {0} años"}},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":{"one":"hace {0} trimestre","other":"hace {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":{"one":"hace {0} mes","other":"hace {0} meses"},"future":{"one":"dentro de {0} mes","other":"dentro de {0} meses"}},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":{"one":"hace {0} semana","other":"hace {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ayer","previous-2":"antier","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":{"one":"hace {0} hora","other":"hace {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hace {0} minuto","other":"hace {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"ahora","past":{"one":"hace {0} segundo","other":"hace {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"dentro de {0} s"}}}');

/***/ }),

/***/ 72863:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"es-US","long":{"year":{"previous":"el año pasado","current":"este año","next":"el año próximo","past":{"one":"hace {0} año","other":"hace {0} años"},"future":{"one":"dentro de {0} año","other":"dentro de {0} años"}},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":{"one":"hace {0} trimestre","other":"hace {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el mes próximo","past":{"one":"hace {0} mes","other":"hace {0} meses"},"future":{"one":"dentro de {0} mes","other":"dentro de {0} meses"}},"week":{"previous":"la semana pasada","current":"esta semana","next":"la semana próxima","past":{"one":"hace {0} semana","other":"hace {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":{"one":"hace {0} hora","other":"hace {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hace {0} minuto","other":"hace {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"ahora","past":{"one":"hace {0} segundo","other":"hace {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la semana próxima","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la semana próxima","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"dentro de {0} s"}}}');

/***/ }),

/***/ 49039:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"es","long":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":{"one":"hace {0} año","other":"hace {0} años"},"future":{"one":"dentro de {0} año","other":"dentro de {0} años"}},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":{"one":"hace {0} trimestre","other":"hace {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":{"one":"hace {0} mes","other":"hace {0} meses"},"future":{"one":"dentro de {0} mes","other":"dentro de {0} meses"}},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":{"one":"hace {0} semana","other":"hace {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":{"one":"hace {0} hora","other":"hace {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hace {0} minuto","other":"hace {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"ahora","past":{"one":"hace {0} segundo","other":"hace {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"el año pasado","current":"este año","next":"el próximo año","past":"hace {0} a","future":"dentro de {0} a"},"quarter":{"previous":"el trimestre pasado","current":"este trimestre","next":"el próximo trimestre","past":"hace {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"el mes pasado","current":"este mes","next":"el próximo mes","past":"hace {0} m","future":"dentro de {0} m"},"week":{"previous":"la semana pasada","current":"esta semana","next":"la próxima semana","past":"hace {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ayer","previous-2":"anteayer","current":"hoy","next":"mañana","next-2":"pasado mañana","past":{"one":"hace {0} día","other":"hace {0} días"},"future":{"one":"dentro de {0} día","other":"dentro de {0} días"}},"hour":{"current":"esta hora","past":"hace {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"hace {0} min","future":"dentro de {0} min"},"second":{"current":"ahora","past":"hace {0} s","future":"dentro de {0} s"}}}');

/***/ }),

/***/ 13454:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"et","long":{"year":{"previous":"eelmine aasta","current":"käesolev aasta","next":"järgmine aasta","past":"{0} aasta eest","future":"{0} aasta pärast"},"quarter":{"previous":"eelmine kvartal","current":"käesolev kvartal","next":"järgmine kvartal","past":"{0} kvartali eest","future":"{0} kvartali pärast"},"month":{"previous":"eelmine kuu","current":"käesolev kuu","next":"järgmine kuu","past":"{0} kuu eest","future":"{0} kuu pärast"},"week":{"previous":"eelmine nädal","current":"käesolev nädal","next":"järgmine nädal","past":"{0} nädala eest","future":"{0} nädala pärast"},"day":{"previous":"eile","previous-2":"üleeile","current":"täna","next":"homme","next-2":"ülehomme","past":"{0} päeva eest","future":"{0} päeva pärast"},"hour":{"current":"praegusel tunnil","past":"{0} tunni eest","future":"{0} tunni pärast"},"minute":{"current":"praegusel minutil","past":"{0} minuti eest","future":"{0} minuti pärast"},"second":{"current":"nüüd","past":"{0} sekundi eest","future":"{0} sekundi pärast"}},"short":{"year":{"previous":"eelmine aasta","current":"käesolev aasta","next":"järgmine aasta","past":"{0} a eest","future":"{0} a pärast"},"quarter":{"previous":"eelmine kv","current":"käesolev kv","next":"järgmine kv","past":"{0} kv eest","future":"{0} kv pärast"},"month":{"previous":"eelmine kuu","current":"käesolev kuu","next":"järgmine kuu","past":"{0} kuu eest","future":"{0} kuu pärast"},"week":{"previous":"eelmine nädal","current":"käesolev nädal","next":"järgmine nädal","past":"{0} näd eest","future":"{0} näd pärast"},"day":{"previous":"eile","previous-2":"üleeile","current":"täna","next":"homme","next-2":"ülehomme","past":"{0} p eest","future":"{0} p pärast"},"hour":{"current":"praegusel tunnil","past":"{0} t eest","future":"{0} t pärast"},"minute":{"current":"praegusel minutil","past":"{0} min eest","future":"{0} min pärast"},"second":{"current":"nüüd","past":"{0} sek eest","future":"{0} sek pärast"}},"narrow":{"year":{"previous":"eelmine aasta","current":"käesolev aasta","next":"järgmine aasta","past":"{0} a eest","future":"{0} a pärast"},"quarter":{"previous":"eelmine kv","current":"käesolev kv","next":"järgmine kv","past":"{0} kv eest","future":"{0} kv pärast"},"month":{"previous":"eelmine kuu","current":"käesolev kuu","next":"järgmine kuu","past":"{0} k eest","future":"{0} k pärast"},"week":{"previous":"eelmine nädal","current":"käesolev nädal","next":"järgmine nädal","past":"{0} näd eest","future":"{0} näd pärast"},"day":{"previous":"eile","previous-2":"üleeile","current":"täna","next":"homme","next-2":"ülehomme","past":"{0} p eest","future":"{0} p pärast"},"hour":{"current":"praegusel tunnil","past":"{0} t eest","future":"{0} t pärast"},"minute":{"current":"praegusel minutil","past":"{0} min eest","future":"{0} min pärast"},"second":{"current":"nüüd","past":"{0} s eest","future":"{0} s pärast"}}}');

/***/ }),

/***/ 44974:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"eu","long":{"year":{"previous":"iaz","current":"aurten","next":"hurrengo urtean","past":"Duela {0} urte","future":"{0} urte barru"},"quarter":{"previous":"aurreko hiruhilekoa","current":"hiruhileko hau","next":"hurrengo hiruhilekoa","past":"Duela {0} hiruhileko","future":"{0} hiruhileko barru"},"month":{"previous":"aurreko hilabetean","current":"hilabete honetan","next":"hurrengo hilabetean","past":"Duela {0} hilabete","future":"{0} hilabete barru"},"week":{"previous":"aurreko astean","current":"aste honetan","next":"hurrengo astean","past":"Duela {0} aste","future":"{0} aste barru"},"day":{"previous":"atzo","previous-2":"herenegun","current":"gaur","next":"bihar","next-2":"etzi","past":"Duela {0} egun","future":"{0} egun barru"},"hour":{"current":"ordu honetan","past":"Duela {0} ordu","future":"{0} ordu barru"},"minute":{"current":"minutu honetan","past":"Duela {0} minutu","future":"{0} minutu barru"},"second":{"current":"orain","past":"Duela {0} segundo","future":"{0} segundo barru"}},"short":{"year":{"previous":"aurreko urtea","current":"aurten","next":"hurrengo urtea","past":"Duela {0} urte","future":"{0} urte barru"},"quarter":{"previous":"aurreko hiruhilekoa","current":"hiruhileko hau","next":"hurrengo hiruhilekoa","past":"Duela {0} hiruhileko","future":"{0} hiruhileko barru"},"month":{"previous":"aurreko hilabetean","current":"hilabete honetan","next":"hurrengo hilabetean","past":"Duela {0} hilabete","future":"{0} hilabete barru"},"week":{"previous":"aurreko astean","current":"aste honetan","next":"hurrengo astean","past":"Duela {0} aste","future":"{0} aste barru"},"day":{"previous":"atzo","previous-2":"herenegun","current":"gaur","next":"bihar","next-2":"etzi","past":"Duela {0} egun","future":"{0} egun barru"},"hour":{"current":"ordu honetan","past":"Duela {0} ordu","future":"{0} ordu barru"},"minute":{"current":"minutu honetan","past":"Duela {0} minutu","future":"{0} minutu barru"},"second":{"current":"orain","past":"Duela {0} segundo","future":"{0} segundo barru"}},"narrow":{"year":{"previous":"aurreko urtea","current":"aurten","next":"hurrengo urtea","past":"Duela {0} urte","future":"{0} urte barru"},"quarter":{"previous":"aurreko hiruhilekoa","current":"hiruhileko hau","next":"hurrengo hiruhilekoa","past":"Duela {0} hiruhileko","future":"{0} hiruhileko barru"},"month":{"previous":"aurreko hilabetean","current":"hilabete honetan","next":"hurrengo hilabetean","past":"Duela {0} hilabete","future":"{0} hilabete barru"},"week":{"previous":"aurreko astean","current":"aste honetan","next":"hurrengo astean","past":"Duela {0} aste","future":"{0} aste barru"},"day":{"previous":"atzo","previous-2":"herenegun","current":"gaur","next":"bihar","next-2":"etzi","past":"Duela {0} egun","future":"{0} egun barru"},"hour":{"current":"ordu honetan","past":"Duela {0} ordu","future":"{0} ordu barru"},"minute":{"current":"minutu honetan","past":"Duela {0} minutu","future":"{0} minutu barru"},"second":{"current":"orain","past":"Duela {0} segundo","future":"{0} segundo barru"}}}');

/***/ }),

/***/ 7650:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fa","long":{"year":{"previous":"سال گذشته","current":"امسال","next":"سال آینده","past":"{0} سال پیش","future":"{0} سال بعد"},"quarter":{"previous":"سه‌ماههٔ گذشته","current":"سه‌ماههٔ کنونی","next":"سه‌ماههٔ آینده","past":"{0} سه‌ماههٔ پیش","future":"{0} سه‌ماههٔ بعد"},"month":{"previous":"ماه گذشته","current":"این ماه","next":"ماه آینده","past":"{0} ماه پیش","future":"{0} ماه بعد"},"week":{"previous":"هفتهٔ گذشته","current":"این هفته","next":"هفتهٔ آینده","past":"{0} هفته پیش","future":"{0} هفته بعد"},"day":{"previous":"دیروز","previous-2":"پریروز","current":"امروز","next":"فردا","next-2":"پس‌فردا","past":"{0} روز پیش","future":"{0} روز بعد"},"hour":{"current":"همین ساعت","past":"{0} ساعت پیش","future":"{0} ساعت بعد"},"minute":{"current":"همین دقیقه","past":"{0} دقیقه پیش","future":"{0} دقیقه بعد"},"second":{"current":"اکنون","past":"{0} ثانیه پیش","future":"{0} ثانیه بعد"}},"short":{"year":{"previous":"سال گذشته","current":"امسال","next":"سال آینده","past":"{0} سال پیش","future":"{0} سال بعد"},"quarter":{"previous":"سه‌ماههٔ گذشته","current":"سه‌ماههٔ کنونی","next":"سه‌ماههٔ آینده","past":"{0} سه‌ماههٔ پیش","future":"{0} سه‌ماههٔ بعد"},"month":{"previous":"ماه پیش","current":"این ماه","next":"ماه آینده","past":"{0} ماه پیش","future":"{0} ماه بعد"},"week":{"previous":"هفتهٔ گذشته","current":"این هفته","next":"هفتهٔ آینده","past":"{0} هفته پیش","future":"{0} هفته بعد"},"day":{"previous":"دیروز","previous-2":"پریروز","current":"امروز","next":"فردا","next-2":"پس‌فردا","past":"{0} روز پیش","future":"{0} روز بعد"},"hour":{"current":"همین ساعت","past":"{0} ساعت پیش","future":"{0} ساعت بعد"},"minute":{"current":"همین دقیقه","past":"{0} دقیقه پیش","future":"{0} دقیقه بعد"},"second":{"current":"اکنون","past":"{0} ثانیه پیش","future":"{0} ثانیه بعد"}},"narrow":{"year":{"previous":"سال گذشته","current":"امسال","next":"سال آینده","past":"{0} سال پیش","future":"{0} سال بعد"},"quarter":{"previous":"سه‌ماههٔ گذشته","current":"سه‌ماههٔ کنونی","next":"سه‌ماههٔ آینده","past":"{0} سه‌ماههٔ پیش","future":"{0} سه‌ماههٔ بعد"},"month":{"previous":"ماه پیش","current":"این ماه","next":"ماه آینده","past":"{0} ماه پیش","future":"{0} ماه بعد"},"week":{"previous":"هفتهٔ گذشته","current":"این هفته","next":"هفتهٔ آینده","past":"{0} هفته پیش","future":"{0} هفته بعد"},"day":{"previous":"دیروز","previous-2":"پریروز","current":"امروز","next":"فردا","next-2":"پس‌فردا","past":"{0} روز پیش","future":"{0} روز بعد"},"hour":{"current":"همین ساعت","past":"{0} ساعت پیش","future":"{0} ساعت بعد"},"minute":{"current":"همین دقیقه","past":"{0} دقیقه پیش","future":"{0} دقیقه بعد"},"second":{"current":"اکنون","past":"{0} ثانیه پیش","future":"{0} ثانیه بعد"}}}');

/***/ }),

/***/ 55962:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fi","long":{"year":{"previous":"viime vuonna","current":"tänä vuonna","next":"ensi vuonna","past":{"one":"{0} vuosi sitten","other":"{0} vuotta sitten"},"future":"{0} vuoden päästä"},"quarter":{"previous":"viime neljännesvuonna","current":"tänä neljännesvuonna","next":"ensi neljännesvuonna","past":{"one":"{0} neljännesvuosi sitten","other":"{0} neljännesvuotta sitten"},"future":"{0} neljännesvuoden päästä"},"month":{"previous":"viime kuussa","current":"tässä kuussa","next":"ensi kuussa","past":{"one":"{0} kuukausi sitten","other":"{0} kuukautta sitten"},"future":"{0} kuukauden päästä"},"week":{"previous":"viime viikolla","current":"tällä viikolla","next":"ensi viikolla","past":{"one":"{0} viikko sitten","other":"{0} viikkoa sitten"},"future":"{0} viikon päästä"},"day":{"previous":"eilen","previous-2":"toissa päivänä","current":"tänään","next":"huomenna","next-2":"ylihuomenna","past":{"one":"{0} päivä sitten","other":"{0} päivää sitten"},"future":"{0} päivän päästä"},"hour":{"current":"tämän tunnin aikana","past":{"one":"{0} tunti sitten","other":"{0} tuntia sitten"},"future":"{0} tunnin päästä"},"minute":{"current":"tämän minuutin aikana","past":{"one":"{0} minuutti sitten","other":"{0} minuuttia sitten"},"future":"{0} minuutin päästä"},"second":{"current":"nyt","past":{"one":"{0} sekunti sitten","other":"{0} sekuntia sitten"},"future":"{0} sekunnin päästä"}},"short":{"year":{"previous":"viime v","current":"tänä v","next":"ensi v","past":"{0} v sitten","future":"{0} v päästä"},"quarter":{"previous":"viime neljänneksenä","current":"tänä neljänneksenä","next":"ensi neljänneksenä","past":{"one":"{0} neljännes sitten","other":"{0} neljännestä sitten"},"future":"{0} neljänneksen päästä"},"month":{"previous":"viime kk","current":"tässä kk","next":"ensi kk","past":"{0} kk sitten","future":"{0} kk päästä"},"week":{"previous":"viime vk","current":"tällä vk","next":"ensi vk","past":"{0} vk sitten","future":"{0} vk päästä"},"day":{"previous":"eilen","previous-2":"toissap.","current":"tänään","next":"huom.","next-2":"ylihuom.","past":"{0} pv sitten","future":"{0} pv päästä"},"hour":{"current":"tunnin sisällä","past":"{0} t sitten","future":"{0} t päästä"},"minute":{"current":"minuutin sisällä","past":"{0} min sitten","future":"{0} min päästä"},"second":{"current":"nyt","past":"{0} s sitten","future":"{0} s päästä"}},"narrow":{"year":{"previous":"viime v","current":"tänä v","next":"ensi v","past":"{0} v sitten","future":"{0} v päästä"},"quarter":{"previous":"viime nelj.","current":"tänä nelj.","next":"ensi nelj.","past":"{0} nelj. sitten","future":"{0} nelj. päästä"},"month":{"previous":"viime kk","current":"tässä kk","next":"ensi kk","past":"{0} kk sitten","future":"{0} kk päästä"},"week":{"previous":"viime vk","current":"tällä vk","next":"ensi vk","past":"{0} vk sitten","future":"{0} vk päästä"},"day":{"previous":"eilen","previous-2":"toissap.","current":"tänään","next":"huom.","next-2":"ylihuom.","past":"{0} pv sitten","future":"{0} pv päästä"},"hour":{"current":"tunnin sisällä","past":"{0} t sitten","future":"{0} t päästä"},"minute":{"current":"minuutin sisällä","past":"{0} min sitten","future":"{0} min päästä"},"second":{"current":"nyt","past":"{0} s sitten","future":"{0} s päästä"}}}');

/***/ }),

/***/ 13591:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fil","long":{"year":{"previous":"nakaraang taon","current":"ngayong taon","next":"susunod na taon","past":{"one":"{0} taon ang nakalipas","other":"{0} (na) taon ang nakalipas"},"future":{"one":"sa {0} taon","other":"sa {0} (na) taon"}},"quarter":{"previous":"nakaraang quarter","current":"ngayong quarter","next":"susunod na quarter","past":{"one":"{0} quarter ang nakalipas","other":"{0} (na) quarter ang nakalipas"},"future":{"one":"sa {0} quarter","other":"sa {0} (na) quarter"}},"month":{"previous":"nakaraang buwan","current":"ngayong buwan","next":"susunod na buwan","past":{"one":"{0} buwan ang nakalipas","other":"{0} (na) buwan ang nakalipas"},"future":{"one":"sa {0} buwan","other":"sa {0} (na) buwan"}},"week":{"previous":"nakalipas na linggo","current":"sa linggong ito","next":"susunod na linggo","past":{"one":"{0} linggo ang nakalipas","other":"{0} (na) linggo ang nakalipas"},"future":{"one":"sa {0} linggo","other":"sa {0} (na) linggo"}},"day":{"previous":"kahapon","previous-2":"Araw bago ang kahapon","current":"ngayong araw","next":"bukas","next-2":"Samakalawa","past":{"one":"{0} araw ang nakalipas","other":"{0} (na) araw ang nakalipas"},"future":{"one":"sa {0} araw","other":"sa {0} (na) araw"}},"hour":{"current":"ngayong oras","past":{"one":"{0} oras ang nakalipas","other":"{0} (na) oras ang nakalipas"},"future":{"one":"sa {0} oras","other":"sa {0} (na) oras"}},"minute":{"current":"sa minutong ito","past":{"one":"{0} minuto ang nakalipas","other":"{0} (na) minuto ang nakalipas"},"future":{"one":"sa {0} minuto","other":"sa {0} (na) minuto"}},"second":{"current":"ngayon","past":{"one":"{0} segundo ang nakalipas","other":"{0} (na) segundo ang nakalipas"},"future":{"one":"sa {0} segundo","other":"sa {0} (na) segundo"}}},"short":{"year":{"previous":"nakaraang taon","current":"ngayong taon","next":"susunod na taon","past":{"one":"{0} taon ang nakalipas","other":"{0} (na) taon ang nakalipas"},"future":{"one":"sa {0} taon","other":"sa {0} (na) taon"}},"quarter":{"previous":"nakaraang quarter","current":"ngayong quarter","next":"susunod na quarter","past":{"one":"{0} quarter ang nakalipas","other":"{0} (na) quarter ang nakalipas"},"future":"sa {0} (na) quarter"},"month":{"previous":"nakaraang buwan","current":"ngayong buwan","next":"susunod na buwan","past":{"one":"{0} buwan ang nakalipas","other":"{0} (na) buwan ang nakalipas"},"future":{"one":"sa {0} buwan","other":"sa {0} (na) buwan"}},"week":{"previous":"nakaraang linggo","current":"ngayong linggo","next":"susunod na linggo","past":{"one":"{0} linggo ang nakalipas","other":"{0} (na) linggo ang nakalipas"},"future":{"one":"sa {0} linggo","other":"sa {0} (na) linggo"}},"day":{"previous":"kahapon","previous-2":"Araw bago ang kahapon","current":"ngayong araw","next":"bukas","next-2":"Samakalawa","past":"{0} (na) araw ang nakalipas","future":"sa {0} (na) araw"},"hour":{"current":"ngayong oras","past":{"one":"{0} oras ang nakalipas","other":"{0} (na) oras ang nakalipas"},"future":{"one":"sa {0} oras","other":"sa {0} (na) oras"}},"minute":{"current":"sa minutong ito","past":{"one":"{0} min. ang nakalipas","other":"{0} (na) min. ang nakalipas"},"future":{"one":"sa {0} min.","other":"sa {0} (na) min."}},"second":{"current":"ngayon","past":{"one":"{0} seg. ang nakalipas","other":"{0} (na) seg. nakalipas"},"future":{"one":"sa {0} seg.","other":"sa {0} (na) seg."}}},"narrow":{"year":{"previous":"nakaraang taon","current":"ngayong taon","next":"susunod na taon","past":{"one":"{0} taon ang nakalipas","other":"{0} (na) taon ang nakalipas"},"future":{"one":"sa {0} taon","other":"sa {0} (na) taon"}},"quarter":{"previous":"nakaraang quarter","current":"ngayong quarter","next":"susunod na quarter","past":{"one":"{0} quarter ang nakalipas","other":"{0} (na) quarter ang nakalipas"},"future":{"one":"sa {0} quarter","other":"sa {0} (na) quarter"}},"month":{"previous":"nakaraang buwan","current":"ngayong buwan","next":"susunod na buwan","past":{"one":"{0} buwan ang nakalipas","other":"{0} (na) buwan ang nakalipas"},"future":{"one":"sa {0} buwan","other":"sa {0} (na) buwan"}},"week":{"previous":"nakaraang linggo","current":"ngayong linggo","next":"susunod na linggo","past":{"one":"{0} linggo ang nakalipas","other":"{0} (na) linggo ang nakalipas"},"future":{"one":"sa {0} linggo","other":"sa {0} (na) linggo"}},"day":{"previous":"kahapon","previous-2":"Araw bago ang kahapon","current":"ngayong araw","next":"bukas","next-2":"Samakalawa","past":{"one":"{0} araw ang nakalipas","other":"{0} (na) araw ang nakalipas"},"future":{"one":"sa {0} araw","other":"sa {0} (na) araw"}},"hour":{"current":"ngayong oras","past":{"one":"{0} oras nakalipas","other":"{0} (na) oras nakalipas"},"future":{"one":"sa {0} oras","other":"sa {0} (na) oras"}},"minute":{"current":"sa minutong ito","past":{"one":"{0} min. ang nakalipas","other":"{0} (na) min. ang nakalipas"},"future":{"one":"sa {0} min.","other":"sa {0} (na) min."}},"second":{"current":"ngayon","past":{"one":"{0} seg. nakalipas","other":"{0} (na) seg. nakalipas"},"future":{"one":"sa {0} seg.","other":"sa {0} (na) seg."}}}}');

/***/ }),

/***/ 9163:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fo","long":{"year":{"previous":"í fjør","current":"í ár","next":"næsta ár","past":"{0} ár síðan","future":"um {0} ár"},"quarter":{"previous":"seinasta ársfjórðing","current":"hendan ársfjórðingin","next":"næsta ársfjórðing","past":{"one":"{0} ársfjórðing síðan","other":"{0} ársfjórðingar síðan"},"future":{"one":"um {0} ársfjórðing","other":"um {0} ársfjórðingar"}},"month":{"previous":"seinasta mánað","current":"henda mánaðin","next":"næsta mánað","past":{"one":"{0} mánað síðan","other":"{0} mánaðir síðan"},"future":{"one":"um {0} mánað","other":"um {0} mánaðir"}},"week":{"previous":"seinastu viku","current":"hesu viku","next":"næstu viku","past":{"one":"{0} vika síðan","other":"{0} vikur síðan"},"future":{"one":"um {0} viku","other":"um {0} vikur"}},"day":{"previous":"í gjár","previous-2":"fyrradagin","current":"í dag","next":"í morgin","next-2":"í ovurmorgin","past":{"one":"{0} dagur síðan","other":"{0} dagar síðan"},"future":{"one":"um {0} dag","other":"um {0} dagar"}},"hour":{"current":"hendan tíman","past":{"one":"{0} tími síðan","other":"{0} tímar síðan"},"future":{"one":"um {0} tíma","other":"um {0} tímar"}},"minute":{"current":"hendan minuttin","past":{"one":"{0} minutt síðan","other":"{0} minuttir síðan"},"future":{"one":"um {0} minutt","other":"um {0} minuttir"}},"second":{"current":"nú","past":"{0} sekund síðan","future":"um {0} sekund"}},"short":{"year":{"previous":"í fjør","current":"í ár","next":"næsta ár","past":"{0} ár síðan","future":"um {0} ár"},"quarter":{"previous":"seinasta ársfjórðing","current":"hendan ársfjórðingin","next":"næsta ársfjórðing","past":"{0} ársfj. síðan","future":"um {0} ársfj."},"month":{"previous":"seinasta mánað","current":"henda mánaðin","next":"næsta mánað","past":"{0} mnð. síðan","future":"um {0} mnð."},"week":{"previous":"seinastu viku","current":"hesu viku","next":"næstu viku","past":"{0} vi. síðan","future":"um {0} vi."},"day":{"previous":"í gjár","previous-2":"fyrradagin","current":"í dag","next":"í morgin","next-2":"í ovurmorgin","past":"{0} da. síðan","future":"um {0} da."},"hour":{"current":"hendan tíman","past":"{0} t. síðan","future":"um {0} t."},"minute":{"current":"hendan minuttin","past":"{0} min. síðan","future":"um {0} min."},"second":{"current":"nú","past":"{0} sek. síðan","future":"um {0} sek."}},"narrow":{"year":{"previous":"í fjør","current":"í ár","next":"næsta ár","past":"{0} ár síðan","future":"um {0} ár"},"quarter":{"previous":"seinasta ársfjórðing","current":"hendan ársfjórðingin","next":"næsta ársfjórðing","past":"{0} ársfj. síðan","future":"um {0} ársfj."},"month":{"previous":"seinasta mánað","current":"henda mánaðin","next":"næsta mánað","past":"{0} mnð. síðan","future":"um {0} mnð."},"week":{"previous":"seinastu viku","current":"hesu viku","next":"næstu viku","past":"{0} v. síðan","future":"um {0} v."},"day":{"previous":"í gjár","previous-2":"fyrradagin","current":"í dag","next":"í morgin","next-2":"í ovurmorgin","past":"{0} d. síðan","future":"um {0} d."},"hour":{"current":"hendan tíman","past":"{0} t. síðan","future":"um {0} t."},"minute":{"current":"hendan minuttin","past":"{0} m. síðan","future":"um {0} m."},"second":{"current":"nú","past":"{0} s. síðan","future":"um {0} s."}}}');

/***/ }),

/***/ 44943:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fr-CA","long":{"year":{"previous":"l’année dernière","current":"cette année","next":"l’année prochaine","past":{"one":"Il y a {0} an","other":"Il y a {0} ans"},"future":{"one":"Dans {0} an","other":"Dans {0} ans"}},"quarter":{"previous":"le trimestre dernier","current":"ce trimestre-ci","next":"le trimestre prochain","past":{"one":"il y a {0} trimestre","other":"il y a {0} trimestres"},"future":{"one":"dans {0} trimestre","other":"dans {0} trimestres"}},"month":{"previous":"le mois dernier","current":"ce mois-ci","next":"le mois prochain","past":"il y a {0} mois","future":"dans {0} mois"},"week":{"previous":"la semaine dernière","current":"cette semaine","next":"la semaine prochaine","past":{"one":"il y a {0} semaine","other":"il y a {0} semaines"},"future":{"one":"dans {0} semaine","other":"dans {0} semaines"}},"day":{"previous":"hier","previous-2":"avant-hier","current":"aujourd’hui","next":"demain","next-2":"après-demain","past":{"one":"il y a {0} jour","other":"il y a {0} jours"},"future":{"one":"dans {0} jour","other":"dans {0} jours"}},"hour":{"current":"cette heure-ci","past":{"one":"il y a {0} heure","other":"il y a {0} heures"},"future":{"one":"dans {0} heure","other":"dans {0} heures"}},"minute":{"current":"cette minute-ci","past":{"one":"il y a {0} minute","other":"il y a {0} minutes"},"future":{"one":"dans {0} minute","other":"dans {0} minutes"}},"second":{"current":"maintenant","past":{"one":"il y a {0} seconde","other":"il y a {0} secondes"},"future":{"one":"dans {0} seconde","other":"dans {0} secondes"}}},"short":{"year":{"previous":"l’année dernière","current":"cette année","next":"l’année prochaine","past":"il y a {0} a","future":"dans {0} a"},"quarter":{"previous":"trim. dernier","current":"ce trim.","next":"trim. prochain","past":"il y a {0} trim.","future":"dans {0} trim."},"month":{"previous":"le mois dernier","current":"ce mois-ci","next":"le mois prochain","past":"il y a {0} m.","future":"dans {0} m."},"week":{"previous":"la semaine dernière","current":"cette semaine","next":"la semaine prochaine","past":"il y a {0} sem.","future":"dans {0} sem."},"day":{"previous":"hier","previous-2":"avant-hier","current":"aujourd’hui","next":"demain","next-2":"après-demain","past":"il y a {0} j","future":"dans {0} j"},"hour":{"current":"cette heure-ci","past":"il y a {0} h","future":"dans {0} h"},"minute":{"current":"cette minute-ci","past":"il y a {0} min","future":"dans {0} min"},"second":{"current":"maintenant","past":"il y a {0} s","future":"dans {0} s"}},"narrow":{"year":{"previous":"l’année dernière","current":"cette année","next":"l’année prochaine","past":"-{0} a","future":"+{0} a"},"quarter":{"previous":"trim. dernier","current":"ce trim.","next":"trim.prochain","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"le mois dernier","current":"ce mois-ci","next":"le mois prochain","past":"-{0} m.","future":"+{0} m."},"week":{"previous":"la semaine dernière","current":"cette semaine","next":"la semaine prochaine","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"hier","previous-2":"avant-hier","current":"aujourd’hui","next":"demain","next-2":"après-demain","past":"-{0} j","future":"+{0} j"},"hour":{"current":"cette heure-ci","past":"-{0} h","future":"+{0} h"},"minute":{"current":"cette minute-ci","past":"-{0} min","future":"+{0} min"},"second":{"current":"maintenant","past":"-{0} s","future":{"one":"+ {0} s","other":"+{0} s"}}}}');

/***/ }),

/***/ 93601:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fr","long":{"year":{"previous":"l’année dernière","current":"cette année","next":"l’année prochaine","past":{"one":"il y a {0} an","other":"il y a {0} ans"},"future":{"one":"dans {0} an","other":"dans {0} ans"}},"quarter":{"previous":"le trimestre dernier","current":"ce trimestre","next":"le trimestre prochain","past":{"one":"il y a {0} trimestre","other":"il y a {0} trimestres"},"future":{"one":"dans {0} trimestre","other":"dans {0} trimestres"}},"month":{"previous":"le mois dernier","current":"ce mois-ci","next":"le mois prochain","past":"il y a {0} mois","future":"dans {0} mois"},"week":{"previous":"la semaine dernière","current":"cette semaine","next":"la semaine prochaine","past":{"one":"il y a {0} semaine","other":"il y a {0} semaines"},"future":{"one":"dans {0} semaine","other":"dans {0} semaines"}},"day":{"previous":"hier","previous-2":"avant-hier","current":"aujourd’hui","next":"demain","next-2":"après-demain","past":{"one":"il y a {0} jour","other":"il y a {0} jours"},"future":{"one":"dans {0} jour","other":"dans {0} jours"}},"hour":{"current":"cette heure-ci","past":{"one":"il y a {0} heure","other":"il y a {0} heures"},"future":{"one":"dans {0} heure","other":"dans {0} heures"}},"minute":{"current":"cette minute-ci","past":{"one":"il y a {0} minute","other":"il y a {0} minutes"},"future":{"one":"dans {0} minute","other":"dans {0} minutes"}},"second":{"current":"maintenant","past":{"one":"il y a {0} seconde","other":"il y a {0} secondes"},"future":{"one":"dans {0} seconde","other":"dans {0} secondes"}}},"short":{"year":{"previous":"l’année dernière","current":"cette année","next":"l’année prochaine","past":"il y a {0} a","future":"dans {0} a"},"quarter":{"previous":"le trimestre dernier","current":"ce trimestre","next":"le trimestre prochain","past":"il y a {0} trim.","future":"dans {0} trim."},"month":{"previous":"le mois dernier","current":"ce mois-ci","next":"le mois prochain","past":"il y a {0} m.","future":"dans {0} m."},"week":{"previous":"la semaine dernière","current":"cette semaine","next":"la semaine prochaine","past":"il y a {0} sem.","future":"dans {0} sem."},"day":{"previous":"hier","previous-2":"avant-hier","current":"aujourd’hui","next":"demain","next-2":"après-demain","past":"il y a {0} j","future":"dans {0} j"},"hour":{"current":"cette heure-ci","past":"il y a {0} h","future":"dans {0} h"},"minute":{"current":"cette minute-ci","past":"il y a {0} min","future":"dans {0} min"},"second":{"current":"maintenant","past":"il y a {0} s","future":"dans {0} s"}},"narrow":{"year":{"previous":"l’année dernière","current":"cette année","next":"l’année prochaine","past":"-{0} a","future":"+{0} a"},"quarter":{"previous":"le trimestre dernier","current":"ce trimestre","next":"le trimestre prochain","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"le mois dernier","current":"ce mois-ci","next":"le mois prochain","past":"-{0} m.","future":"+{0} m."},"week":{"previous":"la semaine dernière","current":"cette semaine","next":"la semaine prochaine","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"hier","previous-2":"avant-hier","current":"aujourd’hui","next":"demain","next-2":"après-demain","past":"-{0} j","future":"+{0} j"},"hour":{"current":"cette heure-ci","past":"-{0} h","future":"+{0} h"},"minute":{"current":"cette minute-ci","past":"-{0} min","future":"+{0} min"},"second":{"current":"maintenant","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 35165:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fur","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} an indaûr","other":"{0} agns indaûr"},"future":{"one":"ca di {0} an","other":"ca di {0} agns"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"{0} mês indaûr","future":"ca di {0} mês"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} setemane indaûr","other":"{0} setemanis indaûr"},"future":{"one":"ca di {0} setemane","other":"ca di {0} setemanis"}},"day":{"previous":"îr","previous-2":"îr l’altri","current":"vuê","next":"doman","next-2":"passantdoman","past":{"one":"{0} zornade indaûr","other":"{0} zornadis indaûr"},"future":{"one":"ca di {0} zornade","other":"ca di {0} zornadis"}},"hour":{"current":"this hour","past":{"one":"{0} ore indaûr","other":"{0} oris indaûr"},"future":{"one":"ca di {0} ore","other":"ca di {0} oris"}},"minute":{"current":"this minute","past":{"one":"{0} minût indaûr","other":"{0} minûts indaûr"},"future":{"one":"ca di {0} minût","other":"ca di {0} minûts"}},"second":{"current":"now","past":{"one":"{0} secont indaûr","other":"{0} seconts indaûr"},"future":{"one":"ca di {0} secont","other":"ca di {0} seconts"}}},"short":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} an indaûr","other":"{0} agns indaûr"},"future":{"one":"ca di {0} an","other":"ca di {0} agns"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"{0} mês indaûr","future":"ca di {0} mês"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} setemane indaûr","other":"{0} setemanis indaûr"},"future":{"one":"ca di {0} setemane","other":"ca di {0} setemanis"}},"day":{"previous":"îr","previous-2":"îr l’altri","current":"vuê","next":"doman","next-2":"passantdoman","past":{"one":"{0} zornade indaûr","other":"{0} zornadis indaûr"},"future":{"one":"ca di {0} zornade","other":"ca di {0} zornadis"}},"hour":{"current":"this hour","past":{"one":"{0} ore indaûr","other":"{0} oris indaûr"},"future":{"one":"ca di {0} ore","other":"ca di {0} oris"}},"minute":{"current":"this minute","past":{"one":"{0} minût indaûr","other":"{0} minûts indaûr"},"future":{"one":"ca di {0} minût","other":"ca di {0} minûts"}},"second":{"current":"now","past":{"one":"{0} secont indaûr","other":"{0} seconts indaûr"},"future":{"one":"ca di {0} secont","other":"ca di {0} seconts"}}},"narrow":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} an indaûr","other":"{0} agns indaûr"},"future":{"one":"ca di {0} an","other":"ca di {0} agns"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"{0} mês indaûr","future":"ca di {0} mês"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} setemane indaûr","other":"{0} setemanis indaûr"},"future":{"one":"ca di {0} setemane","other":"ca di {0} setemanis"}},"day":{"previous":"îr","previous-2":"îr l’altri","current":"vuê","next":"doman","next-2":"passantdoman","past":{"one":"{0} zornade indaûr","other":"{0} zornadis indaûr"},"future":{"one":"ca di {0} zornade","other":"ca di {0} zornadis"}},"hour":{"current":"this hour","past":{"one":"{0} ore indaûr","other":"{0} oris indaûr"},"future":{"one":"ca di {0} ore","other":"ca di {0} oris"}},"minute":{"current":"this minute","past":{"one":"{0} minût indaûr","other":"{0} minûts indaûr"},"future":{"one":"ca di {0} minût","other":"ca di {0} minûts"}},"second":{"current":"now","past":{"one":"{0} secont indaûr","other":"{0} seconts indaûr"},"future":{"one":"ca di {0} secont","other":"ca di {0} seconts"}}}}');

/***/ }),

/***/ 89775:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"fy","long":{"year":{"previous":"foarich jier","current":"dit jier","next":"folgjend jier","past":"{0} jier lyn","future":"Oer {0} jier"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"foarige moanne","current":"dizze moanne","next":"folgjende moanne","past":{"one":"{0} moanne lyn","other":"{0} moannen lyn"},"future":{"one":"Oer {0} moanne","other":"Oer {0} moannen"}},"week":{"previous":"foarige wike","current":"dizze wike","next":"folgjende wike","past":{"one":"{0} wike lyn","other":"{0} wiken lyn"},"future":{"one":"Oer {0} wike","other":"Oer {0} wiken"}},"day":{"previous":"gisteren","previous-2":"eergisteren","current":"vandaag","next":"morgen","next-2":"Oermorgen","past":{"one":"{0} dei lyn","other":"{0} deien lyn"},"future":{"one":"Oer {0} dei","other":"Oer {0} deien"}},"hour":{"current":"this hour","past":"{0} oere lyn","future":"Oer {0} oere"},"minute":{"current":"this minute","past":{"one":"{0} minút lyn","other":"{0} minuten lyn"},"future":{"one":"Oer {0} minút","other":"Oer {0} minuten"}},"second":{"current":"nu","past":{"one":"{0} sekonde lyn","other":"{0} sekonden lyn"},"future":{"one":"Oer {0} sekonde","other":"Oer {0} sekonden"}}},"short":{"year":{"previous":"foarich jier","current":"dit jier","next":"folgjend jier","past":"{0} jier lyn","future":"Oer {0} jier"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"foarige moanne","current":"dizze moanne","next":"folgjende moanne","past":{"one":"{0} moanne lyn","other":"{0} moannen lyn"},"future":{"one":"Oer {0} moanne","other":"Oer {0} moannen"}},"week":{"previous":"foarige wike","current":"dizze wike","next":"folgjende wike","past":{"one":"{0} wike lyn","other":"{0} wiken lyn"},"future":{"one":"Oer {0} wike","other":"Oer {0} wiken"}},"day":{"previous":"gisteren","previous-2":"eergisteren","current":"vandaag","next":"morgen","next-2":"Oermorgen","past":{"one":"{0} dei lyn","other":"{0} deien lyn"},"future":{"one":"Oer {0} dei","other":"Oer {0} deien"}},"hour":{"current":"this hour","past":"{0} oere lyn","future":"Oer {0} oere"},"minute":{"current":"this minute","past":{"one":"{0} minút lyn","other":"{0} minuten lyn"},"future":{"one":"Oer {0} minút","other":"Oer {0} minuten"}},"second":{"current":"nu","past":{"one":"{0} sekonde lyn","other":"{0} sekonden lyn"},"future":{"one":"Oer {0} sekonde","other":"Oer {0} sekonden"}}},"narrow":{"year":{"previous":"foarich jier","current":"dit jier","next":"folgjend jier","past":"{0} jier lyn","future":"Oer {0} jier"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"foarige moanne","current":"dizze moanne","next":"folgjende moanne","past":{"one":"{0} moanne lyn","other":"{0} moannen lyn"},"future":{"one":"Oer {0} moanne","other":"Oer {0} moannen"}},"week":{"previous":"foarige wike","current":"dizze wike","next":"folgjende wike","past":{"one":"{0} wike lyn","other":"{0} wiken lyn"},"future":{"one":"Oer {0} wike","other":"Oer {0} wiken"}},"day":{"previous":"gisteren","previous-2":"eergisteren","current":"vandaag","next":"morgen","next-2":"Oermorgen","past":{"one":"{0} dei lyn","other":"{0} deien lyn"},"future":{"one":"Oer {0} dei","other":"Oer {0} deien"}},"hour":{"current":"this hour","past":"{0} oere lyn","future":"Oer {0} oere"},"minute":{"current":"this minute","past":{"one":"{0} minút lyn","other":"{0} minuten lyn"},"future":{"one":"Oer {0} minút","other":"Oer {0} minuten"}},"second":{"current":"nu","past":{"one":"{0} sekonde lyn","other":"{0} sekonden lyn"},"future":{"one":"Oer {0} sekonde","other":"Oer {0} sekonden"}}}}');

/***/ }),

/***/ 13734:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ga","long":{"year":{"previous":"anuraidh","current":"an bhliain seo","next":"an bhliain seo chugainn","past":{"one":"{0} bhliain ó shin","two":"{0} bhliain ó shin","few":"{0} bliana ó shin","many":"{0} mbliana ó shin","other":"{0} bliain ó shin"},"future":{"one":"i gceann {0} bhliain","two":"i gceann {0} bhliain","few":"i gceann {0} bliana","many":"i gceann {0} mbliana","other":"i gceann {0} bliain"}},"quarter":{"previous":"an ráithe seo caite","current":"an ráithe seo","next":"an ráithe seo chugainn","past":"{0} ráithe ó shin","future":"i gceann {0} ráithe"},"month":{"previous":"an mhí seo caite","current":"an mhí seo","next":"an mhí seo chugainn","past":{"one":"{0} mhí ó shin","two":"{0} mhí ó shin","few":"{0} mhí ó shin","other":"{0} mí ó shin"},"future":{"one":"i gceann {0} mhí","two":"i gceann {0} mhí","few":"i gceann {0} mhí","other":"i gceann {0} mí"}},"week":{"previous":"an tseachtain seo caite","current":"an tseachtain seo","next":"an tseachtain seo chugainn","past":{"two":"{0} sheachtain ó shin","few":"{0} seachtaine ó shin","many":"{0} seachtaine ó shin","other":"{0} seachtain ó shin"},"future":{"two":"i gceann {0} sheachtain","few":"i gceann {0} seachtaine","many":"i gceann {0} seachtaine","other":"i gceann {0} seachtain"}},"day":{"previous":"inné","previous-2":"arú inné","current":"inniu","next":"amárach","next-2":"arú amárach","past":"{0} lá ó shin","future":"i gceann {0} lá"},"hour":{"current":"an uair seo","past":{"few":"{0} huaire an chloig ó shin","many":"{0} n-uaire an chloig ó shin","other":"{0} uair an chloig ó shin"},"future":{"few":"i gceann {0} huaire an chloig","many":"i gceann {0} n-uaire an chloig","other":"i gceann {0} uair an chloig"}},"minute":{"current":"an nóiméad seo","past":"{0} nóiméad ó shin","future":"i gceann {0} nóiméad"},"second":{"current":"anois","past":{"two":"{0} shoicind ó shin","few":"{0} shoicind ó shin","other":"{0} soicind ó shin"},"future":{"two":"i gceann {0} shoicind","few":"i gceann {0} shoicind","other":"i gceann {0} soicind"}}},"short":{"year":{"previous":"anuraidh","current":"an bhl. seo","next":"an bhl. seo chugainn","past":{"one":"{0} bhl. ó shin","two":"{0} bhl. ó shin","many":"{0} mbl. ó shin","other":"{0} bl. ó shin"},"future":{"two":"i gceann {0} bhl.","many":"i gceann {0} mbl.","other":"i gceann {0} bl."}},"quarter":{"previous":"an ráithe seo caite","current":"an ráithe seo","next":"an ráithe seo chugainn","past":"{0} ráithe ó shin","future":"i gceann {0} ráithe"},"month":{"previous":"an mhí seo caite","current":"an mhí seo","next":"an mhí seo chugainn","past":{"one":"{0} mhí ó shin","two":"{0} mhí ó shin","few":"{0} mhí ó shin","other":"{0} mí ó shin"},"future":{"one":"i gceann {0} mhí","two":"i gceann {0} mhí","few":"i gceann {0} mhí","other":"i gceann {0} mí"}},"week":{"previous":"an tscht. seo caite","current":"an tscht. seo","next":"an tscht. seo chugainn","past":"{0} scht. ó shin","future":{"two":"i gceann {0} shcht.","other":"i gceann {0} scht."}},"day":{"previous":"inné","previous-2":"arú inné","current":"inniu","next":"amárach","next-2":"arú amárach","past":"{0} lá ó shin","future":"i gceann {0} lá"},"hour":{"current":"an uair seo","past":{"few":"{0} huaire ó shin","many":"{0} n-uaire ó shin","other":"{0} uair ó shin"},"future":{"few":"i gceann {0} huaire","many":"i gceann {0} n-uaire","other":"i gceann {0} uair"}},"minute":{"current":"an nóiméad seo","past":"{0} nóim. ó shin","future":"i gceann {0} nóim."},"second":{"current":"anois","past":{"two":"{0} shoic. ó shin","few":"{0} shoic. ó shin","other":"{0} soic. ó shin"},"future":{"two":"i gceann {0} shoic.","few":"i gceann {0} shoic.","other":"i gceann {0} soic."}}},"narrow":{"year":{"previous":"anuraidh","current":"an bhl. seo","next":"an bhl. seo chugainn","past":{"one":"-{0} bhl.","two":"-{0} bhl.","many":"-{0} mbl.","other":"-{0} bl."},"future":{"one":"+{0} bhl.","two":"+{0} bhl.","many":"+{0} mbl.","other":"+{0} bl."}},"quarter":{"previous":"an ráithe seo caite","current":"an ráithe seo","next":"an ráithe seo chugainn","past":"-{0} R","future":"+{0} R"},"month":{"previous":"an mhí seo caite","current":"an mhí seo","next":"an mhí seo chugainn","past":{"one":"-{0} mhí","two":"-{0} mhí","few":"-{0} mhí","other":"-{0} mí"},"future":{"one":"+{0} mhí","two":"+{0} mhí","few":"+{0} mhí","other":"+{0} mí"}},"week":{"previous":"an tscht. seo caite","current":"an tscht. seo","next":"an tscht. seo chugainn","past":"-{0} scht.","future":"+{0} scht."},"day":{"previous":"inné","previous-2":"arú inné","current":"inniu","next":"amárach","next-2":"arú amárach","past":"-{0} lá","future":"+{0} lá"},"hour":{"current":"an uair seo","past":"-{0} u","future":"+{0} u"},"minute":{"current":"an nóiméad seo","past":"-{0} n","future":"+{0} n"},"second":{"current":"anois","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 84671:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"gd","long":{"year":{"previous":"an-uiridh","previous-2":"a-bhòn-uiridh","current":"am bliadhna","next":"an ath-bhliadhna","past":{"one":"{0} bhliadhna air ais","two":"{0} bhliadhna air ais","few":"{0} bhliadhnaichean air ais","other":"{0} bliadhna air ais"},"future":{"one":"an ceann {0} bhliadhna","two":"an ceann {0} bhliadhna","few":"an ceann {0} bliadhnaichean","other":"an ceann {0} bliadhna"}},"quarter":{"previous":"an cairteal seo chaidh","current":"an cairteal seo","next":"an ath-chairteal","past":{"one":"o chionn {0} chairteil","two":"o chionn {0} chairteil","few":"o chionn {0} cairtealan","other":"o chionn {0} cairteil"},"future":{"one":"an ceann {0} chairteil","two":"an ceann {0} chairteil","few":"an ceann {0} cairtealan","other":"an ceann {0} cairteil"}},"month":{"previous":"am mìos seo chaidh","current":"am mìos seo","next":"an ath-mhìos","past":{"one":"{0} mhìos air ais","two":"{0} mhìos air ais","few":"{0} mìosan air ais","other":"{0} mìos air ais"},"future":{"one":"an ceann {0} mhìosa","two":"an ceann {0} mhìosa","few":"an ceann {0} mìosan","other":"an ceann {0} mìosa"}},"week":{"previous":"an t-seachdain seo chaidh","current":"an t-seachdain seo","next":"an ath-sheachdain","past":{"two":"{0} sheachdain air ais","few":"{0} seachdainean air ais","other":"{0} seachdain air ais"},"future":{"two":"an ceann {0} sheachdain","few":"an ceann {0} seachdainean","other":"an ceann {0} seachdain"}},"day":{"previous":"an-dè","previous-2":"a-bhòin-dè","current":"an-diugh","next":"a-màireach","next-2":"an-earar","next-3":"an-eararais","past":{"few":"{0} làithean air ais","other":"{0} latha air ais"},"future":{"few":"an ceann {0} làithean","other":"an ceann {0} latha"}},"hour":{"current":"am broinn uair a thìde","past":{"few":"{0} uairean a thìde air ais","other":"{0} uair a thìde air ais"},"future":{"few":"an ceann {0} uairean a thìde","other":"an ceann {0} uair a thìde"}},"minute":{"current":"am broinn mionaid","past":{"one":"{0} mhionaid air ais","two":"{0} mhionaid air ais","few":"{0} mionaidean air ais","other":"{0} mionaid air ais"},"future":{"one":"an ceann {0} mhionaid","two":"an ceann {0} mhionaid","few":"an ceann {0} mionaidean","other":"an ceann {0} mionaid"}},"second":{"current":"an-dràsta","past":{"two":"{0} dhiog air ais","few":"{0} diogan air ais","other":"{0} diog air ais"},"future":{"two":"an ceann {0} dhiog","few":"an ceann {0} diogan","other":"an ceann {0} diog"}}},"short":{"year":{"previous":"an-uiridh","previous-2":"a-bhòn-uiridh","current":"am bliadhna","next":"an ath-bhliadhna","past":{"one":"o {0} bhlia.","two":"o {0} bhlia.","other":"o {0} blia."},"future":{"one":"an {0} bhlia.","two":"an {0} bhlia.","other":"an {0} blia."}},"quarter":{"previous":"an cairt. sa chaidh","current":"an cairt. seo","next":"an ath-chairt.","past":{"one":"o {0} chairt.","two":"o {0} chairt.","other":"o {0} cairt."},"future":{"one":"an {0} chairt.","two":"an {0} chairt.","other":"an {0} cairt."}},"month":{"previous":"am mìos sa chaidh","current":"am mìos seo","next":"an ath-mhìos","past":{"one":"o {0} mhìos.","two":"o {0} mhìos.","other":"o {0} mìos."},"future":{"one":"an {0} mhìos.","two":"an {0} mhìos.","other":"an {0} mìos."}},"week":{"previous":"seachd. sa chaidh","current":"an t-seachd. seo","next":"an ath-sheachd.","past":{"one":"o {0} sheachd.","two":"o {0} sheachd.","other":"o {0} seachd."},"future":{"one":"an {0} sheachd.","two":"an {0} sheachd.","other":"an {0} seachd."}},"day":{"previous":"an-dè","previous-2":"a-bhòin-dè","current":"an-diugh","next":"a-màireach","next-2":"an-earar","next-3":"an-eararais","past":{"few":"o {0} là.","other":"o {0} là"},"future":{"few":"an {0} là.","other":"an {0} là"}},"hour":{"current":"am broinn uair","past":{"few":"o {0} uair.","other":"o {0} uair"},"future":{"few":"an {0} uair.","other":"an {0} uair"}},"minute":{"current":"am broinn mion.","past":{"one":"o {0} mhion.","two":"o {0} mhion.","other":"o {0} mion."},"future":{"one":"an {0} mhion.","two":"an {0} mhion.","other":"an {0} mion."}},"second":{"current":"an-dràsta","past":{"two":"o {0} dhiog","few":"o {0} diog.","other":"o {0} diog"},"future":{"two":"an {0} dhiog","few":"an {0} diog.","other":"an {0} diog"}}},"narrow":{"year":{"previous":"an-uir.","previous-2":"a-bh-uir.","current":"am bl.","next":"an ath-bhl.","past":{"one":"-{0} bhl.","two":"-{0} bhl.","other":"-{0} bl."},"future":{"one":"+{0} bhl.","two":"+{0} bhl.","other":"+{0} bl."}},"quarter":{"previous":"c. ch.","current":"an c. seo","next":"ath-ch.","past":"-{0} c.","future":"+{0} c."},"month":{"previous":"mì. ch.","current":"am mì. seo","next":"ath-mhì.","past":{"one":"-{0} mhì.","two":"-{0} mhì.","other":"-{0} mì."},"future":{"one":"+{0} mhì.","two":"+{0} mhì.","other":"+{0} mì."}},"week":{"previous":"sn. ch.","current":"an t-sn. seo","next":"ath-shn.","past":"-{0} sn.","future":"+{0} sn."},"day":{"previous":"an-dè","previous-2":"a-bhòin-dè","current":"an-diugh","next":"a-màireach","next-2":"an-earar","next-3":"an-eararais","past":"-{0} là","future":"+{0} là"},"hour":{"current":"san uair","past":"-{0} u.","future":"+{0} u."},"minute":{"current":"sa mhion.","past":"-{0} m","future":"+{0} m"},"second":{"current":"an-dràsta","past":"-{0} d","future":"+{0} d"}}}');

/***/ }),

/***/ 61867:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"gl","long":{"year":{"previous":"o ano pasado","current":"este ano","next":"o próximo ano","past":{"one":"hai {0} ano","other":"hai {0} anos"},"future":{"one":"en {0} ano","other":"en {0} anos"}},"quarter":{"previous":"o trimestre pasado","current":"este trimestre","next":"o próximo trimestre","past":{"one":"hai {0} trimestre","other":"hai {0} trimestres"},"future":{"one":"en {0} trimestre","other":"en {0} trimestres"}},"month":{"previous":"o mes pasado","current":"este mes","next":"o próximo mes","past":{"one":"hai {0} mes","other":"hai {0} meses"},"future":{"one":"en {0} mes","other":"en {0} meses"}},"week":{"previous":"a semana pasada","current":"esta semana","next":"a próxima semana","past":{"one":"hai {0} semana","other":"hai {0} semanas"},"future":{"one":"en {0} semana","other":"en {0} semanas"}},"day":{"previous":"onte","previous-2":"antonte","current":"hoxe","next":"mañá","next-2":"pasadomañá","past":{"one":"hai {0} día","other":"hai {0} días"},"future":{"one":"en {0} día","other":"en {0} días"}},"hour":{"current":"esta hora","past":{"one":"hai {0} hora","other":"hai {0} horas"},"future":{"one":"en {0} hora","other":"en {0} horas"}},"minute":{"current":"este minuto","past":{"one":"hai {0} minuto","other":"hai {0} minutos"},"future":{"one":"en {0} minuto","other":"en {0} minutos"}},"second":{"current":"agora","past":{"one":"hai {0} segundo","other":"hai {0} segundos"},"future":{"one":"en {0} segundo","other":"en {0} segundos"}}},"short":{"year":{"previous":"ano pasado","current":"este ano","next":"seguinte ano","past":{"one":"hai {0} ano","other":"hai {0} anos"},"future":{"one":"en {0} ano","other":"en {0} anos"}},"quarter":{"previous":"trim. pasado","current":"este trim.","next":"trim. seguinte","past":"hai {0} trim.","future":"en {0} trim."},"month":{"previous":"m. pasado","current":"este m.","next":"m. seguinte","past":{"one":"hai {0} mes","other":"hai {0} meses"},"future":{"one":"en {0} mes","other":"en {0} meses"}},"week":{"previous":"sem. pasada","current":"esta sem.","next":"sem. seguinte","past":"hai {0} sem.","future":"en {0} sem."},"day":{"previous":"onte","previous-2":"antonte","current":"hoxe","next":"mañá","next-2":"pasadomañá","past":{"one":"hai {0} día","other":"hai {0} días"},"future":{"one":"en {0} día","other":"en {0} días"}},"hour":{"current":"esta hora","past":"hai {0} h","future":"en {0} h"},"minute":{"current":"este minuto","past":"hai {0} min","future":"en {0} min"},"second":{"current":"agora","past":"hai {0} s","future":"en {0} s"}},"narrow":{"year":{"previous":"ano pasado","current":"este ano","next":"seguinte ano","past":{"one":"hai {0} ano","other":"hai {0} anos"},"future":{"one":"en {0} ano","other":"en {0} anos"}},"quarter":{"previous":"trim. pasado","current":"este trim.","next":"trim. seguinte","past":"hai {0} trim.","future":"en {0} trim."},"month":{"previous":"m. pasado","current":"este m.","next":"m. seguinte","past":{"one":"hai {0} mes","other":"hai {0} meses"},"future":{"one":"en {0} mes","other":"en {0} meses"}},"week":{"previous":"sem. pasada","current":"esta sem.","next":"sem. seguinte","past":"hai {0} sem.","future":"en {0} sem."},"day":{"previous":"onte","previous-2":"antonte","current":"hoxe","next":"mañá","next-2":"pasadomañá","past":{"one":"hai {0} día","other":"hai {0} días"},"future":{"one":"en {0} día","other":"en {0} días"}},"hour":{"current":"esta hora","past":"hai {0} h","future":"en {0} h"},"minute":{"current":"este minuto","past":"hai {0} min","future":"en {0} min"},"second":{"current":"agora","past":"hai {0} s","future":"en {0} s"}}}');

/***/ }),

/***/ 36036:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"gu","long":{"year":{"previous":"ગયા વર્ષે","current":"આ વર્ષે","next":"આવતા વર્ષે","past":"{0} વર્ષ પહેલાં","future":"{0} વર્ષમાં"},"quarter":{"previous":"છેલ્લું ત્રિમાસિક","current":"આ ત્રિમાસિક","next":"પછીનું ત્રિમાસિક","past":"{0} ત્રિમાસિક પહેલાં","future":"{0} ત્રિમાસિકમાં"},"month":{"previous":"ગયા મહિને","current":"આ મહિને","next":"આવતા મહિને","past":"{0} મહિના પહેલાં","future":"{0} મહિનામાં"},"week":{"previous":"ગયા અઠવાડિયે","current":"આ અઠવાડિયે","next":"આવતા અઠવાડિયે","past":"{0} અઠવાડિયા પહેલાં","future":"{0} અઠવાડિયામાં"},"day":{"previous":"ગઈકાલે","previous-2":"ગયા પરમદિવસે","current":"આજે","next":"આવતીકાલે","next-2":"પરમદિવસે","past":"{0} દિવસ પહેલાં","future":"{0} દિવસમાં"},"hour":{"current":"આ કલાક","past":"{0} કલાક પહેલાં","future":"{0} કલાકમાં"},"minute":{"current":"આ મિનિટ","past":"{0} મિનિટ પહેલાં","future":"{0} મિનિટમાં"},"second":{"current":"હમણાં","past":"{0} સેકંડ પહેલાં","future":"{0} સેકંડમાં"}},"short":{"year":{"previous":"ગયા વર્ષે","current":"આ વર્ષે","next":"આવતા વર્ષે","past":"{0} વર્ષ પહેલાં","future":"{0} વર્ષમાં"},"quarter":{"previous":"છેલ્લું ત્રિમાસિક","current":"આ ત્રિમાસિક","next":"પછીનું ત્રિમાસિક","past":"{0} ત્રિમાસિક પહેલાં","future":"{0} ત્રિમાસિકમાં"},"month":{"previous":"ગયા મહિને","current":"આ મહિને","next":"આવતા મહિને","past":"{0} મહિના પહેલાં","future":"{0} મહિનામાં"},"week":{"previous":"ગયા અઠવાડિયે","current":"આ અઠવાડિયે","next":"આવતા અઠવાડિયે","past":"{0} અઠ. પહેલાં","future":"{0} અઠ. માં"},"day":{"previous":"ગઈકાલે","previous-2":"ગયા પરમદિવસે","current":"આજે","next":"આવતીકાલે","next-2":"પરમદિવસે","past":"{0} દિવસ પહેલાં","future":"{0} દિવસમાં"},"hour":{"current":"આ કલાક","past":"{0} કલાક પહેલાં","future":"{0} કલાકમાં"},"minute":{"current":"આ મિનિટ","past":"{0} મિનિટ પહેલાં","future":"{0} મિનિટમાં"},"second":{"current":"હમણાં","past":"{0} સેકંડ પહેલાં","future":"{0} સેકંડમાં"}},"narrow":{"year":{"previous":"ગયા વર્ષે","current":"આ વર્ષે","next":"આવતા વર્ષે","past":"{0} વર્ષ પહેલાં","future":"{0} વર્ષમાં"},"quarter":{"previous":"છેલ્લું ત્રિમાસિક","current":"આ ત્રિમાસિક","next":"પછીનું ત્રિમાસિક","past":"{0} ત્રિમાસિક પહેલાં","future":"{0} ત્રિમાસિકમાં"},"month":{"previous":"ગયા મહિને","current":"આ મહિને","next":"આવતા મહિને","past":"{0} મહિના પહેલાં","future":"{0} મહિનામાં"},"week":{"previous":"ગયા અઠવાડિયે","current":"આ અઠવાડિયે","next":"આવતા અઠવાડિયે","past":"{0} અઠ. પહેલાં","future":"{0} અઠ. માં"},"day":{"previous":"ગઈકાલે","previous-2":"ગયા પરમદિવસે","current":"આજે","next":"આવતીકાલે","next-2":"પરમદિવસે","past":"{0} દિવસ પહેલાં","future":"{0} દિવસમાં"},"hour":{"current":"આ કલાક","past":"{0} કલાક પહેલાં","future":"{0} કલાકમાં"},"minute":{"current":"આ મિનિટ","past":"{0} મિનિટ પહેલાં","future":"{0} મિનિટમાં"},"second":{"current":"હમણાં","past":"{0} સેકંડ પહેલાં","future":"{0} સેકંડમાં"}}}');

/***/ }),

/***/ 13450:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"he","long":{"year":{"previous":"השנה שעברה","current":"השנה","next":"השנה הבאה","past":{"one":"לפני שנה","two":"לפני שנתיים","many":"לפני {0} שנה","other":"לפני {0} שנים"},"future":{"one":"בעוד שנה","two":"בעוד שנתיים","many":"בעוד {0} שנה","other":"בעוד {0} שנים"}},"quarter":{"previous":"הרבעון הקודם","current":"רבעון זה","next":"הרבעון הבא","past":{"one":"ברבעון הקודם","two":"לפני שני רבעונים","other":"לפני {0} רבעונים"},"future":{"one":"ברבעון הבא","two":"בעוד שני רבעונים","other":"בעוד {0} רבעונים"}},"month":{"previous":"החודש שעבר","current":"החודש","next":"החודש הבא","past":{"one":"לפני חודש","two":"לפני חודשיים","other":"לפני {0} חודשים"},"future":{"one":"בעוד חודש","two":"בעוד חודשיים","other":"בעוד {0} חודשים"}},"week":{"previous":"השבוע שעבר","current":"השבוע","next":"השבוע הבא","past":{"one":"לפני שבוע","two":"לפני שבועיים","other":"לפני {0} שבועות"},"future":{"one":"בעוד שבוע","two":"בעוד שבועיים","other":"בעוד {0} שבועות"}},"day":{"previous":"אתמול","previous-2":"שלשום","current":"היום","next":"מחר","next-2":"מחרתיים","past":{"one":"לפני יום {0}","two":"לפני יומיים","other":"לפני {0} ימים"},"future":{"one":"בעוד יום {0}","two":"בעוד יומיים","other":"בעוד {0} ימים"}},"hour":{"current":"בשעה זו","past":{"one":"לפני שעה","two":"לפני שעתיים","other":"לפני {0} שעות"},"future":{"one":"בעוד שעה","two":"בעוד שעתיים","other":"בעוד {0} שעות"}},"minute":{"current":"בדקה זו","past":{"one":"לפני דקה","two":"לפני שתי דקות","other":"לפני {0} דקות"},"future":{"one":"בעוד דקה","two":"בעוד שתי דקות","other":"בעוד {0} דקות"}},"second":{"current":"עכשיו","past":{"one":"לפני שנייה","two":"לפני שתי שניות","other":"לפני {0} שניות"},"future":{"one":"בעוד שנייה","two":"בעוד שתי שניות","other":"בעוד {0} שניות"}}},"short":{"year":{"previous":"השנה שעברה","current":"השנה","next":"השנה הבאה","past":{"one":"לפני שנה","two":"לפני שנתיים","many":"לפני {0} שנה","other":"לפני {0} שנים"},"future":{"one":"בעוד שנה","two":"בעוד שנתיים","many":"בעוד {0} שנה","other":"בעוד {0} שנים"}},"quarter":{"previous":"הרבעון הקודם","current":"רבעון זה","next":"הרבעון הבא","past":{"one":"ברבע׳ הקודם","two":"לפני שני רבע׳","other":"לפני {0} רבע׳"},"future":{"one":"ברבע׳ הבא","two":"בעוד שני רבע׳","other":"בעוד {0} רבע׳"}},"month":{"previous":"החודש שעבר","current":"החודש","next":"החודש הבא","past":{"one":"לפני חודש","two":"לפני חודשיים","other":"לפני {0} חודשים"},"future":{"one":"בעוד חודש","two":"בעוד חודשיים","other":"בעוד {0} חודשים"}},"week":{"previous":"השבוע שעבר","current":"השבוע","next":"השבוע הבא","past":{"one":"לפני שב׳","two":"לפני שבועיים","other":"לפני {0} שב׳"},"future":{"one":"בעוד שב׳","two":"בעוד שבועיים","other":"בעוד {0} שב׳"}},"day":{"previous":"אתמול","previous-2":"שלשום","current":"היום","next":"מחר","next-2":"מחרתיים","past":{"one":"אתמול","two":"לפני יומיים","other":"לפני {0} ימים"},"future":{"one":"מחר","two":"בעוד יומיים","other":"בעוד {0} ימים"}},"hour":{"current":"בשעה זו","past":{"one":"לפני שעה","two":"לפני שעתיים","other":"לפני {0} שע׳"},"future":{"one":"בעוד שעה","two":"בעוד שעתיים","other":"בעוד {0} שע׳"}},"minute":{"current":"בדקה זו","past":{"one":"לפני דקה","other":"לפני {0} דק׳"},"future":{"one":"בעוד דקה","two":"בעוד שתי דק׳","other":"בעוד {0} דק׳"}},"second":{"current":"עכשיו","past":{"one":"לפני שנ׳","two":"לפני שתי שנ׳","other":"לפני {0} שנ׳"},"future":{"one":"בעוד שנ׳","two":"בעוד שתי שנ׳","other":"בעוד {0} שנ׳"}}},"narrow":{"year":{"previous":"השנה שעברה","current":"השנה","next":"השנה הבאה","past":{"one":"לפני שנה","two":"לפני שנתיים","many":"לפני {0} שנה","other":"לפני {0} שנים"},"future":{"one":"בעוד שנה","two":"בעוד שנתיים","many":"בעוד {0} שנה","other":"בעוד {0} שנים"}},"quarter":{"previous":"הרבעון הקודם","current":"רבעון זה","next":"הרבעון הבא","past":{"one":"ברבע׳ הקודם","two":"לפני שני רבע׳","other":"לפני {0} רבע׳"},"future":{"one":"ברבע׳ הבא","two":"בעוד שני רבע׳","other":"בעוד {0} רבע׳"}},"month":{"previous":"החודש שעבר","current":"החודש","next":"החודש הבא","past":{"one":"לפני חו׳","two":"לפני חודשיים","other":"לפני {0} חו׳"},"future":{"one":"בעוד חו׳","two":"בעוד חודשיים","other":"בעוד {0} חו׳"}},"week":{"previous":"השבוע שעבר","current":"השבוע","next":"השבוע הבא","past":{"one":"לפני שבוע","two":"לפני שבועיים","other":"לפני {0} שב׳"},"future":{"one":"בעוד שב׳","two":"בעוד שבועיים","other":"בעוד {0} שב׳"}},"day":{"previous":"אתמול","previous-2":"שלשום","current":"היום","next":"מחר","next-2":"מחרתיים","past":{"one":"אתמול","two":"לפני יומיים","other":"לפני {0} ימים"},"future":{"one":"מחר","two":"בעוד יומיים","other":"בעוד {0} ימים"}},"hour":{"current":"בשעה זו","past":{"one":"לפני שעה","two":"לפני שעתיים","other":"לפני {0} שע׳"},"future":{"one":"בעוד שעה","two":"בעוד שעתיים","other":"בעוד {0} שע׳"}},"minute":{"current":"בדקה זו","past":{"one":"לפני דקה","two":"לפני שתי דק׳","other":"לפני {0} דק׳"},"future":{"one":"בעוד דקה","two":"בעוד שתי דק׳","other":"בעוד {0} דק׳"}},"second":{"current":"עכשיו","past":{"one":"לפני שנ׳","two":"לפני שתי שנ׳","other":"לפני {0} שנ׳"},"future":{"one":"בעוד שנ׳","two":"בעוד שתי שנ׳","other":"בעוד {0} שנ׳"}}}}');

/***/ }),

/***/ 80178:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"hi","long":{"year":{"previous":"पिछला वर्ष","current":"इस वर्ष","next":"अगला वर्ष","past":"{0} वर्ष पहले","future":"{0} वर्ष में"},"quarter":{"previous":"अंतिम तिमाही","current":"इस तिमाही","next":"अगली तिमाही","past":"{0} तिमाही पहले","future":{"one":"{0} तिमाही में","other":"{0} तिमाहियों में"}},"month":{"previous":"पिछला माह","current":"इस माह","next":"अगला माह","past":"{0} माह पहले","future":"{0} माह में"},"week":{"previous":"पिछला सप्ताह","current":"इस सप्ताह","next":"अगला सप्ताह","past":"{0} सप्ताह पहले","future":"{0} सप्ताह में"},"day":{"previous":"कल","previous-2":"परसों","current":"आज","next":"कल","next-2":"परसों","past":"{0} दिन पहले","future":"{0} दिन में"},"hour":{"current":"यह घंटा","past":"{0} घंटे पहले","future":"{0} घंटे में"},"minute":{"current":"यह मिनट","past":"{0} मिनट पहले","future":"{0} मिनट में"},"second":{"current":"अब","past":"{0} सेकंड पहले","future":"{0} सेकंड में"}},"short":{"year":{"previous":"पिछला वर्ष","current":"इस वर्ष","next":"अगला वर्ष","past":"{0} वर्ष पहले","future":"{0} वर्ष में"},"quarter":{"previous":"अंतिम तिमाही","current":"इस तिमाही","next":"अगली तिमाही","past":{"one":"{0} तिमाही पहले","other":"{0} तिमाहियों पहले"},"future":{"one":"{0} तिमाही में","other":"{0} तिमाहियों में"}},"month":{"previous":"पिछला माह","current":"इस माह","next":"अगला माह","past":"{0} माह पहले","future":"{0} माह में"},"week":{"previous":"पिछला सप्ताह","current":"इस सप्ताह","next":"अगला सप्ताह","past":"{0} सप्ताह पहले","future":"{0} सप्ताह में"},"day":{"previous":"कल","previous-2":"परसों","current":"आज","next":"कल","next-2":"परसों","past":"{0} दिन पहले","future":"{0} दिन में"},"hour":{"current":"यह घंटा","past":"{0} घं॰ पहले","future":"{0} घं॰ में"},"minute":{"current":"यह मिनट","past":"{0} मि॰ पहले","future":"{0} मि॰ में"},"second":{"current":"अब","past":"{0} से॰ पहले","future":"{0} से॰ में"}},"narrow":{"year":{"previous":"पिछला वर्ष","current":"इस वर्ष","next":"अगला वर्ष","past":"{0} वर्ष पहले","future":"{0} वर्ष में"},"quarter":{"previous":"अंतिम तिमाही","current":"इस तिमाही","next":"अगली तिमाही","past":"{0} ति॰ पहले","future":"{0} ति॰ में"},"month":{"previous":"पिछला माह","current":"इस माह","next":"अगला माह","past":"{0} माह पहले","future":"{0} माह में"},"week":{"previous":"पिछला सप्ताह","current":"इस सप्ताह","next":"अगला सप्ताह","past":"{0} सप्ताह पहले","future":"{0} सप्ताह में"},"day":{"previous":"कल","previous-2":"परसों","current":"आज","next":"कल","next-2":"परसों","past":"{0} दिन पहले","future":"{0} दिन में"},"hour":{"current":"यह घंटा","past":"{0} घं॰ पहले","future":"{0} घं॰ में"},"minute":{"current":"यह मिनट","past":"{0} मि॰ पहले","future":"{0} मि॰ में"},"second":{"current":"अब","past":"{0} से॰ पहले","future":"{0} से॰ में"}}}');

/***/ }),

/***/ 63049:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"hr","long":{"year":{"previous":"prošle godine","current":"ove godine","next":"sljedeće godine","past":{"one":"prije {0} godinu","few":"prije {0} godine","other":"prije {0} godina"},"future":{"one":"za {0} godinu","few":"za {0} godine","other":"za {0} godina"}},"quarter":{"previous":"prošli kvartal","current":"ovaj kvartal","next":"sljedeći kvartal","past":{"one":"prije {0} kvartal","other":"prije {0} kvartala"},"future":{"one":"za {0} kvartal","other":"za {0} kvartala"}},"month":{"previous":"prošli mjesec","current":"ovaj mjesec","next":"sljedeći mjesec","past":{"one":"prije {0} mjesec","few":"prije {0} mjeseca","other":"prije {0} mjeseci"},"future":{"one":"za {0} mjesec","few":"za {0} mjeseca","other":"za {0} mjeseci"}},"week":{"previous":"prošli tjedan","current":"ovaj tjedan","next":"sljedeći tjedan","past":{"one":"prije {0} tjedan","few":"prije {0} tjedna","other":"prije {0} tjedana"},"future":{"one":"za {0} tjedan","few":"za {0} tjedna","other":"za {0} tjedana"}},"day":{"previous":"jučer","previous-2":"prekjučer","current":"danas","next":"sutra","next-2":"prekosutra","past":{"one":"prije {0} dan","other":"prije {0} dana"},"future":{"one":"za {0} dan","other":"za {0} dana"}},"hour":{"current":"ovaj sat","past":{"one":"prije {0} sat","few":"prije {0} sata","other":"prije {0} sati"},"future":{"one":"za {0} sat","few":"za {0} sata","other":"za {0} sati"}},"minute":{"current":"ova minuta","past":{"one":"prije {0} minutu","few":"prije {0} minute","other":"prije {0} minuta"},"future":{"one":"za {0} minutu","few":"za {0} minute","other":"za {0} minuta"}},"second":{"current":"sad","past":{"one":"prije {0} sekundu","few":"prije {0} sekunde","other":"prije {0} sekundi"},"future":{"one":"za {0} sekundu","few":"za {0} sekunde","other":"za {0} sekundi"}}},"short":{"year":{"previous":"prošle god.","current":"ove god.","next":"sljedeće god.","past":"prije {0} g.","future":"za {0} g."},"quarter":{"previous":"prošli kv.","current":"ovaj kv.","next":"sljedeći kv.","past":"prije {0} kv.","future":"za {0} kv."},"month":{"previous":"prošli mj.","current":"ovaj mj.","next":"sljedeći mj.","past":"prije {0} mj.","future":"za {0} mj."},"week":{"previous":"prošli tj.","current":"ovaj tj.","next":"sljedeći tj.","past":"prije {0} tj.","future":"za {0} tj."},"day":{"previous":"jučer","previous-2":"prekjučer","current":"danas","next":"sutra","next-2":"prekosutra","past":{"one":"prije {0} dan","other":"prije {0} dana"},"future":{"one":"za {0} dan","other":"za {0} dana"}},"hour":{"current":"ovaj sat","past":"prije {0} h","future":"za {0} h"},"minute":{"current":"ova minuta","past":"prije {0} min","future":"za {0} min"},"second":{"current":"sad","past":"prije {0} s","future":"za {0} s"}},"narrow":{"year":{"previous":"prošle g.","current":"ove g.","next":"sljedeće g.","past":"prije {0} g.","future":"za {0} g."},"quarter":{"previous":"prošli kv.","current":"ovaj kv.","next":"sljedeći kv.","past":"prije {0} kv.","future":"za {0} kv."},"month":{"previous":"prošli mj.","current":"ovaj mj.","next":"sljedeći mj.","past":"prije {0} mj.","future":"za {0} mj."},"week":{"previous":"prošli tj.","current":"ovaj tj.","next":"sljedeći tj.","past":"prije {0} tj.","future":"za {0} tj."},"day":{"previous":"jučer","previous-2":"prekjučer","current":"danas","next":"sutra","next-2":"prekosutra","past":"prije {0} d","future":"za {0} d"},"hour":{"current":"ovaj sat","past":"prije {0} h","future":"za {0} h"},"minute":{"current":"ova minuta","past":"prije {0} min","future":"za {0} min"},"second":{"current":"sad","past":"prije {0} s","future":"za {0} s"}}}');

/***/ }),

/***/ 74812:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"hsb","long":{"year":{"previous":"loni","current":"lětsa","next":"klětu","past":{"one":"před {0} lětom","two":"před {0} lětomaj","other":"před {0} lětami"},"future":{"one":"za {0} lěto","two":"za {0} lěće","few":"za {0} lěta","other":"za {0} lět"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"před {0} kwartalom","two":"před {0} kwartalomaj","other":"před {0} kwartalemi"},"future":{"one":"za {0} kwartal","two":"za {0} kwartalej","few":"za {0} kwartale","other":"za {0} kwartalow"}},"month":{"previous":"zašły měsac","current":"tutón měsac","next":"přichodny měsac","past":{"one":"před {0} měsacom","two":"před {0} měsacomaj","other":"před {0} měsacami"},"future":{"one":"za {0} měsac","two":"za {0} měsacaj","few":"za {0} měsacy","other":"za {0} měsacow"}},"week":{"previous":"zašły tydźeń","current":"tutón tydźeń","next":"přichodny tydźeń","past":{"one":"před {0} tydźenjom","two":"před {0} tydźenjomaj","other":"před {0} tydźenjemi"},"future":{"one":"za {0} tydźeń","two":"za {0} tydźenjej","few":"za {0} tydźenje","other":"za {0} tydźenjow"}},"day":{"previous":"wčera","current":"dźensa","next":"jutře","past":{"one":"před {0} dnjom","two":"před {0} dnjomaj","other":"před {0} dnjemi"},"future":{"one":"za {0} dźeń","two":"za {0} dnjej","few":"za {0} dny","other":"za {0} dnjow"}},"hour":{"current":"this hour","past":{"one":"před {0} hodźinu","two":"před {0} hodźinomaj","other":"před {0} hodźinami"},"future":{"one":"za {0} hodźinu","two":"za {0} hodźinje","few":"za {0} hodźiny","other":"za {0} hodźin"}},"minute":{"current":"this minute","past":{"one":"před {0} minutu","two":"před {0} minutomaj","other":"před {0} minutami"},"future":{"one":"za {0} minutu","two":"za {0} minuće","few":"za {0} minuty","other":"za {0} minutow"}},"second":{"current":"now","past":{"one":"před {0} sekundu","two":"před {0} sekundomaj","other":"před {0} sekundami"},"future":{"one":"za {0} sekundu","two":"za {0} sekundźe","few":"za {0} sekundy","other":"za {0} sekundow"}}},"short":{"year":{"previous":"loni","current":"lětsa","next":"klětu","past":"před {0} l.","future":"za {0} l."},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"před {0} kwart.","future":"za {0} kwart."},"month":{"previous":"zašły měsac","current":"tutón měsac","next":"přichodny měsac","past":"před {0} měs.","future":"za {0} měs."},"week":{"previous":"zašły tydźeń","current":"tutón tydźeń","next":"přichodny tydźeń","past":"před {0} tydź.","future":"za {0} tydź."},"day":{"previous":"wčera","current":"dźensa","next":"jutře","past":"před {0} dnj.","future":{"one":"za {0} dźeń","few":"za {0} dny","other":"za {0} dnj."}},"hour":{"current":"this hour","past":"před {0} hodź.","future":"za {0} hodź."},"minute":{"current":"this minute","past":"před {0} min.","future":"za {0} min."},"second":{"current":"now","past":"před {0} sek.","future":"za {0} sek."}},"narrow":{"year":{"previous":"loni","current":"lětsa","next":"klětu","past":"před {0} l.","future":"za {0} l."},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"před {0} kw.","future":"za {0} kw."},"month":{"previous":"zašły měsac","current":"tutón měsac","next":"přichodny měsac","past":"před {0} měs.","future":"za {0} měs."},"week":{"previous":"zašły tydźeń","current":"tutón tydźeń","next":"přichodny tydźeń","past":"před {0} tydź.","future":"za {0} tydź."},"day":{"previous":"wčera","current":"dźensa","next":"jutře","past":"před {0} d","future":"za {0} d"},"hour":{"current":"this hour","past":"před {0} h","future":"za {0} h"},"minute":{"current":"this minute","past":"před {0} m","future":"za {0} m"},"second":{"current":"now","past":"před {0} s","future":"za {0} s"}}}');

/***/ }),

/***/ 5994:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"hu","long":{"year":{"previous":"előző év","current":"ez az év","next":"következő év","past":"{0} évvel ezelőtt","future":"{0} év múlva"},"quarter":{"previous":"előző negyedév","current":"ez a negyedév","next":"következő negyedév","past":"{0} negyedévvel ezelőtt","future":"{0} negyedév múlva"},"month":{"previous":"előző hónap","current":"ez a hónap","next":"következő hónap","past":"{0} hónappal ezelőtt","future":"{0} hónap múlva"},"week":{"previous":"előző hét","current":"ez a hét","next":"következő hét","past":"{0} héttel ezelőtt","future":"{0} hét múlva"},"day":{"previous":"tegnap","previous-2":"tegnapelőtt","current":"ma","next":"holnap","next-2":"holnapután","past":"{0} nappal ezelőtt","future":"{0} nap múlva"},"hour":{"current":"ebben az órában","past":"{0} órával ezelőtt","future":"{0} óra múlva"},"minute":{"current":"ebben a percben","past":"{0} perccel ezelőtt","future":"{0} perc múlva"},"second":{"current":"most","past":"{0} másodperccel ezelőtt","future":"{0} másodperc múlva"}},"short":{"year":{"previous":"előző év","current":"ez az év","next":"következő év","past":"{0} évvel ezelőtt","future":"{0} év múlva"},"quarter":{"previous":"előző negyedév","current":"ez a negyedév","next":"következő negyedév","past":"{0} negyedévvel ezelőtt","future":"{0} negyedév múlva"},"month":{"previous":"előző hónap","current":"ez a hónap","next":"következő hónap","past":"{0} hónappal ezelőtt","future":"{0} hónap múlva"},"week":{"previous":"előző hét","current":"ez a hét","next":"következő hét","past":"{0} héttel ezelőtt","future":"{0} hét múlva"},"day":{"previous":"tegnap","previous-2":"tegnapelőtt","current":"ma","next":"holnap","next-2":"holnapután","past":"{0} napja","future":"{0} nap múlva"},"hour":{"current":"ebben az órában","past":"{0} órával ezelőtt","future":"{0} óra múlva"},"minute":{"current":"ebben a percben","past":"{0} perccel ezelőtt","future":"{0} perc múlva"},"second":{"current":"most","past":"{0} másodperccel ezelőtt","future":"{0} másodperc múlva"}},"narrow":{"year":{"previous":"előző év","current":"ez az év","next":"következő év","past":"{0} évvel ezelőtt","future":"{0} év múlva"},"quarter":{"previous":"előző negyedév","current":"ez a negyedév","next":"következő negyedév","past":"{0} negyedévvel ezelőtt","future":"{0} n.év múlva"},"month":{"previous":"előző hónap","current":"ez a hónap","next":"következő hónap","past":"{0} hónappal ezelőtt","future":"{0} hónap múlva"},"week":{"previous":"előző hét","current":"ez a hét","next":"következő hét","past":"{0} héttel ezelőtt","future":"{0} hét múlva"},"day":{"previous":"tegnap","previous-2":"tegnapelőtt","current":"ma","next":"holnap","next-2":"holnapután","past":"{0} napja","future":"{0} nap múlva"},"hour":{"current":"ebben az órában","past":"{0} órával ezelőtt","future":"{0} óra múlva"},"minute":{"current":"ebben a percben","past":"{0} perccel ezelőtt","future":"{0} perc múlva"},"second":{"current":"most","past":"{0} másodperccel ezelőtt","future":"{0} másodperc múlva"}}}');

/***/ }),

/***/ 7759:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"hy","long":{"year":{"previous":"նախորդ տարի","current":"այս տարի","next":"հաջորդ տարի","past":"{0} տարի առաջ","future":"{0} տարուց"},"quarter":{"previous":"նախորդ եռամսյակ","current":"այս եռամսյակ","next":"հաջորդ եռամսյակ","past":"{0} եռամսյակ առաջ","future":"{0} եռամսյակից"},"month":{"previous":"նախորդ ամիս","current":"այս ամիս","next":"հաջորդ ամիս","past":"{0} ամիս առաջ","future":"{0} ամսից"},"week":{"previous":"նախորդ շաբաթ","current":"այս շաբաթ","next":"հաջորդ շաբաթ","past":"{0} շաբաթ առաջ","future":"{0} շաբաթից"},"day":{"previous":"երեկ","previous-2":"երեկ չէ առաջի օրը","current":"այսօր","next":"վաղը","next-2":"վաղը չէ մյուս օրը","past":"{0} օր առաջ","future":"{0} օրից"},"hour":{"current":"այս ժամին","past":"{0} ժամ առաջ","future":"{0} ժամից"},"minute":{"current":"այս րոպեին","past":"{0} րոպե առաջ","future":"{0} րոպեից"},"second":{"current":"հիմա","past":"{0} վայրկյան առաջ","future":"{0} վայրկյանից"}},"short":{"year":{"previous":"նախորդ տարի","current":"այս տարի","next":"հաջորդ տարի","past":"{0} տ առաջ","future":"{0} տարուց"},"quarter":{"previous":"նախորդ եռամսյակ","current":"այս եռամսյակ","next":"հաջորդ եռամսյակ","past":"{0} եռմս առաջ","future":"{0} եռմս-ից"},"month":{"previous":"անցյալ ամիս","current":"այս ամիս","next":"հաջորդ ամիս","past":"{0} ամիս առաջ","future":"{0} ամսից"},"week":{"previous":"նախորդ շաբաթ","current":"այս շաբաթ","next":"հաջորդ շաբաթ","past":"{0} շաբ առաջ","future":"{0} շաբ-ից"},"day":{"previous":"երեկ","previous-2":"երեկ չէ առաջի օրը","current":"այսօր","next":"վաղը","next-2":"վաղը չէ մյուս օրը","past":"{0} օր առաջ","future":"{0} օրից"},"hour":{"current":"այս ժամին","past":"{0} ժ առաջ","future":"{0} ժ-ից"},"minute":{"current":"այս րոպեին","past":"{0} ր առաջ","future":"{0} ր-ից"},"second":{"current":"հիմա","past":"{0} վրկ առաջ","future":"{0} վրկ-ից"}},"narrow":{"year":{"previous":"նախորդ տարի","current":"այս տարի","next":"հաջորդ տարի","past":"{0} տ առաջ","future":"{0} տարուց"},"quarter":{"previous":"նախորդ եռամսյակ","current":"այս եռամսյակ","next":"հաջորդ եռամսյակ","past":"{0} եռմս առաջ","future":"{0} եռմս-ից"},"month":{"previous":"անցյալ ամիս","current":"այս ամիս","next":"հաջորդ ամիս","past":"{0} ամիս առաջ","future":"{0} ամսից"},"week":{"previous":"նախորդ շաբաթ","current":"այս շաբաթ","next":"հաջորդ շաբաթ","past":"{0} շաբ առաջ","future":"{0} շաբ անց"},"day":{"previous":"երեկ","previous-2":"երեկ չէ առաջի օրը","current":"այսօր","next":"վաղը","next-2":"վաղը չէ մյուս օրը","past":"{0} օր առաջ","future":"{0} օրից"},"hour":{"current":"այս ժամին","past":"{0} ժ առաջ","future":"{0} ժ-ից"},"minute":{"current":"այս րոպեին","past":"{0} ր առաջ","future":"{0} ր-ից"},"second":{"current":"հիմա","past":"{0} վ առաջ","future":"{0} վ-ից"}}}');

/***/ }),

/***/ 31695:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ia","long":{"year":{"previous":"le anno passate","current":"iste anno","next":"le anno proxime","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"le trimestre passate","current":"iste trimestre","next":"le trimestre proxime","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"le mense passate","current":"iste mense","next":"le mense proxime","past":"-{0} m","future":"+{0} m"},"week":{"previous":"le septimana passate","current":"iste septimana","next":"le septimana proxime","past":"-{0} w","future":"+{0} w"},"day":{"previous":"heri","current":"hodie","next":"deman","past":"-{0} d","future":"+{0} d"},"hour":{"current":"iste hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"iste minuta","past":"-{0} min","future":"+{0} min"},"second":{"current":"ora","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"le anno passate","current":"iste anno","next":"le anno proxime","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"le trimestre passate","current":"iste trimestre","next":"le trimestre proxime","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"le mense passate","current":"iste mense","next":"le mense proxime","past":"-{0} m","future":"+{0} m"},"week":{"previous":"le septimana passate","current":"iste septimana","next":"le septimana proxime","past":"-{0} w","future":"+{0} w"},"day":{"previous":"heri","current":"hodie","next":"deman","past":"-{0} d","future":"+{0} d"},"hour":{"current":"iste hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"iste minuta","past":"-{0} min","future":"+{0} min"},"second":{"current":"ora","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"le anno passate","current":"iste anno","next":"le anno proxime","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"le trimestre passate","current":"iste trimestre","next":"le trimestre proxime","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"le mense passate","current":"iste mense","next":"le mense proxime","past":"-{0} m","future":"+{0} m"},"week":{"previous":"le septimana passate","current":"iste septimana","next":"le septimana proxime","past":"-{0} w","future":"+{0} w"},"day":{"previous":"heri","current":"hodie","next":"deman","past":"-{0} d","future":"+{0} d"},"hour":{"current":"iste hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"iste minuta","past":"-{0} min","future":"+{0} min"},"second":{"current":"ora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 17079:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"id","long":{"year":{"previous":"tahun lalu","current":"tahun ini","next":"tahun depan","past":"{0} tahun yang lalu","future":"dalam {0} tahun"},"quarter":{"previous":"Kuartal lalu","current":"kuartal ini","next":"kuartal berikutnya","past":"{0} kuartal yang lalu","future":"dalam {0} kuartal"},"month":{"previous":"bulan lalu","current":"bulan ini","next":"bulan berikutnya","past":"{0} bulan yang lalu","future":"dalam {0} bulan"},"week":{"previous":"minggu lalu","current":"minggu ini","next":"minggu depan","past":"{0} minggu yang lalu","future":"dalam {0} minggu"},"day":{"previous":"kemarin","previous-2":"kemarin dulu","current":"hari ini","next":"besok","next-2":"lusa","past":"{0} hari yang lalu","future":"dalam {0} hari"},"hour":{"current":"jam ini","past":"{0} jam yang lalu","future":"dalam {0} jam"},"minute":{"current":"menit ini","past":"{0} menit yang lalu","future":"dalam {0} menit"},"second":{"current":"sekarang","past":"{0} detik yang lalu","future":"dalam {0} detik"}},"short":{"year":{"previous":"tahun lalu","current":"tahun ini","next":"tahun depan","past":"{0} thn lalu","future":"dlm {0} thn"},"quarter":{"previous":"Kuartal lalu","current":"kuartal ini","next":"kuartal berikutnya","past":"{0} krtl. lalu","future":"dlm {0} krtl."},"month":{"previous":"bulan lalu","current":"bulan ini","next":"bulan berikutnya","past":"{0} bln lalu","future":"dlm {0} bln"},"week":{"previous":"minggu lalu","current":"minggu ini","next":"minggu depan","past":"{0} mgg lalu","future":"dlm {0} mgg"},"day":{"previous":"kemarin","previous-2":"kemarin dulu","current":"hari ini","next":"besok","next-2":"lusa","past":"{0} h lalu","future":"dalam {0} h"},"hour":{"current":"jam ini","past":"{0} jam lalu","future":"dalam {0} jam"},"minute":{"current":"menit ini","past":"{0} mnt lalu","future":"dlm {0} mnt"},"second":{"current":"sekarang","past":"{0} dtk lalu","future":"dlm {0} dtk"}},"narrow":{"year":{"previous":"tahun lalu","current":"tahun ini","next":"tahun depan","past":"{0} thn lalu","future":"dlm {0} thn"},"quarter":{"previous":"Kuartal lalu","current":"kuartal ini","next":"kuartal berikutnya","past":"{0} krtl. lalu","future":"dlm {0} krtl."},"month":{"previous":"bulan lalu","current":"bulan ini","next":"bulan berikutnya","past":"{0} bln lalu","future":"dlm {0} bln"},"week":{"previous":"minggu lalu","current":"minggu ini","next":"minggu depan","past":"{0} mgg lalu","future":"dlm {0} mgg"},"day":{"previous":"kemarin","previous-2":"kemarin dulu","current":"hari ini","next":"besok","next-2":"lusa","past":"{0} h lalu","future":"dalam {0} h"},"hour":{"current":"jam ini","past":"{0} jam lalu","future":"dalam {0} jam"},"minute":{"current":"menit ini","past":"{0} mnt lalu","future":"dlm {0} mnt"},"second":{"current":"sekarang","past":"{0} dtk lalu","future":"dlm {0} dtk"}}}');

/***/ }),

/***/ 24631:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"is","long":{"year":{"previous":"á síðasta ári","current":"á þessu ári","next":"á næsta ári","past":{"one":"fyrir {0} ári","other":"fyrir {0} árum"},"future":"eftir {0} ár"},"quarter":{"previous":"síðasti ársfjórðungur","current":"þessi ársfjórðungur","next":"næsti ársfjórðungur","past":{"one":"fyrir {0} ársfjórðungi","other":"fyrir {0} ársfjórðungum"},"future":{"one":"eftir {0} ársfjórðung","other":"eftir {0} ársfjórðunga"}},"month":{"previous":"í síðasta mánuði","current":"í þessum mánuði","next":"í næsta mánuði","past":{"one":"fyrir {0} mánuði","other":"fyrir {0} mánuðum"},"future":{"one":"eftir {0} mánuð","other":"eftir {0} mánuði"}},"week":{"previous":"í síðustu viku","current":"í þessari viku","next":"í næstu viku","past":{"one":"fyrir {0} viku","other":"fyrir {0} vikum"},"future":{"one":"eftir {0} viku","other":"eftir {0} vikur"}},"day":{"previous":"í gær","previous-2":"í fyrradag","current":"í dag","next":"á morgun","next-2":"eftir tvo daga","past":{"one":"fyrir {0} degi","other":"fyrir {0} dögum"},"future":{"one":"eftir {0} dag","other":"eftir {0} daga"}},"hour":{"current":"þessa stundina","past":{"one":"fyrir {0} klukkustund","other":"fyrir {0} klukkustundum"},"future":{"one":"eftir {0} klukkustund","other":"eftir {0} klukkustundir"}},"minute":{"current":"á þessari mínútu","past":{"one":"fyrir {0} mínútu","other":"fyrir {0} mínútum"},"future":{"one":"eftir {0} mínútu","other":"eftir {0} mínútur"}},"second":{"current":"núna","past":{"one":"fyrir {0} sekúndu","other":"fyrir {0} sekúndum"},"future":{"one":"eftir {0} sekúndu","other":"eftir {0} sekúndur"}}},"short":{"year":{"previous":"á síðasta ári","current":"á þessu ári","next":"á næsta ári","past":{"one":"fyrir {0} ári","other":"fyrir {0} árum"},"future":"eftir {0} ár"},"quarter":{"previous":"síðasti ársfj.","current":"þessi ársfj.","next":"næsti ársfj.","past":"fyrir {0} ársfj.","future":"eftir {0} ársfj."},"month":{"previous":"í síðasta mán.","current":"í þessum mán.","next":"í næsta mán.","past":"fyrir {0} mán.","future":"eftir {0} mán."},"week":{"previous":"í síðustu viku","current":"í þessari viku","next":"í næstu viku","past":{"one":"fyrir {0} viku","other":"fyrir {0} vikum"},"future":{"one":"eftir {0} viku","other":"eftir {0} vikur"}},"day":{"previous":"í gær","previous-2":"í fyrradag","current":"í dag","next":"á morgun","next-2":"eftir tvo daga","past":{"one":"fyrir {0} degi","other":"fyrir {0} dögum"},"future":{"one":"eftir {0} dag","other":"eftir {0} daga"}},"hour":{"current":"þessa stundina","past":"fyrir {0} klst.","future":"eftir {0} klst."},"minute":{"current":"á þessari mínútu","past":"fyrir {0} mín.","future":"eftir {0} mín."},"second":{"current":"núna","past":"fyrir {0} sek.","future":"eftir {0} sek."}},"narrow":{"year":{"previous":"á síðasta ári","current":"á þessu ári","next":"á næsta ári","past":"fyrir {0} árum","future":"eftir {0} ár"},"quarter":{"previous":"síðasti ársfj.","current":"þessi ársfj.","next":"næsti ársfj.","past":"fyrir {0} ársfj.","future":"eftir {0} ársfj."},"month":{"previous":"í síðasta mán.","current":"í þessum mán.","next":"í næsta mán.","past":"fyrir {0} mán.","future":"eftir {0} mán."},"week":{"previous":"í síðustu viku","current":"í þessari viku","next":"í næstu viku","past":{"one":"-{0} viku","other":"-{0} vikur"},"future":{"one":"+{0} viku","other":"+{0} vikur"}},"day":{"previous":"í gær","previous-2":"í fyrradag","current":"í dag","next":"á morgun","next-2":"eftir tvo daga","past":{"one":"-{0} degi","other":"-{0} dögum"},"future":{"one":"+{0} dag","other":"+{0} daga"}},"hour":{"current":"þessa stundina","past":"-{0} klst.","future":"+{0} klst."},"minute":{"current":"á þessari mínútu","past":"-{0} mín.","future":"+{0} mín."},"second":{"current":"núna","past":"-{0} sek.","future":"+{0} sek."}}}');

/***/ }),

/***/ 40604:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"it","long":{"year":{"previous":"anno scorso","current":"quest’anno","next":"anno prossimo","past":{"one":"{0} anno fa","other":"{0} anni fa"},"future":{"one":"tra {0} anno","other":"tra {0} anni"}},"quarter":{"previous":"trimestre scorso","current":"questo trimestre","next":"trimestre prossimo","past":{"one":"{0} trimestre fa","other":"{0} trimestri fa"},"future":{"one":"tra {0} trimestre","other":"tra {0} trimestri"}},"month":{"previous":"mese scorso","current":"questo mese","next":"mese prossimo","past":{"one":"{0} mese fa","other":"{0} mesi fa"},"future":{"one":"tra {0} mese","other":"tra {0} mesi"}},"week":{"previous":"settimana scorsa","current":"questa settimana","next":"settimana prossima","past":{"one":"{0} settimana fa","other":"{0} settimane fa"},"future":{"one":"tra {0} settimana","other":"tra {0} settimane"}},"day":{"previous":"ieri","previous-2":"l’altro ieri","current":"oggi","next":"domani","next-2":"dopodomani","past":{"one":"{0} giorno fa","other":"{0} giorni fa"},"future":{"one":"tra {0} giorno","other":"tra {0} giorni"}},"hour":{"current":"quest’ora","past":{"one":"{0} ora fa","other":"{0} ore fa"},"future":{"one":"tra {0} ora","other":"tra {0} ore"}},"minute":{"current":"questo minuto","past":{"one":"{0} minuto fa","other":"{0} minuti fa"},"future":{"one":"tra {0} minuto","other":"tra {0} minuti"}},"second":{"current":"ora","past":{"one":"{0} secondo fa","other":"{0} secondi fa"},"future":{"one":"tra {0} secondo","other":"tra {0} secondi"}}},"short":{"year":{"previous":"anno scorso","current":"quest’anno","next":"anno prossimo","past":{"one":"{0} anno fa","other":"{0} anni fa"},"future":{"one":"tra {0} anno","other":"tra {0} anni"}},"quarter":{"previous":"trim. scorso","current":"questo trim.","next":"trim. prossimo","past":"{0} trim. fa","future":"tra {0} trim."},"month":{"previous":"mese scorso","current":"questo mese","next":"mese prossimo","past":{"one":"{0} mese fa","other":"{0} mesi fa"},"future":{"one":"tra {0} mese","other":"tra {0} mesi"}},"week":{"previous":"settimana scorsa","current":"questa settimana","next":"settimana prossima","past":"{0} sett. fa","future":"tra {0} sett."},"day":{"previous":"ieri","previous-2":"l’altro ieri","current":"oggi","next":"domani","next-2":"dopodomani","past":{"one":"{0} g fa","other":"{0} gg fa"},"future":{"one":"tra {0} g","other":"tra {0} gg"}},"hour":{"current":"quest’ora","past":"{0} h fa","future":"tra {0} h"},"minute":{"current":"questo minuto","past":"{0} min fa","future":"tra {0} min"},"second":{"current":"ora","past":{"one":"{0} s fa","other":"{0} sec. fa"},"future":{"one":"tra {0} s","other":"tra {0} sec."}}},"narrow":{"year":{"previous":"anno scorso","current":"quest’anno","next":"anno prossimo","past":{"one":"{0} anno fa","other":"{0} anni fa"},"future":{"one":"tra {0} anno","other":"tra {0} anni"}},"quarter":{"previous":"trim. scorso","current":"questo trim.","next":"trim. prossimo","past":"{0} trim. fa","future":"tra {0} trim."},"month":{"previous":"mese scorso","current":"questo mese","next":"mese prossimo","past":{"one":"{0} mese fa","other":"{0} mesi fa"},"future":{"one":"tra {0} mese","other":"tra {0} mesi"}},"week":{"previous":"settimana scorsa","current":"questa settimana","next":"settimana prossima","past":"{0} sett. fa","future":"tra {0} sett."},"day":{"previous":"ieri","previous-2":"l’altro ieri","current":"oggi","next":"domani","next-2":"dopodomani","past":{"one":"{0} g fa","other":"{0} gg fa"},"future":{"one":"tra {0} g","other":"tra {0} gg"}},"hour":{"current":"quest’ora","past":"{0} h fa","future":"tra {0} h"},"minute":{"current":"questo minuto","past":"{0} min fa","future":"tra {0} min"},"second":{"current":"ora","past":"{0} s fa","future":"tra {0} s"}}}');

/***/ }),

/***/ 93886:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ja","long":{"year":{"previous":"昨年","current":"今年","next":"翌年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"前四半期","current":"今四半期","next":"翌四半期","past":"{0} 四半期前","future":"{0} 四半期後"},"month":{"previous":"先月","current":"今月","next":"翌月","past":"{0} か月前","future":"{0} か月後"},"week":{"previous":"先週","current":"今週","next":"翌週","past":"{0} 週間前","future":"{0} 週間後"},"day":{"previous":"昨日","previous-2":"一昨日","current":"今日","next":"明日","next-2":"明後日","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"1 時間以内","past":"{0} 時間前","future":"{0} 時間後"},"minute":{"current":"1 分以内","past":"{0} 分前","future":"{0} 分後"},"second":{"current":"今","past":"{0} 秒前","future":"{0} 秒後"}},"short":{"year":{"previous":"昨年","current":"今年","next":"翌年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"前四半期","current":"今四半期","next":"翌四半期","past":"{0} 四半期前","future":"{0} 四半期後"},"month":{"previous":"先月","current":"今月","next":"翌月","past":"{0} か月前","future":"{0} か月後"},"week":{"previous":"先週","current":"今週","next":"翌週","past":"{0} 週間前","future":"{0} 週間後"},"day":{"previous":"昨日","previous-2":"一昨日","current":"今日","next":"明日","next-2":"明後日","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"1 時間以内","past":"{0} 時間前","future":"{0} 時間後"},"minute":{"current":"1 分以内","past":"{0} 分前","future":"{0} 分後"},"second":{"current":"今","past":"{0} 秒前","future":"{0} 秒後"}},"narrow":{"year":{"previous":"昨年","current":"今年","next":"翌年","past":"{0}年前","future":"{0}年後"},"quarter":{"previous":"前四半期","current":"今四半期","next":"翌四半期","past":"{0}四半期前","future":"{0}四半期後"},"month":{"previous":"先月","current":"今月","next":"翌月","past":"{0}か月前","future":"{0}か月後"},"week":{"previous":"先週","current":"今週","next":"翌週","past":"{0}週間前","future":"{0}週間後"},"day":{"previous":"昨日","previous-2":"一昨日","current":"今日","next":"明日","next-2":"明後日","past":"{0}日前","future":"{0}日後"},"hour":{"current":"1 時間以内","past":"{0}時間前","future":"{0}時間後"},"minute":{"current":"1 分以内","past":"{0}分前","future":"{0}分後"},"second":{"current":"今","past":"{0}秒前","future":"{0}秒後"}}}');

/***/ }),

/***/ 76504:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"jgo","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":"Ɛ́gɛ́ mɔ́ ŋguꞋ {0}","future":"Nǔu ŋguꞋ {0}"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"ɛ́ gɛ́ mɔ́ pɛsaŋ {0}","future":"Nǔu {0} saŋ"},"week":{"previous":"last week","current":"this week","next":"next week","past":"Ɛ́ gɛ́ mɔ {0} ŋgap-mbi","future":"Nǔu ŋgap-mbi {0}"},"day":{"previous":"yesterday","current":"lɔꞋɔ","next":"tomorrow","past":"Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}","future":"Nǔu lɛ́Ꞌ {0}"},"hour":{"current":"this hour","past":"ɛ́ gɛ mɔ́ {0} háwa","future":"nǔu háwa {0}"},"minute":{"current":"this minute","past":"ɛ́ gɛ́ mɔ́ minút {0}","future":"nǔu {0} minút"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"last year","current":"this year","next":"next year","past":"Ɛ́gɛ́ mɔ́ ŋguꞋ {0}","future":"Nǔu ŋguꞋ {0}"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"ɛ́ gɛ́ mɔ́ pɛsaŋ {0}","future":"Nǔu {0} saŋ"},"week":{"previous":"last week","current":"this week","next":"next week","past":"Ɛ́ gɛ́ mɔ {0} ŋgap-mbi","future":"Nǔu ŋgap-mbi {0}"},"day":{"previous":"yesterday","current":"lɔꞋɔ","next":"tomorrow","past":"Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}","future":"Nǔu lɛ́Ꞌ {0}"},"hour":{"current":"this hour","past":"ɛ́ gɛ mɔ́ {0} háwa","future":"nǔu háwa {0}"},"minute":{"current":"this minute","past":"ɛ́ gɛ́ mɔ́ minút {0}","future":"nǔu {0} minút"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"last year","current":"this year","next":"next year","past":"Ɛ́gɛ́ mɔ́ ŋguꞋ {0}","future":"Nǔu ŋguꞋ {0}"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"ɛ́ gɛ́ mɔ́ pɛsaŋ {0}","future":"Nǔu {0} saŋ"},"week":{"previous":"last week","current":"this week","next":"next week","past":"Ɛ́ gɛ́ mɔ {0} ŋgap-mbi","future":"Nǔu ŋgap-mbi {0}"},"day":{"previous":"yesterday","current":"lɔꞋɔ","next":"tomorrow","past":"Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}","future":"Nǔu lɛ́Ꞌ {0}"},"hour":{"current":"this hour","past":"ɛ́ gɛ mɔ́ {0} háwa","future":"nǔu háwa {0}"},"minute":{"current":"this minute","past":"ɛ́ gɛ́ mɔ́ minút {0}","future":"nǔu {0} minút"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 25378:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"jv","long":{"year":{"previous":"taun wingi","current":"taun iki","next":"taun ngarep","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"sasi wingi","current":"sasi iki","next":"sasi ngarep","past":"-{0} m","future":"+{0} m"},"week":{"previous":"pekan wingi","current":"pekan iki","next":"pekan ngarep","past":"-{0} w","future":"+{0} w"},"day":{"previous":"wingi","current":"saiki","next":"sesuk","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"taun wingi","current":"taun iki","next":"taun ngarep","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"sasi wingi","current":"sasi iki","next":"sasi ngarep","past":"-{0} m","future":"+{0} m"},"week":{"previous":"pekan wingi","current":"pekan iki","next":"pekan ngarep","past":"-{0} w","future":"+{0} w"},"day":{"previous":"wingi","current":"saiki","next":"sesuk","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"taun wingi","current":"taun iki","next":"taun ngarep","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"sasi wingi","current":"sasi iki","next":"sasi ngarep","past":"-{0} m","future":"+{0} m"},"week":{"previous":"pekan wingi","current":"pekan iki","next":"pekan ngarep","past":"-{0} w","future":"+{0} w"},"day":{"previous":"wingi","current":"saiki","next":"sesuk","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 79548:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ka","long":{"year":{"previous":"გასულ წელს","current":"ამ წელს","next":"მომავალ წელს","past":"{0} წლის წინ","future":"{0} წელიწადში"},"quarter":{"previous":"გასულ კვარტალში","current":"ამ კვარტალში","next":"შემდეგ კვარტალში","past":"{0} კვარტალის წინ","future":"{0} კვარტალში"},"month":{"previous":"გასულ თვეს","current":"ამ თვეში","next":"მომავალ თვეს","past":"{0} თვის წინ","future":"{0} თვეში"},"week":{"previous":"გასულ კვირაში","current":"ამ კვირაში","next":"მომავალ კვირაში","past":"{0} კვირის წინ","future":"{0} კვირაში"},"day":{"previous":"გუშინ","previous-2":"გუშინწინ","current":"დღეს","next":"ხვალ","next-2":"ზეგ","past":"{0} დღის წინ","future":"{0} დღეში"},"hour":{"current":"ამ საათში","past":"{0} საათის წინ","future":"{0} საათში"},"minute":{"current":"ამ წუთში","past":"{0} წუთის წინ","future":"{0} წუთში"},"second":{"current":"ახლა","past":"{0} წამის წინ","future":"{0} წამში"}},"short":{"year":{"previous":"გასულ წელს","current":"ამ წელს","next":"მომავალ წელს","past":"{0} წლის წინ","future":"{0} წელში"},"quarter":{"previous":"გასულ კვარტალში","current":"ამ კვარტალში","next":"შემდეგ კვარტალში","past":"{0} კვარტ. წინ","future":"{0} კვარტალში"},"month":{"previous":"გასულ თვეს","current":"ამ თვეში","next":"მომავალ თვეს","past":"{0} თვის წინ","future":"{0} თვეში"},"week":{"previous":"გასულ კვირაში","current":"ამ კვირაში","next":"მომავალ კვირაში","past":"{0} კვ. წინ","future":"{0} კვირაში"},"day":{"previous":"გუშინ","previous-2":"გუშინწინ","current":"დღეს","next":"ხვალ","next-2":"ზეგ","past":"{0} დღის წინ","future":"{0} დღეში"},"hour":{"current":"ამ საათში","past":"{0} სთ წინ","future":"{0} საათში"},"minute":{"current":"ამ წუთში","past":"{0} წთ წინ","future":"{0} წუთში"},"second":{"current":"ახლა","past":"{0} წმ წინ","future":"{0} წამში"}},"narrow":{"year":{"previous":"გასულ წელს","current":"ამ წელს","next":"მომავალ წელს","past":"{0} წლის წინ","future":"{0} წელში"},"quarter":{"previous":"გასულ კვარტალში","current":"ამ კვარტალში","next":"შემდეგ კვარტალში","past":"{0} კვარტ. წინ","future":"{0} კვარტალში"},"month":{"previous":"გასულ თვეს","current":"ამ თვეში","next":"მომავალ თვეს","past":"{0} თვის წინ","future":"{0} თვეში"},"week":{"previous":"გასულ კვირაში","current":"ამ კვირაში","next":"მომავალ კვირაში","past":"{0} კვირის წინ","future":"{0} კვირაში"},"day":{"previous":"გუშინ","previous-2":"გუშინწინ","current":"დღეს","next":"ხვალ","next-2":"ზეგ","past":"{0} დღის წინ","future":"{0} დღეში"},"hour":{"current":"ამ საათში","past":"{0} სთ წინ","future":"{0} საათში"},"minute":{"current":"ამ წუთში","past":"{0} წთ წინ","future":"{0} წუთში"},"second":{"current":"ახლა","past":"{0} წმ წინ","future":"{0} წამში"}}}');

/***/ }),

/***/ 33236:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"kea","long":{"year":{"previous":"anu pasadu","current":"es anu li","next":"prósimu anu","past":"a ten {0} anu","future":"di li {0} anu"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"a ten {0} trimestri","future":"di li {0} trimestri"},"month":{"previous":"mes pasadu","current":"es mes li","next":"prósimu mes","past":"a ten {0} mes","future":"di li {0} mes"},"week":{"previous":"simana pasadu","current":"es simana li","next":"prósimu simana","past":"a ten {0} simana","future":"di li {0} simana"},"day":{"previous":"onti","current":"oji","next":"manha","past":"a ten {0} dia","future":"di li {0} dia"},"hour":{"current":"this hour","past":"a ten {0} ora","future":"di li {0} ora"},"minute":{"current":"this minute","past":"a ten {0} minutu","future":"di li {0} minutu"},"second":{"current":"now","past":"a ten {0} sigundu","future":"di li {0} sigundu"}},"short":{"year":{"previous":"anu pasadu","current":"es anu li","next":"prósimu anu","past":"a ten {0} anu","future":"di li {0} anu"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"a ten {0} trim.","future":"di li {0} trim."},"month":{"previous":"mes pasadu","current":"es mes li","next":"prósimu mes","past":"a ten {0} mes","future":"di li {0} mes"},"week":{"previous":"simana pasadu","current":"es simana li","next":"prósimu simana","past":"a ten {0} sim.","future":"di li {0} sim."},"day":{"previous":"onti","current":"oji","next":"manha","past":"a ten {0} dia","future":"di li {0} dia"},"hour":{"current":"this hour","past":"a ten {0} ora","future":"di li {0} ora"},"minute":{"current":"this minute","past":"a ten {0} min","future":"di li {0} min"},"second":{"current":"now","past":"a ten {0} sig","future":"di li {0} sig"}},"narrow":{"year":{"previous":"anu pasadu","current":"es anu li","next":"prósimu anu","past":"a ten {0} anu","future":"di li {0} anu"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"a ten {0} trim.","future":"di li {0} trim."},"month":{"previous":"mes pasadu","current":"es mes li","next":"prósimu mes","past":"a ten {0} mes","future":"di li {0} mes"},"week":{"previous":"simana pasadu","current":"es simana li","next":"prósimu simana","past":"a ten {0} sim.","future":"di li {0} sim."},"day":{"previous":"onti","current":"oji","next":"manha","past":"a ten {0} dia","future":"di li {0} dia"},"hour":{"current":"this hour","past":"a ten {0} ora","future":"di li {0} ora"},"minute":{"current":"this minute","past":"a ten {0} m","future":"di li {0} m"},"second":{"current":"now","past":"a ten {0} s","future":"di li {0} s"}}}');

/***/ }),

/***/ 27531:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"kk","long":{"year":{"previous":"былтырғы жыл","current":"биылғы жыл","next":"келесі жыл","past":"{0} жыл бұрын","future":"{0} жылдан кейін"},"quarter":{"previous":"өткен тоқсан","current":"осы тоқсан","next":"келесі тоқсан","past":"{0} тоқсан бұрын","future":"{0} тоқсаннан кейін"},"month":{"previous":"өткен ай","current":"осы ай","next":"келесі ай","past":"{0} ай бұрын","future":"{0} айдан кейін"},"week":{"previous":"өткен апта","current":"осы апта","next":"келесі апта","past":"{0} апта бұрын","future":"{0} аптадан кейін"},"day":{"previous":"кеше","previous-2":"алдыңгүні","current":"бүгін","next":"ертең","next-2":"бүрсігүні","past":"{0} күн бұрын","future":"{0} күннен кейін"},"hour":{"current":"осы сағат","past":"{0} сағат бұрын","future":"{0} сағаттан кейін"},"minute":{"current":"осы минут","past":"{0} минут бұрын","future":"{0} минуттан кейін"},"second":{"current":"қазір","past":"{0} секунд бұрын","future":"{0} секундтан кейін"}},"short":{"year":{"previous":"былтырғы жыл","current":"биылғы жыл","next":"келесі жыл","past":"{0} ж. бұрын","future":"{0} ж. кейін"},"quarter":{"previous":"өткен тоқсан","current":"осы тоқсан","next":"келесі тоқсан","past":"{0} тқс. бұрын","future":"{0} тқс. кейін"},"month":{"previous":"өткен ай","current":"осы ай","next":"келесі ай","past":"{0} ай бұрын","future":"{0} айдан кейін"},"week":{"previous":"өткен апта","current":"осы апта","next":"келесі апта","past":"{0} ап. бұрын","future":"{0} ап. кейін"},"day":{"previous":"кеше","previous-2":"алдыңғы күні","current":"бүгін","next":"ертең","next-2":"бүрсігүні","past":"{0} күн бұрын","future":"{0} күннен кейін"},"hour":{"current":"осы сағат","past":"{0} сағ. бұрын","future":"{0} сағ. кейін"},"minute":{"current":"осы минут","past":"{0} мин. бұрын","future":"{0} мин. кейін"},"second":{"current":"қазір","past":"{0} сек. бұрын","future":"{0} сек. кейін"}},"narrow":{"year":{"previous":"былтырғы жыл","current":"биылғы жыл","next":"келесі жыл","past":"{0} ж. бұрын","future":"{0} ж. кейін"},"quarter":{"previous":"өткен тоқсан","current":"осы тоқсан","next":"келесі тоқсан","past":"{0} тқс. бұрын","future":"{0} тқс. кейін"},"month":{"previous":"өткен ай","current":"осы ай","next":"келесі ай","past":"{0} ай бұрын","future":"{0} айдан кейін"},"week":{"previous":"өткен апта","current":"осы апта","next":"келесі апта","past":"{0} ап. бұрын","future":"{0} ап. кейін"},"day":{"previous":"кеше","previous-2":"алдыңғы күні","current":"бүгін","next":"ертең","next-2":"бүрсігүні","past":"{0} күн бұрын","future":"{0} күннен кейін"},"hour":{"current":"осы сағат","past":"{0} сағ. бұрын","future":"{0} сағ. кейін"},"minute":{"current":"осы минут","past":"{0} мин. бұрын","future":"{0} мин. кейін"},"second":{"current":"қазір","past":"{0} сек. бұрын","future":"{0} сек. кейін"}}}');

/***/ }),

/***/ 28546:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"kl","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":"for {0} ukioq siden","future":"om {0} ukioq"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"for {0} qaammat siden","future":"om {0} qaammat"},"week":{"previous":"last week","current":"this week","next":"next week","past":"for {0} sapaatip-akunnera siden","future":"om {0} sapaatip-akunnera"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":"for {0} ulloq unnuarlu siden","future":"om {0} ulloq unnuarlu"},"hour":{"current":"this hour","past":"for {0} nalunaaquttap-akunnera siden","future":"om {0} nalunaaquttap-akunnera"},"minute":{"current":"this minute","past":"for {0} minutsi siden","future":"om {0} minutsi"},"second":{"current":"now","past":"for {0} sekundi siden","future":"om {0} sekundi"}},"short":{"year":{"previous":"last year","current":"this year","next":"next year","past":"for {0} ukioq siden","future":"om {0} ukioq"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"for {0} qaammat siden","future":"om {0} qaammat"},"week":{"previous":"last week","current":"this week","next":"next week","past":"for {0} sapaatip-akunnera siden","future":"om {0} sapaatip-akunnera"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":"for {0} ulloq unnuarlu siden","future":"om {0} ulloq unnuarlu"},"hour":{"current":"this hour","past":"for {0} nalunaaquttap-akunnera siden","future":"om {0} nalunaaquttap-akunnera"},"minute":{"current":"this minute","past":"for {0} minutsi siden","future":"om {0} minutsi"},"second":{"current":"now","past":"for {0} sekundi siden","future":"om {0} sekundi"}},"narrow":{"year":{"previous":"last year","current":"this year","next":"next year","past":"for {0} ukioq siden","future":"om {0} ukioq"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"for {0} qaammat siden","future":"om {0} qaammat"},"week":{"previous":"last week","current":"this week","next":"next week","past":"for {0} sapaatip-akunnera siden","future":"om {0} sapaatip-akunnera"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":"for {0} ulloq unnuarlu siden","future":"om {0} ulloq unnuarlu"},"hour":{"current":"this hour","past":"for {0} nalunaaquttap-akunnera siden","future":"om {0} nalunaaquttap-akunnera"},"minute":{"current":"this minute","past":"for {0} minutsi siden","future":"om {0} minutsi"},"second":{"current":"now","past":"for {0} sekundi siden","future":"om {0} sekundi"}}}');

/***/ }),

/***/ 64029:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"km","long":{"year":{"previous":"ឆ្នាំ​មុន","current":"ឆ្នាំ​នេះ","next":"ឆ្នាំ​ក្រោយ","past":"{0} ឆ្នាំ​មុន","future":"{0} ឆ្នាំទៀត"},"quarter":{"previous":"ត្រីមាស​មុន","current":"ត្រីមាស​នេះ","next":"ត្រីមាស​ក្រោយ","past":"{0} ត្រីមាស​មុន","future":"{0} ត្រីមាសទៀត"},"month":{"previous":"ខែ​មុន","current":"ខែ​នេះ","next":"ខែ​ក្រោយ","past":"{0} ខែមុន","future":"{0} ខែទៀត"},"week":{"previous":"សប្ដាហ៍​មុន","current":"សប្ដាហ៍​នេះ","next":"សប្ដាហ៍​ក្រោយ","past":"{0} សប្ដាហ៍​មុន","future":"{0} សប្ដាហ៍ទៀត"},"day":{"previous":"ម្សិលមិញ","previous-2":"ម្សិល​ម៉្ងៃ","current":"ថ្ងៃ​នេះ","next":"ថ្ងៃ​ស្អែក","next-2":"​ខាន​ស្អែក","past":"{0} ថ្ងៃ​មុន","future":"{0} ថ្ងៃទៀត"},"hour":{"current":"ម៉ោងនេះ","past":"{0} ម៉ោង​មុន","future":"ក្នុង​រយៈ​ពេល {0} ម៉ោង"},"minute":{"current":"នាទីនេះ","past":"{0} នាទី​មុន","future":"{0} នាទីទៀត"},"second":{"current":"ឥឡូវ","past":"{0} វិនាទី​មុន","future":"{0} វិនាទីទៀត"}},"short":{"year":{"previous":"ឆ្នាំ​មុន","current":"ឆ្នាំ​នេះ","next":"ឆ្នាំ​ក្រោយ","past":"{0} ឆ្នាំ​មុន","future":"{0} ឆ្នាំទៀត"},"quarter":{"previous":"ត្រីមាស​មុន","current":"ត្រីមាស​នេះ","next":"ត្រីមាស​ក្រោយ","past":"{0} ត្រីមាស​មុន","future":"{0} ត្រីមាសទៀត"},"month":{"previous":"ខែ​មុន","current":"ខែ​នេះ","next":"ខែ​ក្រោយ","past":"{0} ខែមុន","future":"{0} ខែទៀត"},"week":{"previous":"សប្ដាហ៍​មុន","current":"សប្ដាហ៍​នេះ","next":"សប្ដាហ៍​ក្រោយ","past":"{0} សប្ដាហ៍​មុន","future":"{0} សប្ដាហ៍ទៀត"},"day":{"previous":"ម្សិលមិញ","previous-2":"ម្សិល​ម៉្ងៃ","current":"ថ្ងៃ​នេះ","next":"ថ្ងៃស្អែក","next-2":"​ខាន​ស្អែក","past":"{0} ថ្ងៃ​​មុន","future":"{0} ថ្ងៃទៀត"},"hour":{"current":"ម៉ោងនេះ","past":"{0} ម៉ោង​មុន","future":"{0} ម៉ោងទៀត"},"minute":{"current":"នាទីនេះ","past":"{0} នាទី​​មុន","future":"{0} នាទីទៀត"},"second":{"current":"ឥឡូវ","past":"{0} វិនាទី​មុន","future":"{0} វិនាទីទៀត"}},"narrow":{"year":{"previous":"ឆ្នាំ​មុន","current":"ឆ្នាំ​នេះ","next":"ឆ្នាំ​ក្រោយ","past":"{0} ឆ្នាំ​មុន","future":"{0} ឆ្នាំទៀត"},"quarter":{"previous":"ត្រីមាស​មុន","current":"ត្រីមាស​នេះ","next":"ត្រីមាស​ក្រោយ","past":"{0} ត្រីមាស​មុន","future":"{0} ត្រីមាសទៀត"},"month":{"previous":"ខែ​មុន","current":"ខែ​នេះ","next":"ខែ​ក្រោយ","past":"{0} ខែមុន","future":"{0} ខែទៀត"},"week":{"previous":"សប្ដាហ៍​មុន","current":"សប្ដាហ៍​នេះ","next":"សប្ដាហ៍​ក្រោយ","past":"{0} សប្ដាហ៍​មុន","future":"{0} សប្ដាហ៍ទៀត"},"day":{"previous":"ម្សិលមិញ","previous-2":"ម្សិល​ម៉្ងៃ","current":"ថ្ងៃ​នេះ","next":"ថ្ងៃស្អែក","next-2":"​ខាន​ស្អែក","past":"{0} ថ្ងៃ​​មុន","future":"{0} ថ្ងៃទៀត"},"hour":{"current":"ម៉ោងនេះ","past":"{0} ម៉ោង​មុន","future":"{0} ម៉ោងទៀត"},"minute":{"current":"នាទីនេះ","past":"{0} នាទី​​មុន","future":"{0} នាទីទៀត"},"second":{"current":"ឥឡូវ","past":"{0} វិនាទី​មុន","future":"{0} វិនាទីទៀត"}}}');

/***/ }),

/***/ 98117:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"kn","long":{"year":{"previous":"ಹಿಂದಿನ ವರ್ಷ","current":"ಈ ವರ್ಷ","next":"ಮುಂದಿನ ವರ್ಷ","past":{"one":"{0} ವರ್ಷದ ಹಿಂದೆ","other":"{0} ವರ್ಷಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ವರ್ಷದಲ್ಲಿ","other":"{0} ವರ್ಷಗಳಲ್ಲಿ"}},"quarter":{"previous":"ಹಿಂದಿನ ತ್ರೈಮಾಸಿಕ","current":"ಈ ತ್ರೈಮಾಸಿಕ","next":"ಮುಂದಿನ ತ್ರೈಮಾಸಿಕ","past":{"one":"{0} ತ್ರೈಮಾಸಿಕದ ಹಿಂದೆ","other":"{0} ತ್ರೈಮಾಸಿಕಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ತ್ರೈಮಾಸಿಕದಲ್ಲಿ","other":"{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ"}},"month":{"previous":"ಕಳೆದ ತಿಂಗಳು","current":"ಈ ತಿಂಗಳು","next":"ಮುಂದಿನ ತಿಂಗಳು","past":{"one":"{0} ತಿಂಗಳ ಹಿಂದೆ","other":"{0} ತಿಂಗಳುಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ತಿಂಗಳಲ್ಲಿ","other":"{0} ತಿಂಗಳುಗಳಲ್ಲಿ"}},"week":{"previous":"ಕಳೆದ ವಾರ","current":"ಈ ವಾರ","next":"ಮುಂದಿನ ವಾರ","past":{"one":"{0} ವಾರದ ಹಿಂದೆ","other":"{0} ವಾರಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ವಾರದಲ್ಲಿ","other":"{0} ವಾರಗಳಲ್ಲಿ"}},"day":{"previous":"ನಿನ್ನೆ","previous-2":"ಮೊನ್ನೆ","current":"ಇಂದು","next":"ನಾಳೆ","next-2":"ನಾಡಿದ್ದು","past":{"one":"{0} ದಿನದ ಹಿಂದೆ","other":"{0} ದಿನಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ದಿನದಲ್ಲಿ","other":"{0} ದಿನಗಳಲ್ಲಿ"}},"hour":{"current":"ಈ ಗಂಟೆ","past":{"one":"{0} ಗಂಟೆ ಹಿಂದೆ","other":"{0} ಗಂಟೆಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ಗಂಟೆಯಲ್ಲಿ","other":"{0} ಗಂಟೆಗಳಲ್ಲಿ"}},"minute":{"current":"ಈ ನಿಮಿಷ","past":{"one":"{0} ನಿಮಿಷದ ಹಿಂದೆ","other":"{0} ನಿಮಿಷಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ನಿಮಿಷದಲ್ಲಿ","other":"{0} ನಿಮಿಷಗಳಲ್ಲಿ"}},"second":{"current":"ಈಗ","past":{"one":"{0} ಸೆಕೆಂಡ್ ಹಿಂದೆ","other":"{0} ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ಸೆಕೆಂಡ್‌ನಲ್ಲಿ","other":"{0} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ"}}},"short":{"year":{"previous":"ಕಳೆದ ವರ್ಷ","current":"ಈ ವರ್ಷ","next":"ಮುಂದಿನ ವರ್ಷ","past":{"one":"{0} ವರ್ಷದ ಹಿಂದೆ","other":"{0} ವರ್ಷಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ವರ್ಷದಲ್ಲಿ","other":"{0} ವರ್ಷಗಳಲ್ಲಿ"}},"quarter":{"previous":"ಕಳೆದ ತ್ರೈಮಾಸಿಕ","current":"ಈ ತ್ರೈಮಾಸಿಕ","next":"ಮುಂದಿನ ತ್ರೈಮಾಸಿಕ","past":{"one":"{0} ತ್ರೈ.ಮಾ. ಹಿಂದೆ","other":"{0} ತ್ರೈಮಾಸಿಕಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ತ್ರೈ.ಮಾ.ದಲ್ಲಿ","other":"{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ"}},"month":{"previous":"ಕಳೆದ ತಿಂಗಳು","current":"ಈ ತಿಂಗಳು","next":"ಮುಂದಿನ ತಿಂಗಳು","past":{"one":"{0} ತಿಂಗಳು ಹಿಂದೆ","other":"{0} ತಿಂಗಳುಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ತಿಂಗಳಲ್ಲಿ","other":"{0} ತಿಂಗಳುಗಳಲ್ಲಿ"}},"week":{"previous":"ಕಳೆದ ವಾರ","current":"ಈ ವಾರ","next":"ಮುಂದಿನ ವಾರ","past":{"one":"{0} ವಾರದ ಹಿಂದೆ","other":"{0} ವಾರಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ವಾರದಲ್ಲಿ","other":"{0} ವಾರಗಳಲ್ಲಿ"}},"day":{"previous":"ನಿನ್ನೆ","previous-2":"ಮೊನ್ನೆ","current":"ಇಂದು","next":"ನಾಳೆ","next-2":"ನಾಡಿದ್ದು","past":{"one":"{0} ದಿನದ ಹಿಂದೆ","other":"{0} ದಿನಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ದಿನದಲ್ಲಿ","other":"{0} ದಿನಗಳಲ್ಲಿ"}},"hour":{"current":"ಈ ಗಂಟೆ","past":{"one":"{0} ಗಂಟೆ ಹಿಂದೆ","other":"{0} ಗಂಟೆಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ಗಂಟೆಯಲ್ಲಿ","other":"{0} ಗಂಟೆಗಳಲ್ಲಿ"}},"minute":{"current":"ಈ ನಿಮಿಷ","past":{"one":"{0} ನಿಮಿಷದ ಹಿಂದೆ","other":"{0} ನಿಮಿಷಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ನಿಮಿಷದಲ್ಲಿ","other":"{0} ನಿಮಿಷಗಳಲ್ಲಿ"}},"second":{"current":"ಈಗ","past":{"one":"{0} ಸೆಕೆಂಡ್ ಹಿಂದೆ","other":"{0} ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ಸೆಕೆಂಡ್‌ನಲ್ಲಿ","other":"{0} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ"}}},"narrow":{"year":{"previous":"ಕಳೆದ ವರ್ಷ","current":"ಈ ವರ್ಷ","next":"ಮುಂದಿನ ವರ್ಷ","past":{"one":"{0} ವರ್ಷದ ಹಿಂದೆ","other":"{0} ವರ್ಷಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ವರ್ಷದಲ್ಲಿ","other":"{0} ವರ್ಷಗಳಲ್ಲಿ"}},"quarter":{"previous":"ಕಳೆದ ತ್ರೈಮಾಸಿಕ","current":"ಈ ತ್ರೈಮಾಸಿಕ","next":"ಮುಂದಿನ ತ್ರೈಮಾಸಿಕ","past":{"one":"{0} ತ್ರೈ.ಮಾ. ಹಿಂದೆ","other":"{0} ತ್ರೈಮಾಸಿಕಗಳ ಹಿಂದೆ"},"future":"{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ"},"month":{"previous":"ಕಳೆದ ತಿಂಗಳು","current":"ಈ ತಿಂಗಳು","next":"ಮುಂದಿನ ತಿಂಗಳು","past":{"one":"{0} ತಿಂಗಳ ಹಿಂದೆ","other":"{0} ತಿಂಗಳುಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ತಿಂಗಳಲ್ಲಿ","other":"{0} ತಿಂಗಳುಗಳಲ್ಲಿ"}},"week":{"previous":"ಕಳೆದ ವಾರ","current":"ಈ ವಾರ","next":"ಮುಂದಿನ ವಾರ","past":{"one":"{0} ವಾರದ ಹಿಂದೆ","other":"{0} ವಾರಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ವಾರದಲ್ಲಿ","other":"{0} ವಾರಗಳಲ್ಲಿ"}},"day":{"previous":"ನಿನ್ನೆ","previous-2":"ಮೊನ್ನೆ","current":"ಇಂದು","next":"ನಾಳೆ","next-2":"ನಾಡಿದ್ದು","past":{"one":"{0} ದಿನದ ಹಿಂದೆ","other":"{0} ದಿನಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ದಿನದಲ್ಲಿ","other":"{0} ದಿನಗಳಲ್ಲಿ"}},"hour":{"current":"ಈ ಗಂಟೆ","past":{"one":"{0} ಗಂಟೆ ಹಿಂದೆ","other":"{0} ಗಂಟೆಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ಗಂಟೆಯಲ್ಲಿ","other":"{0} ಗಂಟೆಗಳಲ್ಲಿ"}},"minute":{"current":"ಈ ನಿಮಿಷ","past":{"one":"{0} ನಿಮಿಷದ ಹಿಂದೆ","other":"{0} ನಿಮಿಷಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ನಿಮಿಷದಲ್ಲಿ","other":"{0} ನಿಮಿಷಗಳಲ್ಲಿ"}},"second":{"current":"ಈಗ","past":{"one":"{0} ಸೆಕೆಂಡ್ ಹಿಂದೆ","other":"{0} ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ"},"future":{"one":"{0} ಸೆಕೆಂಡ್‌ನಲ್ಲಿ","other":"{0} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ"}}}}');

/***/ }),

/***/ 30497:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ko","long":{"year":{"previous":"작년","current":"올해","next":"내년","past":"{0}년 전","future":"{0}년 후"},"quarter":{"previous":"지난 분기","current":"이번 분기","next":"다음 분기","past":"{0}분기 전","future":"{0}분기 후"},"month":{"previous":"지난달","current":"이번 달","next":"다음 달","past":"{0}개월 전","future":"{0}개월 후"},"week":{"previous":"지난주","current":"이번 주","next":"다음 주","past":"{0}주 전","future":"{0}주 후"},"day":{"previous":"어제","previous-2":"그저께","current":"오늘","next":"내일","next-2":"모레","past":"{0}일 전","future":"{0}일 후"},"hour":{"current":"현재 시간","past":"{0}시간 전","future":"{0}시간 후"},"minute":{"current":"현재 분","past":"{0}분 전","future":"{0}분 후"},"second":{"current":"지금","past":"{0}초 전","future":"{0}초 후"}},"short":{"year":{"previous":"작년","current":"올해","next":"내년","past":"{0}년 전","future":"{0}년 후"},"quarter":{"previous":"지난 분기","current":"이번 분기","next":"다음 분기","past":"{0}분기 전","future":"{0}분기 후"},"month":{"previous":"지난달","current":"이번 달","next":"다음 달","past":"{0}개월 전","future":"{0}개월 후"},"week":{"previous":"지난주","current":"이번 주","next":"다음 주","past":"{0}주 전","future":"{0}주 후"},"day":{"previous":"어제","previous-2":"그저께","current":"오늘","next":"내일","next-2":"모레","past":"{0}일 전","future":"{0}일 후"},"hour":{"current":"현재 시간","past":"{0}시간 전","future":"{0}시간 후"},"minute":{"current":"현재 분","past":"{0}분 전","future":"{0}분 후"},"second":{"current":"지금","past":"{0}초 전","future":"{0}초 후"}},"narrow":{"year":{"previous":"작년","current":"올해","next":"내년","past":"{0}년 전","future":"{0}년 후"},"quarter":{"previous":"지난 분기","current":"이번 분기","next":"다음 분기","past":"{0}분기 전","future":"{0}분기 후"},"month":{"previous":"지난달","current":"이번 달","next":"다음 달","past":"{0}개월 전","future":"{0}개월 후"},"week":{"previous":"지난주","current":"이번 주","next":"다음 주","past":"{0}주 전","future":"{0}주 후"},"day":{"previous":"어제","previous-2":"그저께","current":"오늘","next":"내일","next-2":"모레","past":"{0}일 전","future":"{0}일 후"},"hour":{"current":"현재 시간","past":"{0}시간 전","future":"{0}시간 후"},"minute":{"current":"현재 분","past":"{0}분 전","future":"{0}분 후"},"second":{"current":"지금","past":"{0}초 전","future":"{0}초 후"}}}');

/***/ }),

/***/ 987:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"kok","long":{"year":{"previous":"फाटलें वर्स","current":"हें वर्स","next":"फुडलें वर्स","past":"{0} वर्सां आदीं","future":"{0} वर्सांनीं"},"quarter":{"previous":"फाटलो त्रैमासीक","current":"हो त्रैमासीक","next":"फुडलो त्रैमासीक","past":"{0} त्रैमासीकां आदीं","future":"{0} त्रैमासीकांत"},"month":{"previous":"फाटलो म्हयनो","current":"हो म्हयनो","next":"फुडलो म्हयनो","past":"{0} म्हयन्यां आदीं","future":"{0} म्हयन्यानीं"},"week":{"previous":"निमाणो सप्तक","current":"हो सप्तक","next":"फुडलो सप्तक","past":"{0} सप्तकां आदीं","future":"{0} सप्तकांनीं"},"day":{"previous":"काल","current":"आयज","next":"फाल्यां","past":"{0} दीस आदीं","future":"{0} दिसानीं"},"hour":{"current":"हें वर","past":"{0} वरा आदीं","future":"{0} वरांनीं"},"minute":{"current":"हें मिनीट","past":"{0} मिन्टां आदीं","future":"{0} मिन्टां"},"second":{"current":"आतां","past":"{0} सेकंद आदीं","future":"{0} सेकंदानीं"}},"short":{"year":{"previous":"फाटलें वर्स","current":"हें वर्स","next":"फुडलें वर्स","past":"{0} वर्स आदीं","future":"{0} वर्सांनीं"},"quarter":{"previous":"फाटलो त्रैमासीक","current":"हो त्रैमासीक","next":"फुडलो त्रैमासीक","past":"{0} त्रैमासीकां आदीं","future":"{0} त्रैमासीकांत"},"month":{"previous":"फाटलो म्हयनो","current":"हो म्हयनो","next":"फुडलो म्हयनो","past":"{0} म्हयन्यां आदीं","future":"{0} म्हयन्यानीं"},"week":{"previous":"निमाणो सप्तक","current":"हो सप्तक","next":"फुडलो सप्तक","past":"{0} सप्तकां आदीं","future":"{0} सप्त."},"day":{"previous":"काल","current":"आयज","next":"फाल्यां","past":"{0} दीस आदीं","future":"{0} दिसानीं"},"hour":{"current":"हें वर","past":"{0} वरा आदीं","future":"{0} वरांनीं"},"minute":{"current":"हें मिनीट","past":"{0} मिन्टां आदीं","future":"{0} मिन्टां"},"second":{"current":"आतां","past":"{0} से. आदीं","future":"{0} सेकंदानीं"}},"narrow":{"year":{"previous":"फाटलें वर्स","current":"हें वर्स","next":"फुडलें वर्स","past":"{0} वर्स आदीं","future":"{0} वर्सांनीं"},"quarter":{"previous":"फाटलो त्रैमासीक","current":"हो त्रैमासीक","next":"फुडलो त्रैमासीक","past":"{0} त्रैमासीकां आदीं","future":"{0} त्रैमासीकांत"},"month":{"previous":"फाटलो म्हयनो","current":"हो म्हयनो","next":"फुडलो म्हयनो","past":"{0} म्हयन्यां आदीं","future":"{0} म्हयन्यानीं"},"week":{"previous":"निमाणो सप्तक","current":"हो सप्तक","next":"फुडलो सप्तक","past":"{0} सप्त. आदीं","future":"{0} सप्तकांनीं"},"day":{"previous":"काल","current":"आयज","next":"फाल्यां","past":"{0} दीस आदीं","future":"{0} दिसानीं"},"hour":{"current":"हें वर","past":"{0} वरा आदीं","future":"{0} वरांनीं"},"minute":{"current":"हें मिनीट","past":"{0} मिन्टां आदीं","future":"{0} मिन्टां"},"second":{"current":"आतां","past":"{0} से. आदीं","future":"{0} सेकंदानीं"}}}');

/***/ }),

/***/ 83176:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ksh","long":{"year":{"previous":"läz Johr","current":"diß Johr","next":"näx Johr","past":{"zero":"vör keijnem Johr","one":"vör {0} Johr","other":"vör {0} Johre"},"future":{"zero":"en keinem Johr","one":"en {0} Johr","other":"en {0} Johre"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"lätzde Mohnd","current":"diese Mohnd","next":"nächste Mohnd","past":"-{0} m","future":"+{0} m"},"week":{"previous":"läz Woch","current":"di Woch","next":"nächste Woche","past":"-{0} w","future":"+{0} w"},"day":{"previous":"jestere","previous-2":"vörjestere","current":"hück","next":"morje","next-2":"övvermorje","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"läz Johr","current":"diß Johr","next":"näx Johr","past":{"zero":"vör keijnem Johr","one":"vör {0} Johr","other":"vör {0} Johre"},"future":{"zero":"en keinem Johr","one":"en {0} Johr","other":"en {0} Johre"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"lätzde Mohnd","current":"diese Mohnd","next":"nächste Mohnd","past":"-{0} m","future":"+{0} m"},"week":{"previous":"läz Woch","current":"di Woch","next":"nächste Woche","past":"-{0} w","future":"+{0} w"},"day":{"previous":"jestere","previous-2":"vörjestere","current":"hück","next":"morje","next-2":"övvermorje","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"läz Johr","current":"diß Johr","next":"näx Johr","past":{"zero":"vör keijnem Johr","one":"vör {0} Johr","other":"vör {0} Johre"},"future":{"zero":"en keinem Johr","one":"en {0} Johr","other":"en {0} Johre"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"lätzde Mohnd","current":"diese Mohnd","next":"nächste Mohnd","past":"-{0} m","future":"+{0} m"},"week":{"previous":"läz Woch","current":"di Woch","next":"nächste Woche","past":"-{0} w","future":"+{0} w"},"day":{"previous":"jestere","previous-2":"vörjestere","current":"hück","next":"morje","next-2":"övvermorje","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 4320:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ku","long":{"year":{"previous":"par","current":"îsal","next":"sala piştî","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"-{0} m","future":"+{0} m"},"week":{"previous":"last week","current":"this week","next":"next week","past":"-{0} w","future":"+{0} w"},"day":{"previous":"duh","current":"îro","next":"sibe","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"par","current":"îsal","next":"sala piştî","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"-{0} m","future":"+{0} m"},"week":{"previous":"last week","current":"this week","next":"next week","past":"-{0} w","future":"+{0} w"},"day":{"previous":"duh","current":"îro","next":"sibe","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"par","current":"îsal","next":"sala piştî","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"-{0} m","future":"+{0} m"},"week":{"previous":"last week","current":"this week","next":"next week","past":"-{0} w","future":"+{0} w"},"day":{"previous":"duh","current":"îro","next":"sibe","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 60387:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ky","long":{"year":{"previous":"былтыр","current":"быйыл","next":"эмдиги жылы","past":"{0} жыл мурун","future":"{0} жылдан кийин"},"quarter":{"previous":"акыркы чейрек","current":"бул чейрек","next":"кийинки чейрек","past":"{0} чейрек мурун","future":"{0} чейректен кийин"},"month":{"previous":"өткөн айда","current":"бул айда","next":"эмдиги айда","past":"{0} ай мурун","future":"{0} айдан кийин"},"week":{"previous":"өткөн аптада","current":"ушул аптада","next":"келерки аптада","past":"{0} апта мурун","future":"{0} аптадан кийин"},"day":{"previous":"кечээ","previous-2":"мурдагы күнү","current":"бүгүн","next":"эртең","next-2":"бүрсүгүнү","past":"{0} күн мурун","future":"{0} күндөн кийин"},"hour":{"current":"ушул саатта","past":"{0} саат мурун","future":"{0} сааттан кийин"},"minute":{"current":"ушул мүнөттө","past":"{0} мүнөт мурун","future":"{0} мүнөттөн кийин"},"second":{"current":"азыр","past":"{0} секунд мурун","future":"{0} секунддан кийин"}},"short":{"year":{"previous":"былтыр","current":"быйыл","next":"эмдиги жылы","past":"{0} жыл мурун","future":"{0} жыл. кийин"},"quarter":{"previous":"акыркы чейр.","current":"бул чейр.","next":"кийинки чейр.","past":"{0} чейр. мурун","future":"{0} чейректен кийин"},"month":{"previous":"өткөн айда","current":"бул айда","next":"эмдиги айда","past":"{0} ай мурун","future":"{0} айд. кийин"},"week":{"previous":"өткөн апт.","current":"ушул апт.","next":"келерки апт.","past":"{0} апт. мурун","future":"{0} апт. кийин"},"day":{"previous":"кечээ","previous-2":"мурдагы күнү","current":"бүгүн","next":"эртең","next-2":"бүрсүгүнү","past":"{0} күн мурун","future":"{0} күн. кийин"},"hour":{"current":"ушул саатта","past":"{0} саат. мурун","future":"{0} саат. кийин"},"minute":{"current":"ушул мүнөттө","past":"{0} мүн. мурун","future":"{0} мүн. кийин"},"second":{"current":"азыр","past":"{0} сек. мурун","future":"{0} сек. кийин"}},"narrow":{"year":{"previous":"былтыр","current":"быйыл","next":"эмдиги жылы","past":"{0} жыл мурун","future":"{0} жыл. кийин"},"quarter":{"previous":"акыркы чейр.","current":"бул чейр.","next":"кийинки чейр.","past":"{0} чейр. мурун","future":"{0} чейр. кийин"},"month":{"previous":"өткөн айда","current":"бул айда","next":"эмдиги айда","past":"{0} ай мурн","future":"{0} айд. кийн"},"week":{"previous":"өткөн апт.","current":"ушул апт.","next":"келерки апт.","past":"{0} апт. мурун","future":"{0} апт. кийин"},"day":{"previous":"кечээ","previous-2":"мурдагы күнү","current":"бүгүн","next":"эртең","next-2":"бүрсүгүнү","past":"{0} күн мурун","future":"{0} күн. кийин"},"hour":{"current":"ушул саатта","past":"{0} с. мурн","future":"{0} с. кийн"},"minute":{"current":"ушул мүнөттө","past":"{0} мүн. мурн","future":"{0} мүн. кийн"},"second":{"current":"азыр","past":"{0} сек. мурн","future":"{0} сек. кийн"}}}');

/***/ }),

/***/ 71202:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"lb","long":{"year":{"previous":"lescht Joer","current":"dëst Joer","next":"nächst Joer","past":{"one":"virun {0} Joer","other":"viru(n) {0} Joer"},"future":{"one":"an {0} Joer","other":"a(n) {0} Joer"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"virun {0} Quartal","other":"viru(n) {0} Quartaler"},"future":{"one":"an {0} Quartal","other":"a(n) {0} Quartaler"}},"month":{"previous":"leschte Mount","current":"dëse Mount","next":"nächste Mount","past":{"one":"virun {0} Mount","other":"viru(n) {0} Méint"},"future":{"one":"an {0} Mount","other":"a(n) {0} Méint"}},"week":{"previous":"lescht Woch","current":"dës Woch","next":"nächst Woch","past":{"one":"virun {0} Woch","other":"viru(n) {0} Wochen"},"future":{"one":"an {0} Woch","other":"a(n) {0} Wochen"}},"day":{"previous":"gëschter","current":"haut","next":"muer","past":{"one":"virun {0} Dag","other":"viru(n) {0} Deeg"},"future":{"one":"an {0} Dag","other":"a(n) {0} Deeg"}},"hour":{"current":"this hour","past":{"one":"virun {0} Stonn","other":"viru(n) {0} Stonnen"},"future":{"one":"an {0} Stonn","other":"a(n) {0} Stonnen"}},"minute":{"current":"this minute","past":{"one":"virun {0} Minutt","other":"viru(n) {0} Minutten"},"future":{"one":"an {0} Minutt","other":"a(n) {0} Minutten"}},"second":{"current":"now","past":{"one":"virun {0} Sekonn","other":"viru(n) {0} Sekonnen"},"future":{"one":"an {0} Sekonn","other":"a(n) {0} Sekonnen"}}},"short":{"year":{"previous":"lescht Joer","current":"dëst Joer","next":"nächst Joer","past":{"one":"virun {0} J.","other":"viru(n) {0} J."},"future":{"one":"an {0} J.","other":"a(n) {0} J."}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":{"one":"virun {0} Q.","other":"viru(n) {0} Q."},"future":{"one":"an {0} Q.","other":"a(n) {0} Q."}},"month":{"previous":"leschte Mount","current":"dëse Mount","next":"nächste Mount","past":{"one":"virun {0} M.","other":"viru(n) {0} M."},"future":{"one":"an {0} M.","other":"a(n) {0} M."}},"week":{"previous":"lescht Woch","current":"dës Woch","next":"nächst Woch","past":{"one":"virun {0} W.","other":"viru(n) {0} W."},"future":{"one":"an {0} W.","other":"a(n) {0} W."}},"day":{"previous":"gëschter","current":"haut","next":"muer","past":{"one":"virun {0} D.","other":"viru(n) {0} D."},"future":{"one":"an {0} D.","other":"a(n) {0} D."}},"hour":{"current":"this hour","past":{"one":"virun {0} St.","other":"viru(n) {0} St."},"future":{"one":"an {0} St.","other":"a(n) {0} St."}},"minute":{"current":"this minute","past":{"one":"virun {0} Min.","other":"viru(n) {0} Min."},"future":{"one":"an {0} Min.","other":"a(n) {0} Min."}},"second":{"current":"now","past":{"one":"virun {0} Sek.","other":"viru(n) {0} Sek."},"future":{"one":"an {0} Sek.","other":"a(n) {0} Sek."}}},"narrow":{"year":{"previous":"lescht Joer","current":"dëst Joer","next":"nächst Joer","past":"-{0} J.","future":"+{0} J."},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q.","future":"+{0} Q."},"month":{"previous":"leschte Mount","current":"dëse Mount","next":"nächste Mount","past":"-{0} M.","future":"+{0} M."},"week":{"previous":"lescht Woch","current":"dës Woch","next":"nächst Woch","past":"-{0} W.","future":"+{0} W."},"day":{"previous":"gëschter","current":"haut","next":"muer","past":"-{0} D.","future":"+{0} D."},"hour":{"current":"this hour","past":"-{0} St.","future":"+{0} St."},"minute":{"current":"this minute","past":"-{0} Min.","future":"+{0} Min."},"second":{"current":"now","past":"-{0} Sek.","future":"+{0} Sek."}}}');

/***/ }),

/***/ 40717:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"lkt","long":{"year":{"previous":"Ómakȟa kʼuŋ héhaŋ","current":"Lé ómakȟa kiŋ","next":"Tȟokáta ómakȟa kiŋháŋ","past":"Hékta ómakȟa {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ ómakȟa {0} kiŋháŋ"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Wí kʼuŋ héhaŋ","current":"Lé wí kiŋ","next":"Tȟokáta wí kiŋháŋ","past":"Hékta wíyawapi {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ wíyawapi {0} kiŋháŋ"},"week":{"previous":"Okó kʼuŋ héhaŋ","current":"Lé okó kiŋ","next":"Tȟokáta okó kiŋháŋ","past":"Hékta okó {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ okó {0} kiŋháŋ"},"day":{"previous":"Ȟtálehaŋ","current":"Lé aŋpétu kiŋ","next":"Híŋhaŋni kiŋháŋ","past":"Hékta {0}-čháŋ k’uŋ héhaŋ","future":"Letáŋhaŋ {0}-čháŋ kiŋháŋ"},"hour":{"current":"this hour","past":"Hékta owápȟe {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ owápȟe {0} kiŋháŋ"},"minute":{"current":"this minute","past":"Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ","future":"Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"},"second":{"current":"now","past":"Hékta okpí {0} k’uŋ héhaŋ","future":"Letáŋhaŋ okpí {0} kiŋháŋ"}},"short":{"year":{"previous":"Ómakȟa kʼuŋ héhaŋ","current":"Lé ómakȟa kiŋ","next":"Tȟokáta ómakȟa kiŋháŋ","past":"Hékta ómakȟa {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ ómakȟa {0} kiŋháŋ"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Wí kʼuŋ héhaŋ","current":"Lé wí kiŋ","next":"Tȟokáta wí kiŋháŋ","past":"Hékta wíyawapi {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ wíyawapi {0} kiŋháŋ"},"week":{"previous":"Okó kʼuŋ héhaŋ","current":"Lé okó kiŋ","next":"Tȟokáta okó kiŋháŋ","past":"Hékta okó {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ okó {0} kiŋháŋ"},"day":{"previous":"Ȟtálehaŋ","current":"Lé aŋpétu kiŋ","next":"Híŋhaŋni kiŋháŋ","past":"Hékta {0}-čháŋ k’uŋ héhaŋ","future":"Letáŋhaŋ {0}-čháŋ kiŋháŋ"},"hour":{"current":"this hour","past":"Hékta owápȟe {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ owápȟe {0} kiŋháŋ"},"minute":{"current":"this minute","past":"Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ","future":"Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"},"second":{"current":"now","past":"Hékta okpí {0} k’uŋ héhaŋ","future":"Letáŋhaŋ okpí {0} kiŋháŋ"}},"narrow":{"year":{"previous":"Ómakȟa kʼuŋ héhaŋ","current":"Lé ómakȟa kiŋ","next":"Tȟokáta ómakȟa kiŋháŋ","past":"Hékta ómakȟa {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ ómakȟa {0} kiŋháŋ"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Wí kʼuŋ héhaŋ","current":"Lé wí kiŋ","next":"Tȟokáta wí kiŋháŋ","past":"Hékta wíyawapi {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ wíyawapi {0} kiŋháŋ"},"week":{"previous":"Okó kʼuŋ héhaŋ","current":"Lé okó kiŋ","next":"Tȟokáta okó kiŋháŋ","past":"Hékta okó {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ okó {0} kiŋháŋ"},"day":{"previous":"Ȟtálehaŋ","current":"Lé aŋpétu kiŋ","next":"Híŋhaŋni kiŋháŋ","past":"Hékta {0}-čháŋ k’uŋ héhaŋ","future":"Letáŋhaŋ {0}-čháŋ kiŋháŋ"},"hour":{"current":"this hour","past":"Hékta owápȟe {0} kʼuŋ héhaŋ","future":"Letáŋhaŋ owápȟe {0} kiŋháŋ"},"minute":{"current":"this minute","past":"Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ","future":"Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"},"second":{"current":"now","past":"Hékta okpí {0} k’uŋ héhaŋ","future":"Letáŋhaŋ okpí {0} kiŋháŋ"}}}');

/***/ }),

/***/ 56881:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"lo","long":{"year":{"previous":"ປີກາຍ","current":"ປີນີ້","next":"ປີໜ້າ","past":"{0} ປີກ່ອນ","future":"ໃນອີກ {0} ປີ"},"quarter":{"previous":"ໄຕຣມາດກ່ອນໜ້າ","current":"ໄຕຣມາດນີ້","next":"ໄຕຣມາດໜ້າ","past":"{0} ໄຕຣມາດກ່ອນ","future":"ໃນອີກ {0} ໄຕຣມາດ"},"month":{"previous":"ເດືອນແລ້ວ","current":"ເດືອນນີ້","next":"ເດືອນໜ້າ","past":"{0} ເດືອນກ່ອນ","future":"ໃນອີກ {0} ເດືອນ"},"week":{"previous":"ອາທິດແລ້ວ","current":"ອາທິດນີ້","next":"ອາທິດໜ້າ","past":"{0} ອາທິດກ່ອນ","future":"ໃນອີກ {0} ອາທິດ"},"day":{"previous":"ມື້ວານ","previous-2":"ມື້ກ່ອນ","current":"ມື້ນີ້","next":"ມື້ອື່ນ","next-2":"ມື້ຮື","past":"{0} ມື້ກ່ອນ","future":"ໃນອີກ {0} ມື້"},"hour":{"current":"ຊົ່ວໂມງນີ້","past":"{0} ຊົ່ວໂມງກ່ອນ","future":"ໃນອີກ {0} ຊົ່ວໂມງ"},"minute":{"current":"ນາທີນີ້","past":"{0} ນາທີກ່ອນ","future":"{0} ໃນອີກ 0 ນາທີ"},"second":{"current":"ຕອນນີ້","past":"{0} ວິນາທີກ່ອນ","future":"ໃນອີກ {0} ວິນາທີ"}},"short":{"year":{"previous":"ປີກາຍ","current":"ປີນີ້","next":"ປີໜ້າ","past":"{0} ປີກ່ອນ","future":"ໃນອີກ {0} ປີ"},"quarter":{"previous":"ໄຕຣມາດກ່ອນໜ້າ","current":"ໄຕຣມາດນີ້","next":"ໄຕຣມາດໜ້າ","past":"{0} ຕມ. ກ່ອນ","future":"ໃນ {0} ຕມ."},"month":{"previous":"ເດືອນແລ້ວ","current":"ເດືອນນີ້","next":"ເດືອນໜ້າ","past":"{0} ດ. ກ່ອນ","future":"ໃນອີກ {0} ດ."},"week":{"previous":"ອາທິດແລ້ວ","current":"ອາທິດນີ້","next":"ອາທິດໜ້າ","past":"{0} ອທ. ກ່ອນ","future":"ໃນອີກ {0} ອທ."},"day":{"previous":"ມື້ວານ","previous-2":"ມື້ກ່ອນ","current":"ມື້ນີ້","next":"ມື້ອື່ນ","next-2":"ມື້ຮື","past":"{0} ມື້ກ່ອນ","future":"ໃນອີກ {0} ມື້"},"hour":{"current":"ຊົ່ວໂມງນີ້","past":"{0} ຊມ. ກ່ອນ","future":"ໃນອີກ {0} ຊມ."},"minute":{"current":"ນາທີນີ້","past":"{0} ນທ. ກ່ອນ","future":"ໃນ {0} ນທ."},"second":{"current":"ຕອນນີ້","past":"{0} ວິ. ກ່ອນ","future":"ໃນ {0} ວິ."}},"narrow":{"year":{"previous":"ປີກາຍ","current":"ປີນີ້","next":"ປີໜ້າ","past":"{0} ປີກ່ອນ","future":"ໃນອີກ {0} ປີ"},"quarter":{"previous":"ໄຕຣມາດກ່ອນໜ້າ","current":"ໄຕຣມາດນີ້","next":"ໄຕຣມາດໜ້າ","past":"{0} ຕມ. ກ່ອນ","future":"ໃນ {0} ຕມ."},"month":{"previous":"ເດືອນແລ້ວ","current":"ເດືອນນີ້","next":"ເດືອນໜ້າ","past":"{0} ດ. ກ່ອນ","future":"ໃນອີກ {0} ດ."},"week":{"previous":"ອາທິດແລ້ວ","current":"ອາທິດນີ້","next":"ອາທິດໜ້າ","past":"{0} ອທ. ກ່ອນ","future":"ໃນອີກ {0} ອທ."},"day":{"previous":"ມື້ວານ","previous-2":"ມື້ກ່ອນ","current":"ມື້ນີ້","next":"ມື້ອື່ນ","next-2":"ມື້ຮື","past":"{0} ມື້ກ່ອນ","future":"ໃນອີກ {0} ມື້"},"hour":{"current":"ຊົ່ວໂມງນີ້","past":"{0} ຊມ. ກ່ອນ","future":"ໃນອີກ {0} ຊມ."},"minute":{"current":"ນາທີນີ້","past":"{0} ນທ. ກ່ອນ","future":"ໃນ {0} ນທ."},"second":{"current":"ຕອນນີ້","past":"{0} ວິ. ກ່ອນ","future":"ໃນ {0} ວິ."}}}');

/***/ }),

/***/ 70291:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"lt","long":{"year":{"previous":"praėjusiais metais","current":"šiais metais","next":"kitais metais","past":{"one":"prieš {0} metus","few":"prieš {0} metus","other":"prieš {0} metų"},"future":"po {0} metų"},"quarter":{"previous":"praėjęs ketvirtis","current":"šis ketvirtis","next":"kitas ketvirtis","past":{"one":"prieš {0} ketvirtį","few":"prieš {0} ketvirčius","many":"prieš {0} ketvirčio","other":"prieš {0} ketvirčių"},"future":{"one":"po {0} ketvirčio","many":"po {0} ketvirčio","other":"po {0} ketvirčių"}},"month":{"previous":"praėjusį mėnesį","current":"šį mėnesį","next":"kitą mėnesį","past":{"one":"prieš {0} mėnesį","few":"prieš {0} mėnesius","many":"prieš {0} mėnesio","other":"prieš {0} mėnesių"},"future":{"one":"po {0} mėnesio","many":"po {0} mėnesio","other":"po {0} mėnesių"}},"week":{"previous":"praėjusią savaitę","current":"šią savaitę","next":"kitą savaitę","past":{"one":"prieš {0} savaitę","few":"prieš {0} savaites","many":"prieš {0} savaitės","other":"prieš {0} savaičių"},"future":{"one":"po {0} savaitės","many":"po {0} savaitės","other":"po {0} savaičių"}},"day":{"previous":"vakar","previous-2":"užvakar","current":"šiandien","next":"rytoj","next-2":"poryt","past":{"one":"prieš {0} dieną","few":"prieš {0} dienas","many":"prieš {0} dienos","other":"prieš {0} dienų"},"future":{"one":"po {0} dienos","many":"po {0} dienos","other":"po {0} dienų"}},"hour":{"current":"šią valandą","past":{"one":"prieš {0} valandą","few":"prieš {0} valandas","many":"prieš {0} valandos","other":"prieš {0} valandų"},"future":{"one":"po {0} valandos","many":"po {0} valandos","other":"po {0} valandų"}},"minute":{"current":"šią minutę","past":{"one":"prieš {0} minutę","few":"prieš {0} minutes","many":"prieš {0} minutės","other":"prieš {0} minučių"},"future":{"one":"po {0} minutės","many":"po {0} minutės","other":"po {0} minučių"}},"second":{"current":"dabar","past":{"one":"prieš {0} sekundę","few":"prieš {0} sekundes","many":"prieš {0} sekundės","other":"prieš {0} sekundžių"},"future":{"one":"po {0} sekundės","many":"po {0} sekundės","other":"po {0} sekundžių"}}},"short":{"year":{"previous":"praėjusiais metais","current":"šiais metais","next":"kitais metais","past":"prieš {0} m.","future":"po {0} m."},"quarter":{"previous":"praėjęs ketvirtis","current":"šis ketvirtis","next":"kitas ketvirtis","past":"prieš {0} ketv.","future":"po {0} ketv."},"month":{"previous":"praėjusį mėnesį","current":"šį mėnesį","next":"kitą mėnesį","past":"prieš {0} mėn.","future":"po {0} mėn."},"week":{"previous":"praėjusią savaitę","current":"šią savaitę","next":"kitą savaitę","past":"prieš {0} sav.","future":"po {0} sav."},"day":{"previous":"vakar","previous-2":"užvakar","current":"šiandien","next":"rytoj","next-2":"poryt","past":"prieš {0} d.","future":"po {0} d."},"hour":{"current":"šią valandą","past":"prieš {0} val.","future":"po {0} val."},"minute":{"current":"šią minutę","past":"prieš {0} min.","future":"po {0} min."},"second":{"current":"dabar","past":"prieš {0} sek.","future":"po {0} sek."}},"narrow":{"year":{"previous":"praėjusiais metais","current":"šiais metais","next":"kitais metais","past":"prieš {0} m.","future":"po {0} m."},"quarter":{"previous":"praėjęs ketvirtis","current":"šis ketvirtis","next":"kitas ketvirtis","past":"prieš {0} ketv.","future":"po {0} ketv."},"month":{"previous":"praėjusį mėnesį","current":"šį mėnesį","next":"kitą mėnesį","past":"prieš {0} mėn.","future":"po {0} mėn."},"week":{"previous":"praėjusią savaitę","current":"šią savaitę","next":"kitą savaitę","past":"prieš {0} sav.","future":"po {0} sav."},"day":{"previous":"vakar","previous-2":"užvakar","current":"šiandien","next":"rytoj","next-2":"poryt","past":"prieš {0} d.","future":"po {0} d."},"hour":{"current":"šią valandą","past":"prieš {0} val.","future":"po {0} val."},"minute":{"current":"šią minutę","past":"prieš {0} min.","future":"po {0} min."},"second":{"current":"dabar","past":"prieš {0} s","future":"po {0} s"}}}');

/***/ }),

/***/ 20337:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"lv","long":{"year":{"previous":"pagājušajā gadā","current":"šajā gadā","next":"nākamajā gadā","past":{"one":"pirms {0} gada","other":"pirms {0} gadiem"},"future":{"one":"pēc {0} gada","other":"pēc {0} gadiem"}},"quarter":{"previous":"pēdējais ceturksnis","current":"šis ceturksnis","next":"nākamais ceturksnis","past":{"one":"pirms {0} ceturkšņa","other":"pirms {0} ceturkšņiem"},"future":{"one":"pēc {0} ceturkšņa","other":"pēc {0} ceturkšņiem"}},"month":{"previous":"pagājušajā mēnesī","current":"šajā mēnesī","next":"nākamajā mēnesī","past":{"one":"pirms {0} mēneša","other":"pirms {0} mēnešiem"},"future":{"one":"pēc {0} mēneša","other":"pēc {0} mēnešiem"}},"week":{"previous":"pagājušajā nedēļā","current":"šajā nedēļā","next":"nākamajā nedēļā","past":{"one":"pirms {0} nedēļas","other":"pirms {0} nedēļām"},"future":{"one":"pēc {0} nedēļas","other":"pēc {0} nedēļām"}},"day":{"previous":"vakar","previous-2":"aizvakar","current":"šodien","next":"rīt","next-2":"parīt","past":{"one":"pirms {0} dienas","other":"pirms {0} dienām"},"future":{"one":"pēc {0} dienas","other":"pēc {0} dienām"}},"hour":{"current":"šajā stundā","past":{"one":"pirms {0} stundas","other":"pirms {0} stundām"},"future":{"one":"pēc {0} stundas","other":"pēc {0} stundām"}},"minute":{"current":"šajā minūtē","past":{"one":"pirms {0} minūtes","other":"pirms {0} minūtēm"},"future":{"one":"pēc {0} minūtes","other":"pēc {0} minūtēm"}},"second":{"current":"tagad","past":{"one":"pirms {0} sekundes","other":"pirms {0} sekundēm"},"future":{"one":"pēc {0} sekundes","other":"pēc {0} sekundēm"}}},"short":{"year":{"previous":"pagājušajā gadā","current":"šajā gadā","next":"nākamajā gadā","past":"pirms {0} g.","future":"pēc {0} g."},"quarter":{"previous":"pēdējais ceturksnis","current":"šis ceturksnis","next":"nākamais ceturksnis","past":"pirms {0} cet.","future":"pēc {0} cet."},"month":{"previous":"pagājušajā mēnesī","current":"šajā mēnesī","next":"nākamajā mēnesī","past":"pirms {0} mēn.","future":"pēc {0} mēn."},"week":{"previous":"pagājušajā nedēļā","current":"šajā nedēļā","next":"nākamajā nedēļā","past":"pirms {0} ned.","future":"pēc {0} ned."},"day":{"previous":"vakar","previous-2":"aizvakar","current":"šodien","next":"rīt","next-2":"parīt","past":{"one":"pirms {0} d.","other":"pirms {0} d."},"future":{"one":"pēc {0} d.","other":"pēc {0} d."}},"hour":{"current":"šajā stundā","past":"pirms {0} st.","future":"pēc {0} st."},"minute":{"current":"šajā minūtē","past":"pirms {0} min.","future":"pēc {0} min."},"second":{"current":"tagad","past":"pirms {0} sek.","future":"pēc {0} sek."}},"narrow":{"year":{"previous":"pagājušajā gadā","current":"šajā gadā","next":"nākamajā gadā","past":"pirms {0} g.","future":"pēc {0} g."},"quarter":{"previous":"pēdējais ceturksnis","current":"šis ceturksnis","next":"nākamais ceturksnis","past":"pirms {0} cet.","future":"pēc {0} cet."},"month":{"previous":"pagājušajā mēnesī","current":"šajā mēnesī","next":"nākamajā mēnesī","past":"pirms {0} mēn.","future":"pēc {0} mēn."},"week":{"previous":"pagājušajā nedēļā","current":"šajā nedēļā","next":"nākamajā nedēļā","past":"pirms {0} ned.","future":"pēc {0} ned."},"day":{"previous":"vakar","previous-2":"aizvakar","current":"šodien","next":"rīt","next-2":"parīt","past":{"one":"pirms {0} d.","other":"pirms {0} d."},"future":{"one":"pēc {0} d.","other":"pēc {0} d."}},"hour":{"current":"šajā stundā","past":"pirms {0} h","future":"pēc {0} h"},"minute":{"current":"šajā minūtē","past":"pirms {0} min","future":{"one":"pēc {0} min","other":"pēc {0} min"}},"second":{"current":"tagad","past":{"one":"pirms {0} s","other":"pirms {0} s"},"future":"pēc {0} s"}}}');

/***/ }),

/***/ 21219:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"mk","long":{"year":{"previous":"минатата година","current":"оваа година","next":"следната година","past":{"one":"пред {0} година","other":"пред {0} години"},"future":{"one":"за {0} година","other":"за {0} години"}},"quarter":{"previous":"последното тромесечје","current":"ова тромесечје","next":"следното тромесечје","past":{"one":"пред {0} тромесечје","other":"пред {0} тромесечја"},"future":{"one":"за {0} тромесечје","other":"за {0} тромесечја"}},"month":{"previous":"минатиот месец","current":"овој месец","next":"следниот месец","past":{"one":"пред {0} месец","other":"пред {0} месеци"},"future":{"one":"за {0} месец","other":"за {0} месеци"}},"week":{"previous":"минатата седмица","current":"оваа седмица","next":"следната седмица","past":{"one":"пред {0} седмица","other":"пред {0} седмици"},"future":{"one":"за {0} седмица","other":"за {0} седмици"}},"day":{"previous":"вчера","previous-2":"завчера","current":"денес","next":"утре","next-2":"задутре","past":{"one":"пред {0} ден","other":"пред {0} дена"},"future":{"one":"за {0} ден","other":"за {0} дена"}},"hour":{"current":"часов","past":{"one":"пред {0} час","other":"пред {0} часа"},"future":{"one":"за {0} час","other":"за {0} часа"}},"minute":{"current":"оваа минута","past":{"one":"пред {0} минута","other":"пред {0} минути"},"future":{"one":"за {0} минута","other":"за {0} минути"}},"second":{"current":"сега","past":{"one":"пред {0} секунда","other":"пред {0} секунди"},"future":{"one":"за {0} секунда","other":"за {0} секунди"}}},"short":{"year":{"previous":"минатата година","current":"оваа година","next":"следната година","past":"пред {0} год.","future":"за {0} год."},"quarter":{"previous":"последното тромесечје","current":"ова тромесечје","next":"следното тромесечје","past":"пред {0} тромес.","future":"за {0} тромес."},"month":{"previous":"минатиот месец","current":"овој месец","next":"следниот месец","past":{"one":"пред {0} месец","other":"пред {0} месеци"},"future":{"one":"за {0} месец","other":"за {0} месеци"}},"week":{"previous":"минатата седмица","current":"оваа седмица","next":"следната седмица","past":{"one":"пред {0} седмица","other":"пред {0} седмици"},"future":{"one":"за {0} седмица","other":"за {0} седмици"}},"day":{"previous":"вчера","previous-2":"завчера","current":"денес","next":"утре","next-2":"задутре","past":{"one":"пред {0} ден","other":"пред {0} дена"},"future":{"one":"за {0} ден","other":"за {0} дена"}},"hour":{"current":"часов","past":{"one":"пред {0} час","other":"пред {0} часа"},"future":{"one":"за {0} час","other":"за {0} часа"}},"minute":{"current":"оваа минута","past":"пред {0} мин.","future":"за {0} мин."},"second":{"current":"сега","past":"пред {0} сек.","future":"за {0} сек."}},"narrow":{"year":{"previous":"минатата година","current":"оваа година","next":"следната година","past":"пред {0} год.","future":"за {0} год."},"quarter":{"previous":"последното тромесечје","current":"ова тромесечје","next":"следното тромесечје","past":"пред {0} тромес.","future":"за {0} тромес."},"month":{"previous":"минатиот месец","current":"овој месец","next":"следниот месец","past":{"one":"пред {0} месец","other":"пред {0} месеци"},"future":{"one":"за {0} месец","other":"за {0} месеци"}},"week":{"previous":"минатата седмица","current":"оваа седмица","next":"следната седмица","past":{"one":"пред {0} седмица","other":"пред {0} седмици"},"future":{"one":"за {0} седмица","other":"за {0} седмици"}},"day":{"previous":"вчера","previous-2":"завчера","current":"денес","next":"утре","next-2":"задутре","past":{"one":"пред {0} ден","other":"пред {0} дена"},"future":{"one":"за {0} ден","other":"за {0} дена"}},"hour":{"current":"часов","past":{"one":"пред {0} час","other":"пред {0} часа"},"future":{"one":"за {0} час","other":"за {0} часа"}},"minute":{"current":"оваа минута","past":"пред {0} мин.","future":"за {0} мин."},"second":{"current":"сега","past":"пред {0} сек.","future":"за {0} сек."}}}');

/***/ }),

/***/ 76413:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ml","long":{"year":{"previous":"കഴിഞ്ഞ വർഷം","current":"ഈ വർ‌ഷം","next":"അടുത്തവർഷം","past":"{0} വർഷം മുമ്പ്","future":"{0} വർഷത്തിൽ"},"quarter":{"previous":"കഴിഞ്ഞ പാദം","current":"ഈ പാദം","next":"അടുത്ത പാദം","past":"{0} പാദം മുമ്പ്","future":"{0} പാദത്തിൽ"},"month":{"previous":"കഴിഞ്ഞ മാസം","current":"ഈ മാസം","next":"അടുത്ത മാസം","past":"{0} മാസം മുമ്പ്","future":"{0} മാസത്തിൽ"},"week":{"previous":"കഴിഞ്ഞ ആഴ്‌ച","current":"ഈ ആഴ്ച","next":"അടുത്ത ആഴ്ച","past":"{0} ആഴ്ച മുമ്പ്","future":"{0} ആഴ്ചയിൽ"},"day":{"previous":"ഇന്നലെ","previous-2":"മിനിഞ്ഞാന്ന്","current":"ഇന്ന്","next":"നാളെ","next-2":"മറ്റന്നാൾ","past":"{0} ദിവസം മുമ്പ്","future":"{0} ദിവസത്തിൽ"},"hour":{"current":"ഈ മണിക്കൂറിൽ","past":"{0} മണിക്കൂർ മുമ്പ്","future":"{0} മണിക്കൂറിൽ"},"minute":{"current":"ഈ മിനിറ്റിൽ","past":"{0} മിനിറ്റ് മുമ്പ്","future":"{0} മിനിറ്റിൽ"},"second":{"current":"ഇപ്പോൾ","past":"{0} സെക്കൻഡ് മുമ്പ്","future":"{0} സെക്കൻഡിൽ"}},"short":{"year":{"previous":"കഴിഞ്ഞ വർഷം","current":"ഈ വർ‌ഷം","next":"അടുത്തവർഷം","past":"{0} വർഷം മുമ്പ്","future":"{0} വർഷത്തിൽ"},"quarter":{"previous":"കഴിഞ്ഞ പാദം","current":"ഈ പാദം","next":"അടുത്ത പാദം","past":"{0} പാദം മുമ്പ്","future":"{0} പാദത്തിൽ"},"month":{"previous":"കഴിഞ്ഞ മാസം","current":"ഈ മാസം","next":"അടുത്ത മാസം","past":"{0} മാസം മുമ്പ്","future":"{0} മാസത്തിൽ"},"week":{"previous":"കഴിഞ്ഞ ആഴ്‌ച","current":"ഈ ആഴ്ച","next":"അടുത്ത ആഴ്ച","past":"{0} ആഴ്ച മുമ്പ്","future":"{0} ആഴ്ചയിൽ"},"day":{"previous":"ഇന്നലെ","previous-2":"മിനിഞ്ഞാന്ന്","current":"ഇന്ന്","next":"നാളെ","next-2":"മറ്റന്നാൾ","past":"{0} ദിവസം മുമ്പ്","future":"{0} ദിവസത്തിൽ"},"hour":{"current":"ഈ മണിക്കൂറിൽ","past":"{0} മണിക്കൂർ മുമ്പ്","future":"{0} മണിക്കൂറിൽ"},"minute":{"current":"ഈ മിനിറ്റിൽ","past":"{0} മിനിറ്റ് മുമ്പ്","future":"{0} മിനിറ്റിൽ"},"second":{"current":"ഇപ്പോൾ","past":"{0} സെക്കൻഡ് മുമ്പ്","future":"{0} സെക്കൻഡിൽ"}},"narrow":{"year":{"previous":"കഴിഞ്ഞ വർഷം","current":"ഈ വർ‌ഷം","next":"അടുത്തവർഷം","past":"{0} വർഷം മുമ്പ്","future":"{0} വർഷത്തിൽ"},"quarter":{"previous":"കഴിഞ്ഞ പാദം","current":"ഈ പാദം","next":"അടുത്ത പാദം","past":"{0} പാദം മുമ്പ്","future":"{0} പാദത്തിൽ"},"month":{"previous":"കഴിഞ്ഞ മാസം","current":"ഈ മാസം","next":"അടുത്ത മാസം","past":"{0} മാസം മുമ്പ്","future":"{0} മാസത്തിൽ"},"week":{"previous":"കഴിഞ്ഞ ആഴ്‌ച","current":"ഈ ആഴ്ച","next":"അടുത്ത ആഴ്ച","past":"{0} ആഴ്ച മുമ്പ്","future":"{0} ആഴ്ചയിൽ"},"day":{"previous":"ഇന്നലെ","previous-2":"മിനിഞ്ഞാന്ന്","current":"ഇന്ന്","next":"നാളെ","next-2":"മറ്റന്നാൾ","past":"{0} ദിവസം മുമ്പ്","future":"{0} ദിവസത്തിൽ"},"hour":{"current":"ഈ മണിക്കൂറിൽ","past":"{0} മണിക്കൂർ മുമ്പ്","future":"{0} മണിക്കൂറിൽ"},"minute":{"current":"ഈ മിനിറ്റിൽ","past":"{0} മിനിറ്റ് മുമ്പ്","future":"{0} മിനിറ്റിൽ"},"second":{"current":"ഇപ്പോൾ","past":"{0} സെക്കൻഡ് മുമ്പ്","future":"{0} സെക്കൻഡിൽ"}}}');

/***/ }),

/***/ 6978:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"mn","long":{"year":{"previous":"өнгөрсөн жил","current":"энэ жил","next":"ирэх жил","past":"{0} жилийн өмнө","future":"{0} жилийн дараа"},"quarter":{"previous":"өнгөрсөн улирал","current":"энэ улирал","next":"дараагийн улирал","past":"{0} улирлын өмнө","future":"{0} улирлын дараа"},"month":{"previous":"өнгөрсөн сар","current":"энэ сар","next":"ирэх сар","past":"{0} сарын өмнө","future":"{0} сарын дараа"},"week":{"previous":"өнгөрсөн долоо хоног","current":"энэ долоо хоног","next":"ирэх долоо хоног","past":"{0} долоо хоногийн өмнө","future":"{0} долоо хоногийн дараа"},"day":{"previous":"өчигдөр","previous-2":"уржигдар","current":"өнөөдөр","next":"маргааш","next-2":"нөгөөдөр","past":"{0} өдрийн өмнө","future":"{0} өдрийн дараа"},"hour":{"current":"энэ цаг","past":"{0} цагийн өмнө","future":"{0} цагийн дараа"},"minute":{"current":"энэ минут","past":"{0} минутын өмнө","future":"{0} минутын дараа"},"second":{"current":"одоо","past":"{0} секундын өмнө","future":"{0} секундын дараа"}},"short":{"year":{"previous":"өнгөрсөн жил","current":"энэ жил","next":"ирэх жил","past":"{0} жилийн өмнө","future":"{0} жилийн дараа"},"quarter":{"previous":"өнгөрсөн улирал","current":"энэ улирал","next":"дараагийн улирал","past":"{0} улирлын өмнө","future":"{0} улирлын дараа"},"month":{"previous":"өнгөрсөн сар","current":"энэ сар","next":"ирэх сар","past":"{0} сарын өмнө","future":"{0} сарын дараа"},"week":{"previous":"өнгөрсөн долоо хоног","current":"энэ долоо хоног","next":"ирэх долоо хоног","past":"{0} 7 хоногийн өмнө","future":"{0} 7 хоногийн дараа"},"day":{"previous":"өчигдөр","previous-2":"уржигдар","current":"өнөөдөр","next":"маргааш","next-2":"нөгөөдөр","past":"{0} өдрийн өмнө","future":"{0} өдрийн дараа"},"hour":{"current":"энэ цаг","past":"{0} ц өмнө","future":"{0} ц дараа"},"minute":{"current":"энэ минут","past":"{0} мин өмнө","future":"{0} мин дараа"},"second":{"current":"одоо","past":"{0} сек өмнө","future":"{0} сек дараа"}},"narrow":{"year":{"previous":"өнгөрсөн жил","current":"энэ жил","next":"ирэх жил","past":"{0} жилийн өмнө","future":"{0} жилийн дараа"},"quarter":{"previous":"өнгөрсөн улирал","current":"энэ улирал","next":"дараагийн улирал","past":"{0} улирлын өмнө","future":"{0} улирлын дараа"},"month":{"previous":"өнгөрсөн сар","current":"энэ сар","next":"ирэх сар","past":"{0} сарын өмнө","future":"{0} сарын дараа"},"week":{"previous":"өнгөрсөн долоо хоног","current":"энэ долоо хоног","next":"ирэх долоо хоног","past":"{0} 7 хоногийн өмнө","future":"{0} 7 хоногийн дараа"},"day":{"previous":"өчигдөр","previous-2":"уржигдар","current":"өнөөдөр","next":"маргааш","next-2":"нөгөөдөр","past":"{0} өдрийн өмнө","future":"{0} өдрийн дараа"},"hour":{"current":"энэ цаг","past":"{0} ц өмнө","future":"{0} ц дараа"},"minute":{"current":"энэ минут","past":"{0} мин өмнө","future":"{0} мин дараа"},"second":{"current":"одоо","past":"{0} сек өмнө","future":"{0} сек дараа"}}}');

/***/ }),

/***/ 33456:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"mr","long":{"year":{"previous":"मागील वर्ष","current":"हे वर्ष","next":"पुढील वर्ष","past":{"one":"{0} वर्षापूर्वी","other":"{0} वर्षांपूर्वी"},"future":{"one":"येत्या {0} वर्षामध्ये","other":"येत्या {0} वर्षांमध्ये"}},"quarter":{"previous":"मागील तिमाही","current":"ही तिमाही","next":"पुढील तिमाही","past":{"one":"{0} तिमाहीपूर्वी","other":"{0} तिमाहींपूर्वी"},"future":{"one":"{0} तिमाहीमध्ये","other":"{0} तिमाहींमध्ये"}},"month":{"previous":"मागील महिना","current":"हा महिना","next":"पुढील महिना","past":{"one":"{0} महिन्यापूर्वी","other":"{0} महिन्यांपूर्वी"},"future":{"one":"येत्या {0} महिन्यामध्ये","other":"येत्या {0} महिन्यांमध्ये"}},"week":{"previous":"मागील आठवडा","current":"हा आठवडा","next":"पुढील आठवडा","past":{"one":"{0} आठवड्यापूर्वी","other":"{0} आठवड्यांपूर्वी"},"future":{"one":"{0} आठवड्यामध्ये","other":"{0} आठवड्यांमध्ये"}},"day":{"previous":"काल","current":"आज","next":"उद्या","past":{"one":"{0} दिवसापूर्वी","other":"{0} दिवसांपूर्वी"},"future":{"one":"येत्या {0} दिवसामध्ये","other":"येत्या {0} दिवसांमध्ये"}},"hour":{"current":"तासात","past":{"one":"{0} तासापूर्वी","other":"{0} तासांपूर्वी"},"future":{"one":"{0} तासामध्ये","other":"{0} तासांमध्ये"}},"minute":{"current":"या मिनिटात","past":{"one":"{0} मिनिटापूर्वी","other":"{0} मिनिटांपूर्वी"},"future":{"one":"{0} मिनिटामध्ये","other":"{0} मिनिटांमध्ये"}},"second":{"current":"आत्ता","past":{"one":"{0} सेकंदापूर्वी","other":"{0} सेकंदांपूर्वी"},"future":{"one":"{0} सेकंदामध्ये","other":"{0} सेकंदांमध्ये"}}},"short":{"year":{"previous":"मागील वर्ष","current":"हे वर्ष","next":"पुढील वर्ष","past":{"one":"{0} वर्षापूर्वी","other":"{0} वर्षांपूर्वी"},"future":{"one":"{0} वर्षामध्ये","other":"{0} वर्षांमध्ये"}},"quarter":{"previous":"मागील तिमाही","current":"ही तिमाही","next":"पुढील तिमाही","past":{"one":"{0} तिमाहीपूर्वी","other":"{0} तिमाहींपूर्वी"},"future":{"one":"येत्या {0} तिमाहीमध्ये","other":"येत्या {0} तिमाहींमध्ये"}},"month":{"previous":"मागील महिना","current":"हा महिना","next":"पुढील महिना","past":{"one":"{0} महिन्यापूर्वी","other":"{0} महिन्यांपूर्वी"},"future":"{0} महिन्यामध्ये"},"week":{"previous":"मागील आठवडा","current":"हा आठवडा","next":"पुढील आठवडा","past":{"one":"{0} आठवड्यापूर्वी","other":"{0} आठवड्यांपूर्वी"},"future":{"one":"येत्या {0} आठवड्यामध्ये","other":"येत्या {0} आठवड्यांमध्ये"}},"day":{"previous":"काल","current":"आज","next":"उद्या","past":{"one":"{0} दिवसापूर्वी","other":"{0} दिवसांपूर्वी"},"future":{"one":"{0} दिवसामध्ये","other":"येत्या {0} दिवसांमध्ये"}},"hour":{"current":"तासात","past":{"one":"{0} तासापूर्वी","other":"{0} तासांपूर्वी"},"future":{"one":"{0} तासामध्ये","other":"{0} तासांमध्ये"}},"minute":{"current":"या मिनिटात","past":"{0} मिनि. पूर्वी","future":"{0} मिनि. मध्ये"},"second":{"current":"आत्ता","past":"{0} से. पूर्वी","future":"{0} से. मध्ये"}},"narrow":{"year":{"previous":"मागील वर्ष","current":"हे वर्ष","next":"पुढील वर्ष","past":{"one":"{0} वर्षापूर्वी","other":"{0} वर्षांपूर्वी"},"future":{"one":"येत्या {0} वर्षामध्ये","other":"येत्या {0} वर्षांमध्ये"}},"quarter":{"previous":"मागील तिमाही","current":"ही तिमाही","next":"पुढील तिमाही","past":{"one":"{0} तिमाहीपूर्वी","other":"{0} तिमाहींपूर्वी"},"future":{"one":"{0} तिमाहीमध्ये","other":"{0} तिमाहींमध्ये"}},"month":{"previous":"मागील महिना","current":"हा महिना","next":"पुढील महिना","past":{"one":"{0} महिन्यापूर्वी","other":"{0} महिन्यांपूर्वी"},"future":{"one":"{0} महिन्यामध्ये","other":"{0} महिन्यांमध्ये"}},"week":{"previous":"मागील आठवडा","current":"हा आठवडा","next":"पुढील आठवडा","past":{"one":"{0} आठवड्यापूर्वी","other":"{0} आठवड्यांपूर्वी"},"future":{"one":"येत्या {0} आठवड्यामध्ये","other":"येत्या {0} आठवड्यांमध्ये"}},"day":{"previous":"काल","current":"आज","next":"उद्या","past":{"one":"{0} दिवसापूर्वी","other":"{0} दिवसांपूर्वी"},"future":{"one":"{0} दिवसामध्ये","other":"{0} दिवसांमध्ये"}},"hour":{"current":"तासात","past":{"one":"{0} तासापूर्वी","other":"{0} तासांपूर्वी"},"future":{"one":"येत्या {0} तासामध्ये","other":"येत्या {0} तासांमध्ये"}},"minute":{"current":"या मिनिटात","past":"{0} मिनि. पूर्वी","future":"{0} मिनि. मध्ये"},"second":{"current":"आत्ता","past":"{0} से. पूर्वी","future":{"one":"{0} से. मध्ये","other":"येत्या {0} से. मध्ये"}}}}');

/***/ }),

/***/ 78233:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ms","long":{"year":{"previous":"tahun lalu","current":"tahun ini","next":"tahun depan","past":"{0} tahun lalu","future":"dalam {0} tahun"},"quarter":{"previous":"suku tahun lalu","current":"suku tahun ini","next":"suku tahun seterusnya","past":"{0} suku tahun lalu","future":"dalam {0} suku tahun"},"month":{"previous":"bulan lalu","current":"bulan ini","next":"bulan depan","past":"{0} bulan lalu","future":"dalam {0} bulan"},"week":{"previous":"minggu lalu","current":"minggu ini","next":"minggu depan","past":"{0} minggu lalu","future":"dalam {0} minggu"},"day":{"previous":"semalam","previous-2":"kelmarin","current":"hari ini","next":"esok","next-2":"lusa","past":"{0} hari lalu","future":"dalam {0} hari"},"hour":{"current":"jam ini","past":"{0} jam lalu","future":"dalam {0} jam"},"minute":{"current":"pada minit ini","past":"{0} minit lalu","future":"dalam {0} minit"},"second":{"current":"sekarang","past":"{0} saat lalu","future":"dalam {0} saat"}},"short":{"year":{"previous":"thn lepas","current":"thn ini","next":"thn depan","past":"{0} thn lalu","future":"dalam {0} thn"},"quarter":{"previous":"suku lepas","current":"suku ini","next":"suku seterusnya","past":"{0} suku thn lalu","future":"dlm {0} suku thn"},"month":{"previous":"bln lalu","current":"bln ini","next":"bln depan","past":"{0} bln lalu","future":"dlm {0} bln"},"week":{"previous":"mng lepas","current":"mng ini","next":"mng depan","past":"{0} mgu lalu","future":"dlm {0} mgu"},"day":{"previous":"semlm","previous-2":"kelmarin","current":"hari ini","next":"esok","next-2":"lusa","past":"{0} hari lalu","future":"dlm {0} hari"},"hour":{"current":"jam ini","past":"{0} jam lalu","future":"dlm {0} jam"},"minute":{"current":"pada minit ini","past":"{0} min lalu","future":"dlm {0} min"},"second":{"current":"sekarang","past":"{0} saat lalu","future":"dlm {0} saat"}},"narrow":{"year":{"previous":"thn lepas","current":"thn ini","next":"thn depan","past":"{0} thn lalu","future":"dalam {0} thn"},"quarter":{"previous":"suku lepas","current":"suku ini","next":"suku seterusnya","past":"{0} suku thn lalu","future":"dlm {0} suku thn"},"month":{"previous":"bln lalu","current":"bln ini","next":"bln depan","past":"{0} bulan lalu","future":"dlm {0} bln"},"week":{"previous":"mng lepas","current":"mng ini","next":"mng depan","past":"{0} mgu lalu","future":"dlm {0} mgu"},"day":{"previous":"semlm","previous-2":"kelmarin","current":"hari ini","next":"esok","next-2":"lusa","past":"{0} hari lalu","future":"dlm {0} hari"},"hour":{"current":"jam ini","past":"{0} jam lalu","future":"dlm {0} jam"},"minute":{"current":"pada minit ini","past":"{0} min lalu","future":"dlm {0} min"},"second":{"current":"sekarang","past":"{0} saat lalu","future":"dlm {0} saat"}}}');

/***/ }),

/***/ 21205:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"mt","long":{"year":{"previous":"is-sena l-oħra","current":"din is-sena","next":"is-sena d-dieħla","past":{"one":"sena ilu","other":"{0} snin ilu"},"future":{"one":"fi żmien sena","other":"fi żmien {0} snin oħra"}},"quarter":{"previous":"il-kwart ta’ sena li għadda","current":"il-kwart ta’ sena li qegħdin fih","next":"il-kwart li jmiss tas-sena","past":{"one":"il-kwart ta’ sena li għadda","other":"{0} kwarti ta’ sena li għaddew"},"future":"f’{0} kwarti ta’ sena oħrajn"},"month":{"previous":"Ix-xahar li għadda","current":"Dan ix-xahar","next":"Ix-xahar id-dieħel","past":{"one":"xahar ilu","other":"{0} xhur ilu"},"future":{"one":"sa xahar ieħor","other":"fi {0} xhur oħra"}},"week":{"previous":"il-ġimgħa li għaddiet","current":"din il-ġimgħa","next":"il-ġimgħa d-dieħla","past":{"one":"ġimgħa ilu","other":"{0} ġimgħat ilu"},"future":{"one":"sa ġimgħa oħra","other":"sa {0} ġimgħat oħra"}},"day":{"previous":"lbieraħ","current":"illum","next":"għada","past":{"one":"ġurnata ilu","few":"{0} ġranet ilu","other":"{0}-il ġurnata ilu"},"future":{"one":"fi żmien ġurnata","other":"fi żmien {0} ġurnata oħra"}},"hour":{"current":"din is-siegħa","past":{"one":"siegħa ilu","other":"{0} sigħat ilu"},"future":{"one":"fi żmien siegħa oħra","many":"fi żmien{0} sigħat","other":"fi żmien {0} sigħat"}},"minute":{"current":"din il-minuta","past":{"one":"minuta ilu","other":"{0} minuti ilu"},"future":{"one":"sa minuta oħra","other":"sa {0} minuti oħra"}},"second":{"current":"issa","past":{"one":"sekonda ilu","other":"{0} sekondi ilu"},"future":"sa {0} sekondi oħra"}},"short":{"year":{"previous":"is-sena l-oħra","current":"din is-sena","next":"is-sena d-dieħla","past":{"one":"sa sena ilu","other":"{0} snin ilu"},"future":{"one":"fi żmien sena","other":"fi żmien {0} snin oħra"}},"quarter":{"previous":"il-kwart ta’ sena li għadda","current":"il-kwart ta’ sena li qegħdin fih","next":"il-kwart li jmiss tas-sena","past":{"one":"fil-kwart tas-sena li għadda","other":"{0} kwarti ta’ sena ilu"},"future":{"one":"fil-kwart tas-sena li ġej","other":"f’{0} kwarti ta’ sena oħrajn"}},"month":{"previous":"Ix-xahar li għadda","current":"Dan ix-xahar","next":"Ix-xahar id-dieħel","past":{"one":"{0} xahar ilu","other":"{0} xhur ilu"},"future":{"one":"sa xahar ieħor","other":"sa {0} xhur oħra"}},"week":{"previous":"il-ġimgħa li għaddiet","current":"din il-ġimgħa","next":"il-ġimgħa d-dieħla","past":{"one":"ġimgħa ilu","other":"{0} ġimgħat ilu"},"future":{"one":"sa ġimgħa oħra","few":"sa {0} ġimgħat oħra","many":"sa {0} ġimgħat oħra","other":"+{0} w"}},"day":{"previous":"lbieraħ","current":"illum","next":"għada","past":{"one":"ġurnata ilu","few":"{0} ġranet ilu","other":"{0}-il ġurnata ilu"},"future":{"one":"fi żmien ġurnata","other":"fi żmien {0} ġurnata oħra"}},"hour":{"current":"din is-siegħa","past":{"one":"siegħa ilu","other":"{0} sigħat ilu"},"future":{"one":"fi żmien siegħa oħra","many":"+{0} h","other":"fi żmien {0} sigħat"}},"minute":{"current":"din il-minuta","past":{"one":"min. ilu","many":"{0} minuti ilu","other":"{0} min. ilu"},"future":{"one":"sa min. oħra","other":"sa {0} min. oħra"}},"second":{"current":"issa","past":{"one":"sek. ilu","other":"{0} sek. ilu"},"future":{"few":"sa {0} sek. oħra","many":"sa {0} sek. oħra","other":"sa {0} sekondi oħra"}}},"narrow":{"year":{"previous":"is-sena l-oħra","current":"din is-sena","next":"is-sena d-dieħla","past":{"one":"sena ilu","other":"{0} snin ilu"},"future":{"one":"fi żmien sena","other":"fi żmien {0} snin oħra"}},"quarter":{"previous":"il-kwart ta’ sena li għadda","current":"il-kwart ta’ sena li qegħdin fih","next":"il-kwart li jmiss tas-sena","past":{"one":"fil-kwart tas-sena li għadda","other":"{0} kwarti ta’ sena ilu"},"future":{"one":"fi kwart ta’ sena ieħor","other":"f’{0} kwarti ta’ sena oħrajn"}},"month":{"previous":"Ix-xahar li għadda","current":"Dan ix-xahar","next":"Ix-xahar id-dieħel","past":{"one":"xahar ilu","other":"{0} xhur ilu"},"future":{"one":"sa xahar ieħor","other":"sa {0} xhur oħra"}},"week":{"previous":"il-ġimgħa li għaddiet","current":"din il-ġimgħa","next":"il-ġimgħa d-dieħla","past":{"one":"ġimgħa ilu","other":"{0} ġimgħat ilu"},"future":{"one":"sa ġimgħa oħra","other":"sa {0} ġimgħat oħra"}},"day":{"previous":"lbieraħ","current":"illum","next":"għada","past":{"one":"ġurnata ilu","few":"{0} ġranet ilu","other":"{0}-il ġurnata ilu"},"future":{"one":"fi żmien ġurnata","other":"fi żmien {0} ġurnata oħra"}},"hour":{"current":"din is-siegħa","past":{"one":"siegħa ilu","other":"{0} sigħat ilu"},"future":{"one":"fi żmien siegħa oħra","other":"fi żmien {0} sigħat"}},"minute":{"current":"din il-minuta","past":{"one":"min. ilu","other":"{0} min. ilu"},"future":{"one":"sa min. oħra","many":"+{0} min","other":"sa {0} min. oħra"}},"second":{"current":"issa","past":{"one":"sek. ilu","other":"{0} sek. ilu"},"future":{"one":"sa sek. oħra","other":"sa {0} sek. oħra"}}}}');

/***/ }),

/***/ 99093:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"my","long":{"year":{"previous":"ယမန်နှစ်","current":"ယခုနှစ်","next":"လာမည့်နှစ်","past":"ပြီးခဲ့သည့် {0} နှစ်","future":"{0} နှစ်အတွင်း"},"quarter":{"previous":"ပြီးခဲ့သည့် သုံးလပတ်","current":"ယခု သုံးလပတ်","next":"လာမည့် သုံးလပတ်","past":"ပြီးခဲ့သည့် သုံးလပတ်ကာလ {0} ခုအတွင်း","future":"သုံးလပတ်ကာလ {0} အတွင်း"},"month":{"previous":"ပြီးခဲ့သည့်လ","current":"ယခုလ","next":"လာမည့်လ","past":"ပြီးခဲ့သည့် {0} လ","future":"{0} လအတွင်း"},"week":{"previous":"ပြီးခဲ့သည့် သီတင်းပတ်","current":"ယခု သီတင်းပတ်","next":"လာမည့် သီတင်းပတ်","past":"ပြီးခဲ့သည့် {0} ပတ်","future":"{0} ပတ်အတွင်း"},"day":{"previous":"မနေ့က","previous-2":"တစ်နေ့က","current":"ယနေ့","next":"မနက်ဖြန်","next-2":"သန်ဘက်ခါ","past":"ပြီးခဲ့သည့် {0} ရက်","future":"{0} ရက်အတွင်း"},"hour":{"current":"ဤအချိန်","past":"ပြီးခဲ့သည့် {0} နာရီ","future":"{0} နာရီအတွင်း"},"minute":{"current":"ဤမိနစ်","past":"ပြီးခဲ့သည့် {0} မိနစ်","future":"{0} မိနစ်အတွင်း"},"second":{"current":"ယခု","past":"ပြီးခဲ့သည့် {0} စက္ကန့်","future":"{0} စက္ကန့်အတွင်း"}},"short":{"year":{"previous":"ယမန်နှစ်","current":"ယခုနှစ်","next":"လာမည့်နှစ်","past":"ပြီးခဲ့သည့် {0} နှစ်","future":"{0} နှစ်အတွင်း"},"quarter":{"previous":"ပြီးခဲ့သောသုံးလပတ်","current":"ယခုသုံးလပတ်","next":"နောက်လာမည့်သုံးလပတ်","past":"ပြီးခဲ့သည့် သုံးလပတ်ကာလ {0} ခုအတွင်း","future":"သုံးလပတ်ကာလ {0} ခုအတွင်း"},"month":{"previous":"ပြီးခဲ့သည့်လ","current":"ယခုလ","next":"လာမည့်လ","past":"ပြီးခဲ့သည့် {0} လ","future":"{0} လအတွင်း"},"week":{"previous":"ပြီးခဲ့သည့် သီတင်းပတ်","current":"ယခု သီတင်းပတ်","next":"လာမည့် သီတင်းပတ်","past":"ပြီးခဲ့သည့် {0} ပတ်","future":"{0} ပတ်အတွင်း"},"day":{"previous":"မနေ့က","previous-2":"တစ်နေ့က","current":"ယနေ့","next":"မနက်ဖြန်","next-2":"သန်ဘက်ခါ","past":"ပြီးခဲ့သည့် {0} ရက်","future":"{0} ရက်အတွင်း"},"hour":{"current":"ဤအချိန်","past":"ပြီးခဲ့သည့် {0} နာရီ","future":"{0} နာရီအတွင်း"},"minute":{"current":"ဤမိနစ်","past":"ပြီးခဲ့သည့် {0} မိနစ်","future":"{0} မိနစ်အတွင်း"},"second":{"current":"ယခု","past":"ပြီးခဲ့သည့် {0} စက္ကန့်","future":"{0} စက္ကန့်အတွင်း"}},"narrow":{"year":{"previous":"ယမန်နှစ်","current":"ယခုနှစ်","next":"လာမည့်နှစ်","past":"ပြီးခဲ့သည့် {0} နှစ်","future":"{0} နှစ်အတွင်း"},"quarter":{"previous":"ပြီးခဲ့သောသုံးလပတ်","current":"ယခုသုံးလပတ်","next":"နောက်လာမည့်သုံးလပတ်","past":"ပြီးခဲ့သည့် သုံးလပတ်ကာလ {0} ခုအတွင်း","future":"သုံးလပတ်ကာလ {0} ခုအတွင်း"},"month":{"previous":"ပြီးခဲ့သည့်လ","current":"ယခုလ","next":"လာမည့်လ","past":"ပြီးခဲ့သည့် {0} လ","future":"{0} လအတွင်း"},"week":{"previous":"ပြီးခဲ့သည့် သီတင်းပတ်","current":"ယခု သီတင်းပတ်","next":"လာမည့် သီတင်းပတ်","past":"ပြီးခဲ့သည့် {0} ပတ်","future":"{0} ပတ်အတွင်း"},"day":{"previous":"မနေ့က","previous-2":"တစ်နေ့က","current":"ယနေ့","next":"မနက်ဖြန်","next-2":"သန်ဘက်ခါ","past":"ပြီးခဲ့သည့် {0} ရက်","future":"{0} ရက်အတွင်း"},"hour":{"current":"ဤအချိန်","past":"ပြီးခဲ့သည့် {0} နာရီ","future":"{0} နာရီအတွင်း"},"minute":{"current":"ဤမိနစ်","past":"ပြီးခဲ့သည့် {0} မိနစ်","future":"{0} မိနစ်အတွင်း"},"second":{"current":"ယခု","past":"ပြီးခဲ့သည့် {0} စက္ကန့်","future":"{0} စက္ကန့်အတွင်း"}}}');

/***/ }),

/***/ 32460:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"mzn","long":{"year":{"previous":"پارسال","current":"امسال","next":"سال دیگه","past":"{0} سال پیش","future":"{0} سال دله"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"{0} ربع پیش","future":"{0} ربع دله"},"month":{"previous":"ماه قبل","current":"این ماه","next":"ماه ِبعد","past":"{0} ماه پیش","future":"{0} ماه دله"},"week":{"previous":"قبلی هفته","current":"این هفته","next":"بعدی هفته","past":"{0} هفته پیش","future":"{0} هفته دله"},"day":{"previous":"دیروز","current":"اَمروز","next":"فِردا","past":"{0} روز پیش","future":"{0} روز دله"},"hour":{"current":"this hour","past":"{0} ساعِت پیش","future":"{0} ساعِت دله"},"minute":{"current":"this minute","past":"{0} دَقه پیش","future":"{0} دقیقه دله"},"second":{"current":"now","past":"{0} ثانیه پیش","future":"{0} ثانیه دله"}},"short":{"year":{"previous":"پارسال","current":"امسال","next":"سال دیگه","past":"{0} سال پیش","future":"{0} سال دله"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"{0} ربع پیش","future":"{0} ربع دله"},"month":{"previous":"ماه قبل","current":"این ماه","next":"ماه ِبعد","past":"{0} ماه پیش","future":"{0} ماه دله"},"week":{"previous":"قبلی هفته","current":"این هفته","next":"بعدی هفته","past":"{0} هفته پیش","future":"{0} هفته دله"},"day":{"previous":"دیروز","current":"اَمروز","next":"فِردا","past":"{0} روز پیش","future":"{0} روز دله"},"hour":{"current":"this hour","past":"{0} ساعت پیش","future":"{0} ساعت دله"},"minute":{"current":"this minute","past":"{0} دَقه پیش","future":"{0} دَقه دله"},"second":{"current":"now","past":"{0} ثانیه پیش","future":"{0} ثانیه دله"}},"narrow":{"year":{"previous":"پارسال","current":"امسال","next":"سال دیگه","past":"{0} سال پیش","future":"{0} سال دله"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"{0} ربع پیش","future":"{0} ربع دله"},"month":{"previous":"ماه قبل","current":"این ماه","next":"ماه ِبعد","past":"{0} ماه پیش","future":"{0} ماه دله"},"week":{"previous":"قبلی هفته","current":"این هفته","next":"بعدی هفته","past":"{0} هفته پیش","future":"{0} هفته دله"},"day":{"previous":"دیروز","current":"اَمروز","next":"فِردا","past":"{0} روز پیش","future":"{0} روز دله"},"hour":{"current":"this hour","past":"{0} ساعت پیش","future":"{0} ساعت دله"},"minute":{"current":"this minute","past":"{0} دَقه پیش","future":"{0} دَقه دله"},"second":{"current":"now","past":"{0} ثانیه پیش","future":"{0} ثانیه دله"}}}');

/***/ }),

/***/ 33672:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"nb","long":{"year":{"previous":"i fjor","current":"i år","next":"neste år","past":"for {0} år siden","future":"om {0} år"},"quarter":{"previous":"forrige kvartal","current":"dette kvartalet","next":"neste kvartal","past":{"one":"for {0} kvartal siden","other":"for {0} kvartaler siden"},"future":{"one":"om {0} kvartal","other":"om {0} kvartaler"}},"month":{"previous":"forrige måned","current":"denne måneden","next":"neste måned","past":{"one":"for {0} måned siden","other":"for {0} måneder siden"},"future":{"one":"om {0} måned","other":"om {0} måneder"}},"week":{"previous":"forrige uke","current":"denne uken","next":"neste uke","past":{"one":"for {0} uke siden","other":"for {0} uker siden"},"future":{"one":"om {0} uke","other":"om {0} uker"}},"day":{"previous":"i går","previous-2":"i forgårs","current":"i dag","next":"i morgen","next-2":"i overmorgen","past":"for {0} døgn siden","future":"om {0} døgn"},"hour":{"current":"denne timen","past":{"one":"for {0} time siden","other":"for {0} timer siden"},"future":{"one":"om {0} time","other":"om {0} timer"}},"minute":{"current":"dette minuttet","past":{"one":"for {0} minutt siden","other":"for {0} minutter siden"},"future":{"one":"om {0} minutt","other":"om {0} minutter"}},"second":{"current":"nå","past":{"one":"for {0} sekund siden","other":"for {0} sekunder siden"},"future":{"one":"om {0} sekund","other":"om {0} sekunder"}}},"short":{"year":{"previous":"i fjor","current":"i år","next":"neste år","past":"for {0} år siden","future":"om {0} år"},"quarter":{"previous":"forrige kv.","current":"dette kv.","next":"neste kv.","past":"for {0} kv. siden","future":"om {0} kv."},"month":{"previous":"forrige md.","current":"denne md.","next":"neste md.","past":"for {0} md. siden","future":"om {0} md."},"week":{"previous":"forrige uke","current":"denne uken","next":"neste uke","past":"for {0} u. siden","future":"om {0} u."},"day":{"previous":"i går","previous-2":"i forgårs","current":"i dag","next":"i morgen","next-2":"i overmorgen","past":"for {0} d. siden","future":"om {0} d."},"hour":{"current":"denne timen","past":"for {0} t siden","future":"om {0} t"},"minute":{"current":"dette minuttet","past":"for {0} min siden","future":"om {0} min"},"second":{"current":"nå","past":"for {0} sek siden","future":"om {0} sek"}},"narrow":{"year":{"previous":"i fjor","current":"i år","next":"neste år","past":"–{0} år","future":"+{0} år"},"quarter":{"previous":"forrige kv.","current":"dette kv.","next":"neste kv.","past":"–{0} kv.","future":"+{0} kv."},"month":{"previous":"forrige md.","current":"denne md.","next":"neste md.","past":"-{0} md.","future":"+{0} md."},"week":{"previous":"forrige uke","current":"denne uken","next":"neste uke","past":"-{0} u.","future":"+{0} u."},"day":{"previous":"i går","previous-2":"-2 d.","current":"i dag","next":"i morgen","next-2":"+2 d.","past":"-{0} d.","future":"+{0} d."},"hour":{"current":"denne timen","past":"-{0} t","future":"+{0} t"},"minute":{"current":"dette minuttet","past":"-{0} min","future":"+{0} min"},"second":{"current":"nå","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 24153:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ne","long":{"year":{"previous":"गत वर्ष","current":"यो वर्ष","next":"आगामी वर्ष","past":"{0} वर्ष अघि","future":"{0} वर्षमा"},"quarter":{"previous":"अघिल्लो सत्र","current":"यो सत्र","next":"अर्को सत्र","past":"{0}सत्र अघि","future":{"one":"+{0} सत्रमा","other":"{0}सत्रमा"}},"month":{"previous":"गत महिना","current":"यो महिना","next":"अर्को महिना","past":"{0} महिना पहिले","future":"{0} महिनामा"},"week":{"previous":"गत हप्ता","current":"यो हप्ता","next":"आउने हप्ता","past":"{0} हप्ता पहिले","future":"{0} हप्तामा"},"day":{"previous":"हिजो","previous-2":"अस्ति","current":"आज","next":"भोलि","next-2":"पर्सि","past":"{0} दिन पहिले","future":"{0} दिनमा"},"hour":{"current":"यस घडीमा","past":"{0} घण्टा पहिले","future":"{0} घण्टामा"},"minute":{"current":"यही मिनेटमा","past":"{0} मिनेट पहिले","future":"{0} मिनेटमा"},"second":{"current":"अहिले","past":"{0} सेकेन्ड पहिले","future":"{0} सेकेन्डमा"}},"short":{"year":{"previous":"गत वर्ष","current":"यो वर्ष","next":"आगामी वर्ष","past":"{0} वर्ष अघि","future":"{0} वर्षमा"},"quarter":{"previous":"अघिल्लो सत्र","current":"यो सत्र","next":"अर्को सत्र","past":"{0}सत्र अघि","future":"{0}सत्रमा"},"month":{"previous":"गत महिना","current":"यो महिना","next":"अर्को महिना","past":"{0} महिना पहिले","future":"{0} महिनामा"},"week":{"previous":"गत हप्ता","current":"यो हप्ता","next":"आउने हप्ता","past":"{0} हप्ता पहिले","future":"{0} हप्तामा"},"day":{"previous":"हिजो","previous-2":"अस्ति","current":"आज","next":"भोलि","next-2":"पर्सि","past":"{0} दिन पहिले","future":"{0} दिनमा"},"hour":{"current":"यस घडीमा","past":"{0} घण्टा पहिले","future":"{0} घण्टामा"},"minute":{"current":"यही मिनेटमा","past":"{0} मिनेट पहिले","future":"{0} मिनेटमा"},"second":{"current":"अहिले","past":"{0} सेकेन्ड पहिले","future":"{0} सेकेन्डमा"}},"narrow":{"year":{"previous":"गत वर्ष","current":"यो वर्ष","next":"आगामी वर्ष","past":"{0} वर्ष अघि","future":"{0} वर्षमा"},"quarter":{"previous":"अघिल्लो सत्र","current":"यो सत्र","next":"अर्को सत्र","past":"{0}सत्र अघि","future":"{0}सत्रमा"},"month":{"previous":"गत महिना","current":"यो महिना","next":"अर्को महिना","past":"{0} महिना पहिले","future":"{0} महिनामा"},"week":{"previous":"गत हप्ता","current":"यो हप्ता","next":"आउने हप्ता","past":"{0} हप्ता पहिले","future":"{0} हप्तामा"},"day":{"previous":"हिजो","previous-2":"अस्ति","current":"आज","next":"भोलि","next-2":"पर्सि","past":"{0} दिन पहिले","future":"{0} दिनमा"},"hour":{"current":"यस घडीमा","past":"{0} घण्टा पहिले","future":"{0} घण्टामा"},"minute":{"current":"यही मिनेटमा","past":"{0} मिनेट पहिले","future":"{0} मिनेटमा"},"second":{"current":"अहिले","past":"{0} सेकेन्ड पहिले","future":"{0} सेकेन्डमा"}}}');

/***/ }),

/***/ 30344:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"nl","long":{"year":{"previous":"vorig jaar","current":"dit jaar","next":"volgend jaar","past":"{0} jaar geleden","future":"over {0} jaar"},"quarter":{"previous":"vorig kwartaal","current":"dit kwartaal","next":"volgend kwartaal","past":{"one":"{0} kwartaal geleden","other":"{0} kwartalen geleden"},"future":{"one":"over {0} kwartaal","other":"over {0} kwartalen"}},"month":{"previous":"vorige maand","current":"deze maand","next":"volgende maand","past":{"one":"{0} maand geleden","other":"{0} maanden geleden"},"future":{"one":"over {0} maand","other":"over {0} maanden"}},"week":{"previous":"vorige week","current":"deze week","next":"volgende week","past":{"one":"{0} week geleden","other":"{0} weken geleden"},"future":{"one":"over {0} week","other":"over {0} weken"}},"day":{"previous":"gisteren","previous-2":"eergisteren","current":"vandaag","next":"morgen","next-2":"overmorgen","past":{"one":"{0} dag geleden","other":"{0} dagen geleden"},"future":{"one":"over {0} dag","other":"over {0} dagen"}},"hour":{"current":"binnen een uur","past":"{0} uur geleden","future":"over {0} uur"},"minute":{"current":"binnen een minuut","past":{"one":"{0} minuut geleden","other":"{0} minuten geleden"},"future":{"one":"over {0} minuut","other":"over {0} minuten"}},"second":{"current":"nu","past":{"one":"{0} seconde geleden","other":"{0} seconden geleden"},"future":{"one":"over {0} seconde","other":"over {0} seconden"}}},"short":{"year":{"previous":"vorig jaar","current":"dit jaar","next":"volgend jaar","past":"{0} jaar geleden","future":"over {0} jaar"},"quarter":{"previous":"vorig kwartaal","current":"dit kwartaal","next":"volgend kwartaal","past":{"one":"{0} kwartaal geleden","other":"{0} kwartalen geleden"},"future":{"one":"over {0} kwartaal","other":"over {0} kwartalen"}},"month":{"previous":"vorige maand","current":"deze maand","next":"volgende maand","past":{"one":"{0} maand geleden","other":"{0} maanden geleden"},"future":{"one":"over {0} maand","other":"over {0} maanden"}},"week":{"previous":"vorige week","current":"deze week","next":"volgende week","past":{"one":"{0} week geleden","other":"{0} weken geleden"},"future":{"one":"over {0} week","other":"over {0} weken"}},"day":{"previous":"gisteren","previous-2":"eergisteren","current":"vandaag","next":"morgen","next-2":"overmorgen","past":{"one":"{0} dag geleden","other":"{0} dgn geleden"},"future":{"one":"over {0} dag","other":"over {0} dgn"}},"hour":{"current":"binnen een uur","past":"{0} uur geleden","future":"over {0} uur"},"minute":{"current":"binnen een minuut","past":"{0} min. geleden","future":"over {0} min."},"second":{"current":"nu","past":"{0} sec. geleden","future":"over {0} sec."}},"narrow":{"year":{"previous":"vorig jaar","current":"dit jaar","next":"volgend jaar","past":"{0} jaar geleden","future":"over {0} jaar"},"quarter":{"previous":"vorig kwartaal","current":"dit kwartaal","next":"volgend kwartaal","past":{"one":"{0} kwartaal geleden","other":"{0} kwartalen geleden"},"future":{"one":"over {0} kw.","other":"over {0} kwartalen"}},"month":{"previous":"vorige maand","current":"deze maand","next":"volgende maand","past":{"one":"{0} maand geleden","other":"{0} maanden geleden"},"future":{"one":"over {0} maand","other":"over {0} maanden"}},"week":{"previous":"vorige week","current":"deze week","next":"volgende week","past":{"one":"{0} week geleden","other":"{0} weken geleden"},"future":{"one":"over {0} week","other":"over {0} weken"}},"day":{"previous":"gisteren","previous-2":"eergisteren","current":"vandaag","next":"morgen","next-2":"overmorgen","past":{"one":"{0} dag geleden","other":"{0} dgn geleden"},"future":{"one":"over {0} dag","other":"over {0} dgn"}},"hour":{"current":"binnen een uur","past":"{0} uur geleden","future":"over {0} uur"},"minute":{"current":"binnen een minuut","past":"{0} min. geleden","future":"over {0} min."},"second":{"current":"nu","past":"{0} sec. geleden","future":"over {0} sec."}}}');

/***/ }),

/***/ 71277:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"nn","long":{"year":{"previous":"i fjor","current":"i år","next":"neste år","past":"for {0} år sidan","future":"om {0} år"},"quarter":{"previous":"førre kvartal","current":"dette kvartalet","next":"neste kvartal","past":"for {0} kvartal sidan","future":"om {0} kvartal"},"month":{"previous":"førre månad","current":"denne månaden","next":"neste månad","past":{"one":"for {0} månad sidan","other":"for {0} månadar sidan"},"future":{"one":"om {0} månad","other":"om {0} månadar"}},"week":{"previous":"førre veke","current":"denne veka","next":"neste veke","past":{"one":"for {0} veke sidan","other":"for {0} veker sidan"},"future":{"one":"om {0} veke","other":"om {0} veker"}},"day":{"previous":"i går","previous-2":"i førgår","current":"i dag","next":"i morgon","next-2":"i overmorgon","past":"for {0} døgn sidan","future":"om {0} døgn"},"hour":{"current":"denne timen","past":{"one":"for {0} time sidan","other":"for {0} timar sidan"},"future":{"one":"om {0} time","other":"om {0} timar"}},"minute":{"current":"dette minuttet","past":"for {0} minutt sidan","future":"om {0} minutt"},"second":{"current":"no","past":"for {0} sekund sidan","future":{"one":"om {0} sekund","other":"om {0} sekund"}}},"short":{"year":{"previous":"i fjor","current":"i år","next":"neste år","past":"for {0} år sidan","future":"om {0} år"},"quarter":{"previous":"førre kvartal","current":"dette kvartalet","next":"neste kvartal","past":"for {0} kv. sidan","future":"om {0} kv."},"month":{"previous":"førre månad","current":"denne månaden","next":"neste månad","past":"for {0} md. sidan","future":"om {0} md."},"week":{"previous":"førre veke","current":"denne veka","next":"neste veke","past":"for {0} v. sidan","future":"om {0} v."},"day":{"previous":"i går","previous-2":"i førgår","current":"i dag","next":"i morgon","next-2":"i overmorgon","past":"for {0} d. sidan","future":"om {0} d."},"hour":{"current":"denne timen","past":"for {0} t sidan","future":"om {0} t"},"minute":{"current":"dette minuttet","past":"for {0} min sidan","future":"om {0} min"},"second":{"current":"no","past":"for {0} sek sidan","future":"om {0} sek"}},"narrow":{"year":{"previous":"i fjor","current":"i år","next":"neste år","past":"for {0} år sidan","future":"om {0} år"},"quarter":{"previous":"førre kvartal","current":"dette kvartalet","next":"neste kvartal","past":"–{0} kv.","future":"+{0} kv."},"month":{"previous":"førre månad","current":"denne månaden","next":"neste månad","past":"–{0} md.","future":"+{0} md."},"week":{"previous":"førre veke","current":"denne veka","next":"neste veke","past":"–{0} v.","future":"+{0} v."},"day":{"previous":"i går","previous-2":"i førgår","current":"i dag","next":"i morgon","next-2":"i overmorgon","past":"–{0} d.","future":"+{0} d."},"hour":{"current":"denne timen","past":"–{0} t","future":"+{0} t"},"minute":{"current":"dette minuttet","past":"–{0} min","future":"+{0} min"},"second":{"current":"no","past":{"one":"–{0} s","other":"–{0} s"},"future":"+{0} s"}}}');

/***/ }),

/***/ 77156:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"or","long":{"year":{"previous":"ଗତ ବର୍ଷ","current":"ଏହି ବର୍ଷ","next":"ଆଗାମୀ ବର୍ଷ","past":"{0} ବର୍ଷ ପୂର୍ବେ","future":"{0} ବର୍ଷରେ"},"quarter":{"previous":"ଗତ ତ୍ରୟମାସ","current":"ଗତ ତ୍ରୟମାସ","next":"ଆଗାମୀ ତ୍ରୟମାସ","past":"{0} ତ୍ରୟମାସ ପୂର୍ବେ","future":"{0} ତ୍ରୟମାସରେ"},"month":{"previous":"ଗତ ମାସ","current":"ଏହି ମାସ","next":"ଆଗାମୀ ମାସ","past":"{0} ମାସ ପୂର୍ବେ","future":"{0} ମାସରେ"},"week":{"previous":"ଗତ ସପ୍ତାହ","current":"ଏହି ସପ୍ତାହ","next":"ଆଗାମୀ ସପ୍ତାହ","past":{"one":"{0} ସପ୍ତାହରେ","other":"{0} ସପ୍ତାହ ପୂର୍ବେ"},"future":"{0} ସପ୍ତାହରେ"},"day":{"previous":"ଗତକାଲି","current":"ଆଜି","next":"ଆସନ୍ତାକାଲି","past":"{0} ଦିନ ପୂର୍ବେ","future":"{0} ଦିନରେ"},"hour":{"current":"ଏହି ଘଣ୍ଟା","past":"{0} ଘଣ୍ଟା ପୂର୍ବେ","future":"{0} ଘଣ୍ଟାରେ"},"minute":{"current":"ଏହି ମିନିଟ୍","past":"{0} ମିନିଟ୍ ପୂର୍ବେ","future":"{0} ମିନିଟ୍‌‌ରେ"},"second":{"current":"ବର୍ତ୍ତମାନ","past":"{0} ସେକେଣ୍ଡ ପୂର୍ବେ","future":"{0} ସେକେଣ୍ଡରେ"}},"short":{"year":{"previous":"ଗତ ବର୍ଷ","current":"ଏହି ବର୍ଷ","next":"ଆଗାମୀ ବର୍ଷ","past":"{0} ବ. ପୂର୍ବେ","future":"{0} ବ. ରେ"},"quarter":{"previous":"ଗତ ତ୍ରୟମାସ","current":"ଗତ ତ୍ରୟମାସ","next":"ଆଗାମୀ ତ୍ରୟମାସ","past":"{0} ତ୍ରୟ. ପୂର୍ବେ","future":"{0} ତ୍ରୟ. ରେ"},"month":{"previous":"ଗତ ମାସ","current":"ଏହି ମାସ","next":"ଆଗାମୀ ମାସ","past":"{0} ମା. ପୂର୍ବେ","future":"{0} ମା. ରେ"},"week":{"previous":"ଗତ ସପ୍ତାହ","current":"ଏହି ସପ୍ତାହ","next":"ଆଗାମୀ ସପ୍ତାହ","past":"{0} ସପ୍ତା. ପୂର୍ବେ","future":"{0} ସପ୍ତା. ରେ"},"day":{"previous":"ଗତକାଲି","current":"ଆଜି","next":"ଆସନ୍ତାକାଲି","past":"{0} ଦିନ ପୂର୍ବେ","future":"{0} ଦିନରେ"},"hour":{"current":"ଏହି ଘଣ୍ଟା","past":"{0} ଘ. ପୂର୍ବେ","future":"{0} ଘ. ରେ"},"minute":{"current":"ଏହି ମିନିଟ୍","past":"{0} ମି. ପୂର୍ବେ","future":"{0} ମି. ରେ"},"second":{"current":"ବର୍ତ୍ତମାନ","past":"{0} ସେ. ପୂର୍ବେ","future":"{0} ସେ. ରେ"}},"narrow":{"year":{"previous":"ଗତ ବର୍ଷ","current":"ଏହି ବର୍ଷ","next":"ଆଗାମୀ ବର୍ଷ","past":"{0} ବ. ପୂର୍ବେ","future":"{0} ବ. ରେ"},"quarter":{"previous":"ଗତ ତ୍ରୟମାସ","current":"ଗତ ତ୍ରୟମାସ","next":"ଆଗାମୀ ତ୍ରୟମାସ","past":"{0} ତ୍ରୟ. ପୂର୍ବେ","future":"{0} ତ୍ରୟ. ରେ"},"month":{"previous":"ଗତ ମାସ","current":"ଏହି ମାସ","next":"ଆଗାମୀ ମାସ","past":"{0} ମା. ପୂର୍ବେ","future":"{0} ମା. ରେ"},"week":{"previous":"ଗତ ସପ୍ତାହ","current":"ଏହି ସପ୍ତାହ","next":"ଆଗାମୀ ସପ୍ତାହ","past":"{0} ସପ୍ତା. ପୂର୍ବେ","future":"{0} ସପ୍ତା. ରେ"},"day":{"previous":"ଗତକାଲି","current":"ଆଜି","next":"ଆସନ୍ତାକାଲି","past":"{0} ଦିନ ପୂର୍ବେ","future":"{0} ଦିନରେ"},"hour":{"current":"ଏହି ଘଣ୍ଟା","past":"{0} ଘ. ପୂର୍ବେ","future":"{0} ଘ. ରେ"},"minute":{"current":"ଏହି ମିନିଟ୍","past":"{0} ମି. ପୂର୍ବେ","future":"{0} ମି. ରେ"},"second":{"current":"ବର୍ତ୍ତମାନ","past":"{0} ସେ. ପୂର୍ବେ","future":"{0} ସେ. ରେ"}}}');

/***/ }),

/***/ 45720:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pa","long":{"year":{"previous":"ਪਿਛਲਾ ਸਾਲ","current":"ਇਹ ਸਾਲ","next":"ਅਗਲਾ ਸਾਲ","past":"{0} ਸਾਲ ਪਹਿਲਾਂ","future":{"one":"{0} ਸਾਲ ਵਿੱਚ","other":"{0} ਸਾਲਾਂ ਵਿੱਚ"}},"quarter":{"previous":"ਪਿਛਲੀ ਤਿਮਾਹੀ","current":"ਇਸ ਤਿਮਾਹੀ","next":"ਅਗਲੀ ਤਿਮਾਹੀ","past":{"one":"{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ","other":"{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਤਿਮਾਹੀ ਵਿੱਚ","other":"{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"}},"month":{"previous":"ਪਿਛਲਾ ਮਹੀਨਾ","current":"ਇਹ ਮਹੀਨਾ","next":"ਅਗਲਾ ਮਹੀਨਾ","past":{"one":"{0} ਮਹੀਨਾ ਪਹਿਲਾਂ","other":"{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਮਹੀਨੇ ਵਿੱਚ","other":"{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"}},"week":{"previous":"ਪਿਛਲਾ ਹਫ਼ਤਾ","current":"ਇਹ ਹਫ਼ਤਾ","next":"ਅਗਲਾ ਹਫ਼ਤਾ","past":{"one":"{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ","other":"{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਹਫ਼ਤੇ ਵਿੱਚ","other":"{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"}},"day":{"previous":"ਬੀਤਿਆ ਕੱਲ੍ਹ","current":"ਅੱਜ","next":"ਭਲਕੇ","past":"{0} ਦਿਨ ਪਹਿਲਾਂ","future":{"one":"{0} ਦਿਨ ਵਿੱਚ","other":"{0} ਦਿਨਾਂ ਵਿੱਚ"}},"hour":{"current":"ਇਸ ਘੰਟੇ","past":{"one":"{0} ਘੰਟਾ ਪਹਿਲਾਂ","other":"{0} ਘੰਟੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਘੰਟੇ ਵਿੱਚ","other":"{0} ਘੰਟਿਆਂ ਵਿੱਚ"}},"minute":{"current":"ਇਸ ਮਿੰਟ","past":"{0} ਮਿੰਟ ਪਹਿਲਾਂ","future":{"one":"{0} ਮਿੰਟ ਵਿੱਚ","other":"{0} ਮਿੰਟਾਂ ਵਿੱਚ"}},"second":{"current":"ਹੁਣ","past":"{0} ਸਕਿੰਟ ਪਹਿਲਾਂ","future":{"one":"{0} ਸਕਿੰਟ ਵਿੱਚ","other":"{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"}}},"short":{"year":{"previous":"ਪਿਛਲਾ ਸਾਲ","current":"ਇਹ ਸਾਲ","next":"ਅਗਲਾ ਸਾਲ","past":"{0} ਸਾਲ ਪਹਿਲਾਂ","future":{"one":"{0} ਸਾਲ ਵਿੱਚ","other":"{0} ਸਾਲਾਂ ਵਿੱਚ"}},"quarter":{"previous":"ਪਿਛਲੀ ਤਿਮਾਹੀ","current":"ਇਹ ਤਿਮਾਹੀ","next":"ਅਗਲੀ ਤਿਮਾਹੀ","past":{"one":"{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ","other":"{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਤਿਮਾਹੀ ਵਿੱਚ","other":"{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"}},"month":{"previous":"ਪਿਛਲਾ ਮਹੀਨਾ","current":"ਇਹ ਮਹੀਨਾ","next":"ਅਗਲਾ ਮਹੀਨਾ","past":{"one":"{0} ਮਹੀਨਾ ਪਹਿਲਾਂ","other":"{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਮਹੀਨੇ ਵਿੱਚ","other":"{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"}},"week":{"previous":"ਪਿਛਲਾ ਹਫ਼ਤਾ","current":"ਇਹ ਹਫ਼ਤਾ","next":"ਅਗਲਾ ਹਫ਼ਤਾ","past":{"one":"{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ","other":"{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਹਫ਼ਤੇ ਵਿੱਚ","other":"{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"}},"day":{"previous":"ਬੀਤਿਆ ਕੱਲ੍ਹ","current":"ਅੱਜ","next":"ਭਲਕੇ","past":"{0} ਦਿਨ ਪਹਿਲਾਂ","future":{"one":"{0} ਦਿਨ ਵਿੱਚ","other":"{0} ਦਿਨਾਂ ਵਿੱਚ"}},"hour":{"current":"ਇਸ ਘੰਟੇ","past":{"one":"{0} ਘੰਟਾ ਪਹਿਲਾਂ","other":"{0} ਘੰਟੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਘੰਟੇ ਵਿੱਚ","other":"{0} ਘੰਟਿਆਂ ਵਿੱਚ"}},"minute":{"current":"ਇਸ ਮਿੰਟ","past":"{0} ਮਿੰਟ ਪਹਿਲਾਂ","future":{"one":"{0} ਮਿੰਟ ਵਿੱਚ","other":"{0} ਮਿੰਟਾਂ ਵਿੱਚ"}},"second":{"current":"ਹੁਣ","past":"{0} ਸਕਿੰਟ ਪਹਿਲਾਂ","future":{"one":"{0} ਸਕਿੰਟ ਵਿੱਚ","other":"{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"}}},"narrow":{"year":{"previous":"ਪਿਛਲਾ ਸਾਲ","current":"ਇਹ ਸਾਲ","next":"ਅਗਲਾ ਸਾਲ","past":"{0} ਸਾਲ ਪਹਿਲਾਂ","future":{"one":"{0} ਸਾਲ ਵਿੱਚ","other":"{0} ਸਾਲਾਂ ਵਿੱਚ"}},"quarter":{"previous":"ਪਿਛਲੀ ਤਿਮਾਹੀ","current":"ਇਹ ਤਿਮਾਹੀ","next":"ਅਗਲੀ ਤਿਮਾਹੀ","past":{"one":"{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ","other":"{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਤਿਮਾਹੀ ਵਿੱਚ","other":"{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"}},"month":{"previous":"ਪਿਛਲਾ ਮਹੀਨਾ","current":"ਇਹ ਮਹੀਨਾ","next":"ਅਗਲਾ ਮਹੀਨਾ","past":{"one":"{0} ਮਹੀਨਾ ਪਹਿਲਾਂ","other":"{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਮਹੀਨੇ ਵਿੱਚ","other":"{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"}},"week":{"previous":"ਪਿਛਲਾ ਹਫ਼ਤਾ","current":"ਇਹ ਹਫ਼ਤਾ","next":"ਅਗਲਾ ਹਫ਼ਤਾ","past":{"one":"{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ","other":"{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਹਫ਼ਤੇ ਵਿੱਚ","other":"{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"}},"day":{"previous":"ਬੀਤਿਆ ਕੱਲ੍ਹ","current":"ਅੱਜ","next":"ਭਲਕੇ","past":"{0} ਦਿਨ ਪਹਿਲਾਂ","future":{"one":"{0} ਦਿਨ ਵਿੱਚ","other":"{0} ਦਿਨਾਂ ਵਿੱਚ"}},"hour":{"current":"ਇਸ ਘੰਟੇ","past":{"one":"{0} ਘੰਟਾ ਪਹਿਲਾਂ","other":"{0} ਘੰਟੇ ਪਹਿਲਾਂ"},"future":{"one":"{0} ਘੰਟੇ ਵਿੱਚ","other":"{0} ਘੰਟਿਆਂ ਵਿੱਚ"}},"minute":{"current":"ਇਸ ਮਿੰਟ","past":"{0} ਮਿੰਟ ਪਹਿਲਾਂ","future":{"one":"{0} ਮਿੰਟ ਵਿੱਚ","other":"{0} ਮਿੰਟਾਂ ਵਿੱਚ"}},"second":{"current":"ਹੁਣ","past":"{0} ਸਕਿੰਟ ਪਹਿਲਾਂ","future":{"one":"{0} ਸਕਿੰਟ ਵਿੱਚ","other":"{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"}}}}');

/***/ }),

/***/ 73552:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pl","long":{"year":{"previous":"w zeszłym roku","current":"w tym roku","next":"w przyszłym roku","past":{"one":"{0} rok temu","few":"{0} lata temu","many":"{0} lat temu","other":"{0} roku temu"},"future":{"one":"za {0} rok","few":"za {0} lata","many":"za {0} lat","other":"za {0} roku"}},"quarter":{"previous":"w zeszłym kwartale","current":"w tym kwartale","next":"w przyszłym kwartale","past":{"one":"{0} kwartał temu","few":"{0} kwartały temu","many":"{0} kwartałów temu","other":"{0} kwartału temu"},"future":{"one":"za {0} kwartał","few":"za {0} kwartały","many":"za {0} kwartałów","other":"za {0} kwartału"}},"month":{"previous":"w zeszłym miesiącu","current":"w tym miesiącu","next":"w przyszłym miesiącu","past":{"one":"{0} miesiąc temu","few":"{0} miesiące temu","many":"{0} miesięcy temu","other":"{0} miesiąca temu"},"future":{"one":"za {0} miesiąc","few":"za {0} miesiące","many":"za {0} miesięcy","other":"za {0} miesiąca"}},"week":{"previous":"w zeszłym tygodniu","current":"w tym tygodniu","next":"w przyszłym tygodniu","past":{"one":"{0} tydzień temu","few":"{0} tygodnie temu","many":"{0} tygodni temu","other":"{0} tygodnia temu"},"future":{"one":"za {0} tydzień","few":"za {0} tygodnie","many":"za {0} tygodni","other":"za {0} tygodnia"}},"day":{"previous":"wczoraj","previous-2":"przedwczoraj","current":"dzisiaj","next":"jutro","next-2":"pojutrze","past":{"one":"{0} dzień temu","few":"{0} dni temu","many":"{0} dni temu","other":"{0} dnia temu"},"future":{"one":"za {0} dzień","few":"za {0} dni","many":"za {0} dni","other":"za {0} dnia"}},"hour":{"current":"ta godzina","past":{"one":"{0} godzinę temu","many":"{0} godzin temu","other":"{0} godziny temu"},"future":{"one":"za {0} godzinę","many":"za {0} godzin","other":"za {0} godziny"}},"minute":{"current":"ta minuta","past":{"one":"{0} minutę temu","many":"{0} minut temu","other":"{0} minuty temu"},"future":{"one":"za {0} minutę","many":"za {0} minut","other":"za {0} minuty"}},"second":{"current":"teraz","past":{"one":"{0} sekundę temu","many":"{0} sekund temu","other":"{0} sekundy temu"},"future":{"one":"za {0} sekundę","many":"za {0} sekund","other":"za {0} sekundy"}}},"short":{"year":{"previous":"w zeszłym roku","current":"w tym roku","next":"w przyszłym roku","past":{"one":"{0} rok temu","few":"{0} lata temu","many":"{0} lat temu","other":"{0} roku temu"},"future":{"one":"za {0} rok","few":"za {0} lata","many":"za {0} lat","other":"za {0} roku"}},"quarter":{"previous":"w zeszłym kwartale","current":"w tym kwartale","next":"w przyszłym kwartale","past":"{0} kw. temu","future":"za {0} kw."},"month":{"previous":"w zeszłym miesiącu","current":"w tym miesiącu","next":"w przyszłym miesiącu","past":"{0} mies. temu","future":"za {0} mies."},"week":{"previous":"w zeszłym tygodniu","current":"w tym tygodniu","next":"w przyszłym tygodniu","past":{"one":"{0} tydz. temu","other":"{0} tyg. temu"},"future":{"one":"za {0} tydz.","other":"za {0} tyg."}},"day":{"previous":"wczoraj","previous-2":"przedwczoraj","current":"dzisiaj","next":"jutro","next-2":"pojutrze","past":{"one":"{0} dzień temu","few":"{0} dni temu","many":"{0} dni temu","other":"{0} dnia temu"},"future":{"one":"za {0} dzień","few":"za {0} dni","many":"za {0} dni","other":"za {0} dnia"}},"hour":{"current":"ta godzina","past":"{0} godz. temu","future":"za {0} godz."},"minute":{"current":"ta minuta","past":"{0} min temu","future":"za {0} min"},"second":{"current":"teraz","past":"{0} sek. temu","future":"za {0} sek."}},"narrow":{"year":{"previous":"w zeszłym roku","current":"w tym roku","next":"w przyszłym roku","past":{"one":"{0} rok temu","few":"{0} lata temu","many":"{0} lat temu","other":"{0} roku temu"},"future":{"one":"za {0} rok","few":"za {0} lata","many":"za {0} lat","other":"za {0} roku"}},"quarter":{"previous":"w zeszłym kwartale","current":"w tym kwartale","next":"w przyszłym kwartale","past":"{0} kw. temu","future":"za {0} kw."},"month":{"previous":"w zeszłym miesiącu","current":"w tym miesiącu","next":"w przyszłym miesiącu","past":"{0} mies. temu","future":"za {0} mies."},"week":{"previous":"w zeszłym tygodniu","current":"w tym tygodniu","next":"w przyszłym tygodniu","past":{"one":"{0} tydz. temu","other":"{0} tyg. temu"},"future":{"one":"za {0} tydz.","other":"za {0} tyg."}},"day":{"previous":"wczoraj","previous-2":"przedwczoraj","current":"dzisiaj","next":"jutro","next-2":"pojutrze","past":{"one":"{0} dzień temu","few":"{0} dni temu","many":"{0} dni temu","other":"{0} dnia temu"},"future":{"one":"za {0} dzień","few":"za {0} dni","many":"za {0} dni","other":"za {0} dnia"}},"hour":{"current":"ta godzina","past":"{0} g. temu","future":"za {0} g."},"minute":{"current":"ta minuta","past":"{0} min temu","future":"za {0} min"},"second":{"current":"teraz","past":"{0} s temu","future":"za {0} s"}}}');

/***/ }),

/***/ 70785:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ps","long":{"year":{"previous":"پروسږکال","current":"سږکال","next":"بل کال","past":{"one":"{0} کال مخکې","other":"{0} کاله مخکې"},"future":{"one":"په {0} کال کې","other":"په {0} کالونو کې"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"-{0} m","future":"+{0} m"},"week":{"previous":"last week","current":"this week","next":"next week","past":"-{0} w","future":"+{0} w"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"پروسږکال","current":"سږکال","next":"بل کال","past":{"one":"{0} کال مخکې","other":"{0} کاله مخکې"},"future":{"one":"په {0} کال کې","other":"په {0} کالونو کې"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"-{0} m","future":"+{0} m"},"week":{"previous":"last week","current":"this week","next":"next week","past":"-{0} w","future":"+{0} w"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"پروسږکال","current":"سږکال","next":"بل کال","past":{"one":"{0} کال مخکې","other":"{0} کاله مخکې"},"future":{"one":"په {0} کال کې","other":"په {0} کالونو کې"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"-{0} m","future":"+{0} m"},"week":{"previous":"last week","current":"this week","next":"next week","past":"-{0} w","future":"+{0} w"},"day":{"previous":"yesterday","current":"today","next":"tomorrow","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 83519:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-AO","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 78245:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-CH","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 64718:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-CV","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 15821:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-GQ","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 25829:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-GW","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 16251:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-LU","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 37703:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-MO","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 86530:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-MZ","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 67446:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-PT","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 61582:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-ST","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 65151:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt-TL","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trimestre passado","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"dentro de {0} trimestre","other":"dentro de {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"dentro de {0} semana","other":"dentro de {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"dentro de {0} hora","other":"dentro de {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"dentro de {0} minuto","other":"dentro de {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"dentro de {0} segundo","other":"dentro de {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"dentro de {0} ano","other":"dentro de {0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"há {0} trim.","future":"dentro de {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"dentro de {0} mês","other":"dentro de {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"dentro de {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"dentro de {0} dia","other":"dentro de {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"dentro de {0} h"},"minute":{"current":"este minuto","past":"há {0} min","future":"dentro de {0} min"},"second":{"current":"agora","past":"há {0} s","future":"dentro de {0} s"}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"-{0} ano","other":"-{0} anos"},"future":{"one":"+{0} ano","other":"+{0} anos"}},"quarter":{"previous":"trim. passado","current":"este trim.","next":"próximo trim.","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"-{0} mês","other":"-{0} meses"},"future":{"one":"+{0} mês","other":"+{0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"-{0} sem.","future":"+{0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":"há {0} dias","future":{"one":"+{0} dia","other":"+{0} dias"}},"hour":{"current":"esta hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"este minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"agora","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 1824:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"pt","long":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"em {0} ano","other":"em {0} anos"}},"quarter":{"previous":"último trimestre","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trimestre","other":"há {0} trimestres"},"future":{"one":"em {0} trimestre","other":"em {0} trimestres"}},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"em {0} mês","other":"em {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":{"one":"há {0} semana","other":"há {0} semanas"},"future":{"one":"em {0} semana","other":"em {0} semanas"}},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"em {0} dia","other":"em {0} dias"}},"hour":{"current":"esta hora","past":{"one":"há {0} hora","other":"há {0} horas"},"future":{"one":"em {0} hora","other":"em {0} horas"}},"minute":{"current":"este minuto","past":{"one":"há {0} minuto","other":"há {0} minutos"},"future":{"one":"em {0} minuto","other":"em {0} minutos"}},"second":{"current":"agora","past":{"one":"há {0} segundo","other":"há {0} segundos"},"future":{"one":"em {0} segundo","other":"em {0} segundos"}}},"short":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"há {0} anos"},"future":{"one":"em {0} ano","other":"em {0} anos"}},"quarter":{"previous":"último trimestre","current":"este trimestre","next":"próximo trimestre","past":{"one":"há {0} trim.","other":"{0} trim. atrás"},"future":"em {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"em {0} mês","other":"em {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"em {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"em {0} dia","other":"em {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"em {0} h"},"minute":{"current":"este minuto","past":"há {0} min.","future":"em {0} min."},"second":{"current":"agora","past":"há {0} seg.","future":"em {0} seg."}},"narrow":{"year":{"previous":"ano passado","current":"este ano","next":"próximo ano","past":{"one":"há {0} ano","other":"{0} anos atrás"},"future":{"one":"em {0} ano","other":"em {0} anos"}},"quarter":{"previous":"último trimestre","current":"este trimestre","next":"próximo trimestre","past":"há {0} trim.","future":"em {0} trim."},"month":{"previous":"mês passado","current":"este mês","next":"próximo mês","past":{"one":"há {0} mês","other":"há {0} meses"},"future":{"one":"em {0} mês","other":"em {0} meses"}},"week":{"previous":"semana passada","current":"esta semana","next":"próxima semana","past":"há {0} sem.","future":"em {0} sem."},"day":{"previous":"ontem","previous-2":"anteontem","current":"hoje","next":"amanhã","next-2":"depois de amanhã","past":{"one":"há {0} dia","other":"há {0} dias"},"future":{"one":"em {0} dia","other":"em {0} dias"}},"hour":{"current":"esta hora","past":"há {0} h","future":"em {0} h"},"minute":{"current":"este minuto","past":"há {0} min.","future":"em {0} min."},"second":{"current":"agora","past":"há {0} seg.","future":"em {0} seg."}}}');

/***/ }),

/***/ 32228:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"qu","long":{"year":{"previous":"qayna wata","current":"kunan wata","next":"hamuq wata","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"qayna kimsa killa","current":"kunan kimsa killa","next":"hamuq kimsa killa","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"qayna killa","current":"kunan killa","next":"hamuq killa","past":"-{0} m","future":"+{0} m"},"week":{"previous":"qayna semana","current":"kunan semana","next":"hamuq semana","past":"-{0} w","future":"+{0} w"},"day":{"previous":"qayna punchaw","current":"kunan punchaw","next":"paqarin","past":"-{0} d","future":"+{0} d"},"hour":{"current":"kay hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"kay minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"qayna wata","current":"kunan wata","next":"hamuq wata","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"qayna kimsa killa","current":"kunan kimsa killa","next":"hamuq kimsa killa","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"qayna killa","current":"kunan killa","next":"hamuq killa","past":"-{0} m","future":"+{0} m"},"week":{"previous":"qayna semana","current":"kunan semana","next":"hamuq semana","past":"-{0} w","future":"+{0} w"},"day":{"previous":"qayna punchaw","current":"kunan punchaw","next":"paqarin","past":"-{0} d","future":"+{0} d"},"hour":{"current":"kay hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"kay minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"qayna wata","current":"kunan wata","next":"hamuq wata","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"qayna kimsa killa","current":"kunan kimsa killa","next":"hamuq kimsa killa","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"qayna killa","current":"kunan killa","next":"hamuq killa","past":"-{0} m","future":"+{0} m"},"week":{"previous":"qayna semana","current":"kunan semana","next":"hamuq semana","past":"-{0} w","future":"+{0} w"},"day":{"previous":"qayna punchaw","current":"kunan punchaw","next":"paqarin","past":"-{0} d","future":"+{0} d"},"hour":{"current":"kay hora","past":"-{0} h","future":"+{0} h"},"minute":{"current":"kay minuto","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 98546:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ro","long":{"year":{"previous":"anul trecut","current":"anul acesta","next":"anul viitor","past":{"one":"acum {0} an","few":"acum {0} ani","other":"acum {0} de ani"},"future":{"one":"peste {0} an","few":"peste {0} ani","other":"peste {0} de ani"}},"quarter":{"previous":"trimestrul trecut","current":"trimestrul acesta","next":"trimestrul viitor","past":{"one":"acum {0} trimestru","few":"acum {0} trimestre","other":"acum {0} de trimestre"},"future":{"one":"peste {0} trimestru","few":"peste {0} trimestre","other":"peste {0} de trimestre"}},"month":{"previous":"luna trecută","current":"luna aceasta","next":"luna viitoare","past":{"one":"acum {0} lună","few":"acum {0} luni","other":"acum {0} de luni"},"future":{"one":"peste {0} lună","few":"peste {0} luni","other":"peste {0} de luni"}},"week":{"previous":"săptămâna trecută","current":"săptămâna aceasta","next":"săptămâna viitoare","past":{"one":"acum {0} săptămână","few":"acum {0} săptămâni","other":"acum {0} de săptămâni"},"future":{"one":"peste {0} săptămână","few":"peste {0} săptămâni","other":"peste {0} de săptămâni"}},"day":{"previous":"ieri","previous-2":"alaltăieri","current":"azi","next":"mâine","next-2":"poimâine","past":{"one":"acum {0} zi","few":"acum {0} zile","other":"acum {0} de zile"},"future":{"one":"peste {0} zi","few":"peste {0} zile","other":"peste {0} de zile"}},"hour":{"current":"ora aceasta","past":{"one":"acum {0} oră","few":"acum {0} ore","other":"acum {0} de ore"},"future":{"one":"peste {0} oră","few":"peste {0} ore","other":"peste {0} de ore"}},"minute":{"current":"minutul acesta","past":{"one":"acum {0} minut","few":"acum {0} minute","other":"acum {0} de minute"},"future":{"one":"peste {0} minut","few":"peste {0} minute","other":"peste {0} de minute"}},"second":{"current":"acum","past":{"one":"acum {0} secundă","few":"acum {0} secunde","other":"acum {0} de secunde"},"future":{"one":"peste {0} secundă","few":"peste {0} secunde","other":"peste {0} de secunde"}}},"short":{"year":{"previous":"anul trecut","current":"anul acesta","next":"anul viitor","past":{"one":"acum {0} an","few":"acum {0} ani","other":"acum {0} de ani"},"future":{"one":"peste {0} an","few":"peste {0} ani","other":"peste {0} de ani"}},"quarter":{"previous":"trim. trecut","current":"trim. acesta","next":"trim. viitor","past":"acum {0} trim.","future":"peste {0} trim."},"month":{"previous":"luna trecută","current":"luna aceasta","next":"luna viitoare","past":{"one":"acum {0} lună","other":"acum {0} luni"},"future":{"one":"peste {0} lună","other":"peste {0} luni"}},"week":{"previous":"săpt. trecută","current":"săpt. aceasta","next":"săpt. viitoare","past":"acum {0} săpt.","future":"peste {0} săpt."},"day":{"previous":"ieri","previous-2":"alaltăieri","current":"azi","next":"mâine","next-2":"poimâine","past":{"one":"acum {0} zi","few":"acum {0} zile","other":"acum {0} de zile"},"future":{"one":"peste {0} zi","few":"peste {0} zile","other":"peste {0} de zile"}},"hour":{"current":"ora aceasta","past":"acum {0} h","future":"peste {0} h"},"minute":{"current":"minutul acesta","past":"acum {0} min.","future":"peste {0} min."},"second":{"current":"acum","past":"acum {0} sec.","future":"peste {0} sec."}},"narrow":{"year":{"previous":"anul trecut","current":"anul acesta","next":"anul viitor","past":{"one":"-{0} an","other":"-{0} ani"},"future":{"one":"+{0} an","other":"+{0} ani"}},"quarter":{"previous":"trim. trecut","current":"trim. acesta","next":"trim. viitor","past":"-{0} trim.","future":"+{0} trim."},"month":{"previous":"luna trecută","current":"luna aceasta","next":"luna viitoare","past":{"one":"-{0} lună","other":"-{0} luni"},"future":{"one":"+{0} lună","other":"+{0} luni"}},"week":{"previous":"săpt. trecută","current":"săptămâna aceasta","next":"săpt. viitoare","past":"-{0} săpt.","future":"+{0} săpt."},"day":{"previous":"ieri","previous-2":"alaltăieri","current":"azi","next":"mâine","next-2":"poimâine","past":{"one":"-{0} zi","other":"-{0} zile"},"future":{"one":"+{0} zi","other":"+{0} zile"}},"hour":{"current":"ora aceasta","past":"-{0} h","future":"+{0} h"},"minute":{"current":"minutul acesta","past":"-{0} m","future":"+{0} m"},"second":{"current":"acum","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 57692:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ru","long":{"year":{"previous":"в прошлом году","current":"в этом году","next":"в следующем году","past":{"one":"{0} год назад","many":"{0} лет назад","other":"{0} года назад"},"future":{"one":"через {0} год","many":"через {0} лет","other":"через {0} года"}},"quarter":{"previous":"в прошлом квартале","current":"в текущем квартале","next":"в следующем квартале","past":{"one":"{0} квартал назад","many":"{0} кварталов назад","other":"{0} квартала назад"},"future":{"one":"через {0} квартал","many":"через {0} кварталов","other":"через {0} квартала"}},"month":{"previous":"в прошлом месяце","current":"в этом месяце","next":"в следующем месяце","past":{"one":"{0} месяц назад","many":"{0} месяцев назад","other":"{0} месяца назад"},"future":{"one":"через {0} месяц","many":"через {0} месяцев","other":"через {0} месяца"}},"week":{"previous":"на прошлой неделе","current":"на этой неделе","next":"на следующей неделе","past":{"one":"{0} неделю назад","many":"{0} недель назад","other":"{0} недели назад"},"future":{"one":"через {0} неделю","many":"через {0} недель","other":"через {0} недели"}},"day":{"previous":"вчера","previous-2":"позавчера","current":"сегодня","next":"завтра","next-2":"послезавтра","past":{"one":"{0} день назад","many":"{0} дней назад","other":"{0} дня назад"},"future":{"one":"через {0} день","many":"через {0} дней","other":"через {0} дня"}},"hour":{"current":"в этот час","past":{"one":"{0} час назад","many":"{0} часов назад","other":"{0} часа назад"},"future":{"one":"через {0} час","many":"через {0} часов","other":"через {0} часа"}},"minute":{"current":"в эту минуту","past":{"one":"{0} минуту назад","many":"{0} минут назад","other":"{0} минуты назад"},"future":{"one":"через {0} минуту","many":"через {0} минут","other":"через {0} минуты"}},"second":{"current":"сейчас","past":{"one":"{0} секунду назад","many":"{0} секунд назад","other":"{0} секунды назад"},"future":{"one":"через {0} секунду","many":"через {0} секунд","other":"через {0} секунды"}}},"short":{"year":{"previous":"в прошлом г.","current":"в этом г.","next":"в след. г.","past":{"many":"{0} л. назад","other":"{0} г. назад"},"future":{"many":"через {0} л.","other":"через {0} г."}},"quarter":{"previous":"последний кв.","current":"текущий кв.","next":"следующий кв.","past":"{0} кв. назад","future":"через {0} кв."},"month":{"previous":"в прошлом мес.","current":"в этом мес.","next":"в следующем мес.","past":"{0} мес. назад","future":"через {0} мес."},"week":{"previous":"на прошлой нед.","current":"на этой нед.","next":"на следующей нед.","past":"{0} нед. назад","future":"через {0} нед."},"day":{"previous":"вчера","previous-2":"позавчера","current":"сегодня","next":"завтра","next-2":"послезавтра","past":"{0} дн. назад","future":"через {0} дн."},"hour":{"current":"в этот час","past":{"one":"{0} ч. назад","other":"{0} ч. назад"},"future":{"one":"через {0} ч.","other":"через {0} ч."}},"minute":{"current":"в эту минуту","past":"{0} мин. назад","future":"через {0} мин."},"second":{"current":"сейчас","past":"{0} сек. назад","future":"через {0} сек."}},"narrow":{"year":{"previous":"в пр. г.","current":"в эт. г.","next":"в сл. г.","past":{"many":"-{0} л.","other":"-{0} г."},"future":{"many":"+{0} л.","other":"+{0} г."}},"quarter":{"previous":"посл. кв.","current":"тек. кв.","next":"след. кв.","past":"-{0} кв.","future":"+{0} кв."},"month":{"previous":"в пр. мес.","current":"в эт. мес.","next":"в след. мес.","past":"-{0} мес.","future":"+{0} мес."},"week":{"previous":"на пр. нед.","current":"на эт. нед.","next":"на след. неделе","past":"-{0} нед.","future":"+{0} нед."},"day":{"previous":"вчера","previous-2":"позавчера","current":"сегодня","next":"завтра","next-2":"послезавтра","past":"-{0} дн.","future":"+{0} дн."},"hour":{"current":"в этот час","past":"-{0} ч.","future":"+{0} ч."},"minute":{"current":"в эту минуту","past":"-{0} мин.","future":"+{0} мин."},"second":{"current":"сейчас","past":"-{0} с","future":"+{0} с"}}}');

/***/ }),

/***/ 26224:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sah","long":{"year":{"previous":"Былырыын","current":"быйыл","next":"эһиил","past":"{0} сыл ынараа өттүгэр","future":"{0} сылынан"},"quarter":{"previous":"ааспыт кыбаартал","current":"бу кыбаартал","next":"кэлэр кыбаартал","past":"{0} кыбаартал анараа өттүгэр","future":"{0} кыбаарталынан"},"month":{"previous":"ааспыт ый","current":"бу ый","next":"аныгыскы ый","past":"{0} ый ынараа өттүгэр","future":"{0} ыйынан"},"week":{"previous":"ааспыт нэдиэлэ","current":"бу нэдиэлэ","next":"кэлэр нэдиэлэ","past":"{0} нэдиэлэ анараа өттүгэр","future":"{0} нэдиэлэннэн"},"day":{"previous":"Бэҕэһээ","previous-2":"Иллэрээ күн","current":"Бүгүн","next":"Сарсын","next-2":"Өйүүн","past":"{0} күн ынараа өттүгэр","future":"{0} күнүнэн"},"hour":{"current":"this hour","past":"{0} чаас ынараа өттүгэр","future":"{0} чааһынан"},"minute":{"current":"this minute","past":"{0} мүнүүтэ ынараа өттүгэр","future":"{0} мүнүүтэннэн"},"second":{"current":"билигин","past":"{0} сөкүүндэ ынараа өттүгэр","future":"{0} сөкүүндэннэн"}},"short":{"year":{"previous":"Былырыын","current":"быйыл","next":"эһиил","past":"{0} сыл ынараа өттүгэр","future":"{0} сылынан"},"quarter":{"previous":"ааспыт кыбаартал","current":"бу кыбаартал","next":"кэлэр кыбаартал","past":"{0} кыб. анараа өттүгэр","future":"{0} кыбаарталынан"},"month":{"previous":"ааспыт ый","current":"бу ый","next":"аныгыскы ый","past":"{0} ый ынараа өттүгэр","future":"{0} ыйынан"},"week":{"previous":"ааспыт нэдиэлэ","current":"бу нэдиэлэ","next":"кэлэр нэдиэлэ","past":"{0} нэдиэлэ анараа өттүгэр","future":"{0} нэдиэлэннэн"},"day":{"previous":"Бэҕэһээ","previous-2":"Иллэрээ күн","current":"Бүгүн","next":"Сарсын","next-2":"Өйүүн","past":"{0} күн ынараа өттүгэр","future":"{0} күнүнэн"},"hour":{"current":"this hour","past":"{0} чаас ынараа өттүгэр","future":"{0} чааһынан"},"minute":{"current":"this minute","past":"{0} мүнүүтэ ынараа өттүгэр","future":"{0} мүнүүтэннэн"},"second":{"current":"билигин","past":"{0} сөк. анараа өттүгэр","future":"{0} сөкүүндэннэн"}},"narrow":{"year":{"previous":"Былырыын","current":"быйыл","next":"эһиил","past":"{0} сыл ынараа өттүгэр","future":"{0} сылынан"},"quarter":{"previous":"ааспыт кыбаартал","current":"бу кыбаартал","next":"кэлэр кыбаартал","past":"{0} кыб. анараа өттүгэр","future":"{0} кыбаарталынан"},"month":{"previous":"ааспыт ый","current":"бу ый","next":"аныгыскы ый","past":"{0} ый ынараа өттүгэр","future":"{0} ыйынан"},"week":{"previous":"ааспыт нэдиэлэ","current":"бу нэдиэлэ","next":"кэлэр нэдиэлэ","past":"{0} нэдиэлэ анараа өттүгэр","future":"{0} нэдиэлэннэн"},"day":{"previous":"Бэҕэһээ","previous-2":"Иллэрээ күн","current":"Бүгүн","next":"Сарсын","next-2":"Өйүүн","past":"{0} күн ынараа өттүгэр","future":"{0} күнүнэн"},"hour":{"current":"this hour","past":"{0} чаас ынараа өттүгэр","future":"{0} чааһынан"},"minute":{"current":"this minute","past":"{0} мүнүүтэ ынараа өттүгэр","future":"{0} мүнүүтэннэн"},"second":{"current":"билигин","past":"{0} сөк. анараа өттүгэр","future":"{0} сөкүүндэннэн"}}}');

/***/ }),

/***/ 5674:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sd","long":{"year":{"previous":"پويون سال","current":"پويون سال","next":"پويون سال","past":"{0} سال پهرين","future":"{0} سالن ۾"},"quarter":{"previous":"پوئين ٽي ماهي","current":"هن ٽي ماهي","next":"اڳين ٽي ماهي","past":"{0} ٽي ماهي پهرين","future":"{0} ٽي ماهي ۾"},"month":{"previous":"پوئين مهيني","current":"هن مهيني","next":"اڳين مهيني","past":"{0} مهينا پهرين","future":"{0} مهينن ۾"},"week":{"previous":"پوئين هفتي","current":"هن هفتي","next":"اڳين هفتي","past":"{0} هفتا پهرين","future":"{0} هفتن ۾"},"day":{"previous":"ڪل","current":"اڄ","next":"سڀاڻي","past":"{0} ڏينهن پهرين","future":"{0} ڏينهن ۾"},"hour":{"current":"هن ڪلڪ","past":"{0} ڪلاڪ پهرين","future":"{0} ڪلاڪ ۾"},"minute":{"current":"هن منٽ","past":"{0} منٽ پهرين","future":{"one":"{0} منٽن ۾","other":"+{0} min"}},"second":{"current":"هاڻي","past":"{0} سيڪنڊ پهرين","future":"{0} سيڪنڊن ۾"}},"short":{"year":{"previous":"پويون سال","current":"پويون سال","next":"پويون سال","past":"{0} سال پهرين","future":"{0} سالن ۾"},"quarter":{"previous":"پوئين ٽي ماهي","current":"هن ٽي ماهي","next":"اڳين ٽي ماهي","past":"{0} ٽي ماهي پهرين","future":"{0} ٽي ماهي ۾"},"month":{"previous":"پوئين مهيني","current":"هن مهيني","next":"اڳين مهيني","past":"{0} مهينا پهرين","future":"{0} مهينن ۾"},"week":{"previous":"پوئين هفتي","current":"هن هفتي","next":"اڳين هفتي","past":"{0} هفتا پهرين","future":"{0} هفتن ۾"},"day":{"previous":"ڪل","current":"اڄ","next":"سڀاڻي","past":"{0} ڏينهن پهرين","future":"{0} ڏينهن ۾"},"hour":{"current":"هن ڪلڪ","past":"{0} ڪلاڪ پهرين","future":"{0} ڪلاڪ ۾"},"minute":{"current":"هن منٽ","past":"{0} منٽ پهرين","future":"{0} منٽن ۾"},"second":{"current":"هاڻي","past":"{0} سيڪنڊ پهرين","future":"{0} سيڪنڊن ۾"}},"narrow":{"year":{"previous":"پويون سال","current":"پويون سال","next":"پويون سال","past":"{0} سال پهرين","future":"{0} سالن ۾"},"quarter":{"previous":"پوئين ٽي ماهي","current":"هن ٽي ماهي","next":"اڳين ٽي ماهي","past":"{0} ٽي ماهي پهرين","future":"{0} ٽي ماهي ۾"},"month":{"previous":"پوئين مهيني","current":"هن مهيني","next":"اڳين مهيني","past":"{0} مهينا پهرين","future":"{0} مهينن ۾"},"week":{"previous":"پوئين هفتي","current":"هن هفتي","next":"اڳين هفتي","past":"{0} هفتا پهرين","future":"{0} هفتن ۾"},"day":{"previous":"ڪل","current":"اڄ","next":"سڀاڻي","past":"{0} ڏينهن پهرين","future":"{0} ڏينهن ۾"},"hour":{"current":"هن ڪلڪ","past":"{0} ڪلاڪ پهرين","future":"{0} ڪلاڪ ۾"},"minute":{"current":"هن منٽ","past":"{0} منٽ پهرين","future":"{0} منٽن ۾"},"second":{"current":"هاڻي","past":"{0} سيڪنڊ پهرين","future":"{0} سيڪنڊن ۾"}}}');

/***/ }),

/***/ 26959:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"se-FI","long":{"year":{"previous":"diibmá","current":"dán jagi","next":"boahtte jagi","past":{"one":"diibmá","two":"ovddet jagi","other":"{0} jagi dás ovdal"},"future":"{0} jagi siste"},"quarter":{"previous":"mannan njealjádasjagi","current":"dán njealjádasjagi","next":"boahtte njealjádasjagi","past":"-{0} njealjádasjagi dás ovdal","future":"čuovvovaš {0} njealjádasjagi"},"month":{"previous":"mannan mánu","current":"dán mánu","next":"boahtte mánu","past":{"one":"{0} mánnu dás ovdal","other":"{0} mánu dás ovdal"},"future":"{0} mánu siste"},"week":{"previous":"mannan vahku","current":"dán vahku","next":"boahtte vahku","past":{"one":"{0} vahkku dás ovdal","other":"{0} vahku dás ovdal"},"future":"{0} vahku geahčen"},"day":{"previous":"ikte","previous-2":"ovddet beaivvi","current":"odne","next":"ihttin","next-2":"don beaivve","past":{"one":"ikte","two":"ovddet beaivve","other":"{0} beaivve dás ovdal"},"future":"{0} beaivve siste"},"hour":{"current":"dán diimmu","past":{"one":"{0} diibmu áigi","other":"{0} diimmu áigi"},"future":"{0} diimmu siste"},"minute":{"current":"dán minuhta","past":{"one":"{0} minuhtta áigi","other":"{0} minuhta áigi"},"future":"{0} minuhta siste"},"second":{"current":"dál","past":{"one":"{0} sekunda áigi","other":"{0} sekundda áigi"},"future":"{0} sekundda siste"}},"short":{"year":{"previous":"diibmá","current":"dán jagi","next":"boahtte jagi","past":{"one":"diibmá","two":"ovddet jagi","other":"{0} j. dás ovdal"},"future":{"two":"{0} jagi siste","other":"{0} j. siste"}},"quarter":{"previous":"mannan njealjádasjagi","current":"dán njealjádasjagi","next":"boahtte njealjádasjagi","past":{"two":"{0} njealjádasjagi dás ovdal","other":"{0} njealj.j. dás ovdal"},"future":{"two":"boahtte {0} njealjádasjagi","other":"boahtte {0} njealj.j."}},"month":{"previous":"mannan mánu","current":"dán mánu","next":"boahtte mánu","past":{"one":"{0} mánnu dás ovdal","other":"{0} mánu dás ovdal"},"future":"{0} mánu siste"},"week":{"previous":"mannan vahku","current":"dán vahku","next":"boahtte vahku","past":{"two":"{0} vahku dás ovdal","other":"{0} v(k) dás ovdal"},"future":{"two":"{0} vahku siste","other":"{0} v(k) siste"}},"day":{"previous":"ikte","previous-2":"ovddet beaivvi","current":"odne","next":"ihttin","next-2":"don beaivve","past":{"one":"ikte","two":"ovddet beaivve","other":"{0} beaivve dás ovdal"},"future":"{0} beaivve siste"},"hour":{"current":"dán diimmu","past":{"two":"{0} diimmu áigi","other":"{0} dmu áigi"},"future":{"two":"{0} diimmu siste","other":"{0} dmu siste"}},"minute":{"current":"dán minuhta","past":{"two":"{0} minuhta áigi","other":"{0} min. áigi"},"future":{"two":"{0} minuhta siste","other":"{0} min. siste"}},"second":{"current":"dál","past":{"two":"{0} sekundda áigi","other":"{0} sek. áigi"},"future":{"two":"{0} sekundda siste","other":"{0} sek. siste"}}},"narrow":{"year":{"previous":"diibmá","current":"dán jagi","next":"boahtte jagi","past":{"two":"{0} jagi dás ovdal","other":"{0} j. dás ovdal"},"future":"{0} jagi siste"},"quarter":{"previous":"mannan njealjádasjagi","current":"dán njealjádasjagi","next":"boahtte njealjádasjagi","past":{"two":"-{0} njealjádasjagi dás ovdal","other":"{0} njealj.j. dás ovdal"},"future":{"two":"boahtte {0} njealjádasjagi","other":"boahtte {0} njealj.j."}},"month":{"previous":"mannan mánu","current":"dán mánu","next":"boahtte mánu","past":{"one":"{0} mánnu dás ovdal","other":"{0} mánu dás ovdal"},"future":"{0} mánu geahčen"},"week":{"previous":"mannan vahku","current":"dán vahku","next":"boahtte vahku","past":{"one":"{0} vahkku dás ovdal","two":"{0} vahku dás ovdal","other":"{0} v(k) dás ovdal"},"future":"{0} v(k) geahčen"},"day":{"previous":"ikte","previous-2":"ovddet beaivvi","current":"odne","next":"ihttin","next-2":"don beaivve","past":{"one":"ikte","two":"ovddet beaivve","other":"{0} beaivve dás ovdal"},"future":"{0} beaivve siste"},"hour":{"current":"dán diimmu","past":{"two":"{0} diimmu áigi","other":"{0} dmu áigi"},"future":{"two":"{0} diimmu siste","other":"{0} dmu siste"}},"minute":{"current":"dán minuhta","past":{"two":"{0} minuhta áigi","other":"{0} min. áigi"},"future":{"two":"{0} minuhta siste","other":"{0} min. siste"}},"second":{"current":"dál","past":{"two":"{0} sekundda áigi","other":"{0} sek. áigi"},"future":{"two":"{0} sekundda siste","other":"{0} sek. siste"}}}}');

/***/ }),

/***/ 27468:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"se","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} jahki árat","other":"{0} jahkki árat"},"future":{"one":"{0} jahki maŋŋilit","other":"{0} jahkki maŋŋilit"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"{0} mánotbadji árat","future":"{0} mánotbadji maŋŋilit"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} vahku árat","other":"{0} vahkku árat"},"future":{"one":"{0} vahku maŋŋilit","other":"{0} vahkku maŋŋilit"}},"day":{"previous":"ikte","previous-2":"oovdebpeivvi","current":"odne","next":"ihttin","next-2":"paijeelittáá","past":{"one":"{0} jándor árat","other":"{0} jándora árat"},"future":{"one":"{0} jándor maŋŋilit","two":"{0} jándor amaŋŋilit","other":"{0} jándora maŋŋilit"}},"hour":{"current":"this hour","past":{"one":"{0} diibmu árat","other":"{0} diibmur árat"},"future":{"one":"{0} diibmu maŋŋilit","other":"{0} diibmur maŋŋilit"}},"minute":{"current":"this minute","past":{"one":"{0} minuhta árat","other":"{0} minuhtta árat"},"future":{"one":"{0} minuhta maŋŋilit","other":"{0} minuhtta maŋŋilit"}},"second":{"current":"now","past":{"one":"{0} sekunda árat","other":"{0} sekundda árat"},"future":{"one":"{0} sekunda maŋŋilit","other":"{0} sekundda maŋŋilit"}}},"short":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} jahki árat","other":"{0} jahkki árat"},"future":{"one":"{0} jahki maŋŋilit","other":"{0} jahkki maŋŋilit"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"{0} mánotbadji árat","future":"{0} mánotbadji maŋŋilit"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} vahku árat","other":"{0} vahkku árat"},"future":{"one":"{0} vahku maŋŋilit","other":"{0} vahkku maŋŋilit"}},"day":{"previous":"ikte","previous-2":"oovdebpeivvi","current":"odne","next":"ihttin","next-2":"paijeelittáá","past":{"one":"{0} jándor árat","other":"{0} jándora árat"},"future":{"one":"{0} jándor maŋŋilit","two":"{0} jándor amaŋŋilit","other":"{0} jándora maŋŋilit"}},"hour":{"current":"this hour","past":{"one":"{0} diibmu árat","other":"{0} diibmur árat"},"future":{"one":"{0} diibmu maŋŋilit","other":"{0} diibmur maŋŋilit"}},"minute":{"current":"this minute","past":{"one":"{0} minuhta árat","other":"{0} minuhtta árat"},"future":{"one":"{0} minuhta maŋŋilit","other":"{0} minuhtta maŋŋilit"}},"second":{"current":"now","past":{"one":"{0} sekunda árat","other":"{0} sekundda árat"},"future":{"one":"{0} sekunda maŋŋilit","other":"{0} sekundda maŋŋilit"}}},"narrow":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"{0} jahki árat","other":"{0} jahkki árat"},"future":{"one":"{0} jahki maŋŋilit","other":"{0} jahkki maŋŋilit"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"{0} mánotbadji árat","future":"{0} mánotbadji maŋŋilit"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"{0} vahku árat","other":"{0} vahkku árat"},"future":{"one":"{0} vahku maŋŋilit","other":"{0} vahkku maŋŋilit"}},"day":{"previous":"ikte","previous-2":"oovdebpeivvi","current":"odne","next":"ihttin","next-2":"paijeelittáá","past":{"one":"{0} jándor árat","other":"{0} jándora árat"},"future":{"one":"{0} jándor maŋŋilit","two":"{0} jándor amaŋŋilit","other":"{0} jándora maŋŋilit"}},"hour":{"current":"this hour","past":{"one":"{0} diibmu árat","other":"{0} diibmur árat"},"future":{"one":"{0} diibmu maŋŋilit","other":"{0} diibmur maŋŋilit"}},"minute":{"current":"this minute","past":{"one":"{0} minuhta árat","other":"{0} minuhtta árat"},"future":{"one":"{0} minuhta maŋŋilit","other":"{0} minuhtta maŋŋilit"}},"second":{"current":"now","past":{"one":"{0} sekunda árat","other":"{0} sekundda árat"},"future":{"one":"{0} sekunda maŋŋilit","other":"{0} sekundda maŋŋilit"}}}}');

/***/ }),

/***/ 10364:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"si","long":{"year":{"previous":"පසුගිය වසර","current":"මෙම වසර","next":"ඊළඟ වසර","past":"වසර {0}කට පෙර","future":"වසර {0}කින්"},"quarter":{"previous":"පසුගිය කාර්තුව","current":"මෙම කාර්තුව","next":"ඊළඟ කාර්තුව","past":"කාර්තු {0}කට පෙර","future":"කාර්තු {0}කින්"},"month":{"previous":"පසුගිය මාසය","current":"මෙම මාසය","next":"ඊළඟ මාසය","past":"මාස {0}කට පෙර","future":"මාස {0}කින්"},"week":{"previous":"පසුගිය සතිය","current":"මෙම සතිය","next":"ඊළඟ සතිය","past":"සති {0}කට පෙර","future":"සති {0}කින්"},"day":{"previous":"ඊයේ","previous-2":"පෙරේදා","current":"අද","next":"හෙට","next-2":"අනිද්දා","past":"දින {0}කට පෙර","future":"දින {0}න්"},"hour":{"current":"මෙම පැය","past":"පැය {0}කට පෙර","future":"පැය {0}කින්"},"minute":{"current":"මෙම මිනිත්තුව","past":"මිනිත්තු {0}කට පෙර","future":"මිනිත්තු {0}කින්"},"second":{"current":"දැන්","past":"තත්පර {0}කට පෙර","future":"තත්පර {0}කින්"}},"short":{"year":{"previous":"පසුගිය වසර","current":"මෙම වසර","next":"ඊළඟ වසර","past":"වසර {0}කට පෙර","future":"වසර {0}කින්"},"quarter":{"previous":"පසුගිය කාර්.","current":"මෙම කාර්.","next":"ඊළඟ කාර්.","past":"කාර්. {0}කට පෙර","future":"කාර්. {0}කින්"},"month":{"previous":"පසුගිය මාස.","current":"මෙම මාස.","next":"ඊළඟ මාස.","past":"මාස {0}කට පෙර","future":"මාස {0}කින්"},"week":{"previous":"පසුගිය සති.","current":"මෙම සති.","next":"ඊළඟ සති.","past":"සති {0}කට පෙර","future":"සති {0}කින්"},"day":{"previous":"ඊයේ","previous-2":"පෙරේදා","current":"අද","next":"හෙට","next-2":"අනිද්දා","past":"දින {0}කට පෙර","future":"දින {0}න්"},"hour":{"current":"මෙම පැය","past":"පැය {0}කට පෙර","future":"පැය {0}කින්"},"minute":{"current":"මෙම මිනිත්තුව","past":"මිනිත්තු {0}කට පෙර","future":"මිනිත්තු {0}කින්"},"second":{"current":"දැන්","past":"තත්පර {0}කට පෙර","future":"තත්පර {0}කින්"}},"narrow":{"year":{"previous":"පසුගිය වසර","current":"මෙම වසර","next":"ඊළඟ වසර","past":"වසර {0}කට පෙර","future":"වසර {0}කින්"},"quarter":{"previous":"පසුගිය කාර්.","current":"මෙම කාර්.","next":"ඊළඟ කාර්.","past":"කාර්. {0}කට පෙර","future":"කාර්. {0}කින්"},"month":{"previous":"පසුගිය මාස.","current":"මෙම මාස.","next":"ඊළඟ මාස.","past":"මාස {0}කට පෙර","future":"මාස {0}කින්"},"week":{"previous":"පසුගිය සති.","current":"මෙම සති.","next":"ඊළඟ සති.","past":"සති {0}කට පෙර","future":"සති {0}කින්"},"day":{"previous":"ඊයේ","previous-2":"පෙරේදා","current":"අද","next":"හෙට","next-2":"අනිද්දා","past":"දින {0}කට පෙර","future":"දින {0}න්"},"hour":{"current":"මෙම පැය","past":"පැය {0}කට පෙර","future":"පැය {0}කින්"},"minute":{"current":"මෙම මිනිත්තුව","past":"මිනිත්තු {0}කට පෙර","future":"මිනිත්තු {0}කින්"},"second":{"current":"දැන්","past":"තත්පර {0}කට පෙර","future":"තත්පර {0}කින්"}}}');

/***/ }),

/***/ 10540:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sk","long":{"year":{"previous":"minulý rok","current":"tento rok","next":"budúci rok","past":{"one":"pred {0} rokom","many":"pred {0} roka","other":"pred {0} rokmi"},"future":{"one":"o {0} rok","few":"o {0} roky","many":"o {0} roka","other":"o {0} rokov"}},"quarter":{"previous":"minulý štvrťrok","current":"tento štvrťrok","next":"budúci štvrťrok","past":{"one":"pred {0} štvrťrokom","many":"pred {0} štvrťroka","other":"pred {0} štvrťrokmi"},"future":{"one":"o {0} štvrťrok","few":"o {0} štvrťroky","many":"o {0} štvrťroka","other":"o {0} štvrťrokov"}},"month":{"previous":"minulý mesiac","current":"tento mesiac","next":"budúci mesiac","past":{"one":"pred {0} mesiacom","many":"pred {0} mesiaca","other":"pred {0} mesiacmi"},"future":{"one":"o {0} mesiac","few":"o {0} mesiace","many":"o {0} mesiaca","other":"o {0} mesiacov"}},"week":{"previous":"minulý týždeň","current":"tento týždeň","next":"budúci týždeň","past":{"one":"pred {0} týždňom","many":"pred {0} týždňa","other":"pred {0} týždňami"},"future":{"one":"o {0} týždeň","few":"o {0} týždne","many":"o {0} týždňa","other":"o {0} týždňov"}},"day":{"previous":"včera","previous-2":"predvčerom","current":"dnes","next":"zajtra","next-2":"pozajtra","past":{"one":"pred {0} dňom","many":"pred {0} dňa","other":"pred {0} dňami"},"future":{"one":"o {0} deň","few":"o {0} dni","many":"o {0} dňa","other":"o {0} dní"}},"hour":{"current":"v tejto hodine","past":{"one":"pred {0} hodinou","many":"pred {0} hodinou","other":"pred {0} hodinami"},"future":{"one":"o {0} hodinu","few":"o {0} hodiny","many":"o {0} hodiny","other":"o {0} hodín"}},"minute":{"current":"v tejto minúte","past":{"one":"pred {0} minútou","many":"pred {0} minúty","other":"pred {0} minútami"},"future":{"one":"o {0} minútu","few":"o {0} minúty","many":"o {0} minúty","other":"o {0} minút"}},"second":{"current":"teraz","past":{"one":"pred {0} sekundou","many":"pred {0} sekundy","other":"pred {0} sekundami"},"future":{"one":"o {0} sekundu","few":"o {0} sekundy","many":"o {0} sekundy","other":"o {0} sekúnd"}}},"short":{"year":{"previous":"minulý rok","current":"tento rok","next":"budúci rok","past":"pred {0} r.","future":"o {0} r."},"quarter":{"previous":"minulý štvrťr.","current":"tento štvrťr.","next":"budúci štvrťr.","past":"pred {0} štvrťr.","future":"o {0} štvrťr."},"month":{"previous":"minulý mes.","current":"tento mes.","next":"budúci mes.","past":"pred {0} mes.","future":"o {0} mes."},"week":{"previous":"minulý týž.","current":"tento týž.","next":"budúci týž.","past":"pred {0} týž.","future":"o {0} týž."},"day":{"previous":"včera","previous-2":"predvčerom","current":"dnes","next":"zajtra","next-2":"pozajtra","past":"pred {0} d.","future":"o {0} d."},"hour":{"current":"v tejto hodine","past":"pred {0} h","future":"o {0} h"},"minute":{"current":"v tejto minúte","past":"pred {0} min","future":"o {0} min"},"second":{"current":"teraz","past":"pred {0} s","future":"o {0} s"}},"narrow":{"year":{"previous":"minulý rok","current":"tento rok","next":"budúci rok","past":"pred {0} r.","future":"o {0} r."},"quarter":{"previous":"minulý štvrťr.","current":"tento štvrťr.","next":"budúci štvrťr.","past":"pred {0} štvrťr.","future":"o {0} štvrťr."},"month":{"previous":"minulý mes.","current":"tento mes.","next":"budúci mes.","past":"pred {0} mes.","future":"o {0} mes."},"week":{"previous":"minulý týž.","current":"tento týž.","next":"budúci týž.","past":"pred {0} týž.","future":"o {0} týž."},"day":{"previous":"včera","previous-2":"predvčerom","current":"dnes","next":"zajtra","next-2":"pozajtra","past":"pred {0} d.","future":"o {0} d."},"hour":{"current":"v tejto hodine","past":"pred {0} h","future":"o {0} h"},"minute":{"current":"v tejto minúte","past":"pred {0} min","future":"o {0} min"},"second":{"current":"teraz","past":"pred {0} s","future":"o {0} s"}}}');

/***/ }),

/***/ 53472:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sl","long":{"year":{"previous":"lani","current":"letos","next":"naslednje leto","past":{"one":"pred {0} letom","two":"pred {0} letoma","other":"pred {0} leti"},"future":{"one":"čez {0} leto","two":"čez {0} leti","few":"čez {0} leta","other":"čez {0} let"}},"quarter":{"previous":"zadnje četrtletje","current":"to četrtletje","next":"naslednje četrtletje","past":{"one":"pred {0} četrtletjem","two":"pred {0} četrtletjema","other":"pred {0} četrtletji"},"future":{"one":"čez {0} četrtletje","two":"čez {0} četrtletji","few":"čez {0} četrtletja","other":"čez {0} četrtletij"}},"month":{"previous":"prejšnji mesec","current":"ta mesec","next":"naslednji mesec","past":{"one":"pred {0} mesecem","two":"pred {0} mesecema","other":"pred {0} meseci"},"future":{"one":"čez {0} mesec","two":"čez {0} meseca","few":"čez {0} mesece","other":"čez {0} mesecev"}},"week":{"previous":"prejšnji teden","current":"ta teden","next":"naslednji teden","past":{"one":"pred {0} tednom","two":"pred {0} tednoma","other":"pred {0} tedni"},"future":{"one":"čez {0} teden","two":"čez {0} tedna","few":"čez {0} tedne","other":"čez {0} tednov"}},"day":{"previous":"včeraj","previous-2":"predvčerajšnjim","current":"danes","next":"jutri","next-2":"pojutrišnjem","past":{"one":"pred {0} dnevom","two":"pred {0} dnevoma","other":"pred {0} dnevi"},"future":{"one":"čez {0} dan","two":"čez {0} dneva","other":"čez {0} dni"}},"hour":{"current":"v tej uri","past":{"one":"pred {0} uro","two":"pred {0} urama","other":"pred {0} urami"},"future":{"one":"čez {0} uro","two":"čez {0} uri","few":"čez {0} ure","other":"čez {0} ur"}},"minute":{"current":"to minuto","past":{"one":"pred {0} minuto","two":"pred {0} minutama","other":"pred {0} minutami"},"future":{"one":"čez {0} minuto","two":"čez {0} minuti","few":"čez {0} minute","other":"čez {0} minut"}},"second":{"current":"zdaj","past":{"one":"pred {0} sekundo","two":"pred {0} sekundama","other":"pred {0} sekundami"},"future":{"one":"čez {0} sekundo","two":"čez {0} sekundi","few":"čez {0} sekunde","other":"čez {0} sekund"}}},"short":{"year":{"previous":"lani","current":"letos","next":"naslednje leto","past":{"one":"pred {0} letom","two":"pred {0} letoma","other":"pred {0} leti"},"future":{"one":"čez {0} leto","two":"čez {0} leti","few":"čez {0} leta","other":"čez {0} let"}},"quarter":{"previous":"zadnje četrtletje","current":"to četrtletje","next":"naslednje četrtletje","past":"pred {0} četrtl.","future":"čez {0} četrtl."},"month":{"previous":"prejšnji mesec","current":"ta mesec","next":"naslednji mesec","past":"pred {0} mes.","future":"čez {0} mes."},"week":{"previous":"prejšnji teden","current":"ta teden","next":"naslednji teden","past":"pred {0} ted.","future":"čez {0} ted."},"day":{"previous":"včeraj","previous-2":"predvčerajšnjim","current":"danes","next":"jutri","next-2":"pojutrišnjem","past":{"one":"pred {0} dnevom","two":"pred {0} dnevoma","other":"pred {0} dnevi"},"future":{"one":"čez {0} dan","two":"čez {0} dneva","other":"čez {0} dni"}},"hour":{"current":"v tej uri","past":{"one":"pred {0} uro","two":"pred {0} urama","other":"pred {0} urami"},"future":{"one":"čez {0} uro","two":"čez {0} uri","few":"čez {0} ure","other":"čez {0} ur"}},"minute":{"current":"to minuto","past":"pred {0} min.","future":"čez {0} min."},"second":{"current":"zdaj","past":"pred {0} s","future":"čez {0} s"}},"narrow":{"year":{"previous":"lani","current":"letos","next":"naslednje leto","past":{"one":"pred {0} letom","two":"pred {0} letoma","other":"pred {0} leti"},"future":{"one":"čez {0} leto","two":"čez {0} leti","few":"čez {0} leta","other":"čez {0} let"}},"quarter":{"previous":"zadnje četrtletje","current":"to četrtletje","next":"naslednje četrtletje","past":"pred {0} četr.","future":"čez {0} četr."},"month":{"previous":"prejšnji mesec","current":"ta mesec","next":"naslednji mesec","past":"pred {0} mes.","future":"čez {0} mes."},"week":{"previous":"prejšnji teden","current":"ta teden","next":"naslednji teden","past":"pred {0} ted.","future":"čez {0} ted."},"day":{"previous":"včeraj","previous-2":"predvčerajšnjim","current":"danes","next":"jutri","next-2":"pojutrišnjem","past":{"one":"pred {0} dnevom","two":"pred {0} dnevoma","other":"pred {0} dnevi"},"future":{"one":"čez {0} dan","two":"čez {0} dneva","other":"čez {0} dni"}},"hour":{"current":"v tej uri","past":"pred {0} h","future":"čez {0} h"},"minute":{"current":"to minuto","past":"pred {0} min","future":"čez {0} min"},"second":{"current":"zdaj","past":"pred {0} s","future":"čez {0} s"}}}');

/***/ }),

/***/ 60449:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"so","long":{"year":{"previous":"Sannadkii la soo dhaafay","current":"Sannadkan","next":"Sannadka xiga","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Bishii la soo dhaafay","current":"Bishan","next":"Bisha xigta","past":"-{0} m","future":"+{0} m"},"week":{"previous":"Usbuucii la soo dhaafay","current":"Usbuucan","next":"Usbuuca xiga","past":"-{0} w","future":"+{0} w"},"day":{"previous":"Shalay","current":"Maanta","next":"Berri","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"Sannadkii la soo dhaafay","current":"Sannadkan","next":"Sannadka xiga","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Bishii la soo dhaafay","current":"Bishan","next":"Bisha xigta","past":"-{0} m","future":"+{0} m"},"week":{"previous":"Usbuucii la soo dhaafay","current":"Usbuucan","next":"Usbuuca xiga","past":"-{0} w","future":"+{0} w"},"day":{"previous":"Shalay","current":"Maanta","next":"Berri","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"Sannadkii la soo dhaafay","current":"Sannadkan","next":"Sannadka xiga","past":"-{0} y","future":"+{0} y"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"Bishii la soo dhaafay","current":"Bishan","next":"Bisha xigta","past":"-{0} m","future":"+{0} m"},"week":{"previous":"Usbuucii la soo dhaafay","current":"Usbuucan","next":"Usbuuca xiga","past":"-{0} w","future":"+{0} w"},"day":{"previous":"Shalay","current":"Maanta","next":"Berri","past":"-{0} d","future":"+{0} d"},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 21883:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sq","long":{"year":{"previous":"vjet","current":"sivjet","next":"mot","past":{"one":"{0} vit më parë","other":"{0} vjet më parë"},"future":{"one":"pas {0} viti","other":"pas {0} vjetësh"}},"quarter":{"previous":"tremujorin e kaluar","current":"këtë tremujor","next":"tremujorin e ardhshëm","past":{"one":"{0} tremujor më parë","other":"{0} tremujorë më parë"},"future":{"one":"pas {0} tremujori","other":"pas {0} tremujorësh"}},"month":{"previous":"muajin e kaluar","current":"këtë muaj","next":"muajin e ardhshëm","past":"{0} muaj më parë","future":{"one":"pas {0} muaji","other":"pas {0} muajsh"}},"week":{"previous":"javën e kaluar","current":"këtë javë","next":"javën e ardhshme","past":"{0} javë më parë","future":{"one":"pas {0} jave","other":"pas {0} javësh"}},"day":{"previous":"dje","current":"sot","next":"nesër","past":"{0} ditë më parë","future":{"one":"pas {0} dite","other":"pas {0} ditësh"}},"hour":{"current":"këtë orë","past":"{0} orë më parë","future":{"one":"pas {0} ore","other":"pas {0} orësh"}},"minute":{"current":"këtë minutë","past":{"one":"{0} minutë më parë","other":"{0} minuta më parë"},"future":{"one":"pas {0} minute","other":"pas {0} minutash"}},"second":{"current":"tani","past":{"one":"{0} sekondë më parë","other":"{0} sekonda më parë"},"future":{"one":"pas {0} sekonde","other":"pas {0} sekondash"}}},"short":{"year":{"previous":"vitin e kaluar","current":"këtë vit","next":"vitin e ardhshëm","past":{"one":"{0} vit më parë","other":"{0} vjet më parë"},"future":{"one":"pas {0} viti","other":"pas {0} vjetësh"}},"quarter":{"previous":"tremujorin e kaluar","current":"këtë tremujor","next":"tremujorin e ardhshëm","past":{"one":"{0} tremujor më parë","other":"{0} tremujorë më parë"},"future":{"one":"pas {0} tremujori","other":"pas {0} tremujorësh"}},"month":{"previous":"muajin e kaluar","current":"këtë muaj","next":"muajin e ardhshëm","past":"{0} muaj më parë","future":{"one":"pas {0} muaji","other":"pas {0} muajsh"}},"week":{"previous":"javën e kaluar","current":"këtë javë","next":"javën e ardhshme","past":"{0} javë më parë","future":{"one":"pas {0} jave","other":"pas {0} javësh"}},"day":{"previous":"dje","current":"sot","next":"nesër","past":"{0} ditë më parë","future":{"one":"pas {0} dite","other":"pas {0} ditësh"}},"hour":{"current":"këtë orë","past":"{0} orë më parë","future":{"one":"pas {0} ore","other":"pas {0} orësh"}},"minute":{"current":"këtë minutë","past":"{0} min më parë","future":"pas {0} min"},"second":{"current":"tani","past":"{0} sek më parë","future":"pas {0} sek"}},"narrow":{"year":{"previous":"vitin e kaluar","current":"këtë vit","next":"vitin e ardhshëm","past":{"one":"{0} vit më parë","other":"{0} vjet më parë"},"future":{"one":"pas {0} viti","other":"pas {0} vjetësh"}},"quarter":{"previous":"tremujorin e kaluar","current":"këtë tremujor","next":"tremujorin e ardhshëm","past":{"one":"{0} tremujor më parë","other":"{0} tremujorë më parë"},"future":{"one":"pas {0} tremujori","other":"pas {0} tremujorësh"}},"month":{"previous":"muajin e kaluar","current":"këtë muaj","next":"muajin e ardhshëm","past":"{0} muaj më parë","future":{"one":"pas {0} muaji","other":"pas {0} muajsh"}},"week":{"previous":"javën e kaluar","current":"këtë javë","next":"javën e ardhshme","past":"{0} javë më parë","future":{"one":"pas {0} jave","other":"pas {0} javësh"}},"day":{"previous":"dje","current":"sot","next":"nesër","past":"{0} ditë më parë","future":{"one":"pas {0} dite","other":"pas {0} ditësh"}},"hour":{"current":"këtë orë","past":"{0} orë më parë","future":{"one":"pas {0} ore","other":"pas {0} orësh"}},"minute":{"current":"këtë minutë","past":"{0} min më parë","future":"pas {0} min"},"second":{"current":"tani","past":"{0} sek më parë","future":"pas {0} sek"}}}');

/***/ }),

/***/ 32079:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sr-Latn","long":{"year":{"previous":"prošle godine","current":"ove godine","next":"sledeće godine","past":{"one":"pre {0} godine","few":"pre {0} godine","other":"pre {0} godina"},"future":{"one":"za {0} godinu","few":"za {0} godine","other":"za {0} godina"}},"quarter":{"previous":"prošlog kvartala","current":"ovog kvartala","next":"sledećeg kvartala","past":"pre {0} kvartala","future":{"one":"za {0} kvartal","other":"za {0} kvartala"}},"month":{"previous":"prošlog meseca","current":"ovog meseca","next":"sledećeg meseca","past":{"one":"pre {0} meseca","few":"pre {0} meseca","other":"pre {0} meseci"},"future":{"one":"za {0} mesec","few":"za {0} meseca","other":"za {0} meseci"}},"week":{"previous":"prošle nedelje","current":"ove nedelje","next":"sledeće nedelje","past":{"one":"pre {0} nedelje","few":"pre {0} nedelje","other":"pre {0} nedelja"},"future":{"one":"za {0} nedelju","few":"za {0} nedelje","other":"za {0} nedelja"}},"day":{"previous":"juče","previous-2":"prekjuče","current":"danas","next":"sutra","next-2":"prekosutra","past":"pre {0} dana","future":{"one":"za {0} dan","other":"za {0} dana"}},"hour":{"current":"ovog sata","past":{"one":"pre {0} sata","few":"pre {0} sata","other":"pre {0} sati"},"future":{"one":"za {0} sat","few":"za {0} sata","other":"za {0} sati"}},"minute":{"current":"ovog minuta","past":"pre {0} minuta","future":{"one":"za {0} minut","other":"za {0} minuta"}},"second":{"current":"sada","past":{"one":"pre {0} sekunde","few":"pre {0} sekunde","other":"pre {0} sekundi"},"future":{"one":"za {0} sekundu","few":"za {0} sekunde","other":"za {0} sekundi"}}},"short":{"year":{"previous":"prošle god.","current":"ove god.","next":"sledeće god.","past":"pre {0} god.","future":"za {0} god."},"quarter":{"previous":"prošlog kvartala","current":"ovog kvartala","next":"sledećeg kvartala","past":"pre {0} kv.","future":"za {0} kv."},"month":{"previous":"prošlog mes.","current":"ovog mes.","next":"sledećeg mes.","past":"pre {0} mes.","future":"za {0} mes."},"week":{"previous":"prošle ned.","current":"ove ned.","next":"sledeće ned.","past":"pre {0} ned.","future":"za {0} ned."},"day":{"previous":"juče","previous-2":"prekjuče","current":"danas","next":"sutra","next-2":"prekosutra","past":"pre {0} d.","future":"za {0} d."},"hour":{"current":"ovog sata","past":"pre {0} č.","future":"za {0} č."},"minute":{"current":"ovog minuta","past":"pre {0} min.","future":"za {0} min."},"second":{"current":"sada","past":"pre {0} sek.","future":"za {0} sek."}},"narrow":{"year":{"previous":"prošle g.","current":"ove g.","next":"sledeće g.","past":"pre {0} g.","future":"za {0} g."},"quarter":{"previous":"prošlog kvartala","current":"ovog kvartala","next":"sledećeg kvartala","past":"pre {0} kv.","future":"za {0} kv."},"month":{"previous":"prošlog m.","current":"ovog m.","next":"sledećeg m.","past":"pre {0} m.","future":"za {0} m."},"week":{"previous":"prošle n.","current":"ove n.","next":"sledeće n.","past":"pre {0} n.","future":"za {0} n."},"day":{"previous":"juče","previous-2":"prekjuče","current":"danas","next":"sutra","next-2":"prekosutra","past":"pre {0} d.","future":"za {0} d."},"hour":{"current":"ovog sata","past":"pre {0} č.","future":"za {0} č."},"minute":{"current":"ovog minuta","past":"pre {0} min.","future":"za {0} min."},"second":{"current":"sada","past":"pre {0} s.","future":"za {0} s."}}}');

/***/ }),

/***/ 90505:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sr","long":{"year":{"previous":"прошле године","current":"ове године","next":"следеће године","past":{"one":"пре {0} године","few":"пре {0} године","other":"пре {0} година"},"future":{"one":"за {0} годину","few":"за {0} године","other":"за {0} година"}},"quarter":{"previous":"прошлог квартала","current":"овог квартала","next":"следећег квартала","past":"пре {0} квартала","future":{"one":"за {0} квартал","other":"за {0} квартала"}},"month":{"previous":"прошлог месеца","current":"овог месеца","next":"следећег месеца","past":{"one":"пре {0} месеца","few":"пре {0} месеца","other":"пре {0} месеци"},"future":{"one":"за {0} месец","few":"за {0} месеца","other":"за {0} месеци"}},"week":{"previous":"прошле недеље","current":"ове недеље","next":"следеће недеље","past":{"one":"пре {0} недеље","few":"пре {0} недеље","other":"пре {0} недеља"},"future":{"one":"за {0} недељу","few":"за {0} недеље","other":"за {0} недеља"}},"day":{"previous":"јуче","previous-2":"прекјуче","current":"данас","next":"сутра","next-2":"прекосутра","past":"пре {0} дана","future":{"one":"за {0} дан","other":"за {0} дана"}},"hour":{"current":"овог сата","past":{"one":"пре {0} сата","few":"пре {0} сата","other":"пре {0} сати"},"future":{"one":"за {0} сат","few":"за {0} сата","other":"за {0} сати"}},"minute":{"current":"овог минута","past":"пре {0} минута","future":{"one":"за {0} минут","other":"за {0} минута"}},"second":{"current":"сада","past":{"one":"пре {0} секунде","few":"пре {0} секунде","other":"пре {0} секунди"},"future":{"one":"за {0} секунду","few":"за {0} секунде","other":"за {0} секунди"}}},"short":{"year":{"previous":"прошле год.","current":"ове год.","next":"следеће год.","past":"пре {0} год.","future":"за {0} год."},"quarter":{"previous":"прошлог квартала","current":"овог квартала","next":"следећег квартала","past":"пре {0} кв.","future":"за {0} кв."},"month":{"previous":"прошлог мес.","current":"овог мес.","next":"следећег мес.","past":"пре {0} мес.","future":"за {0} мес."},"week":{"previous":"прошле нед.","current":"ове нед.","next":"следеће нед.","past":"пре {0} нед.","future":"за {0} нед."},"day":{"previous":"јуче","previous-2":"прекјуче","current":"данас","next":"сутра","next-2":"прекосутра","past":"пре {0} д.","future":"за {0} д."},"hour":{"current":"овог сата","past":"пре {0} ч.","future":"за {0} ч."},"minute":{"current":"овог минута","past":"пре {0} мин.","future":"за {0} мин."},"second":{"current":"сада","past":"пре {0} сек.","future":"за {0} сек."}},"narrow":{"year":{"previous":"прошле г.","current":"ове г.","next":"следеће г.","past":"пре {0} г.","future":"за {0} г."},"quarter":{"previous":"прошлог квартала","current":"овог квартала","next":"следећег квартала","past":"пре {0} кв.","future":"за {0} кв."},"month":{"previous":"прошлог м.","current":"овог м.","next":"следећег м.","past":"пре {0} м.","future":"за {0} м."},"week":{"previous":"прошле н.","current":"ове н.","next":"следеће н.","past":"пре {0} н.","future":"за {0} н."},"day":{"previous":"јуче","previous-2":"прекјуче","current":"данас","next":"сутра","next-2":"прекосутра","past":"пре {0} д.","future":"за {0} д."},"hour":{"current":"овог сата","past":"пре {0} ч.","future":"за {0} ч."},"minute":{"current":"овог минута","past":"пре {0} мин.","future":"за {0} мин."},"second":{"current":"сада","past":"пре {0} с.","future":"за {0} с."}}}');

/***/ }),

/***/ 7111:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sv","long":{"year":{"previous":"i fjol","current":"i år","next":"nästa år","past":"för {0} år sedan","future":"om {0} år"},"quarter":{"previous":"förra kvartalet","current":"detta kvartal","next":"nästa kvartal","past":"för {0} kvartal sedan","future":"om {0} kvartal"},"month":{"previous":"förra månaden","current":"denna månad","next":"nästa månad","past":{"one":"för {0} månad sedan","other":"för {0} månader sedan"},"future":{"one":"om {0} månad","other":"om {0} månader"}},"week":{"previous":"förra veckan","current":"denna vecka","next":"nästa vecka","past":{"one":"för {0} vecka sedan","other":"för {0} veckor sedan"},"future":{"one":"om {0} vecka","other":"om {0} veckor"}},"day":{"previous":"i går","previous-2":"i förrgår","current":"i dag","next":"i morgon","next-2":"i övermorgon","past":{"one":"för {0} dag sedan","other":"för {0} dagar sedan"},"future":{"one":"om {0} dag","other":"om {0} dagar"}},"hour":{"current":"denna timme","past":{"one":"för {0} timme sedan","other":"för {0} timmar sedan"},"future":{"one":"om {0} timme","other":"om {0} timmar"}},"minute":{"current":"denna minut","past":{"one":"för {0} minut sedan","other":"för {0} minuter sedan"},"future":{"one":"om {0} minut","other":"om {0} minuter"}},"second":{"current":"nu","past":{"one":"för {0} sekund sedan","other":"för {0} sekunder sedan"},"future":{"one":"om {0} sekund","other":"om {0} sekunder"}}},"short":{"year":{"previous":"i fjol","current":"i år","next":"nästa år","past":"för {0} år sen","future":"om {0} år"},"quarter":{"previous":"förra kv.","current":"detta kv.","next":"nästa kv.","past":"för {0} kv. sen","future":"om {0} kv."},"month":{"previous":"förra mån.","current":"denna mån.","next":"nästa mån.","past":"för {0} mån. sen","future":"om {0} mån."},"week":{"previous":"förra v.","current":"denna v.","next":"nästa v.","past":"för {0} v. sedan","future":"om {0} v."},"day":{"previous":"i går","previous-2":"i förrgår","current":"i dag","next":"i morgon","next-2":"i övermorgon","past":{"one":"för {0} d sedan","other":"för {0} d sedan"},"future":"om {0} d"},"hour":{"current":"denna timme","past":"för {0} tim sedan","future":"om {0} tim"},"minute":{"current":"denna minut","past":"för {0} min sen","future":"om {0} min"},"second":{"current":"nu","past":"för {0} s sen","future":{"one":"om {0} sek","other":"om {0} sek"}}},"narrow":{"year":{"previous":"i fjol","current":"i år","next":"nästa år","past":"−{0} år","future":"+{0} år"},"quarter":{"previous":"förra kv.","current":"detta kv.","next":"nästa kv.","past":"−{0} kv","future":"+{0} kv."},"month":{"previous":"förra mån.","current":"denna mån.","next":"nästa mån.","past":"−{0} mån","future":"+{0} mån."},"week":{"previous":"förra v.","current":"denna v.","next":"nästa v.","past":"−{0} v","future":"+{0} v."},"day":{"previous":"igår","previous-2":"i förrgår","current":"idag","next":"imorgon","next-2":"i övermorgon","past":"−{0} d","future":"+{0} d"},"hour":{"current":"denna timme","past":"−{0} h","future":"+{0} h"},"minute":{"current":"denna minut","past":"−{0} min","future":"+{0} min"},"second":{"current":"nu","past":"−{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 62255:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"sw","long":{"year":{"previous":"mwaka uliopita","current":"mwaka huu","next":"mwaka ujao","past":{"one":"mwaka {0} uliopita","other":"miaka {0} iliyopita"},"future":{"one":"baada ya mwaka {0}","other":"baada ya miaka {0}"}},"quarter":{"previous":"robo ya mwaka iliyopita","current":"robo hii ya mwaka","next":"robo ya mwaka inayofuata","past":{"one":"robo {0} iliyopita","other":"robo {0} zilizopita"},"future":"baada ya robo {0}"},"month":{"previous":"mwezi uliopita","current":"mwezi huu","next":"mwezi ujao","past":{"one":"mwezi {0} uliopita","other":"miezi {0} iliyopita"},"future":{"one":"baada ya mwezi {0}","other":"baada ya miezi {0}"}},"week":{"previous":"wiki iliyopita","current":"wiki hii","next":"wiki ijayo","past":{"one":"wiki {0} iliyopita","other":"wiki {0} zilizopita"},"future":"baada ya wiki {0}"},"day":{"previous":"jana","previous-2":"juzi","current":"leo","next":"kesho","next-2":"kesho kutwa","past":{"one":"siku {0} iliyopita","other":"siku {0} zilizopita"},"future":"baada ya siku {0}"},"hour":{"current":"saa hii","past":{"one":"saa {0} iliyopita","other":"saa {0} zilizopita"},"future":"baada ya saa {0}"},"minute":{"current":"dakika hii","past":{"one":"dakika {0} iliyopita","other":"dakika {0} zilizopita"},"future":"baada ya dakika {0}"},"second":{"current":"sasa hivi","past":{"one":"Sekunde {0} iliyopita","other":"Sekunde {0} zilizopita"},"future":"baada ya sekunde {0}"}},"short":{"year":{"previous":"mwaka uliopita","current":"mwaka huu","next":"mwaka ujao","past":{"one":"mwaka {0} uliopita","other":"miaka {0} iliyopita"},"future":{"one":"baada ya mwaka {0}","other":"baada ya miaka {0}"}},"quarter":{"previous":"robo ya mwaka iliyopita","current":"robo hii ya mwaka","next":"robo ya mwaka inayofuata","past":{"one":"robo {0} iliyopita","other":"robo {0} zilizopita"},"future":"baada ya robo {0}"},"month":{"previous":"mwezi uliopita","current":"mwezi huu","next":"mwezi ujao","past":{"one":"mwezi {0} uliopita","other":"miezi {0} iliyopita"},"future":{"one":"baada ya mwezi {0}","other":"baada ya miezi {0}"}},"week":{"previous":"wiki iliyopita","current":"wiki hii","next":"wiki ijayo","past":{"one":"wiki {0} iliyopita","other":"wiki {0} zilizopita"},"future":"baada ya wiki {0}"},"day":{"previous":"jana","previous-2":"juzi","current":"leo","next":"kesho","next-2":"kesho kutwa","past":{"one":"siku {0} iliyopita","other":"siku {0} zilizopita"},"future":"baada ya siku {0}"},"hour":{"current":"saa hii","past":{"one":"saa {0} iliyopita","other":"saa {0} zilizopita"},"future":"baada ya saa {0}"},"minute":{"current":"dakika hii","past":{"one":"dakika {0} iliyopita","other":"dakika {0} zilizopita"},"future":"baada ya dakika {0}"},"second":{"current":"sasa hivi","past":{"one":"sekunde {0} iliyopita","other":"sekunde {0} zilizopita"},"future":"baada ya sekunde {0}"}},"narrow":{"year":{"previous":"mwaka uliopita","current":"mwaka huu","next":"mwaka ujao","past":{"one":"mwaka {0} uliopita","other":"miaka {0} iliyopita"},"future":{"one":"baada ya mwaka {0}","other":"baada ya miaka {0}"}},"quarter":{"previous":"robo ya mwaka iliyopita","current":"robo hii ya mwaka","next":"robo ya mwaka inayofuata","past":{"one":"robo {0} iliyopita","other":"robo {0} zilizopita"},"future":"baada ya robo {0}"},"month":{"previous":"mwezi uliopita","current":"mwezi huu","next":"mwezi ujao","past":{"one":"mwezi {0} uliopita","other":"miezi {0} iliyopita"},"future":{"one":"baada ya mwezi {0}","other":"baada ya miezi {0}"}},"week":{"previous":"wiki iliyopita","current":"wiki hii","next":"wiki ijayo","past":{"one":"wiki {0} iliyopita","other":"wiki {0} zilizopita"},"future":"baada ya wiki {0}"},"day":{"previous":"jana","previous-2":"juzi","current":"leo","next":"kesho","next-2":"kesho kutwa","past":{"one":"siku {0} iliyopita","other":"siku {0} zilizopita"},"future":"baada ya siku {0}"},"hour":{"current":"saa hii","past":{"one":"Saa {0} iliyopita","other":"Saa {0} zilizopita"},"future":"baada ya saa {0}"},"minute":{"current":"dakika hii","past":{"one":"dakika {0} iliyopita","other":"dakika {0} zilizopita"},"future":"baada ya dakika {0}"},"second":{"current":"sasa hivi","past":{"one":"sekunde {0} iliyopita","other":"sekunde {0} zilizopita"},"future":"baada ya sekunde {0}"}}}');

/***/ }),

/***/ 29434:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ta","long":{"year":{"previous":"கடந்த ஆண்டு","current":"இந்த ஆண்டு","next":"அடுத்த ஆண்டு","past":{"one":"{0} ஆண்டிற்கு முன்","other":"{0} ஆண்டுகளுக்கு முன்"},"future":{"one":"{0} ஆண்டில்","other":"{0} ஆண்டுகளில்"}},"quarter":{"previous":"கடந்த காலாண்டு","current":"இந்த காலாண்டு","next":"அடுத்த காலாண்டு","past":{"one":"{0} காலாண்டுக்கு முன்","other":"{0} காலாண்டுகளுக்கு முன்"},"future":{"one":"+{0} காலாண்டில்","other":"{0} காலாண்டுகளில்"}},"month":{"previous":"கடந்த மாதம்","current":"இந்த மாதம்","next":"அடுத்த மாதம்","past":{"one":"{0} மாதத்துக்கு முன்","other":"{0} மாதங்களுக்கு முன்"},"future":{"one":"{0} மாதத்தில்","other":"{0} மாதங்களில்"}},"week":{"previous":"கடந்த வாரம்","current":"இந்த வாரம்","next":"அடுத்த வாரம்","past":{"one":"{0} வாரத்திற்கு முன்","other":"{0} வாரங்களுக்கு முன்"},"future":{"one":"{0} வாரத்தில்","other":"{0} வாரங்களில்"}},"day":{"previous":"நேற்று","previous-2":"நேற்று முன் தினம்","current":"இன்று","next":"நாளை","next-2":"நாளை மறுநாள்","past":{"one":"{0} நாளுக்கு முன்","other":"{0} நாட்களுக்கு முன்"},"future":{"one":"{0} நாளில்","other":"{0} நாட்களில்"}},"hour":{"current":"இந்த ஒரு மணிநேரத்தில்","past":"{0} மணிநேரம் முன்","future":"{0} மணிநேரத்தில்"},"minute":{"current":"இந்த ஒரு நிமிடத்தில்","past":{"one":"{0} நிமிடத்திற்கு முன்","other":"{0} நிமிடங்களுக்கு முன்"},"future":{"one":"{0} நிமிடத்தில்","other":"{0} நிமிடங்களில்"}},"second":{"current":"இப்போது","past":{"one":"{0} விநாடிக்கு முன்","other":"{0} விநாடிகளுக்கு முன்"},"future":{"one":"{0} விநாடியில்","other":"{0} விநாடிகளில்"}}},"short":{"year":{"previous":"கடந்த ஆண்டு","current":"இந்த ஆண்டு","next":"அடுத்த ஆண்டு","past":{"one":"{0} ஆண்டிற்கு முன்","other":"{0} ஆண்டுகளுக்கு முன்"},"future":{"one":"{0} ஆண்டில்","other":"{0} ஆண்டுகளில்"}},"quarter":{"previous":"இறுதி காலாண்டு","current":"இந்த காலாண்டு","next":"அடுத்த காலாண்டு","past":"{0} காலா. முன்","future":"{0} காலா."},"month":{"previous":"கடந்த மாதம்","current":"இந்த மாதம்","next":"அடுத்த மாதம்","past":"{0} மாத. முன்","future":"{0} மாத."},"week":{"previous":"கடந்த வாரம்","current":"இந்த வாரம்","next":"அடுத்த வாரம்","past":"{0} வார. முன்","future":"{0} வார."},"day":{"previous":"நேற்று","previous-2":"நேற்று முன் தினம்","current":"இன்று","next":"நாளை","next-2":"நாளை மறுநாள்","past":{"one":"{0} நாளுக்கு முன்","other":"{0} நாட்களுக்கு முன்"},"future":{"one":"{0} நாளில்","other":"{0} நாட்களில்"}},"hour":{"current":"இந்த ஒரு மணிநேரத்தில்","past":"{0} மணி. முன்","future":"{0} மணி."},"minute":{"current":"இந்த ஒரு நிமிடத்தில்","past":"{0} நிமி. முன்","future":"{0} நிமி."},"second":{"current":"இப்போது","past":"{0} விநா. முன்","future":"{0} விநா."}},"narrow":{"year":{"previous":"கடந்த ஆண்டு","current":"இந்த ஆண்டு","next":"அடுத்த ஆண்டு","past":"{0} ஆ. முன்","future":"{0} ஆ."},"quarter":{"previous":"இறுதி காலாண்டு","current":"இந்த காலாண்டு","next":"அடுத்த காலாண்டு","past":"{0} கா. முன்","future":"{0} கா."},"month":{"previous":"கடந்த மாதம்","current":"இந்த மாதம்","next":"அடுத்த மாதம்","past":"{0} மா. முன்","future":"{0} மா."},"week":{"previous":"கடந்த வாரம்","current":"இந்த வாரம்","next":"அடுத்த வாரம்","past":"{0} வா. முன்","future":"{0} வா."},"day":{"previous":"நேற்று","previous-2":"நேற்று முன் தினம்","current":"இன்று","next":"நாளை","next-2":"நாளை மறுநாள்","past":"{0} நா. முன்","future":"{0} நா."},"hour":{"current":"இந்த ஒரு மணிநேரத்தில்","past":"{0} ம. முன்","future":"{0} ம."},"minute":{"current":"இந்த ஒரு நிமிடத்தில்","past":"{0} நி. முன்","future":"{0} நி."},"second":{"current":"இப்போது","past":"{0} வி. முன்","future":"{0} வி."}}}');

/***/ }),

/***/ 80991:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"te","long":{"year":{"previous":"గత సంవత్సరం","current":"ఈ సంవత్సరం","next":"తదుపరి సంవత్సరం","past":{"one":"{0} సంవత్సరం క్రితం","other":"{0} సంవత్సరాల క్రితం"},"future":{"one":"{0} సంవత్సరంలో","other":"{0} సంవత్సరాల్లో"}},"quarter":{"previous":"గత త్రైమాసికం","current":"ఈ త్రైమాసికం","next":"తదుపరి త్రైమాసికం","past":{"one":"{0} త్రైమాసికం క్రితం","other":"{0} త్రైమాసికాల క్రితం"},"future":{"one":"{0} త్రైమాసికంలో","other":"{0} త్రైమాసికాల్లో"}},"month":{"previous":"గత నెల","current":"ఈ నెల","next":"తదుపరి నెల","past":{"one":"{0} నెల క్రితం","other":"{0} నెలల క్రితం"},"future":{"one":"{0} నెలలో","other":"{0} నెలల్లో"}},"week":{"previous":"గత వారం","current":"ఈ వారం","next":"తదుపరి వారం","past":{"one":"{0} వారం క్రితం","other":"{0} వారాల క్రితం"},"future":{"one":"{0} వారంలో","other":"{0} వారాల్లో"}},"day":{"previous":"నిన్న","previous-2":"మొన్న","current":"ఈ రోజు","next":"రేపు","next-2":"ఎల్లుండి","past":{"one":"{0} రోజు క్రితం","other":"{0} రోజుల క్రితం"},"future":{"one":"{0} రోజులో","other":"{0} రోజుల్లో"}},"hour":{"current":"ఈ గంట","past":{"one":"{0} గంట క్రితం","other":"{0} గంటల క్రితం"},"future":{"one":"{0} గంటలో","other":"{0} గంటల్లో"}},"minute":{"current":"ఈ నిమిషం","past":{"one":"{0} నిమిషం క్రితం","other":"{0} నిమిషాల క్రితం"},"future":{"one":"{0} నిమిషంలో","other":"{0} నిమిషాల్లో"}},"second":{"current":"ప్రస్తుతం","past":{"one":"{0} సెకను క్రితం","other":"{0} సెకన్ల క్రితం"},"future":{"one":"{0} సెకనులో","other":"{0} సెకన్లలో"}}},"short":{"year":{"previous":"గత సంవత్సరం","current":"ఈ సంవత్సరం","next":"తదుపరి సంవత్సరం","past":"{0} సం. క్రితం","future":{"one":"{0} సం.లో","other":"{0} సం.ల్లో"}},"quarter":{"previous":"గత త్రైమాసికం","current":"ఈ త్రైమాసికం","next":"తదుపరి త్రైమాసికం","past":"{0} త్రైమా. క్రితం","future":{"one":"{0} త్రైమా.లో","other":"{0} త్రైమా.ల్లో"}},"month":{"previous":"గత నెల","current":"ఈ నెల","next":"తదుపరి నెల","past":{"one":"{0} నెల క్రితం","other":"{0} నెలల క్రితం"},"future":{"one":"{0} నెలలో","other":"{0} నెలల్లో"}},"week":{"previous":"గత వారం","current":"ఈ వారం","next":"తదుపరి వారం","past":{"one":"{0} వారం క్రితం","other":"{0} వారాల క్రితం"},"future":{"one":"{0} వారంలో","other":"{0} వారాల్లో"}},"day":{"previous":"నిన్న","previous-2":"మొన్న","current":"ఈ రోజు","next":"రేపు","next-2":"ఎల్లుండి","past":{"one":"{0} రోజు క్రితం","other":"{0} రోజుల క్రితం"},"future":{"one":"{0} రోజులో","other":"{0} రోజుల్లో"}},"hour":{"current":"ఈ గంట","past":"{0} గం. క్రితం","future":"{0} గం.లో"},"minute":{"current":"ఈ నిమిషం","past":"{0} నిమి. క్రితం","future":"{0} నిమి.లో"},"second":{"current":"ప్రస్తుతం","past":"{0} సెక. క్రితం","future":{"one":"{0} సెకనులో","other":"{0} సెకన్లలో"}}},"narrow":{"year":{"previous":"గత సంవత్సరం","current":"ఈ సంవత్సరం","next":"తదుపరి సంవత్సరం","past":"{0} సం. క్రితం","future":{"one":"{0} సం.లో","other":"{0} సం.ల్లో"}},"quarter":{"previous":"గత త్రైమాసికం","current":"ఈ త్రైమాసికం","next":"తదుపరి త్రైమాసికం","past":"{0} త్రైమా. క్రితం","future":{"one":"{0} త్రైమాసికంలో","other":"{0} త్రైమాసికాల్లో"}},"month":{"previous":"గత నెల","current":"ఈ నెల","next":"తదుపరి నెల","past":{"one":"{0} నెల క్రితం","other":"{0} నెలల క్రితం"},"future":{"one":"{0} నెలలో","other":"{0} నెలల్లో"}},"week":{"previous":"గత వారం","current":"ఈ వారం","next":"తదుపరి వారం","past":{"one":"{0} వారం క్రితం","other":"{0} వారాల క్రితం"},"future":{"one":"{0} వారంలో","other":"{0} వారాల్లో"}},"day":{"previous":"నిన్న","previous-2":"మొన్న","current":"ఈ రోజు","next":"రేపు","next-2":"ఎల్లుండి","past":{"one":"{0} రోజు క్రితం","other":"{0} రోజుల క్రితం"},"future":{"one":"{0} రోజులో","other":"{0} రోజుల్లో"}},"hour":{"current":"ఈ గంట","past":"{0} గం. క్రితం","future":"{0} గం.లో"},"minute":{"current":"ఈ నిమిషం","past":"{0} నిమి. క్రితం","future":"{0} నిమి.లో"},"second":{"current":"ప్రస్తుతం","past":"{0} సెక. క్రితం","future":{"one":"{0} సెక.లో","other":"{0} సెక. లో"}}}}');

/***/ }),

/***/ 42181:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"th","long":{"year":{"previous":"ปีที่แล้ว","current":"ปีนี้","next":"ปีหน้า","past":"{0} ปีที่แล้ว","future":"ในอีก {0} ปี"},"quarter":{"previous":"ไตรมาสที่แล้ว","current":"ไตรมาสนี้","next":"ไตรมาสหน้า","past":"{0} ไตรมาสที่แล้ว","future":"ในอีก {0} ไตรมาส"},"month":{"previous":"เดือนที่แล้ว","current":"เดือนนี้","next":"เดือนหน้า","past":"{0} เดือนที่ผ่านมา","future":"ในอีก {0} เดือน"},"week":{"previous":"สัปดาห์ที่แล้ว","current":"สัปดาห์นี้","next":"สัปดาห์หน้า","past":"{0} สัปดาห์ที่ผ่านมา","future":"ในอีก {0} สัปดาห์"},"day":{"previous":"เมื่อวาน","previous-2":"เมื่อวานซืน","current":"วันนี้","next":"พรุ่งนี้","next-2":"มะรืนนี้","past":"{0} วันที่ผ่านมา","future":"ในอีก {0} วัน"},"hour":{"current":"ชั่วโมงนี้","past":"{0} ชั่วโมงที่ผ่านมา","future":"ในอีก {0} ชั่วโมง"},"minute":{"current":"นาทีนี้","past":"{0} นาทีที่ผ่านมา","future":"ในอีก {0} นาที"},"second":{"current":"ขณะนี้","past":"{0} วินาทีที่ผ่านมา","future":"ในอีก {0} วินาที"}},"short":{"year":{"previous":"ปีที่แล้ว","current":"ปีนี้","next":"ปีหน้า","past":"{0} ปีที่แล้ว","future":"ใน {0} ปี"},"quarter":{"previous":"ไตรมาสที่แล้ว","current":"ไตรมาสนี้","next":"ไตรมาสหน้า","past":"{0} ไตรมาสที่แล้ว","future":"ใน {0} ไตรมาส"},"month":{"previous":"เดือนที่แล้ว","current":"เดือนนี้","next":"เดือนหน้า","past":"{0} เดือนที่แล้ว","future":"ใน {0} เดือน"},"week":{"previous":"สัปดาห์ที่แล้ว","current":"สัปดาห์นี้","next":"สัปดาห์หน้า","past":"{0} สัปดาห์ที่แล้ว","future":"ใน {0} สัปดาห์"},"day":{"previous":"เมื่อวาน","previous-2":"เมื่อวานซืน","current":"วันนี้","next":"พรุ่งนี้","next-2":"มะรืนนี้","past":"{0} วันที่แล้ว","future":"ใน {0} วัน"},"hour":{"current":"ชั่วโมงนี้","past":"{0} ชม. ที่แล้ว","future":"ใน {0} ชม."},"minute":{"current":"นาทีนี้","past":"{0} นาทีที่แล้ว","future":"ใน {0} นาที"},"second":{"current":"ขณะนี้","past":"{0} วินาทีที่แล้ว","future":"ใน {0} วินาที"}},"narrow":{"year":{"previous":"ปีที่แล้ว","current":"ปีนี้","next":"ปีหน้า","past":"{0} ปีที่แล้ว","future":"ใน {0} ปี"},"quarter":{"previous":"ไตรมาสที่แล้ว","current":"ไตรมาสนี้","next":"ไตรมาสหน้า","past":"{0} ไตรมาสที่แล้ว","future":"ใน {0} ไตรมาส"},"month":{"previous":"เดือนที่แล้ว","current":"เดือนนี้","next":"เดือนหน้า","past":"{0} เดือนที่แล้ว","future":"ใน {0} เดือน"},"week":{"previous":"สัปดาห์ที่แล้ว","current":"สัปดาห์นี้","next":"สัปดาห์หน้า","past":"{0} สัปดาห์ที่แล้ว","future":"ใน {0} สัปดาห์"},"day":{"previous":"เมื่อวาน","previous-2":"เมื่อวานซืน","current":"วันนี้","next":"พรุ่งนี้","next-2":"มะรืนนี้","past":"{0} วันที่แล้ว","future":"ใน {0} วัน"},"hour":{"current":"ชั่วโมงนี้","past":"{0} ชม. ที่แล้ว","future":"ใน {0} ชม."},"minute":{"current":"นาทีนี้","past":"{0} นาทีที่แล้ว","future":"ใน {0} นาที"},"second":{"current":"ขณะนี้","past":"{0} วินาทีที่แล้ว","future":"ใน {0} วินาที"}}}');

/***/ }),

/***/ 49934:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ti","long":{"year":{"previous":"ዓሚ","current":"ሎሚ ዓመት","next":"ንዓመታ","past":"ቅድሚ {0} ዓ","future":"ኣብ {0} ዓ"},"quarter":{"previous":"ዝሓለፈ ርብዒ","current":"ህሉው ርብዒ","next":"ዝመጽእ ርብዒ","past":"ቅድሚ {0} ርብዒ","future":"ኣብ {0} ርብዒ"},"month":{"previous":"last month","current":"ህሉው ወርሒ","next":"ዝመጽእ ወርሒ","past":"ቅድሚ {0} ወርሒ","future":"ኣብ {0} ወርሒ"},"week":{"previous":"ዝሓለፈ ሰሙን","current":"ህሉው ሰሙን","next":"ዝመጽእ ሰሙን","past":"ቅድሚ {0} ሰሙን","future":"ኣብ {0} ሰሙን"},"day":{"previous":"ትማሊ","current":"ሎሚ","next":"ጽባሕ","past":{"one":"ቅድሚ {0} መዓልቲ","other":"ኣብ {0} መዓልቲ"},"future":"ኣብ {0} መዓልቲ"},"hour":{"current":"ኣብዚ ሰዓት","past":"ቅድሚ {0} ሰዓት","future":"ኣብ {0} ሰዓት"},"minute":{"current":"ኣብዚ ደቒቕ","past":"ቅድሚ {0} ደቒቕ","future":"ኣብ {0} ደቒቕ"},"second":{"current":"ሕጂ","past":"ቅድሚ {0} ካልኢት","future":"ኣብ {0} ካልኢት"}},"short":{"year":{"previous":"ዓሚ","current":"ሎሚ ዓመት","next":"ንዓመታ","past":{"one":"ቅድሚ -{0} ዓ","other":"ቅድሚ {0} ዓ"},"future":"ኣብ {0} ዓ"},"quarter":{"previous":"ዝሓለፈ ርብዒ","current":"ህሉው ርብዒ","next":"ዝመጽእ ርብዒ","past":"ቅድሚ {0} ርብዒ","future":"ኣብ {0} ርብዒ"},"month":{"previous":"last month","current":"ህሉው ወርሒ","next":"ዝመጽእ ወርሒ","past":"ቅድሚ {0} ወርሒ","future":"ኣብ {0} ወርሒ"},"week":{"previous":"ዝሓለፈ ሰሙን","current":"ህሉው ሰሙን","next":"ዝመጽእ ሰሙን","past":"ቅድሚ {0} ሰሙን","future":"ኣብ {0} ሰሙን"},"day":{"previous":"ትማሊ","current":"ሎሚ","next":"ጽባሕ","past":"ቅድሚ {0} መዓልቲ","future":"ኣብ {0} መዓልቲ"},"hour":{"current":"ኣብዚ ሰዓት","past":"ቅድሚ {0} ሰዓት","future":"ኣብ {0} ሰዓት"},"minute":{"current":"ኣብዚ ደቒቕ","past":"ቅድሚ {0} ደቒቕ","future":"ኣብ {0} ደቒቕ"},"second":{"current":"ሕጂ","past":"ቅድሚ {0} ካልኢት","future":"ኣብ {0} ካልኢት"}},"narrow":{"year":{"previous":"ዓሚ","current":"ሎሚ ዓመት","next":"ንዓመታ","past":"ቅድሚ {0} ዓ","future":"ኣብ {0} ዓ"},"quarter":{"previous":"ዝሓለፈ ርብዒ","current":"ህሉው ርብዒ","next":"ዝመጽእ ርብዒ","past":"ቅድሚ {0} ርብዒ","future":"ኣብ {0} ርብዒ"},"month":{"previous":"last month","current":"ህሉው ወርሒ","next":"ዝመጽእ ወርሒ","past":"ቅድሚ {0} ወርሒ","future":"ኣብ {0} ወርሒ"},"week":{"previous":"ዝሓለፈ ሰሙን","current":"ህሉው ሰሙን","next":"ዝመጽእ ሰሙን","past":"ቅድሚ {0} ሰሙን","future":"ኣብ {0} ሰሙን"},"day":{"previous":"ትማሊ","current":"ሎሚ","next":"ጽባሕ","past":"ቅድሚ {0} መዓልቲ","future":"ኣብ {0} መዓልቲ"},"hour":{"current":"ኣብዚ ሰዓት","past":"ቅድሚ {0} ሰዓት","future":"ኣብ {0} ሰዓት"},"minute":{"current":"ኣብዚ ደቒቕ","past":"ቅድሚ {0} ደቒቕ","future":"ኣብ {0} ደቒቕ"},"second":{"current":"ሕጂ","past":"ቅድሚ {0} ካልኢት","future":"ኣብ {0} ካልኢት"}}}');

/***/ }),

/***/ 44545:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"tk","long":{"year":{"previous":"geçen ýyl","current":"şu ýyl","next":"indiki ýyl","past":"{0} ýyl öň","future":"{0} ýyldan"},"quarter":{"previous":"geçen çärýek","current":"şu çärýek","next":"indiki çärýek","past":"{0} çärýek öň","future":"{0} çärýekden"},"month":{"previous":"geçen aý","current":"şu aý","next":"indiki aý","past":"{0} aý öň","future":"{0} aýdan"},"week":{"previous":"geçen hepde","current":"şu hepde","next":"indiki hepde","past":"{0} hepde öň","future":"{0} hepdeden"},"day":{"previous":"düýn","current":"şu gün","next":"ertir","past":"{0} gün öň","future":"{0} günden"},"hour":{"current":"şu sagat","past":"{0} sagat öň","future":"{0} sagatdan"},"minute":{"current":"şu minut","past":"{0} minut öň","future":"{0} minutdan"},"second":{"current":"häzir","past":"{0} sekunt öň","future":"{0} sekuntdan"}},"short":{"year":{"previous":"geçen ýyl","current":"şu ýyl","next":"indiki ýyl","past":"{0} ý. öň","future":"{0} ý-dan"},"quarter":{"previous":"geçen çärýek","current":"şu çärýek","next":"indiki çärýek","past":"{0} çär. öň","future":"{0} çär-den"},"month":{"previous":"geçen aý","current":"şu aý","next":"indiki aý","past":"{0} aý öň","future":"{0} aýdan"},"week":{"previous":"geçen hepde","current":"şu hepde","next":"indiki hepde","past":"{0} hep. öň","future":"{0} hep-den"},"day":{"previous":"düýn","current":"şu gün","next":"ertir","past":"{0} g. öň","future":"{0} g-den"},"hour":{"current":"şu sagat","past":"{0} sag. öň","future":"{0} sag-dan"},"minute":{"current":"şu minut","past":"{0} min. öň","future":"{0} min-dan"},"second":{"current":"häzir","past":"{0} sek. öň","future":"{0} sek-dan"}},"narrow":{"year":{"previous":"geçen ýyl","current":"şu ýyl","next":"indiki ýyl","past":"{0} ý. öň","future":"{0} ý-dan"},"quarter":{"previous":"geçen çärýek","current":"şu çärýek","next":"indiki çärýek","past":"{0} ç. öň","future":"{0} ç-den"},"month":{"previous":"geçen aý","current":"şu aý","next":"indiki aý","past":"{0} aý öň","future":"{0} aýdan"},"week":{"previous":"geçen hepde","current":"şu hepde","next":"indiki hepde","past":"{0} h. öň","future":"{0} h-den"},"day":{"previous":"düýn","current":"şu gün","next":"ertir","past":"{0} g. öň","future":"{0} g-den"},"hour":{"current":"şu sagat","past":"{0} sag. öň","future":"{0} sag-dan"},"minute":{"current":"şu minut","past":"{0} min. öň","future":"{0} min-dan"},"second":{"current":"häzir","past":"{0} sek. öň","future":"{0} sek-dan"}}}');

/***/ }),

/***/ 41086:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"to","long":{"year":{"previous":"taʻu kuoʻosi","current":"taʻú ni","next":"taʻu kahaʻu","past":"taʻu ʻe {0} kuoʻosi","future":"ʻi he taʻu ʻe {0}"},"quarter":{"previous":"kuata kuoʻosi","current":"kuata koʻeni","next":"kuata hoko","past":"kuata ʻe {0} kuoʻosi","future":"ʻi he kuata ʻe {0}"},"month":{"previous":"māhina kuoʻosi","current":"māhiná ni","next":"māhina kahaʻu","past":"māhina ʻe {0} kuoʻosi","future":"ʻi he māhina ʻe {0}"},"week":{"previous":"uike kuoʻosi","current":"uiké ni","next":"uike kahaʻu","past":"uike ʻe {0} kuoʻosi","future":"ʻi he uike ʻe {0}"},"day":{"previous":"ʻaneafi","previous-2":"ʻaneheafi","current":"ʻahó ni","next":"ʻapongipongi","next-2":"ʻahepongipongi","past":"ʻaho ʻe {0} kuoʻosi","future":"ʻi he ʻaho ʻe {0}"},"hour":{"current":"this hour","past":"houa ʻe {0} kuoʻosi","future":"ʻi he houa ʻe {0}"},"minute":{"current":"this minute","past":"miniti ʻe {0} kuoʻosi","future":"ʻi he miniti ʻe {0}"},"second":{"current":"taimí ni","past":"sekoni ʻe {0} kuoʻosi","future":"ʻi he sekoni ʻe {0}"}},"short":{"year":{"previous":"taʻu kuoʻosi","current":"taʻú ni","next":"taʻu kahaʻu","past":"taʻu ʻe {0} kuoʻosi","future":"ʻi he taʻu ʻe {0}"},"quarter":{"previous":"kuata kuoʻosi","current":"kuata koʻeni","next":"kuata hoko","past":"kuata ʻe {0} kuoʻosi","future":"ʻi he kuata ʻe {0}"},"month":{"previous":"māhina kuoʻosi","current":"māhiná ni","next":"māhina kahaʻu","past":"māhina ʻe {0} kuoʻosi","future":"ʻi he māhina ʻe {0}"},"week":{"previous":"uike kuoʻosi","current":"uiké ni","next":"uike kahaʻu","past":"uike ʻe {0} kuoʻosi","future":"ʻi he uike ʻe {0}"},"day":{"previous":"ʻaneafi","previous-2":"ʻaneheafi","current":"ʻahó ni","next":"ʻapongipongi","next-2":"ʻahepongipongi","past":"ʻaho ʻe {0} kuoʻosi","future":"ʻi he ʻaho ʻe {0}"},"hour":{"current":"this hour","past":"houa ʻe {0} kuoʻosi","future":"ʻi he houa ʻe {0}"},"minute":{"current":"this minute","past":"miniti ʻe {0} kuoʻosi","future":"ʻi he miniti ʻe {0}"},"second":{"current":"taimí ni","past":"sekoni ʻe {0} kuoʻosi","future":"ʻi he sekoni ʻe {0}"}},"narrow":{"year":{"previous":"taʻu kuoʻosi","current":"taʻú ni","next":"taʻu kahaʻu","past":"taʻu ʻe {0} kuoʻosi","future":"ʻi he taʻu ʻe {0}"},"quarter":{"previous":"kuata kuoʻosi","current":"kuata koʻeni","next":"kuata hoko","past":"kuata ʻe {0} kuoʻosi","future":"ʻi he kuata ʻe {0}"},"month":{"previous":"māhina kuoʻosi","current":"māhiná ni","next":"māhina kahaʻu","past":"māhina ʻe {0} kuoʻosi","future":"ʻi he māhina ʻe {0}"},"week":{"previous":"uike kuoʻosi","current":"uiké ni","next":"uike kahaʻu","past":"uike ʻe {0} kuoʻosi","future":"ʻi he uike ʻe {0}"},"day":{"previous":"ʻaneafi","previous-2":"ʻaneheafi","current":"ʻahó ni","next":"ʻapongipongi","next-2":"ʻahepongipongi","past":"ʻaho ʻe {0} kuoʻosi","future":"ʻi he ʻaho ʻe {0}"},"hour":{"current":"this hour","past":"houa ʻe {0} kuoʻosi","future":"ʻi he houa ʻe {0}"},"minute":{"current":"this minute","past":"miniti ʻe {0} kuoʻosi","future":"ʻi he miniti ʻe {0}"},"second":{"current":"taimí ni","past":"sekoni ʻe {0} kuoʻosi","future":"ʻi he sekoni ʻe {0}"}}}');

/***/ }),

/***/ 19562:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"tr","long":{"year":{"previous":"geçen yıl","current":"bu yıl","next":"gelecek yıl","past":"{0} yıl önce","future":"{0} yıl sonra"},"quarter":{"previous":"geçen çeyrek","current":"bu çeyrek","next":"gelecek çeyrek","past":"{0} çeyrek önce","future":"{0} çeyrek sonra"},"month":{"previous":"geçen ay","current":"bu ay","next":"gelecek ay","past":"{0} ay önce","future":"{0} ay sonra"},"week":{"previous":"geçen hafta","current":"bu hafta","next":"gelecek hafta","past":"{0} hafta önce","future":"{0} hafta sonra"},"day":{"previous":"dün","previous-2":"evvelsi gün","current":"bugün","next":"yarın","next-2":"öbür gün","past":"{0} gün önce","future":"{0} gün sonra"},"hour":{"current":"bu saat","past":"{0} saat önce","future":"{0} saat sonra"},"minute":{"current":"bu dakika","past":"{0} dakika önce","future":"{0} dakika sonra"},"second":{"current":"şimdi","past":"{0} saniye önce","future":"{0} saniye sonra"}},"short":{"year":{"previous":"geçen yıl","current":"bu yıl","next":"gelecek yıl","past":"{0} yıl önce","future":"{0} yıl sonra"},"quarter":{"previous":"geçen çeyrek","current":"bu çeyrek","next":"gelecek çeyrek","past":"{0} çyr. önce","future":"{0} çyr. sonra"},"month":{"previous":"geçen ay","current":"bu ay","next":"gelecek ay","past":"{0} ay önce","future":"{0} ay sonra"},"week":{"previous":"geçen hafta","current":"bu hafta","next":"gelecek hafta","past":"{0} hf. önce","future":"{0} hf. sonra"},"day":{"previous":"dün","previous-2":"evvelsi gün","current":"bugün","next":"yarın","next-2":"öbür gün","past":"{0} gün önce","future":"{0} gün sonra"},"hour":{"current":"bu saat","past":"{0} sa. önce","future":"{0} sa. sonra"},"minute":{"current":"bu dakika","past":"{0} dk. önce","future":"{0} dk. sonra"},"second":{"current":"şimdi","past":"{0} sn. önce","future":"{0} sn. sonra"}},"narrow":{"year":{"previous":"geçen yıl","current":"bu yıl","next":"gelecek yıl","past":"{0} yıl önce","future":"{0} yıl sonra"},"quarter":{"previous":"geçen çeyrek","current":"bu çeyrek","next":"gelecek çeyrek","past":"{0} çyr. önce","future":"{0} çyr. sonra"},"month":{"previous":"geçen ay","current":"bu ay","next":"gelecek ay","past":"{0} ay önce","future":"{0} ay sonra"},"week":{"previous":"geçen hafta","current":"bu hafta","next":"gelecek hafta","past":"{0} hf. önce","future":"{0} hf. sonra"},"day":{"previous":"dün","previous-2":"evvelsi gün","current":"bugün","next":"yarın","next-2":"öbür gün","past":"{0} gün önce","future":"{0} gün sonra"},"hour":{"current":"bu saat","past":"{0} sa. önce","future":"{0} sa. sonra"},"minute":{"current":"bu dakika","past":"{0} dk. önce","future":"{0} dk. sonra"},"second":{"current":"şimdi","past":"{0} sn. önce","future":"{0} sn. sonra"}}}');

/***/ }),

/***/ 38213:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ug","long":{"year":{"previous":"ئۆتكەن يىل","current":"بۇ يىل","next":"كېلەر يىل","past":"{0} يىل ئىلگىرى","future":"{0} يىلدىن كېيىن"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"ئۆتكەن ئاي","current":"بۇ ئاي","next":"كېلەر ئاي","past":"{0} ئاي ئىلگىرى","future":"{0} ئايدىن كېيىن"},"week":{"previous":"ئۆتكەن ھەپتە","current":"بۇ ھەپتە","next":"كېلەر ھەپتە","past":"{0} ھەپتە ئىلگىرى","future":"{0} ھەپتىدىن كېيىن"},"day":{"previous":"تۈنۈگۈن","current":"بۈگۈن","next":"ئەتە","past":"{0} كۈن ئىلگىرى","future":"{0} كۈندىن كېيىن"},"hour":{"current":"this hour","past":"{0} سائەت ئىلگىرى","future":"{0} سائەتتىن كېيىن"},"minute":{"current":"this minute","past":"{0} مىنۇت ئىلگىرى","future":"{0} مىنۇتتىن كېيىن"},"second":{"current":"now","past":"{0} سېكۇنت ئىلگىرى","future":"{0} سېكۇنتتىن كېيىن"}},"short":{"year":{"previous":"ئۆتكەن يىل","current":"بۇ يىل","next":"كېلەر يىل","past":"{0} يىل ئىلگىرى","future":"{0} يىلدىن كېيىن"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"ئۆتكەن ئاي","current":"بۇ ئاي","next":"كېلەر ئاي","past":"{0} ئاي ئىلگىرى","future":"{0} ئايدىن كېيىن"},"week":{"previous":"ئۆتكەن ھەپتە","current":"بۇ ھەپتە","next":"كېلەر ھەپتە","past":"{0} ھەپتە ئىلگىرى","future":"{0} ھەپتىدىن كېيىن"},"day":{"previous":"تۈنۈگۈن","current":"بۈگۈن","next":"ئەتە","past":"{0} كۈن ئىلگىرى","future":"{0} كۈندىن كېيىن"},"hour":{"current":"this hour","past":"{0} سائەت ئىلگىرى","future":"{0} سائەتتىن كېيىن"},"minute":{"current":"this minute","past":"{0} مىنۇت ئىلگىرى","future":"{0} مىنۇتتىن كېيىن"},"second":{"current":"now","past":"{0} سېكۇنت ئىلگىرى","future":"{0} سېكۇنتتىن كېيىن"}},"narrow":{"year":{"previous":"ئۆتكەن يىل","current":"بۇ يىل","next":"كېلەر يىل","past":"{0} يىل ئىلگىرى","future":"{0} يىلدىن كېيىن"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"ئۆتكەن ئاي","current":"بۇ ئاي","next":"كېلەر ئاي","past":"{0} ئاي ئىلگىرى","future":"{0} ئايدىن كېيىن"},"week":{"previous":"ئۆتكەن ھەپتە","current":"بۇ ھەپتە","next":"كېلەر ھەپتە","past":"{0} ھەپتە ئىلگىرى","future":"{0} ھەپتىدىن كېيىن"},"day":{"previous":"تۈنۈگۈن","current":"بۈگۈن","next":"ئەتە","past":"{0} كۈن ئىلگىرى","future":"{0} كۈندىن كېيىن"},"hour":{"current":"this hour","past":"{0} سائەت ئىلگىرى","future":"{0} سائەتتىن كېيىن"},"minute":{"current":"this minute","past":"{0} مىنۇت ئىلگىرى","future":"{0} مىنۇتتىن كېيىن"},"second":{"current":"now","past":"{0} سېكۇنت ئىلگىرى","future":"{0} سېكۇنتتىن كېيىن"}}}');

/***/ }),

/***/ 89595:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"uk","long":{"year":{"previous":"торік","current":"цього року","next":"наступного року","past":{"one":"{0} рік тому","few":"{0} роки тому","many":"{0} років тому","other":"{0} року тому"},"future":{"one":"через {0} рік","few":"через {0} роки","many":"через {0} років","other":"через {0} року"}},"quarter":{"previous":"минулого кварталу","current":"цього кварталу","next":"наступного кварталу","past":{"one":"{0} квартал тому","few":"{0} квартали тому","many":"{0} кварталів тому","other":"{0} кварталу тому"},"future":{"one":"через {0} квартал","few":"через {0} квартали","many":"через {0} кварталів","other":"через {0} кварталу"}},"month":{"previous":"минулого місяця","current":"цього місяця","next":"наступного місяця","past":{"one":"{0} місяць тому","few":"{0} місяці тому","many":"{0} місяців тому","other":"{0} місяця тому"},"future":{"one":"через {0} місяць","few":"через {0} місяці","many":"через {0} місяців","other":"через {0} місяця"}},"week":{"previous":"минулого тижня","current":"цього тижня","next":"наступного тижня","past":{"one":"{0} тиждень тому","few":"{0} тижні тому","many":"{0} тижнів тому","other":"{0} тижня тому"},"future":{"one":"через {0} тиждень","few":"через {0} тижні","many":"через {0} тижнів","other":"через {0} тижня"}},"day":{"previous":"учора","previous-2":"позавчора","current":"сьогодні","next":"завтра","next-2":"післязавтра","past":{"one":"{0} день тому","few":"{0} дні тому","many":"{0} днів тому","other":"{0} дня тому"},"future":{"one":"через {0} день","few":"через {0} дні","many":"через {0} днів","other":"через {0} дня"}},"hour":{"current":"цієї години","past":{"one":"{0} годину тому","many":"{0} годин тому","other":"{0} години тому"},"future":{"one":"через {0} годину","many":"через {0} годин","other":"через {0} години"}},"minute":{"current":"цієї хвилини","past":{"one":"{0} хвилину тому","many":"{0} хвилин тому","other":"{0} хвилини тому"},"future":{"one":"через {0} хвилину","many":"через {0} хвилин","other":"через {0} хвилини"}},"second":{"current":"зараз","past":{"one":"{0} секунду тому","many":"{0} секунд тому","other":"{0} секунди тому"},"future":{"one":"через {0} секунду","many":"через {0} секунд","other":"через {0} секунди"}}},"short":{"year":{"previous":"торік","current":"цього року","next":"наступного року","past":"{0} р. тому","future":"через {0} р."},"quarter":{"previous":"минулого кв.","current":"цього кв.","next":"наступного кв.","past":"{0} кв. тому","future":"через {0} кв."},"month":{"previous":"минулого місяця","current":"цього місяця","next":"наступного місяця","past":"{0} міс. тому","future":"через {0} міс."},"week":{"previous":"минулого тижня","current":"цього тижня","next":"наступного тижня","past":"{0} тиж. тому","future":"через {0} тиж."},"day":{"previous":"учора","previous-2":"позавчора","current":"сьогодні","next":"завтра","next-2":"післязавтра","past":"{0} дн. тому","future":"через {0} дн."},"hour":{"current":"цієї години","past":"{0} год тому","future":"через {0} год"},"minute":{"current":"цієї хвилини","past":"{0} хв тому","future":"через {0} хв"},"second":{"current":"зараз","past":"{0} с тому","future":"через {0} с"}},"narrow":{"year":{"previous":"торік","current":"цього року","next":"наступного року","past":"{0} р. тому","future":"за {0} р."},"quarter":{"previous":"минулого кв.","current":"цього кв.","next":"наступного кв.","past":"{0} кв. тому","future":"за {0} кв."},"month":{"previous":"минулого місяця","current":"цього місяця","next":"наступного місяця","past":"{0} міс. тому","future":"за {0} міс."},"week":{"previous":"минулого тижня","current":"цього тижня","next":"наступного тижня","past":"{0} тиж. тому","future":"за {0} тиж."},"day":{"previous":"учора","previous-2":"позавчора","current":"сьогодні","next":"завтра","next-2":"післязавтра","past":{"one":"{0} д. тому","other":"-{0} дн."},"future":"за {0} д."},"hour":{"current":"цієї години","past":"{0} год тому","future":"за {0} год"},"minute":{"current":"цієї хвилини","past":"{0} хв тому","future":"за {0} хв"},"second":{"current":"зараз","past":"{0} с тому","future":"за {0} с"}}}');

/***/ }),

/***/ 10797:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ur-IN","long":{"year":{"previous":"گزشتہ سال","current":"اس سال","next":"اگلے سال","past":"{0} سال پہلے","future":{"one":"{0} سال میں","other":"{0} سالوں میں"}},"quarter":{"previous":"گزشتہ سہ ماہی","current":"اس سہ ماہی","next":"اگلے سہ ماہی","past":"{0} سہ ماہی پہلے","future":"{0} سہ ماہی میں"},"month":{"previous":"گزشتہ ماہ","current":"اس ماہ","next":"اگلے ماہ","past":"{0} ماہ قبل","future":"{0} ماہ میں"},"week":{"previous":"گزشتہ ہفتہ","current":"اس ہفتہ","next":"اگلے ہفتہ","past":{"one":"{0} ہفتہ قبل","other":"{0} ہفتے قبل"},"future":{"one":"{0} ہفتہ میں","other":"{0} ہفتوں میں"}},"day":{"previous":"گزشتہ کل","previous-2":"گزشتہ پرسوں","current":"آج","next":"آئندہ کل","next-2":"آنے والا پرسوں","past":{"one":"{0} دن پہلے","other":"{0} دنوں پہلے"},"future":{"one":"{0} دن میں","other":"{0} دنوں میں"}},"hour":{"current":"اس گھنٹے","past":{"one":"{0} گھنٹہ پہلے","other":"{0} گھنٹے پہلے"},"future":"{0} گھنٹے میں"},"minute":{"current":"اس منٹ","past":"{0} منٹ قبل","future":"{0} منٹ میں"},"second":{"current":"اب","past":"{0} سیکنڈ قبل","future":"{0} سیکنڈ میں"}},"short":{"year":{"previous":"گزشتہ سال","current":"اس سال","next":"اگلے سال","past":{"one":"{0} سال پہلے","other":"{0} سالوں پہلے"},"future":{"one":"{0} سال میں","other":"{0} سالوں میں"}},"quarter":{"previous":"گزشتہ سہ ماہی","current":"اس سہ ماہی","next":"اگلے سہ ماہی","past":"{0} سہ ماہی قبل","future":"{0} سہ ماہی میں"},"month":{"previous":"پچھلے مہینہ","current":"اس مہینہ","next":"اگلے مہینہ","past":"{0} ماہ قبل","future":"{0} ماہ میں"},"week":{"previous":"پچھلے ہفتہ","current":"اس ہفتہ","next":"اگلے ہفتہ","past":"{0} ہفتے قبل","future":"{0} ہفتے میں"},"day":{"previous":"گزشتہ کل","previous-2":"گزشتہ پرسوں","current":"آج","next":"آئندہ کل","next-2":"آنے والا پرسوں","past":{"one":"{0} دن پہلے","other":"{0} دنوں پہلے"},"future":"{0} دنوں میں"},"hour":{"current":"اس گھنٹے","past":"{0} گھنٹے قبل","future":"{0} گھنٹے میں"},"minute":{"current":"اس منٹ","past":"{0} منٹ قبل","future":"{0} منٹ میں"},"second":{"current":"اب","past":"{0} سیکنڈ قبل","future":"{0} سیکنڈ میں"}},"narrow":{"year":{"previous":"گزشتہ سال","current":"اس سال","next":"اگلے سال","past":"{0} سال پہلے","future":"{0} سال میں"},"quarter":{"previous":"گزشتہ سہ ماہی","current":"اس سہ ماہی","next":"اگلے سہ ماہی","past":"{0} سہ ماہی پہلے","future":"{0} سہ ماہی میں"},"month":{"previous":"پچھلے مہینہ","current":"اس مہینہ","next":"اگلے مہینہ","past":"{0} ماہ قبل","future":"{0} ماہ میں"},"week":{"previous":"پچھلے ہفتہ","current":"اس ہفتہ","next":"اگلے ہفتہ","past":{"one":"{0} ہفتہ قبل","other":"{0} ہفتے قبل"},"future":{"one":"{0} ہفتہ میں","other":"{0} ہفتے میں"}},"day":{"previous":"گزشتہ کل","previous-2":"گزشتہ پرسوں","current":"آج","next":"آئندہ کل","next-2":"آنے والا پرسوں","past":"{0} دن قبل","future":{"one":"{0} دن میں","other":"{0} دنوں میں"}},"hour":{"current":"اس گھنٹے","past":{"one":"{0} گھنٹہ قبل","other":"{0} گھنٹے قبل"},"future":{"one":"{0} گھنٹے میں","other":"{0} گھنٹوں میں"}},"minute":{"current":"اس منٹ","past":"{0} منٹ قبل","future":"{0} منٹ میں"},"second":{"current":"اب","past":"{0} سیکنڈ قبل","future":"{0} سیکنڈ میں"}}}');

/***/ }),

/***/ 6363:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"ur","long":{"year":{"previous":"گزشتہ سال","current":"اس سال","next":"اگلے سال","past":"{0} سال پہلے","future":"{0} سال میں"},"quarter":{"previous":"گزشتہ سہ ماہی","current":"اس سہ ماہی","next":"اگلے سہ ماہی","past":"{0} سہ ماہی پہلے","future":"{0} سہ ماہی میں"},"month":{"previous":"پچھلا مہینہ","current":"اس مہینہ","next":"اگلا مہینہ","past":{"one":"{0} مہینہ پہلے","other":"{0} مہینے پہلے"},"future":{"one":"{0} مہینہ میں","other":"{0} مہینے میں"}},"week":{"previous":"پچھلے ہفتہ","current":"اس ہفتہ","next":"اگلے ہفتہ","past":{"one":"{0} ہفتہ پہلے","other":"{0} ہفتے پہلے"},"future":{"one":"{0} ہفتہ میں","other":"{0} ہفتے میں"}},"day":{"previous":"گزشتہ کل","previous-2":"گزشتہ پرسوں","current":"آج","next":"آئندہ کل","next-2":"آنے والا پرسوں","past":{"one":"{0} دن پہلے","other":"{0} دنوں پہلے"},"future":{"one":"{0} دن میں","other":"{0} دنوں میں"}},"hour":{"current":"اس گھنٹے","past":{"one":"{0} گھنٹہ پہلے","other":"{0} گھنٹے پہلے"},"future":"{0} گھنٹے میں"},"minute":{"current":"اس منٹ","past":"{0} منٹ پہلے","future":"{0} منٹ میں"},"second":{"current":"اب","past":"{0} سیکنڈ پہلے","future":"{0} سیکنڈ میں"}},"short":{"year":{"previous":"گزشتہ سال","current":"اس سال","next":"اگلے سال","past":"{0} سال پہلے","future":"{0} سال میں"},"quarter":{"previous":"گزشتہ سہ ماہی","current":"اس سہ ماہی","next":"اگلے سہ ماہی","past":"{0} سہ ماہی قبل","future":"{0} سہ ماہی میں"},"month":{"previous":"پچھلے مہینہ","current":"اس مہینہ","next":"اگلے مہینہ","past":"{0} ماہ قبل","future":"{0} ماہ میں"},"week":{"previous":"پچھلے ہفتہ","current":"اس ہفتہ","next":"اگلے ہفتہ","past":"{0} ہفتے پہلے","future":"{0} ہفتے میں"},"day":{"previous":"گزشتہ کل","previous-2":"گزشتہ پرسوں","current":"آج","next":"آئندہ کل","next-2":"آنے والا پرسوں","past":{"one":"{0} دن پہلے","other":"{0} دنوں پہلے"},"future":{"one":"{0} دن میں","other":"{0} دنوں میں"}},"hour":{"current":"اس گھنٹے","past":"{0} گھنٹے پہلے","future":"{0} گھنٹے میں"},"minute":{"current":"اس منٹ","past":"{0} منٹ پہلے","future":"{0} منٹ میں"},"second":{"current":"اب","past":"{0} سیکنڈ پہلے","future":"{0} سیکنڈ میں"}},"narrow":{"year":{"previous":"گزشتہ سال","current":"اس سال","next":"اگلے سال","past":"{0} سال پہلے","future":"{0} سال میں"},"quarter":{"previous":"گزشتہ سہ ماہی","current":"اس سہ ماہی","next":"اگلے سہ ماہی","past":"{0} سہ ماہی پہلے","future":"{0} سہ ماہی میں"},"month":{"previous":"پچھلے مہینہ","current":"اس مہینہ","next":"اگلے مہینہ","past":"{0} ماہ پہلے","future":"{0} ماہ میں"},"week":{"previous":"پچھلے ہفتہ","current":"اس ہفتہ","next":"اگلے ہفتہ","past":{"one":"{0} ہفتہ پہلے","other":"{0} ہفتے پہلے"},"future":{"one":"{0} ہفتہ میں","other":"{0} ہفتے میں"}},"day":{"previous":"گزشتہ کل","previous-2":"گزشتہ پرسوں","current":"آج","next":"آئندہ کل","next-2":"آنے والا پرسوں","past":"{0} دن پہلے","future":{"one":"{0} دن میں","other":"{0} دنوں میں"}},"hour":{"current":"اس گھنٹے","past":{"one":"{0} گھنٹہ پہلے","other":"{0} گھنٹے پہلے"},"future":{"one":"{0} گھنٹے میں","other":"{0} گھنٹوں میں"}},"minute":{"current":"اس منٹ","past":"{0} منٹ پہلے","future":"{0} منٹ میں"},"second":{"current":"اب","past":"{0} سیکنڈ پہلے","future":"{0} سیکنڈ میں"}}}');

/***/ }),

/***/ 82507:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"uz-Cyrl","long":{"year":{"previous":"ўтган йил","current":"бу йил","next":"кейинги йил","past":"{0} йил аввал","future":"{0} йилдан сўнг"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"ўтган ой","current":"бу ой","next":"кейинги ой","past":"{0} ой аввал","future":"{0} ойдан сўнг"},"week":{"previous":"ўтган ҳафта","current":"бу ҳафта","next":"кейинги ҳафта","past":"{0} ҳафта олдин","future":"{0} ҳафтадан сўнг"},"day":{"previous":"кеча","current":"бугун","next":"эртага","past":"{0} кун олдин","future":"{0} кундан сўнг"},"hour":{"current":"this hour","past":"{0} соат олдин","future":"{0} соатдан сўнг"},"minute":{"current":"this minute","past":"{0} дақиқа олдин","future":"{0} дақиқадан сўнг"},"second":{"current":"ҳозир","past":"{0} сония олдин","future":"{0} сониядан сўнг"}},"short":{"year":{"previous":"ўтган йил","current":"бу йил","next":"кейинги йил","past":"{0} йил аввал","future":"{0} йилдан сўнг"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"ўтган ой","current":"бу ой","next":"кейинги ой","past":"{0} ой аввал","future":"{0} ойдан сўнг"},"week":{"previous":"ўтган ҳафта","current":"бу ҳафта","next":"кейинги ҳафта","past":"{0} ҳафта олдин","future":"{0} ҳафтадан сўнг"},"day":{"previous":"кеча","current":"бугун","next":"эртага","past":"{0} кун олдин","future":"{0} кундан сўнг"},"hour":{"current":"this hour","past":"{0} соат олдин","future":"{0} соатдан сўнг"},"minute":{"current":"this minute","past":"{0} дақиқа олдин","future":"{0} дақиқадан сўнг"},"second":{"current":"ҳозир","past":"{0} сония олдин","future":"{0} сониядан сўнг"}},"narrow":{"year":{"previous":"ўтган йил","current":"бу йил","next":"кейинги йил","past":"{0} йил аввал","future":"{0} йилдан сўнг"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"ўтган ой","current":"бу ой","next":"кейинги ой","past":"{0} ой аввал","future":"{0} ойдан сўнг"},"week":{"previous":"ўтган ҳафта","current":"бу ҳафта","next":"кейинги ҳафта","past":"{0} ҳафта олдин","future":"{0} ҳафтадан сўнг"},"day":{"previous":"кеча","current":"бугун","next":"эртага","past":"{0} кун олдин","future":"{0} кундан сўнг"},"hour":{"current":"this hour","past":"{0} соат олдин","future":"{0} соатдан сўнг"},"minute":{"current":"this minute","past":"{0} дақиқа олдин","future":"{0} дақиқадан сўнг"},"second":{"current":"ҳозир","past":"{0} сония олдин","future":"{0} сониядан сўнг"}}}');

/***/ }),

/***/ 87012:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"uz","long":{"year":{"previous":"o‘tgan yil","current":"shu yil","next":"keyingi yil","past":"{0} yil oldin","future":"{0} yildan keyin"},"quarter":{"previous":"o‘tgan chorak","current":"shu chorak","next":"keyingi chorak","past":"{0} chorak oldin","future":"{0} chorakdan keyin"},"month":{"previous":"o‘tgan oy","current":"shu oy","next":"keyingi oy","past":"{0} oy oldin","future":"{0} oydan keyin"},"week":{"previous":"o‘tgan hafta","current":"shu hafta","next":"keyingi hafta","past":"{0} hafta oldin","future":"{0} haftadan keyin"},"day":{"previous":"kecha","current":"bugun","next":"ertaga","past":"{0} kun oldin","future":"{0} kundan keyin"},"hour":{"current":"shu soatda","past":"{0} soat oldin","future":"{0} soatdan keyin"},"minute":{"current":"shu daqiqada","past":"{0} daqiqa oldin","future":"{0} daqiqadan keyin"},"second":{"current":"hozir","past":"{0} soniya oldin","future":"{0} soniyadan keyin"}},"short":{"year":{"previous":"oʻtgan yil","current":"bu yil","next":"keyingi yil","past":"{0} yil oldin","future":"{0} yildan keyin"},"quarter":{"previous":"o‘tgan chorak","current":"shu chorak","next":"keyingi chorak","past":"{0} chorak oldin","future":"{0} chorakdan keyin"},"month":{"previous":"o‘tgan oy","current":"shu oy","next":"keyingi oy","past":"{0} oy oldin","future":"{0} oydan keyin"},"week":{"previous":"o‘tgan hafta","current":"shu hafta","next":"keyingi hafta","past":"{0} hafta oldin","future":"{0} haftadan keyin"},"day":{"previous":"kecha","current":"bugun","next":"ertaga","past":"{0} kun oldin","future":"{0} kundan keyin"},"hour":{"current":"shu soatda","past":"{0} soat oldin","future":"{0} soatdan keyin"},"minute":{"current":"shu daqiqada","past":"{0} daqiqa oldin","future":"{0} daqiqadan keyin"},"second":{"current":"hozir","past":"{0} soniya oldin","future":"{0} soniyadan keyin"}},"narrow":{"year":{"previous":"oʻtgan yil","current":"bu yil","next":"keyingi yil","past":"{0} yil oldin","future":"{0} yildan keyin"},"quarter":{"previous":"o‘tgan chorak","current":"shu chorak","next":"keyingi chorak","past":"{0} chorak oldin","future":"{0} chorakdan keyin"},"month":{"previous":"o‘tgan oy","current":"shu oy","next":"keyingi oy","past":"{0} oy oldin","future":"{0} oydan keyin"},"week":{"previous":"o‘tgan hafta","current":"shu hafta","next":"keyingi hafta","past":"{0} hafta oldin","future":"{0} haftadan keyin"},"day":{"previous":"kecha","current":"bugun","next":"ertaga","past":"{0} kun oldin","future":"{0} kundan keyin"},"hour":{"current":"shu soatda","past":"{0} soat oldin","future":"{0} soatdan keyin"},"minute":{"current":"shu daqiqada","past":"{0} daqiqa oldin","future":"{0} daqiqadan keyin"},"second":{"current":"hozir","past":"{0} soniya oldin","future":"{0} soniyadan keyin"}}}');

/***/ }),

/***/ 82946:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"vi","long":{"year":{"previous":"năm ngoái","current":"năm nay","next":"năm sau","past":"{0} năm trước","future":"sau {0} năm nữa"},"quarter":{"previous":"quý trước","current":"quý này","next":"quý sau","past":"{0} quý trước","future":"sau {0} quý nữa"},"month":{"previous":"tháng trước","current":"tháng này","next":"tháng sau","past":"{0} tháng trước","future":"sau {0} tháng nữa"},"week":{"previous":"tuần trước","current":"tuần này","next":"tuần sau","past":"{0} tuần trước","future":"sau {0} tuần nữa"},"day":{"previous":"Hôm qua","previous-2":"Hôm kia","current":"Hôm nay","next":"Ngày mai","next-2":"Ngày kia","past":"{0} ngày trước","future":"sau {0} ngày nữa"},"hour":{"current":"giờ này","past":"{0} giờ trước","future":"sau {0} giờ nữa"},"minute":{"current":"phút này","past":"{0} phút trước","future":"sau {0} phút nữa"},"second":{"current":"bây giờ","past":"{0} giây trước","future":"sau {0} giây nữa"}},"short":{"year":{"previous":"năm ngoái","current":"năm nay","next":"năm sau","past":"{0} năm trước","future":"sau {0} năm nữa"},"quarter":{"previous":"quý trước","current":"quý này","next":"quý sau","past":"{0} quý trước","future":"sau {0} quý nữa"},"month":{"previous":"tháng trước","current":"tháng này","next":"tháng sau","past":"{0} tháng trước","future":"sau {0} tháng nữa"},"week":{"previous":"tuần trước","current":"tuần này","next":"tuần sau","past":"{0} tuần trước","future":"sau {0} tuần nữa"},"day":{"previous":"Hôm qua","previous-2":"Hôm kia","current":"Hôm nay","next":"Ngày mai","next-2":"Ngày kia","past":"{0} ngày trước","future":"sau {0} ngày nữa"},"hour":{"current":"giờ này","past":"{0} giờ trước","future":"sau {0} giờ nữa"},"minute":{"current":"phút này","past":"{0} phút trước","future":"sau {0} phút nữa"},"second":{"current":"bây giờ","past":"{0} giây trước","future":"sau {0} giây nữa"}},"narrow":{"year":{"previous":"năm ngoái","current":"năm nay","next":"năm sau","past":"{0} năm trước","future":"sau {0} năm nữa"},"quarter":{"previous":"quý trước","current":"quý này","next":"quý sau","past":"{0} quý trước","future":"sau {0} quý nữa"},"month":{"previous":"tháng trước","current":"tháng này","next":"tháng sau","past":"{0} tháng trước","future":"sau {0} tháng nữa"},"week":{"previous":"tuần trước","current":"tuần này","next":"tuần sau","past":"{0} tuần trước","future":"sau {0} tuần nữa"},"day":{"previous":"Hôm qua","previous-2":"Hôm kia","current":"Hôm nay","next":"Ngày mai","next-2":"Ngày kia","past":"{0} ngày trước","future":"sau {0} ngày nữa"},"hour":{"current":"giờ này","past":"{0} giờ trước","future":"sau {0} giờ nữa"},"minute":{"current":"phút này","past":"{0} phút trước","future":"sau {0} phút nữa"},"second":{"current":"bây giờ","past":"{0} giây trước","future":"sau {0} giây nữa"}}}');

/***/ }),

/***/ 98912:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"wae","long":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"vor {0} jár","other":"cor {0} jár"},"future":"I {0} jár"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"vor {0} mánet","future":"I {0} mánet"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"vor {0} wuča","other":"cor {0} wučä"},"future":{"one":"i {0} wuča","other":"i {0} wučä"}},"day":{"previous":"Gešter","previous-2":"Vorgešter","current":"Hitte","next":"Móre","next-2":"Ubermóre","past":{"one":"vor {0} tag","other":"vor {0} täg"},"future":{"one":"i {0} tag","other":"i {0} täg"}},"hour":{"current":"this hour","past":{"one":"vor {0} stund","other":"vor {0} stunde"},"future":{"one":"i {0} stund","other":"i {0} stunde"}},"minute":{"current":"this minute","past":{"one":"vor {0} minüta","other":"vor {0} minüte"},"future":{"one":"i {0} minüta","other":"i {0} minüte"}},"second":{"current":"now","past":{"one":"vor {0} sekund","other":"vor {0} sekunde"},"future":{"one":"i {0} sekund","other":"i {0} sekunde"}}},"short":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"vor {0} jár","other":"cor {0} jár"},"future":"I {0} jár"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"vor {0} mánet","future":"I {0} mánet"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"vor {0} wuča","other":"cor {0} wučä"},"future":{"one":"i {0} wuča","other":"i {0} wučä"}},"day":{"previous":"Gešter","previous-2":"Vorgešter","current":"Hitte","next":"Móre","next-2":"Ubermóre","past":{"one":"vor {0} tag","other":"vor {0} täg"},"future":{"one":"i {0} tag","other":"i {0} täg"}},"hour":{"current":"this hour","past":{"one":"vor {0} stund","other":"vor {0} stunde"},"future":{"one":"i {0} stund","other":"i {0} stunde"}},"minute":{"current":"this minute","past":{"one":"vor {0} minüta","other":"vor {0} minüte"},"future":{"one":"i {0} minüta","other":"i {0} minüte"}},"second":{"current":"now","past":{"one":"vor {0} sekund","other":"vor {0} sekunde"},"future":{"one":"i {0} sekund","other":"i {0} sekunde"}}},"narrow":{"year":{"previous":"last year","current":"this year","next":"next year","past":{"one":"vor {0} jár","other":"cor {0} jár"},"future":"I {0} jár"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"last month","current":"this month","next":"next month","past":"vor {0} mánet","future":"I {0} mánet"},"week":{"previous":"last week","current":"this week","next":"next week","past":{"one":"vor {0} wuča","other":"cor {0} wučä"},"future":{"one":"i {0} wuča","other":"i {0} wučä"}},"day":{"previous":"Gešter","previous-2":"Vorgešter","current":"Hitte","next":"Móre","next-2":"Ubermóre","past":{"one":"vor {0} tag","other":"vor {0} täg"},"future":{"one":"i {0} tag","other":"i {0} täg"}},"hour":{"current":"this hour","past":{"one":"vor {0} stund","other":"vor {0} stunde"},"future":{"one":"i {0} stund","other":"i {0} stunde"}},"minute":{"current":"this minute","past":{"one":"vor {0} minüta","other":"vor {0} minüte"},"future":{"one":"i {0} minüta","other":"i {0} minüte"}},"second":{"current":"now","past":{"one":"vor {0} sekund","other":"vor {0} sekunde"},"future":{"one":"i {0} sekund","other":"i {0} sekunde"}}}}');

/***/ }),

/***/ 92397:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"yi","long":{"year":{"previous":"פֿאַראַיאָר","current":"הײַ יאָר","next":"איבער א יאָר","past":"פֿאַר {0} יאָר","future":"איבער {0} יאָר"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"פֿאַרגאנגענעם חודש","current":"דעם חודש","next":"קומענדיקן חודש","past":{"one":"פֿאַר {0} חודש","other":"פֿאַר {0} חדשים"},"future":{"one":"איבער {0} חודש","other":"איבער {0} חדשים"}},"week":{"previous":"last week","current":"this week","next":"איבער אַכט טאָג","past":"-{0} w","future":"+{0} w"},"day":{"previous":"נעכטן","current":"היינט","next":"מארגן","past":"-{0} d","future":{"one":"אין {0} טאָג אַרום","other":"אין {0} טעג אַרום"}},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"short":{"year":{"previous":"פֿאַראַיאָר","current":"הײַ יאָר","next":"איבער א יאָר","past":"פֿאַר {0} יאָר","future":{"one":"איבער א יאָר","other":"איבער {0} יאָר"}},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"פֿאַרגאנגענעם חודש","current":"דעם חודש","next":"קומענדיקן חודש","past":{"one":"פֿאַר {0} חודש","other":"פֿאַר {0} חדשים"},"future":{"one":"איבער {0} חודש","other":"איבער {0} חדשים"}},"week":{"previous":"last week","current":"this week","next":"איבער אַכט טאָג","past":"-{0} w","future":"+{0} w"},"day":{"previous":"נעכטן","current":"היינט","next":"מארגן","past":"-{0} d","future":{"one":"אין {0} טאָג אַרום","other":"אין {0} טעג אַרום"}},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}},"narrow":{"year":{"previous":"פֿאַראַיאָר","current":"הײַ יאָר","next":"איבער א יאָר","past":"פֿאַר {0} יאָר","future":"איבער {0} יאָר"},"quarter":{"previous":"last quarter","current":"this quarter","next":"next quarter","past":"-{0} Q","future":"+{0} Q"},"month":{"previous":"פֿאַרגאנגענעם חודש","current":"דעם חודש","next":"קומענדיקן חודש","past":{"one":"פֿאַר {0} חודש","other":"פֿאַר {0} חדשים"},"future":{"one":"איבער {0} חודש","other":"איבער {0} חדשים"}},"week":{"previous":"last week","current":"this week","next":"איבער אַכט טאָג","past":"-{0} w","future":"+{0} w"},"day":{"previous":"נעכטן","current":"היינט","next":"מארגן","past":"-{0} d","future":{"one":"אין {0} טאָג אַרום","other":"אין {0} טעג אַרום"}},"hour":{"current":"this hour","past":"-{0} h","future":"+{0} h"},"minute":{"current":"this minute","past":"-{0} min","future":"+{0} min"},"second":{"current":"now","past":"-{0} s","future":"+{0} s"}}}');

/***/ }),

/***/ 36160:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"yue-Hans","long":{"year":{"previous":"旧年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年后"},"quarter":{"previous":"上一季","current":"今季","next":"下一季","past":"{0} 季前","future":"{0} 季后"},"month":{"previous":"上个月","current":"今个月","next":"下个月","past":"{0} 个月前","future":"{0} 个月后"},"week":{"previous":"上星期","current":"今个星期","next":"下星期","past":"{0} 个星期前","future":"{0} 个星期后"},"day":{"previous":"寻日","previous-2":"前天","current":"今日","next":"听日","next-2":"后天","past":"{0} 日前","future":"{0} 日后"},"hour":{"current":"呢个小时","past":"{0} 小时前","future":"{0} 小时后"},"minute":{"current":"呢分钟","past":"{0} 分钟前","future":"{0} 分钟后"},"second":{"current":"宜家","past":"{0} 秒前","future":"{0} 秒后"}},"short":{"year":{"previous":"旧年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年后"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"{0} 季前","future":"{0} 季后"},"month":{"previous":"上个月","current":"今个月","next":"下个月","past":"{0} 个月前","future":"{0} 个月后"},"week":{"previous":"上星期","current":"今个星期","next":"下星期","past":"{0} 个星期前","future":"{0} 个星期后"},"day":{"previous":"寻日","previous-2":"前天","current":"今日","next":"听日","next-2":"后天","past":"{0} 日前","future":"{0} 日后"},"hour":{"current":"呢个小时","past":"{0} 小时前","future":"{0} 小时后"},"minute":{"current":"呢分钟","past":"{0} 分钟前","future":"{0} 分钟后"},"second":{"current":"宜家","past":"{0} 秒前","future":"{0} 秒后"}},"narrow":{"year":{"previous":"旧年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年后"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"{0} 季前","future":"{0} 季后"},"month":{"previous":"上个月","current":"今个月","next":"下个月","past":"{0} 个月前","future":"{0} 个月后"},"week":{"previous":"上星期","current":"今个星期","next":"下星期","past":"{0} 个星期前","future":"{0} 个星期后"},"day":{"previous":"寻日","previous-2":"前天","current":"今日","next":"听日","next-2":"后天","past":"{0} 日前","future":"{0} 日后"},"hour":{"current":"呢个小时","past":"{0} 小时前","future":"{0} 小时后"},"minute":{"current":"呢分钟","past":"{0} 分钟前","future":"{0} 分钟后"},"second":{"current":"宜家","past":"{0} 秒前","future":"{0} 秒后"}}}');

/***/ }),

/***/ 56416:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"yue","long":{"year":{"previous":"舊年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上一季","current":"今季","next":"下一季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"今個月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"今個星期","next":"下星期","past":"{0} 個星期前","future":"{0} 個星期後"},"day":{"previous":"尋日","previous-2":"前天","current":"今日","next":"聽日","next-2":"後天","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"呢個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"呢分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"宜家","past":"{0} 秒前","future":"{0} 秒後"}},"short":{"year":{"previous":"舊年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"今個月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"今個星期","next":"下星期","past":"{0} 個星期前","future":"{0} 個星期後"},"day":{"previous":"尋日","previous-2":"前天","current":"今日","next":"聽日","next-2":"後天","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"呢個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"呢分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"宜家","past":"{0} 秒前","future":"{0} 秒後"}},"narrow":{"year":{"previous":"舊年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"今個月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"今個星期","next":"下星期","past":"{0} 個星期前","future":"{0} 個星期後"},"day":{"previous":"尋日","previous-2":"前天","current":"今日","next":"聽日","next-2":"後天","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"呢個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"呢分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"宜家","past":"{0} 秒前","future":"{0} 秒後"}}}');

/***/ }),

/***/ 92874:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh-Hans-HK","long":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"short":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"narrow":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}}}');

/***/ }),

/***/ 69250:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh-Hans-MO","long":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"short":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"narrow":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}}}');

/***/ }),

/***/ 20645:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh-Hans-SG","long":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"short":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"narrow":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}}}');

/***/ }),

/***/ 15801:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh-Hant-HK","long":{"year":{"previous":"上年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上一季","current":"今季","next":"下一季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"本星期","next":"下星期","past":"{0} 星期前","future":"{0} 星期後"},"day":{"previous":"昨日","previous-2":"前日","current":"今日","next":"明日","next-2":"後日","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"這個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}},"short":{"year":{"previous":"上年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"本星期","next":"下星期","past":"{0} 星期前","future":"{0} 星期後"},"day":{"previous":"昨日","previous-2":"前日","current":"今日","next":"明日","next-2":"後日","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"這個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}},"narrow":{"year":{"previous":"上年","current":"今年","next":"下年","past":"{0}年前","future":"{0}年後"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"-{0}Q","future":"+{0}Q"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0}個月前","future":"{0}個月後"},"week":{"previous":"上星期","current":"本星期","next":"下星期","past":"{0}星期前","future":"{0}星期後"},"day":{"previous":"昨日","previous-2":"前日","current":"今日","next":"明日","next-2":"後日","past":"{0}日前","future":"{0}日後"},"hour":{"current":"這個小時","past":"{0}小時前","future":"{0}小時後"},"minute":{"current":"這分鐘","past":"{0}分前","future":"{0}分後"},"second":{"current":"現在","past":"{0}秒前","future":"{0}秒後"}}}');

/***/ }),

/***/ 75047:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh-Hant-MO","long":{"year":{"previous":"上年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上一季","current":"今季","next":"下一季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"本星期","next":"下星期","past":"{0} 星期前","future":"{0} 星期後"},"day":{"previous":"昨日","previous-2":"前日","current":"今日","next":"明日","next-2":"後日","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"這個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}},"short":{"year":{"previous":"上年","current":"今年","next":"下年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上星期","current":"本星期","next":"下星期","past":"{0} 星期前","future":"{0} 星期後"},"day":{"previous":"昨日","previous-2":"前日","current":"今日","next":"明日","next-2":"後日","past":"{0} 日前","future":"{0} 日後"},"hour":{"current":"這個小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}},"narrow":{"year":{"previous":"上年","current":"今年","next":"下年","past":"{0}年前","future":"{0}年後"},"quarter":{"previous":"上季","current":"今季","next":"下季","past":"-{0}Q","future":"+{0}Q"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0}個月前","future":"{0}個月後"},"week":{"previous":"上星期","current":"本星期","next":"下星期","past":"{0}星期前","future":"{0}星期後"},"day":{"previous":"昨日","previous-2":"前日","current":"今日","next":"明日","next-2":"後日","past":"{0}日前","future":"{0}日後"},"hour":{"current":"這個小時","past":"{0}小時前","future":"{0}小時後"},"minute":{"current":"這分鐘","past":"{0}分前","future":"{0}分後"},"second":{"current":"現在","past":"{0}秒前","future":"{0}秒後"}}}');

/***/ }),

/***/ 39290:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh-Hant","long":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上一季","current":"這一季","next":"下一季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上週","current":"本週","next":"下週","past":"{0} 週前","future":"{0} 週後"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"後天","past":"{0} 天前","future":"{0} 天後"},"hour":{"current":"這一小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這一分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}},"short":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上一季","current":"這一季","next":"下一季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上週","current":"本週","next":"下週","past":"{0} 週前","future":"{0} 週後"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"後天","past":"{0} 天前","future":"{0} 天後"},"hour":{"current":"這一小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這一分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}},"narrow":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0} 年前","future":"{0} 年後"},"quarter":{"previous":"上一季","current":"這一季","next":"下一季","past":"{0} 季前","future":"{0} 季後"},"month":{"previous":"上個月","current":"本月","next":"下個月","past":"{0} 個月前","future":"{0} 個月後"},"week":{"previous":"上週","current":"本週","next":"下週","past":"{0} 週前","future":"{0} 週後"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"後天","past":"{0} 天前","future":"{0} 天後"},"hour":{"current":"這一小時","past":"{0} 小時前","future":"{0} 小時後"},"minute":{"current":"這一分鐘","past":"{0} 分鐘前","future":"{0} 分鐘後"},"second":{"current":"現在","past":"{0} 秒前","future":"{0} 秒後"}}}');

/***/ }),

/***/ 50588:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zh","long":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒钟前","future":"{0}秒钟后"}},"short":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}},"narrow":{"year":{"previous":"去年","current":"今年","next":"明年","past":"{0}年前","future":"{0}年后"},"quarter":{"previous":"上季度","current":"本季度","next":"下季度","past":"{0}个季度前","future":"{0}个季度后"},"month":{"previous":"上个月","current":"本月","next":"下个月","past":"{0}个月前","future":"{0}个月后"},"week":{"previous":"上周","current":"本周","next":"下周","past":"{0}周前","future":"{0}周后"},"day":{"previous":"昨天","previous-2":"前天","current":"今天","next":"明天","next-2":"后天","past":"{0}天前","future":"{0}天后"},"hour":{"current":"这一时间 / 此时","past":"{0}小时前","future":"{0}小时后"},"minute":{"current":"此刻","past":"{0}分钟前","future":"{0}分钟后"},"second":{"current":"现在","past":"{0}秒前","future":"{0}秒后"}}}');

/***/ }),

/***/ 85625:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"locale":"zu","long":{"year":{"previous":"onyakeni odlule","current":"kulo nyaka","next":"unyaka ozayo","past":{"one":"{0} unyaka odlule","other":"{0} iminyaka edlule"},"future":{"one":"onyakeni ongu-{0} ozayo","other":"eminyakeni engu-{0} ezayo"}},"quarter":{"previous":"ikota edlule","current":"le kota","next":"ikota ezayo","past":{"one":"{0} ikota edlule","other":"{0} amakota adlule"},"future":{"one":"kwikota engu-{0} ezayo","other":"kumakota angu-{0} ezayo"}},"month":{"previous":"inyanga edlule","current":"le nyanga","next":"inyanga ezayo","past":{"one":"{0} inyanga edlule","other":"{0} izinyanga ezedlule"},"future":{"one":"enyangeni engu-{0}","other":"ezinyangeni ezingu-{0} ezizayo"}},"week":{"previous":"iviki eledlule","current":"leli viki","next":"iviki elizayo","past":{"one":"evikini elingu-{0} eledlule","other":"amaviki angu-{0} edlule"},"future":{"one":"evikini elingu-{0}","other":"emavikini angu-{0}"}},"day":{"previous":"izolo","previous-2":"usuku olwandulela olwayizolo","current":"namhlanje","next":"kusasa","next-2":"usuku olulandela olwakusasa","past":{"one":"osukwini olungu-{0} olwedlule","other":"ezinsukwini ezingu-{0} ezedlule."},"future":{"one":"osukwini olungu-{0} oluzayo","other":"ezinsukwini ezingu-{0} ezizayo"}},"hour":{"current":"leli hora","past":{"one":"{0} ihora eledlule","other":"emahoreni angu-{0} edlule"},"future":{"one":"ehoreni elingu-{0} elizayo","other":"emahoreni angu-{0} ezayo"}},"minute":{"current":"leli minithi","past":{"one":"{0} iminithi eledlule","other":"{0} amaminithi edlule"},"future":{"one":"kuminithi elingu-{0} elizayo","other":"kumaminithi angu-{0} ezayo"}},"second":{"current":"manje","past":{"one":"{0} isekhondi eledlule","other":"{0} amasekhondi edlule"},"future":{"one":"kusekhondi elingu-{0} elizayo","other":"kumasekhondi angu-{0} ezayo"}}},"short":{"year":{"previous":"onyakeni odlule","current":"kulo nyaka","next":"unyaka ozayo","past":"{0} unyaka odlule","future":{"one":"onyakeni ongu-{0} ozayo","other":"eminyakeni engu-{0} ezayo"}},"quarter":{"previous":"ikota edlule","current":"le kota","next":"ikota ezayo","past":{"one":"{0} amakota adlule","other":"{0} amakota edlule"},"future":{"one":"kwikota engu-{0} ezayo","other":"kumakota angu-{0} ezayo"}},"month":{"previous":"inyanga edlule","current":"le nyanga","next":"inyanga ezayo","past":"{0} izinyanga ezedlule","future":"ezinyangeni ezingu-{0} ezizayo"},"week":{"previous":"iviki eledlule","current":"leli viki","next":"iviki elizayo","past":"amaviki angu-{0} edlule","future":{"one":"evikini elingu-{0} elizayo","other":"emavikini angu-{0} ezayo"}},"day":{"previous":"izolo","previous-2":"usuku olwandulela olwayizolo","current":"namhlanje","next":"kusasa","next-2":"usuku olulandela olwakusasa","past":{"one":"{0} usuku olwedlule","other":"{0} izinsuku ezedlule"},"future":{"one":"osukwini olungu-{0} oluzayo","other":"ezinsukwini ezingu-{0} ezizayo"}},"hour":{"current":"leli hora","past":{"one":"{0} ihora eledlule","other":"emahoreni angu-{0} edlule"},"future":{"one":"ehoreni elingu-{0} elizayo","other":"emahoreni angu-{0} ezayo"}},"minute":{"current":"leli minithi","past":{"one":"{0} iminithi eledlule","other":"{0} amaminithi edlule"},"future":{"one":"kuminithi elingu-{0} elizayo","other":"kumaminithi angu-{0} ezayo"}},"second":{"current":"manje","past":{"one":"{0} isekhondi eledlule","other":"{0} amasekhondi edlule"},"future":{"one":"kusekhondi elingu-{0} elizayo","other":"kumasekhondi angu-{0} ezayo"}}},"narrow":{"year":{"previous":"onyakeni odlule","current":"kulo nyaka","next":"unyaka ozayo","past":"{0} unyaka odlule","future":{"one":"onyakeni ongu-{0} ozayo","other":"eminyakeni engu-{0} ezayo"}},"quarter":{"previous":"ikota edlule","current":"le kota","next":"ikota ezayo","past":{"one":"{0} amakota adlule","other":"{0} amakota edlule"},"future":"kumakota angu-{0}"},"month":{"previous":"inyanga edlule","current":"le nyanga","next":"inyanga ezayo","past":"{0} izinyanga ezedlule","future":"enyangeni engu-{0} ezayo"},"week":{"previous":"iviki eledlule","current":"leli viki","next":"iviki elizayo","past":"amaviki angu-{0} edlule","future":"emavikini angu-{0} ezayo"},"day":{"previous":"izolo","previous-2":"usuku olwandulela olwayizolo","current":"namhlanje","next":"kusasa","next-2":"usuku olulandela olwakusasa","past":{"one":"{0} usuku olwedlule","other":"{0} izinsuku ezedlule"},"future":{"one":"osukwini olungu-{0} oluzayo","other":"ezinsukwini ezingu-{0} ezizayo"}},"hour":{"current":"leli hora","past":{"one":"{0} ihora eledlule","other":"{0} amahora edlule"},"future":{"one":"ehoreni elingu-{0} elizayo","other":"emahoreni angu-{0} ezayo"}},"minute":{"current":"leli minithi","past":{"one":"{0} iminithi eledlule","other":"{0} amaminithi edlule"},"future":{"one":"kuminithi elingu-{0} elizayo","other":"kumaminithi angu-{0} ezayo"}},"second":{"current":"manje","past":{"one":"{0} isekhondi eledlule","other":"{0} amasekhondi edlule"},"future":{"one":"kusekhondi elingu-{0} elizayo","other":"kumasekhondi angu-{0} ezayo"}}}}');

/***/ })

}]);